import {
  CSS as CSS2,
  DndContext,
  PointerSensor,
  SortableContext,
  __commonJS,
  __toESM,
  arrayMove,
  closestCenter,
  horizontalListSortingStrategy,
  useSensor,
  useSensors,
  useSortable
} from "./chunk-G6QMFLWR.mjs";

// ../../node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object) {
          if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment11 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal5 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object) {
          return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object) {
          return typeOf(object) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object) {
          return typeOf(object) === REACT_PROVIDER_TYPE;
        }
        function isElement3(object) {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object) {
          return typeOf(object) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object) {
          return typeOf(object) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object) {
          return typeOf(object) === REACT_LAZY_TYPE;
        }
        function isMemo(object) {
          return typeOf(object) === REACT_MEMO_TYPE;
        }
        function isPortal(object) {
          return typeOf(object) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object) {
          return typeOf(object) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object) {
          return typeOf(object) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object) {
          return typeOf(object) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment11;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal5;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement3;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (false) {
      module.exports = null;
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "../../node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i5 = 0; i5 < 10; i5++) {
          test2["_" + String.fromCharCode(i5)] = i5;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n5) {
          return test2[n5];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s5 = 1; s5 < arguments.length; s5++) {
        from = Object(arguments[s5]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i5 = 0; i5 < symbols.length; i5++) {
            if (propIsEnumerable.call(from, symbols[i5])) {
              to[symbols[i5]] = from[symbols[i5]];
            }
          }
        }
      }
      return to;
    };
  }
});

// ../../node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// ../../node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "../../node_modules/prop-types/lib/has.js"(exports, module) {
    "use strict";
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// ../../node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "../../node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (true) {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text2) {
        var message = "Warning: " + text2;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x5) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (true) {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (true) {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// ../../node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "../../node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (true) {
      printWarning = function(text2) {
        var message = "Warning: " + text2;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x5) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x5, y5) {
        if (x5 === y5) {
          return x5 !== 0 || 1 / x5 === 1 / y5;
        } else {
          return x5 !== x5 && y5 !== y5;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (true) {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (typeof console !== "undefined") {
              var cacheKey = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i5 = 0; i5 < propValue.length; i5++) {
            var error = typeChecker(propValue, i5, componentName, location, propFullName + "[" + i5 + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (true) {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i5 = 0; i5 < expectedValues.length; i5++) {
            if (is(propValue, expectedValues[i5])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          true ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i5 = 0; i5 < arrayOfTypeCheckers.length; i5++) {
          var checker = arrayOfTypeCheckers[i5];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i5 + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i6 = 0; i6 < arrayOfTypeCheckers.length; i6++) {
            var checker2 = arrayOfTypeCheckers[i6];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode2(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode2(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode2);
            }
            if (propValue === null || isValidElement(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step;
              if (iteratorFn !== propValue.entries) {
                while (!(step = iterator.next()).done) {
                  if (!isNode2(step.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step = iterator.next()).done) {
                  var entry = step.value;
                  if (entry) {
                    if (!isNode2(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// ../../node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "../../node_modules/prop-types/index.js"(exports, module) {
    "use strict";
    if (true) {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = null();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// ../../node_modules/@fortawesome/free-solid-svg-icons/faCaretDown.js
var require_faCaretDown = __commonJS({
  "../../node_modules/@fortawesome/free-solid-svg-icons/faCaretDown.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "caret-down";
    var width = 320;
    var height = 512;
    var aliases = [];
    var unicode = "f0d7";
    var svgPathData = "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faCaretDown = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faAngleRight.js
var require_faAngleRight = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faAngleRight.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "angle-right";
    var width = 320;
    var height = 512;
    var aliases = [8250];
    var unicode = "f105";
    var svgPathData = "M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faAngleRight = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faAngleLeft.js
var require_faAngleLeft = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faAngleLeft.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "angle-left";
    var width = 320;
    var height = 512;
    var aliases = [8249];
    var unicode = "f104";
    var svgPathData = "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faAngleLeft = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faXmarkLarge.js
var require_faXmarkLarge = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faXmarkLarge.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "xmark-large";
    var width = 448;
    var height = 512;
    var aliases = [];
    var unicode = "e59b";
    var svgPathData = "M41 39C31.6 29.7 16.4 29.7 7 39S-2.3 63.6 7 73l183 183L7 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l183-183L407 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183-183L441 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-183 183L41 39z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faXmarkLarge = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faArrowLeft.js
var require_faArrowLeft = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faArrowLeft.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "arrow-left";
    var width = 448;
    var height = 512;
    var aliases = [8592];
    var unicode = "f060";
    var svgPathData = "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faArrowLeft = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faCheck.js
var require_faCheck = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faCheck.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "check";
    var width = 448;
    var height = 512;
    var aliases = [10003, 10004];
    var unicode = "f00c";
    var svgPathData = "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faCheck = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faChevronUp.js
var require_faChevronUp = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faChevronUp.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "chevron-up";
    var width = 512;
    var height = 512;
    var aliases = [];
    var unicode = "f077";
    var svgPathData = "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faChevronUp = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faChevronDown.js
var require_faChevronDown = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faChevronDown.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "chevron-down";
    var width = 512;
    var height = 512;
    var aliases = [];
    var unicode = "f078";
    var svgPathData = "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faChevronDown = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faMagnifyingGlass.js
var require_faMagnifyingGlass = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faMagnifyingGlass.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "magnifying-glass";
    var width = 512;
    var height = 512;
    var aliases = [128269, "search"];
    var unicode = "f002";
    var svgPathData = "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faMagnifyingGlass = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faSearch.js
var require_faSearch = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faSearch.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var source = require_faMagnifyingGlass();
    exports.definition = {
      prefix: source.prefix,
      iconName: source.iconName,
      icon: [
        source.width,
        source.height,
        source.aliases,
        source.unicode,
        source.svgPathData
      ]
    };
    exports.faSearch = exports.definition;
    exports.prefix = source.prefix;
    exports.iconName = source.iconName;
    exports.width = source.width;
    exports.height = source.height;
    exports.ligatures = source.aliases;
    exports.unicode = source.unicode;
    exports.svgPathData = source.svgPathData;
    exports.aliases = source.aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faChevronRight.js
var require_faChevronRight = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faChevronRight.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "chevron-right";
    var width = 320;
    var height = 512;
    var aliases = [9002];
    var unicode = "f054";
    var svgPathData = "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faChevronRight = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// src/components/Accordion/Accordion.tsx
import * as React2 from "react";

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n5) {
    for (var e3 = 1; e3 < arguments.length; e3++) {
      var t3 = arguments[e3];
      for (var r6 in t3) ({}).hasOwnProperty.call(t3, r6) && (n5[r6] = t3[r6]);
    }
    return n5;
  }, _extends.apply(null, arguments);
}

// ../../node_modules/@radix-ui/react-accordion/dist/index.module.js
import $3DjNB$react from "react";

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/react-context/dist/index.module.js
import { createContext as $3bkAK$createContext, useMemo as $3bkAK$useMemo, createElement as $3bkAK$createElement, useContext as $3bkAK$useContext } from "react";
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ $3bkAK$createContext(defaultContext);
    const index5 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const value = $3bkAK$useMemo(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ $3bkAK$createElement(Context.Provider, {
        value
      }, children);
    }
    function useContext7(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const context = $3bkAK$useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext7
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ $3bkAK$createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return $3bkAK$useMemo(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

// ../../node_modules/@radix-ui/react-collection/dist/index.module.js
import $6vYhU$react from "react";

// ../../node_modules/@radix-ui/react-collection/node_modules/@radix-ui/react-context/dist/index.module.js
import { createContext as $3bkAK$createContext2, useMemo as $3bkAK$useMemo2, createElement as $3bkAK$createElement2, useContext as $3bkAK$useContext2 } from "react";
function $c512c27ab02ef895$export$50c7b4e9d9f19c12(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ $3bkAK$createContext2(defaultContext);
    const index5 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const value = $3bkAK$useMemo2(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ $3bkAK$createElement2(Context.Provider, {
        value
      }, children);
    }
    function useContext7(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const context = $3bkAK$useContext2(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext7
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ $3bkAK$createContext2(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo2(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes2(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes2(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return $3bkAK$useMemo2(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

// ../../node_modules/@radix-ui/react-collection/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import { useCallback as $3vqmr$useCallback } from "react";
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
  return $3vqmr$useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}

// ../../node_modules/@radix-ui/react-collection/dist/index.module.js
import { Slot as $6vYhU$Slot } from "@radix-ui/react-slot";
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb2(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c12(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  });
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = $6vYhU$react.useRef(null);
    const itemMap = $6vYhU$react.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ $6vYhU$react.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  /* @__PURE__ */ Object.assign(CollectionProvider, {
    displayName: PROVIDER_NAME
  });
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */ $6vYhU$react.forwardRef((props, forwardedRef) => {
    const { scope, children } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, context.collectionRef);
    return /* @__PURE__ */ $6vYhU$react.createElement($6vYhU$Slot, {
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionSlot, {
    displayName: COLLECTION_SLOT_NAME
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */ $6vYhU$react.forwardRef((props, forwardedRef) => {
    const { scope, children, ...itemData } = props;
    const ref = $6vYhU$react.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    $6vYhU$react.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */ $6vYhU$react.createElement($6vYhU$Slot, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionItemSlot, {
    displayName: ITEM_SLOT_NAME
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = $6vYhU$react.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a5, b5) => orderedNodes.indexOf(a5.ref.current) - orderedNodes.indexOf(b5.ref.current)
      );
      return orderedItems;
    }, [
      context.collectionRef,
      context.itemMap
    ]);
    return getItems;
  }
  return [
    {
      Provider: CollectionProvider,
      Slot: CollectionSlot,
      ItemSlot: CollectionItemSlot
    },
    useCollection,
    createCollectionScope
  ];
}

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import { useCallback as $3vqmr$useCallback2 } from "react";
function $6ed0406888f73fc4$var$setRef2(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af2(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef2(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d052(...refs) {
  return $3vqmr$useCallback2($6ed0406888f73fc4$export$43e446d32b3d21af2(...refs), refs);
}

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
import { useCallback as $bnPw9$useCallback, useState as $bnPw9$useState, useRef as $bnPw9$useRef, useEffect as $bnPw9$useEffect } from "react";

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import { useRef as $lwiWj$useRef, useEffect as $lwiWj$useEffect, useMemo as $lwiWj$useMemo } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
  const callbackRef = $lwiWj$useRef(callback);
  $lwiWj$useEffect(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
function $71cd76cc60e0454e$export$6f32135080cb4c3({ prop, defaultProp, onChange: onChange2 = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState({
    defaultProp,
    onChange: onChange2
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange2);
  const setValue = $bnPw9$useCallback((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState({ defaultProp, onChange: onChange2 }) {
  const uncontrolledState = $bnPw9$useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = $bnPw9$useRef(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onChange2);
  $bnPw9$useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef, useEffect as $4q5Fq$useEffect, createElement as $4q5Fq$createElement } from "react";
import { flushSync as $4q5Fq$flushSync } from "react-dom";
import { Slot as $4q5Fq$Slot } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot : node;
    $4q5Fq$useEffect(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-collapsible/dist/index.module.js
import { forwardRef as $73KQ4$forwardRef, createElement as $73KQ4$createElement, useCallback as $73KQ4$useCallback, useState as $73KQ4$useState, useRef as $73KQ4$useRef, useEffect as $73KQ4$useEffect } from "react";

// ../../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff102(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

// ../../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-context/dist/index.module.js
import { createContext as $3bkAK$createContext3, useMemo as $3bkAK$useMemo3, createElement as $3bkAK$createElement3, useContext as $3bkAK$useContext3 } from "react";
function $c512c27ab02ef895$export$50c7b4e9d9f19c13(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ $3bkAK$createContext3(defaultContext);
    const index5 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const value = $3bkAK$useMemo3(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ $3bkAK$createElement3(Context.Provider, {
        value
      }, children);
    }
    function useContext7(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const context = $3bkAK$useContext3(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext7
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ $3bkAK$createContext3(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo3(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes3(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes3(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return $3bkAK$useMemo3(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

// ../../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
import { useCallback as $bnPw9$useCallback2, useState as $bnPw9$useState2, useRef as $bnPw9$useRef2, useEffect as $bnPw9$useEffect2 } from "react";

// ../../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import { useRef as $lwiWj$useRef2, useEffect as $lwiWj$useEffect2, useMemo as $lwiWj$useMemo2 } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a2(callback) {
  const callbackRef = $lwiWj$useRef2(callback);
  $lwiWj$useEffect2(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo2(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
function $71cd76cc60e0454e$export$6f32135080cb4c32({ prop, defaultProp, onChange: onChange2 = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState2({
    defaultProp,
    onChange: onChange2
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a2(onChange2);
  const setValue = $bnPw9$useCallback2((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState2({ defaultProp, onChange: onChange2 }) {
  const uncontrolledState = $bnPw9$useState2(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = $bnPw9$useRef2(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a2(onChange2);
  $bnPw9$useEffect2(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}

// ../../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js
import { useLayoutEffect as $dxlwH$useLayoutEffect } from "react";
var $9f79659886946c16$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? $dxlwH$useLayoutEffect : () => {
};

// ../../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import { useCallback as $3vqmr$useCallback3 } from "react";
function $6ed0406888f73fc4$var$setRef3(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af3(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef3(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d053(...refs) {
  return $3vqmr$useCallback3($6ed0406888f73fc4$export$43e446d32b3d21af3(...refs), refs);
}

// ../../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef2, useEffect as $4q5Fq$useEffect2, createElement as $4q5Fq$createElement2 } from "react";
import { flushSync as $4q5Fq$flushSync2 } from "react-dom";
import { Slot as $4q5Fq$Slot2 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES2 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d0342 = $8927f6f2acc4f386$var$NODES2.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef2((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot2 : node;
    $4q5Fq$useEffect2(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement2(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-collapsible/dist/index.module.js
import { Presence as $73KQ4$Presence } from "@radix-ui/react-presence";

// ../../node_modules/@radix-ui/react-collapsible/node_modules/@radix-ui/react-id/dist/index.module.js
import * as $2AODx$react from "react";
var $1746a345f3d73bb7$var$useReactId = $2AODx$react["useId".toString()] || (() => void 0);
var $1746a345f3d73bb7$var$count = 0;
function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
  const [id, setId] = $2AODx$react.useState($1746a345f3d73bb7$var$useReactId());
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (!deterministicId) setId(
      (reactId) => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++)
    );
  }, [
    deterministicId
  ]);
  return deterministicId || (id ? `radix-${id}` : "");
}

// ../../node_modules/@radix-ui/react-collapsible/dist/index.module.js
var $409067139f391064$var$COLLAPSIBLE_NAME = "Collapsible";
var [$409067139f391064$var$createCollapsibleContext, $409067139f391064$export$952b32dcbe73087a] = $c512c27ab02ef895$export$50c7b4e9d9f19c13($409067139f391064$var$COLLAPSIBLE_NAME);
var [$409067139f391064$var$CollapsibleProvider, $409067139f391064$var$useCollapsibleContext] = $409067139f391064$var$createCollapsibleContext($409067139f391064$var$COLLAPSIBLE_NAME);
var $409067139f391064$export$6eb0f7ddcda6131f = /* @__PURE__ */ $73KQ4$forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, open: openProp, defaultOpen, disabled: disabled2, onOpenChange, ...collapsibleProps } = props;
  const [open2 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c32({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ $73KQ4$createElement($409067139f391064$var$CollapsibleProvider, {
    scope: __scopeCollapsible,
    disabled: disabled2,
    contentId: $1746a345f3d73bb7$export$f680877a34711e37(),
    open: open2,
    onOpenToggle: $73KQ4$useCallback(
      () => setOpen(
        (prevOpen) => !prevOpen
      ),
      [
        setOpen
      ]
    )
  }, /* @__PURE__ */ $73KQ4$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0342.div, _extends({
    "data-state": $409067139f391064$var$getState(open2),
    "data-disabled": disabled2 ? "" : void 0
  }, collapsibleProps, {
    ref: forwardedRef
  })));
});
var $409067139f391064$var$TRIGGER_NAME = "CollapsibleTrigger";
var $409067139f391064$export$c135dce7b15bbbdc = /* @__PURE__ */ $73KQ4$forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, ...triggerProps } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$TRIGGER_NAME, __scopeCollapsible);
  return /* @__PURE__ */ $73KQ4$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0342.button, _extends({
    type: "button",
    "aria-controls": context.contentId,
    "aria-expanded": context.open || false,
    "data-state": $409067139f391064$var$getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    disabled: context.disabled
  }, triggerProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff102(props.onClick, context.onOpenToggle)
  }));
});
var $409067139f391064$var$CONTENT_NAME = "CollapsibleContent";
var $409067139f391064$export$aadde00976f34151 = /* @__PURE__ */ $73KQ4$forwardRef((props, forwardedRef) => {
  const { forceMount, ...contentProps } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, props.__scopeCollapsible);
  return /* @__PURE__ */ $73KQ4$createElement(
    $73KQ4$Presence,
    {
      present: forceMount || context.open
    },
    ({ present }) => /* @__PURE__ */ $73KQ4$createElement($409067139f391064$var$CollapsibleContentImpl, _extends({}, contentProps, {
      ref: forwardedRef,
      present
    }))
  );
});
var $409067139f391064$var$CollapsibleContentImpl = /* @__PURE__ */ $73KQ4$forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, present, children, ...contentProps } = props;
  const context = $409067139f391064$var$useCollapsibleContext($409067139f391064$var$CONTENT_NAME, __scopeCollapsible);
  const [isPresent, setIsPresent] = $73KQ4$useState(present);
  const ref = $73KQ4$useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d053(forwardedRef, ref);
  const heightRef = $73KQ4$useRef(0);
  const height = heightRef.current;
  const widthRef = $73KQ4$useRef(0);
  const width = widthRef.current;
  const isOpen = context.open || isPresent;
  const isMountAnimationPreventedRef = $73KQ4$useRef(isOpen);
  const originalStylesRef = $73KQ4$useRef();
  $73KQ4$useEffect(() => {
    const rAF = requestAnimationFrame(
      () => isMountAnimationPreventedRef.current = false
    );
    return () => cancelAnimationFrame(rAF);
  }, []);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    const node = ref.current;
    if (node) {
      originalStylesRef.current = originalStylesRef.current || {
        transitionDuration: node.style.transitionDuration,
        animationDuration: node.style.animationDuration,
        animationFillMode: node.style.animationFillMode
      };
      node.style.transitionDuration = "0s";
      node.style.animationDuration = "0s";
      node.style.animationFillMode = "none";
      const rect = node.getBoundingClientRect();
      heightRef.current = rect.height;
      widthRef.current = rect.width;
      if (!isMountAnimationPreventedRef.current) {
        node.style.transitionDuration = originalStylesRef.current.transitionDuration;
        node.style.animationDuration = originalStylesRef.current.animationDuration;
        node.style.animationFillMode = originalStylesRef.current.animationFillMode;
      }
      setIsPresent(present);
    }
  }, [
    context.open,
    present
  ]);
  return /* @__PURE__ */ $73KQ4$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0342.div, _extends({
    "data-state": $409067139f391064$var$getState(context.open),
    "data-disabled": context.disabled ? "" : void 0,
    id: context.contentId,
    hidden: !isOpen
  }, contentProps, {
    ref: composedRefs,
    style: {
      [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
      [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
      ...props.style
    }
  }), isOpen && children);
});
function $409067139f391064$var$getState(open2) {
  return open2 ? "open" : "closed";
}
var $409067139f391064$export$be92b6f5f03c0fe9 = $409067139f391064$export$6eb0f7ddcda6131f;
var $409067139f391064$export$41fb9f06171c75f4 = $409067139f391064$export$c135dce7b15bbbdc;
var $409067139f391064$export$7c6e2c02157bb7d2 = $409067139f391064$export$aadde00976f34151;

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/react-id/dist/index.module.js
import * as $2AODx$react2 from "react";

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js
import { useLayoutEffect as $dxlwH$useLayoutEffect2 } from "react";
var $9f79659886946c16$export$e5c5a5f917a5871c2 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? $dxlwH$useLayoutEffect2 : () => {
};

// ../../node_modules/@radix-ui/react-accordion/node_modules/@radix-ui/react-id/dist/index.module.js
var $1746a345f3d73bb7$var$useReactId2 = $2AODx$react2["useId".toString()] || (() => void 0);
var $1746a345f3d73bb7$var$count2 = 0;
function $1746a345f3d73bb7$export$f680877a34711e372(deterministicId) {
  const [id, setId] = $2AODx$react2.useState($1746a345f3d73bb7$var$useReactId2());
  $9f79659886946c16$export$e5c5a5f917a5871c2(() => {
    if (!deterministicId) setId(
      (reactId) => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count2++)
    );
  }, [
    deterministicId
  ]);
  return deterministicId || (id ? `radix-${id}` : "");
}

// ../../node_modules/@radix-ui/react-accordion/dist/index.module.js
var $1bf158f521e1b1b4$var$ACCORDION_NAME = "Accordion";
var $1bf158f521e1b1b4$var$ACCORDION_KEYS = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp"
];
var [$1bf158f521e1b1b4$var$Collection, $1bf158f521e1b1b4$var$useCollection, $1bf158f521e1b1b4$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb2($1bf158f521e1b1b4$var$ACCORDION_NAME);
var [$1bf158f521e1b1b4$var$createAccordionContext, $1bf158f521e1b1b4$export$9748edc328a73be1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($1bf158f521e1b1b4$var$ACCORDION_NAME, [
  $1bf158f521e1b1b4$var$createCollectionScope,
  $409067139f391064$export$952b32dcbe73087a
]);
var $1bf158f521e1b1b4$var$useCollapsibleScope = $409067139f391064$export$952b32dcbe73087a();
var $1bf158f521e1b1b4$export$a766cd26d0d69044 = /* @__PURE__ */ $3DjNB$react.forwardRef((props, forwardedRef) => {
  const { type, ...accordionProps } = props;
  const singleProps = accordionProps;
  const multipleProps = accordionProps;
  return /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$Collection.Provider, {
    scope: props.__scopeAccordion
  }, type === "multiple" ? /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionImplMultiple, _extends({}, multipleProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionImplSingle, _extends({}, singleProps, {
    ref: forwardedRef
  })));
});
$1bf158f521e1b1b4$export$a766cd26d0d69044.propTypes = {
  type(props) {
    const value = props.value || props.defaultValue;
    if (props.type && ![
      "single",
      "multiple"
    ].includes(props.type)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.");
    if (props.type === "multiple" && typeof value === "string") return new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.");
    if (props.type === "single" && Array.isArray(value)) return new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.");
    return null;
  }
};
var [$1bf158f521e1b1b4$var$AccordionValueProvider, $1bf158f521e1b1b4$var$useAccordionValueContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
var [$1bf158f521e1b1b4$var$AccordionCollapsibleProvider, $1bf158f521e1b1b4$var$useAccordionCollapsibleContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME, {
  collapsible: false
});
var $1bf158f521e1b1b4$var$AccordionImplSingle = /* @__PURE__ */ $3DjNB$react.forwardRef((props, forwardedRef) => {
  const { value: valueProp, defaultValue, onValueChange = () => {
  }, collapsible = false, ...accordionSingleProps } = props;
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  return /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value ? [
      value
    ] : [],
    onItemOpen: setValue,
    onItemClose: $3DjNB$react.useCallback(
      () => collapsible && setValue(""),
      [
        collapsible,
        setValue
      ]
    )
  }, /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
    scope: props.__scopeAccordion,
    collapsible
  }, /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends({}, accordionSingleProps, {
    ref: forwardedRef
  }))));
});
var $1bf158f521e1b1b4$var$AccordionImplMultiple = /* @__PURE__ */ $3DjNB$react.forwardRef((props, forwardedRef) => {
  const { value: valueProp, defaultValue, onValueChange = () => {
  }, ...accordionMultipleProps } = props;
  const [value1 = [], setValue] = $71cd76cc60e0454e$export$6f32135080cb4c3({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  const handleItemOpen = $3DjNB$react.useCallback(
    (itemValue) => setValue(
      (prevValue = []) => [
        ...prevValue,
        itemValue
      ]
    ),
    [
      setValue
    ]
  );
  const handleItemClose = $3DjNB$react.useCallback(
    (itemValue) => setValue(
      (prevValue = []) => prevValue.filter(
        (value) => value !== itemValue
      )
    ),
    [
      setValue
    ]
  );
  return /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value1,
    onItemOpen: handleItemOpen,
    onItemClose: handleItemClose
  }, /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionCollapsibleProvider, {
    scope: props.__scopeAccordion,
    collapsible: true
  }, /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionImpl, _extends({}, accordionMultipleProps, {
    ref: forwardedRef
  }))));
});
var [$1bf158f521e1b1b4$var$AccordionImplProvider, $1bf158f521e1b1b4$var$useAccordionContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ACCORDION_NAME);
var $1bf158f521e1b1b4$var$AccordionImpl = /* @__PURE__ */ $3DjNB$react.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, disabled: disabled2, ...accordionProps } = props;
  const accordionRef = $3DjNB$react.useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d052(accordionRef, forwardedRef);
  const getItems = $1bf158f521e1b1b4$var$useCollection(__scopeAccordion);
  const handleKeyDown = $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onKeyDown, (event) => {
    var _triggerCollection$cl;
    if (!$1bf158f521e1b1b4$var$ACCORDION_KEYS.includes(event.key)) return;
    const target = event.target;
    const triggerCollection = getItems().filter((item) => {
      var _item$ref$current;
      return !((_item$ref$current = item.ref.current) !== null && _item$ref$current !== void 0 && _item$ref$current.disabled);
    });
    const triggerIndex = triggerCollection.findIndex(
      (item) => item.ref.current === target
    );
    const triggerCount = triggerCollection.length;
    if (triggerIndex === -1) return;
    event.preventDefault();
    let nextIndex = triggerIndex;
    switch (event.key) {
      case "Home":
        nextIndex = 0;
        break;
      case "End":
        nextIndex = triggerCount - 1;
        break;
      case "ArrowDown":
        nextIndex = triggerIndex + 1;
        break;
      case "ArrowUp":
        nextIndex = triggerIndex - 1;
        if (nextIndex < 0) nextIndex = triggerCount - 1;
        break;
    }
    const clampedIndex = nextIndex % triggerCount;
    (_triggerCollection$cl = triggerCollection[clampedIndex].ref.current) === null || _triggerCollection$cl === void 0 || _triggerCollection$cl.focus();
  });
  return /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionImplProvider, {
    scope: __scopeAccordion,
    disabled: disabled2
  }, /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$Collection.Slot, {
    scope: __scopeAccordion
  }, /* @__PURE__ */ $3DjNB$react.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends({}, accordionProps, {
    ref: composedRefs,
    onKeyDown: disabled2 ? void 0 : handleKeyDown
  }))));
});
var $1bf158f521e1b1b4$var$ITEM_NAME = "AccordionItem";
var [$1bf158f521e1b1b4$var$AccordionItemProvider, $1bf158f521e1b1b4$var$useAccordionItemContext] = $1bf158f521e1b1b4$var$createAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME);
var $1bf158f521e1b1b4$export$d99097c13d4dac9f = /* @__PURE__ */ $3DjNB$react.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, value, ...accordionItemProps } = props;
  const accordionContext = $1bf158f521e1b1b4$var$useAccordionContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
  const valueContext = $1bf158f521e1b1b4$var$useAccordionValueContext($1bf158f521e1b1b4$var$ITEM_NAME, __scopeAccordion);
  const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
  const triggerId = $1746a345f3d73bb7$export$f680877a34711e372();
  const open1 = value && valueContext.value.includes(value) || false;
  const disabled2 = accordionContext.disabled || props.disabled;
  return /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$AccordionItemProvider, {
    scope: __scopeAccordion,
    open: open1,
    disabled: disabled2,
    triggerId
  }, /* @__PURE__ */ $3DjNB$react.createElement($409067139f391064$export$be92b6f5f03c0fe9, _extends({
    "data-state": open1 ? "open" : "closed"
  }, collapsibleScope, accordionItemProps, {
    ref: forwardedRef,
    disabled: disabled2,
    open: open1,
    onOpenChange: (open2) => {
      if (open2) valueContext.onItemOpen(value);
      else valueContext.onItemClose(value);
    }
  })));
});
var $1bf158f521e1b1b4$var$HEADER_NAME = "AccordionHeader";
var $1bf158f521e1b1b4$export$5e3e5deaaf81ee41 = /* @__PURE__ */ $3DjNB$react.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, ...headerProps } = props;
  const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$HEADER_NAME, __scopeAccordion);
  return /* @__PURE__ */ $3DjNB$react.createElement($8927f6f2acc4f386$export$250ffa63cdc0d034.h3, _extends({
    "data-state": $1bf158f521e1b1b4$var$getState(itemContext.open),
    "data-disabled": itemContext.disabled ? "" : void 0
  }, headerProps, {
    ref: forwardedRef
  }));
});
var $1bf158f521e1b1b4$var$TRIGGER_NAME = "AccordionTrigger";
var $1bf158f521e1b1b4$export$94e939b1f85bdd73 = /* @__PURE__ */ $3DjNB$react.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, ...triggerProps } = props;
  const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
  const collapsibleContext = $1bf158f521e1b1b4$var$useAccordionCollapsibleContext($1bf158f521e1b1b4$var$TRIGGER_NAME, __scopeAccordion);
  const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */ $3DjNB$react.createElement($1bf158f521e1b1b4$var$Collection.ItemSlot, {
    scope: __scopeAccordion
  }, /* @__PURE__ */ $3DjNB$react.createElement($409067139f391064$export$41fb9f06171c75f4, _extends({
    "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
    id: itemContext.triggerId
  }, collapsibleScope, triggerProps, {
    ref: forwardedRef
  })));
});
var $1bf158f521e1b1b4$var$CONTENT_NAME = "AccordionContent";
var $1bf158f521e1b1b4$export$985b9a77379b54a0 = /* @__PURE__ */ $3DjNB$react.forwardRef((props, forwardedRef) => {
  const { __scopeAccordion, ...contentProps } = props;
  const itemContext = $1bf158f521e1b1b4$var$useAccordionItemContext($1bf158f521e1b1b4$var$CONTENT_NAME, __scopeAccordion);
  const collapsibleScope = $1bf158f521e1b1b4$var$useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */ $3DjNB$react.createElement($409067139f391064$export$7c6e2c02157bb7d2, _extends({
    role: "region",
    "aria-labelledby": itemContext.triggerId
  }, collapsibleScope, contentProps, {
    ref: forwardedRef,
    style: {
      ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
      ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
      ...props.style
    }
  }));
});
function $1bf158f521e1b1b4$var$getState(open2) {
  return open2 ? "open" : "closed";
}
var $1bf158f521e1b1b4$export$be92b6f5f03c0fe9 = $1bf158f521e1b1b4$export$a766cd26d0d69044;
var $1bf158f521e1b1b4$export$6d08773d2e66f8f2 = $1bf158f521e1b1b4$export$d99097c13d4dac9f;
var $1bf158f521e1b1b4$export$8b251419efc915eb = $1bf158f521e1b1b4$export$5e3e5deaaf81ee41;
var $1bf158f521e1b1b4$export$41fb9f06171c75f4 = $1bf158f521e1b1b4$export$94e939b1f85bdd73;
var $1bf158f521e1b1b4$export$7c6e2c02157bb7d2 = $1bf158f521e1b1b4$export$985b9a77379b54a0;

// ../../node_modules/@fortawesome/fontawesome-svg-core/index.mjs
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i5 = 1; i5 < arguments.length; i5++) {
    var source = null != arguments[i5] ? arguments[i5] : {};
    i5 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i5 = 0; i5 < props.length; i5++) {
    var descriptor = props[i5];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i5) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i5) || _unsupportedIterableToArray(arr, i5) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i5) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i5 && _arr.length === i5) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o5, minLen) {
  if (!o5) return;
  if (typeof o5 === "string") return _arrayLikeToArray(o5, minLen);
  var n5 = Object.prototype.toString.call(o5).slice(8, -1);
  if (n5 === "Object" && o5.constructor) n5 = o5.constructor.name;
  if (n5 === "Map" || n5 === "Set") return Array.from(o5);
  if (n5 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n5)) return _arrayLikeToArray(o5, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i5 = 0, arr2 = new Array(len); i5 < len; i5++) arr2[i5] = arr[i5];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var noop = function noop2() {
};
var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};
try {
  if (typeof window !== "undefined") _WINDOW = window;
  if (typeof document !== "undefined") _DOCUMENT = document;
  if (typeof MutationObserver !== "undefined") _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== "undefined") _PERFORMANCE = performance;
} catch (e3) {
}
var _ref = _WINDOW.navigator || {};
var _ref$userAgent = _ref.userAgent;
var userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var _familyProxy;
var _familyProxy2;
var _familyProxy3;
var _familyProxy4;
var _familyProxy5;
var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var UNITS_IN_GRID = 16;
var DEFAULT_CSS_PREFIX = "fa";
var DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var DATA_FA_I2SVG = "data-fa-i2svg";
var DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var DATA_PREFIX = "data-prefix";
var DATA_ICON = "data-icon";
var HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var MUTATION_APPROACH_ASYNC = "async";
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ["HTML", "HEAD", "STYLE", "SCRIPT"];
var PRODUCTION = (function() {
  try {
    return false;
  } catch (e3) {
    return false;
  }
})();
var FAMILY_CLASSIC = "classic";
var FAMILY_SHARP = "sharp";
var FAMILIES = [FAMILY_CLASSIC, FAMILY_SHARP];
function familyProxy(obj) {
  return new Proxy(obj, {
    get: function get2(target, prop) {
      return prop in target ? target[prop] : target[FAMILY_CLASSIC];
    }
  });
}
var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty(_familyProxy, FAMILY_CLASSIC, {
  "fa": "solid",
  "fas": "solid",
  "fa-solid": "solid",
  "far": "regular",
  "fa-regular": "regular",
  "fal": "light",
  "fa-light": "light",
  "fat": "thin",
  "fa-thin": "thin",
  "fad": "duotone",
  "fa-duotone": "duotone",
  "fab": "brands",
  "fa-brands": "brands",
  "fak": "kit",
  "fa-kit": "kit"
}), _defineProperty(_familyProxy, FAMILY_SHARP, {
  "fa": "solid",
  "fass": "solid",
  "fa-solid": "solid",
  "fasr": "regular",
  "fa-regular": "regular"
}), _familyProxy));
var STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty(_familyProxy2, FAMILY_CLASSIC, {
  "solid": "fas",
  "regular": "far",
  "light": "fal",
  "thin": "fat",
  "duotone": "fad",
  "brands": "fab",
  "kit": "fak"
}), _defineProperty(_familyProxy2, FAMILY_SHARP, {
  "solid": "fass",
  "regular": "fasr"
}), _familyProxy2));
var PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty(_familyProxy3, FAMILY_CLASSIC, {
  "fab": "fa-brands",
  "fad": "fa-duotone",
  "fak": "fa-kit",
  "fal": "fa-light",
  "far": "fa-regular",
  "fas": "fa-solid",
  "fat": "fa-thin"
}), _defineProperty(_familyProxy3, FAMILY_SHARP, {
  "fass": "fa-solid",
  "fasr": "fa-regular"
}), _familyProxy3));
var LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty(_familyProxy4, FAMILY_CLASSIC, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), _defineProperty(_familyProxy4, FAMILY_SHARP, {
  "fa-solid": "fass",
  "fa-regular": "fasr"
}), _familyProxy4));
var ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr)?[\-\ ]/;
var LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty(_familyProxy5, FAMILY_CLASSIC, {
  "900": "fas",
  "400": "far",
  "normal": "far",
  "300": "fal",
  "100": "fat"
}), _defineProperty(_familyProxy5, FAMILY_SHARP, {
  "900": "fass",
  "400": "fasr"
}), _familyProxy5));
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"];
var DUOTONE_CLASSES = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
};
var prefixes = /* @__PURE__ */ new Set();
Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
var RESERVED_CLASSES = [].concat(FAMILIES, _toConsumableArray(prefixes), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function(n5) {
  return "".concat(n5, "x");
})).concat(oneToTwenty.map(function(n5) {
  return "w-".concat(n5);
}));
var initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector("script[" + attr + "]");
  if (element) {
    return element.getAttribute(attr);
  }
}
function coerce(val) {
  if (val === "") return true;
  if (val === "false") return false;
  if (val === "true") return true;
  return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === "function") {
  attrs = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  attrs.forEach(function(_ref2) {
    var _ref22 = _slicedToArray(_ref2, 2), attr = _ref22[0], key = _ref22[1];
    var val = coerce(getAttrConfig(attr));
    if (val !== void 0 && val !== null) {
      initial[key] = val;
    }
  });
}
var attrs;
var _default = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: DEFAULT_CSS_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: "async",
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};
if (initial.familyPrefix) {
  initial.cssPrefix = initial.familyPrefix;
}
var _config = _objectSpread2(_objectSpread2({}, _default), initial);
if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_default).forEach(function(key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set2(val) {
      _config[key] = val;
      _onChangeCb.forEach(function(cb) {
        return cb(config);
      });
    },
    get: function get2() {
      return _config[key];
    }
  });
});
Object.defineProperty(config, "familyPrefix", {
  enumerable: true,
  set: function set(val) {
    _config.cssPrefix = val;
    _onChangeCb.forEach(function(cb) {
      return cb(config);
    });
  },
  get: function get() {
    return _config.cssPrefix;
  }
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
  _onChangeCb.push(cb);
  return function() {
    _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
  };
}
var d = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css2) {
  if (!css2 || !IS_DOM) {
    return;
  }
  var style = DOCUMENT.createElement("style");
  style.setAttribute("type", "text/css");
  style.innerHTML = css2;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;
  for (var i5 = headChildren.length - 1; i5 > -1; i5--) {
    var child = headChildren[i5];
    var tagName = (child.tagName || "").toUpperCase();
    if (["STYLE", "LINK"].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }
  DOCUMENT.head.insertBefore(style, beforeChild);
  return css2;
}
var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId() {
  var size3 = 12;
  var id = "";
  while (size3-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }
  return id;
}
function toArray(obj) {
  var array = [];
  for (var i5 = (obj || []).length >>> 0; i5--; ) {
    array[i5] = obj[i5];
  }
  return array;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute("class") || "").split(" ").filter(function(i5) {
      return i5;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
    return acc + "".concat(attributeName, '="').concat(htmlEscape(attributes[attributeName]), '" ');
  }, "").trim();
}
function joinStyles(styles2) {
  return Object.keys(styles2 || {}).reduce(function(acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles2[styleName].trim(), ";");
  }, "");
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref2) {
  var transform = _ref2.transform, containerWidth = _ref2.containerWidth, iconWidth = _ref2.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer,
    inner,
    path
  };
}
function transformForCss(_ref2) {
  var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = "";
  if (startCentered && IS_IE) {
    val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
  } else {
    val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
  }
  val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform.rotate, "deg) ");
  return val;
}
var baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function css() {
  var dcp = DEFAULT_CSS_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.cssPrefix;
  var rc = config.replacementClass;
  var s5 = baseStyles;
  if (fp !== dcp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dcp, "\\-"), "g");
    var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), "g");
    var rPatt = new RegExp("\\.".concat(drc), "g");
    s5 = s5.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }
  return s5;
}
var _cssInserted = false;
function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}
var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions = [];
var listener = function listener2() {
  DOCUMENT.removeEventListener("DOMContentLoaded", listener2);
  loaded = 1;
  functions.map(function(fn) {
    return fn();
  });
};
var loaded = false;
if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener("DOMContentLoaded", listener);
}
function domready(fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}
function toHtml(abstractNodes) {
  var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
  if (typeof abstractNodes === "string") {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(""), "</").concat(tag, ">");
  }
}
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix,
      iconName,
      icon: mapping[prefix][iconName]
    };
  }
}
var bindInternal4 = function bindInternal42(func, thisContext) {
  return function(a5, b5, c5, d6) {
    return func.call(thisContext, a5, b5, c5, d6);
  };
};
var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== void 0 ? bindInternal4(fn, thisContext) : fn, i5, key, result;
  if (initialValue === void 0) {
    i5 = 1;
    result = subject[keys[0]];
  } else {
    i5 = 0;
    result = initialValue;
  }
  for (; i5 < length; i5++) {
    key = keys[i5];
    result = iterator(result, subject[key], key, subject);
  }
  return result;
};
function ucs2decode(string) {
  var output = [];
  var counter2 = 0;
  var length = string.length;
  while (counter2 < length) {
    var value = string.charCodeAt(counter2++);
    if (value >= 55296 && value <= 56319 && counter2 < length) {
      var extra = string.charCodeAt(counter2++);
      if ((extra & 64512) == 56320) {
        output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
      } else {
        output.push(value);
        counter2--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}
function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index5) {
  var size3 = string.length;
  var first = string.charCodeAt(index5);
  var second;
  if (first >= 55296 && first <= 56319 && size3 > index5 + 1) {
    second = string.charCodeAt(index5 + 1);
    if (second >= 56320 && second <= 57343) {
      return (first - 55296) * 1024 + second - 56320 + 65536;
    }
  }
  return first;
}
function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function(acc, iconName) {
    var icon3 = icons[iconName];
    var expanded = !!icon3.icon;
    if (expanded) {
      acc[icon3.iconName] = icon3.icon;
    } else {
      acc[iconName] = icon3;
    }
    return acc;
  }, {});
}
function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);
  if (typeof namespace.hooks.addPack === "function" && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
  }
  if (prefix === "fas") {
    defineIcons("fa", icons);
  }
}
var _LONG_STYLE;
var _PREFIXES;
var _PREFIXES_FOR_FAMILY;
var styles = namespace.styles;
var shims = namespace.shims;
var LONG_STYLE = (_LONG_STYLE = {}, _defineProperty(_LONG_STYLE, FAMILY_CLASSIC, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_LONG_STYLE, FAMILY_SHARP, Object.values(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = (_PREFIXES = {}, _defineProperty(_PREFIXES, FAMILY_CLASSIC, Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES, FAMILY_SHARP, Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP])), _PREFIXES);
function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}
function getIconName(cssPrefix, cls) {
  var parts = cls.split("-");
  var prefix = parts[0];
  var iconName = parts.slice(1).join("-");
  if (prefix === cssPrefix && iconName !== "" && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build2() {
  var lookup = function lookup2(reducer) {
    return reduce(styles, function(o5, style, prefix) {
      o5[prefix] = reduce(style, reducer, {});
      return o5;
    }, {});
  };
  _byUnicode = lookup(function(acc, icon3, iconName) {
    if (icon3[3]) {
      acc[icon3[3]] = iconName;
    }
    if (icon3[2]) {
      var aliases = icon3[2].filter(function(a5) {
        return typeof a5 === "number";
      });
      aliases.forEach(function(alias) {
        acc[alias.toString(16)] = iconName;
      });
    }
    return acc;
  });
  _byLigature = lookup(function(acc, icon3, iconName) {
    acc[iconName] = iconName;
    if (icon3[2]) {
      var aliases = icon3[2].filter(function(a5) {
        return typeof a5 === "string";
      });
      aliases.forEach(function(alias) {
        acc[alias] = iconName;
      });
    }
    return acc;
  });
  _byAlias = lookup(function(acc, icon3, iconName) {
    var aliases = icon3[2];
    acc[iconName] = iconName;
    aliases.forEach(function(alias) {
      acc[alias] = iconName;
    });
    return acc;
  });
  var hasRegular = "far" in styles || config.autoFetchSvg;
  var shimLookups = reduce(shims, function(acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];
    if (prefix === "far" && !hasRegular) {
      prefix = "fas";
    }
    if (typeof maybeNameMaybeUnicode === "string") {
      acc.names[maybeNameMaybeUnicode] = {
        prefix,
        iconName
      };
    }
    if (typeof maybeNameMaybeUnicode === "number") {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix,
        iconName
      };
    }
    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault, {
    family: config.familyDefault
  });
};
onChange(function(c5) {
  _defaultUsablePrefix = getCanonicalPrefix(c5.styleDefault, {
    family: config.familyDefault
  });
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode("fas", unicode);
  return oldUnicode || (newUnicode ? {
    prefix: "fas",
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon2() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$family = params.family, family = _params$family === void 0 ? FAMILY_CLASSIC : _params$family;
  var style = PREFIX_TO_STYLE[family][styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[family][styleOrPrefix] || STYLE_TO_PREFIX[family][style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
var PREFIXES_FOR_FAMILY = (_PREFIXES_FOR_FAMILY = {}, _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_CLASSIC, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC])), _defineProperty(_PREFIXES_FOR_FAMILY, FAMILY_SHARP, Object.keys(PREFIX_TO_LONG_STYLE[FAMILY_SHARP])), _PREFIXES_FOR_FAMILY);
function getCanonicalIcon(values) {
  var _famProps;
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var famProps = (_famProps = {}, _defineProperty(_famProps, FAMILY_CLASSIC, "".concat(config.cssPrefix, "-").concat(FAMILY_CLASSIC)), _defineProperty(_famProps, FAMILY_SHARP, "".concat(config.cssPrefix, "-").concat(FAMILY_SHARP)), _famProps);
  var givenPrefix = null;
  var family = FAMILY_CLASSIC;
  if (values.includes(famProps[FAMILY_CLASSIC]) || values.some(function(v5) {
    return PREFIXES_FOR_FAMILY[FAMILY_CLASSIC].includes(v5);
  })) {
    family = FAMILY_CLASSIC;
  }
  if (values.includes(famProps[FAMILY_SHARP]) || values.some(function(v5) {
    return PREFIXES_FOR_FAMILY[FAMILY_SHARP].includes(v5);
  })) {
    family = FAMILY_SHARP;
  }
  var canonical = values.reduce(function(acc, cls) {
    var iconName = getIconName(config.cssPrefix, cls);
    if (styles[cls]) {
      cls = LONG_STYLE[family].includes(cls) ? LONG_STYLE_TO_PREFIX[family][cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES[family].indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls, {
        family
      });
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass && cls !== famProps[FAMILY_CLASSIC] && cls !== famProps[FAMILY_SHARP]) {
      acc.rest.push(cls);
    }
    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === "fa" ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);
      if (shim.prefix) {
        givenPrefix = null;
      }
      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;
      if (acc.prefix === "far" && !styles["far"] && styles["fas"] && !config.autoFetchSvg) {
        acc.prefix = "fas";
      }
    }
    return acc;
  }, emptyCanonicalIcon());
  if (values.includes("fa-brands") || values.includes("fab")) {
    canonical.prefix = "fab";
  }
  if (values.includes("fa-duotone") || values.includes("fad")) {
    canonical.prefix = "fad";
  }
  if (!canonical.prefix && family === FAMILY_SHARP && (styles["fass"] || config.autoFetchSvg)) {
    canonical.prefix = "fass";
    canonical.iconName = byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
  }
  if (canonical.prefix === "fa" || givenPrefix === "fa") {
    canonical.prefix = getDefaultUsablePrefix() || "fas";
  }
  return canonical;
}
var Library = /* @__PURE__ */ (function() {
  function Library2() {
    _classCallCheck(this, Library2);
    this.definitions = {};
  }
  _createClass(Library2, [{
    key: "add",
    value: function add() {
      var _this = this;
      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }
      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function(key) {
        _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[FAMILY_CLASSIC][key];
        if (longPrefix) defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function(key) {
        var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon3 = _normalized$key.icon;
        var aliases = icon3[2];
        if (!additions[prefix]) additions[prefix] = {};
        if (aliases.length > 0) {
          aliases.forEach(function(alias) {
            if (typeof alias === "string") {
              additions[prefix][alias] = icon3;
            }
          });
        }
        additions[prefix][iconName] = icon3;
      });
      return additions;
    }
  }]);
  return Library2;
})();
var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref2) {
  var obj = _ref2.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function(k3) {
    if (defaultProviderKeys.indexOf(k3) === -1) {
      delete providers[k3];
    }
  });
  _plugins.forEach(function(plugin) {
    var mixout8 = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout8).forEach(function(tk) {
      if (typeof mixout8[tk] === "function") {
        obj[tk] = mixout8[tk];
      }
      if (_typeof(mixout8[tk]) === "object") {
        Object.keys(mixout8[tk]).forEach(function(sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }
          obj[tk][sk] = mixout8[tk][sk];
        });
      }
    });
    if (plugin.hooks) {
      var hooks8 = plugin.hooks();
      Object.keys(hooks8).forEach(function(hook) {
        if (!_hooks[hook]) {
          _hooks[hook] = [];
        }
        _hooks[hook].push(hooks8[hook]);
      });
    }
    if (plugin.provides) {
      plugin.provides(providers);
    }
  });
  return obj;
}
function chainHooks(hook, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function(hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args));
  });
  return accumulator;
}
function callHooks(hook) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  var hookFns = _hooks[hook] || [];
  hookFns.forEach(function(hookFn) {
    hookFn.apply(null, args);
  });
  return void 0;
}
function callProvided() {
  var hook = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook] ? providers[hook].apply(null, args) : void 0;
}
function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === "fa") {
    iconLookup.prefix = "fas";
  }
  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName) return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto2() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks("noAuto");
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (IS_DOM) {
      callHooks("beforeI2svg", params);
      callProvided("pseudoElements2svg", params);
      return callProvided("i2svg", params);
    } else {
      return Promise.reject("Operation requires a DOM of some kind.");
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }
    config.observeMutations = true;
    domready(function() {
      autoReplace({
        autoReplaceSvgRoot
      });
      callHooks("watch", params);
    });
  }
};
var parse = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }
    if (_typeof(_icon) === "object" && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }
    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }
    if (typeof _icon === "string" && (_icon.indexOf("".concat(config.cssPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(" "), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }
    if (typeof _icon === "string") {
      var _prefix = getDefaultUsablePrefix();
      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto,
  config,
  dom,
  parse,
  library,
  findIconDefinition,
  toHtml
};
var autoReplace = function autoReplace2() {
  var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
    node: autoReplaceSvgRoot
  });
};
function domVariants(val, abstractCreator) {
  Object.defineProperty(val, "abstract", {
    get: abstractCreator
  });
  Object.defineProperty(val, "html", {
    get: function get2() {
      return val.abstract.map(function(a5) {
        return toHtml(a5);
      });
    }
  });
  Object.defineProperty(val, "node", {
    get: function get2() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement("div");
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}
function asIcon(_ref2) {
  var children = _ref2.children, main = _ref2.main, mask = _ref2.mask, attributes = _ref2.attributes, styles2 = _ref2.styles, transform = _ref2.transform;
  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width, height = main.height;
    var offset3 = {
      x: width / height / 2,
      y: 0.5
    };
    attributes["style"] = joinStyles(_objectSpread2(_objectSpread2({}, styles2), {}, {
      "transform-origin": "".concat(offset3.x + transform.x / 16, "em ").concat(offset3.y + transform.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes,
    children
  }];
}
function asSymbol(_ref2) {
  var prefix = _ref2.prefix, iconName = _ref2.iconName, children = _ref2.children, attributes = _ref2.attributes, symbol = _ref2.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.cssPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
        id
      }),
      children
    }]
  }];
}
function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
  var _ref2 = mask.found ? mask : main, width = _ref2.width, height = _ref2.height;
  var isUploadedIcon = prefix === "fak";
  var attrClass = [config.replacementClass, iconName ? "".concat(config.cssPrefix, "-").concat(iconName) : ""].filter(function(c5) {
    return extra.classes.indexOf(c5) === -1;
  }).filter(function(c5) {
    return c5 !== "" || !!c5;
  }).concat(extra.classes).join(" ");
  var content = {
    children: [],
    attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
      "data-prefix": prefix,
      "data-icon": iconName,
      "class": attrClass,
      "role": extra.attributes.role || "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};
  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = "";
  }
  if (title) {
    content.children.push({
      tag: "title",
      attributes: {
        id: content.attributes["aria-labelledby"] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title]
    });
    delete content.attributes.title;
  }
  var args = _objectSpread2(_objectSpread2({}, content), {}, {
    prefix,
    iconName,
    main,
    mask,
    maskId,
    transform,
    symbol,
    styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
  });
  var _ref22 = mask.found && main.found ? callProvided("generateAbstractMask", args) || {
    children: [],
    attributes: {}
  } : callProvided("generateAbstractIcon", args) || {
    children: [],
    attributes: {}
  }, children = _ref22.children, attributes = _ref22.attributes;
  args.children = children;
  args.attributes = attributes;
  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    "title": title
  } : {}), {}, {
    "class": extra.classes.join(" ")
  });
  if (watchable) {
    attributes[DATA_FA_I2SVG] = "";
  }
  var styles2 = _objectSpread2({}, extra.styles);
  if (transformIsMeaningful(transform)) {
    styles2["transform"] = transformForCss({
      transform,
      startCentered: true,
      width,
      height
    });
    styles2["-webkit-transform"] = styles2["transform"];
  }
  var styleString = joinStyles(styles2);
  if (styleString.length > 0) {
    attributes["style"] = styleString;
  }
  var val = [];
  val.push({
    tag: "span",
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: "span",
      attributes: {
        class: "sr-only"
      },
      children: [title]
    });
  }
  return val;
}
function makeLayersCounterAbstract(params) {
  var content = params.content, title = params.title, extra = params.extra;
  var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
    "title": title
  } : {}), {}, {
    "class": extra.classes.join(" ")
  });
  var styleString = joinStyles(extra.styles);
  if (styleString.length > 0) {
    attributes["style"] = styleString;
  }
  var val = [];
  val.push({
    tag: "span",
    attributes,
    children: [content]
  });
  if (title) {
    val.push({
      tag: "span",
      attributes: {
        class: "sr-only"
      },
      children: [title]
    });
  }
  return val;
}
var styles$1 = namespace.styles;
function asFoundIcon(icon3) {
  var width = icon3[0];
  var height = icon3[1];
  var _icon$slice = icon3.slice(4), _icon$slice2 = _slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
  var element = null;
  if (Array.isArray(vectorData)) {
    element = {
      tag: "g",
      attributes: {
        class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: "path",
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: "currentColor",
          d: vectorData[0]
        }
      }, {
        tag: "path",
        attributes: {
          class: "".concat(config.cssPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: "currentColor",
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: "path",
      attributes: {
        fill: "currentColor",
        d: vectorData
      }
    };
  }
  return {
    found: true,
    width,
    height,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};
function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION && !config.showMissingIcons && iconName) {
    console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
  }
}
function findIcon(iconName, prefix) {
  var givenPrefix = prefix;
  if (prefix === "fa" && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }
  return new Promise(function(resolve, reject) {
    var val = {
      found: false,
      width: 512,
      height: 512,
      icon: callProvided("missingIconAbstract") || {}
    };
    if (givenPrefix === "fa") {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }
    if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
      var icon3 = styles$1[prefix][iconName];
      return resolve(asFoundIcon(icon3));
    }
    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided("missingIconAbstract") || {} : {}
    }));
  });
}
var noop$1 = function noop3() {
};
var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = 'FA "6.3.0"';
var begin = function begin2(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function() {
    return end(name);
  };
};
var end = function end2(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};
var perf = {
  begin,
  end
};
var noop$2 = function noop4() {
};
function isWatched(node) {
  var i2svg2 = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg2 === "string";
}
function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon3 = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon3;
}
function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}
function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }
  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}
function createElementNS(tag) {
  return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function createElement3(tag) {
  return DOCUMENT.createElement(tag);
}
function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? createElementNS : createElement3 : _params$ceFn;
  if (typeof abstractObj === "string") {
    return DOCUMENT.createTextNode(abstractObj);
  }
  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function(key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function(child) {
    tag.appendChild(convertSVG(child, {
      ceFn
    }));
  });
  return tag;
}
function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  return comment;
}
var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];
    if (node.parentNode) {
      mutation[1].forEach(function(_abstract) {
        node.parentNode.insertBefore(convertSVG(_abstract), node);
      });
      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var _abstract2 = mutation[1];
    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }
    var forSvg = new RegExp("".concat(config.cssPrefix, "-.*"));
    delete _abstract2[0].attributes.id;
    if (_abstract2[0].attributes.class) {
      var splitClasses = _abstract2[0].attributes.class.split(" ").reduce(function(acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }
        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      _abstract2[0].attributes.class = splitClasses.toSvg.join(" ");
      if (splitClasses.toNode.length === 0) {
        node.removeAttribute("class");
      } else {
        node.setAttribute("class", splitClasses.toNode.join(" "));
      }
    }
    var newInnerHTML = _abstract2.map(function(a5) {
      return toHtml(a5);
    }).join("\n");
    node.setAttribute(DATA_FA_I2SVG, "");
    node.innerHTML = newInnerHTML;
  }
};
function performOperationSync(op) {
  op();
}
function perform(mutations, callback) {
  var callbackFunction = typeof callback === "function" ? callback : noop$2;
  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;
    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }
    frame(function() {
      var mutator = getMutator();
      var mark = perf.begin("mutate");
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled = false;
function disableObservation() {
  disabled = true;
}
function enableObservation() {
  disabled = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }
  if (!config.observeMutations) {
    return;
  }
  var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function(objects) {
    if (disabled) return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function(mutationRecord) {
      if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }
        treeCallback(mutationRecord.target);
      }
      if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }
      if (mutationRecord.type === "attributes" && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === "class" && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM) return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo) return;
  mo.disconnect();
}
function styleParser(node) {
  var style = node.getAttribute("style");
  var val = [];
  if (style) {
    val = style.split(";").reduce(function(acc, style2) {
      var styles2 = style2.split(":");
      var prop = styles2[0];
      var value = styles2.slice(1);
      if (prop && value.length > 0) {
        acc[prop] = value.join(":").trim();
      }
      return acc;
    }, {});
  }
  return val;
}
function classParser(node) {
  var existingPrefix = node.getAttribute("data-prefix");
  var existingIconName = node.getAttribute("data-icon");
  var innerText = node.innerText !== void 0 ? node.innerText.trim() : "";
  var val = getCanonicalIcon(classArray(node));
  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }
  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }
  if (val.iconName && val.prefix) {
    return val;
  }
  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }
  if (!val.iconName && config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) {
    val.iconName = node.firstChild.data;
  }
  return val;
}
function attributesParser(node) {
  var extraAttributes = toArray(node.attributes).reduce(function(acc, attr) {
    if (acc.name !== "class" && acc.name !== "style") {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});
  var title = node.getAttribute("title");
  var titleId = node.getAttribute("data-fa-title-id");
  if (config.autoA11y) {
    if (title) {
      extraAttributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes["aria-hidden"] = "true";
      extraAttributes["focusable"] = "false";
    }
  }
  return extraAttributes;
}
function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: true
  };
  var _classParser = classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks("parseNodeAttributes", {}, node);
  var extraStyles = parser.styleParser ? styleParser(node) : [];
  return _objectSpread2({
    iconName,
    title: node.getAttribute("title"),
    titleId: node.getAttribute("data-fa-title-id"),
    prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}
var styles$2 = namespace.styles;
function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === "nest" ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);
  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided("generateLayersText", node, nodeMeta);
  } else {
    return callProvided("generateSvgReplacementMutation", node, nodeMeta);
  }
}
var knownPrefixes = /* @__PURE__ */ new Set();
FAMILIES.map(function(family) {
  knownPrefixes.add("fa-".concat(family));
});
Object.keys(PREFIX_TO_STYLE[FAMILY_CLASSIC]).map(knownPrefixes.add.bind(knownPrefixes));
Object.keys(PREFIX_TO_STYLE[FAMILY_SHARP]).map(knownPrefixes.add.bind(knownPrefixes));
knownPrefixes = _toConsumableArray(knownPrefixes);
function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!IS_DOM) return Promise.resolve();
  var htmlClassList = DOCUMENT.documentElement.classList;
  var hclAdd = function hclAdd2(suffix) {
    return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };
  var hclRemove = function hclRemove2(suffix) {
    return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };
  var prefixes2 = config.autoFetchSvg ? knownPrefixes : FAMILIES.map(function(f5) {
    return "fa-".concat(f5);
  }).concat(Object.keys(styles$2));
  if (!prefixes2.includes("fa")) {
    prefixes2.push("fa");
  }
  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes2.map(function(p6) {
    return ".".concat(p6, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(", ");
  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }
  var candidates = [];
  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e3) {
  }
  if (candidates.length > 0) {
    hclAdd("pending");
    hclRemove("complete");
  } else {
    return Promise.resolve();
  }
  var mark = perf.begin("onTree");
  var mutations = candidates.reduce(function(acc, node) {
    try {
      var mutation = generateMutation(node);
      if (mutation) {
        acc.push(mutation);
      }
    } catch (e3) {
      if (!PRODUCTION) {
        if (e3.name === "MissingIcon") {
          console.error(e3);
        }
      }
    }
    return acc;
  }, []);
  return new Promise(function(resolve, reject) {
    Promise.all(mutations).then(function(resolvedMutations) {
      perform(resolvedMutations, function() {
        hclAdd("active");
        hclAdd("complete");
        hclRemove("pending");
        if (typeof callback === "function") callback();
        mark();
        resolve();
      });
    }).catch(function(e3) {
      mark();
      reject(e3);
    });
  });
}
function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  generateMutation(node).then(function(mutation) {
    if (mutation) {
      perform([mutation], callback);
    }
  });
}
function resolveIcons(next) {
  return function(maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;
    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }
    return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
      mask
    }));
  };
}
var render = function render2(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon3 = iconDefinition.icon;
  return domVariants(_objectSpread2({
    type: "icon"
  }, iconDefinition), function() {
    callHooks("beforeDOMElementCreation", {
      iconDefinition,
      params
    });
    if (config.autoA11y) {
      if (title) {
        attributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes["aria-hidden"] = "true";
        attributes["focusable"] = "false";
      }
    }
    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon3),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix,
      iconName,
      transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
      symbol,
      title,
      maskId,
      titleId,
      extra: {
        attributes,
        styles: styles2,
        classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout2() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks2() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function(params) {
      var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {
      } : _params$callback;
      return onTree(node, callback);
    };
    providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
      var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
      return new Promise(function(resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(_ref2) {
          var _ref22 = _slicedToArray(_ref2, 2), main = _ref22[0], mask2 = _ref22[1];
          resolve([node, makeInlineSvgAbstract({
            icons: {
              main,
              mask: mask2
            },
            prefix,
            iconName,
            transform,
            symbol,
            maskId,
            title,
            titleId,
            extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };
    providers$$1.generateAbstractIcon = function(_ref3) {
      var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles2 = _ref3.styles;
      var styleString = joinStyles(styles2);
      if (styleString.length > 0) {
        attributes["style"] = styleString;
      }
      var nextChild;
      if (transformIsMeaningful(transform)) {
        nextChild = callProvided("generateAbstractTransformGrouping", {
          main,
          transform,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }
      children.push(nextChild || main.icon);
      return {
        children,
        attributes
      };
    };
  }
};
var Layers = {
  mixout: function mixout3() {
    return {
      layer: function layer2(assembler) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: "layer"
        }, function() {
          callHooks("beforeDOMElementCreation", {
            assembler,
            params
          });
          var children = [];
          assembler(function(args) {
            Array.isArray(args) ? args.map(function(a5) {
              children = children.concat(a5.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: "span",
            attributes: {
              class: ["".concat(config.cssPrefix, "-layers")].concat(_toConsumableArray(classes)).join(" ")
            },
            children
          }];
        });
      }
    };
  }
};
var LayersCounter = {
  mixout: function mixout4() {
    return {
      counter: function counter2(content) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: "counter",
          content
        }, function() {
          callHooks("beforeDOMElementCreation", {
            content,
            params
          });
          return makeLayersCounterAbstract({
            content: content.toString(),
            title,
            extra: {
              attributes,
              styles: styles2,
              classes: ["".concat(config.cssPrefix, "-layers-counter")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  }
};
var LayersText = {
  mixout: function mixout5() {
    return {
      text: function text2(content) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: "text",
          content
        }, function() {
          callHooks("beforeDOMElementCreation", {
            content,
            params
          });
          return makeLayersTextAbstract({
            content,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            title,
            extra: {
              attributes,
              styles: styles2,
              classes: ["".concat(config.cssPrefix, "-layers-text")].concat(_toConsumableArray(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides2(providers$$1) {
    providers$$1.generateLayersText = function(node, nodeMeta) {
      var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
      var width = null;
      var height = null;
      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width = boundingClientRect.width / computedFontSize;
        height = boundingClientRect.height / computedFontSize;
      }
      if (config.autoA11y && !title) {
        extra.attributes["aria-hidden"] = "true";
      }
      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width,
        height,
        transform,
        title,
        extra,
        watchable: true
      })]);
    };
  }
};
var CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content) {
  var cleaned = content.replace(CLEAN_CONTENT_PATTERN, "");
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}
function replaceForPosition(node, position) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
  return new Promise(function(resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      return resolve();
    }
    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function(c5) {
      return c5.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
    })[0];
    var styles2 = WINDOW.getComputedStyle(node, position);
    var fontFamily = styles2.getPropertyValue("font-family").match(FONT_FAMILY_PATTERN);
    var fontWeight = styles2.getPropertyValue("font-weight");
    var content = styles2.getPropertyValue("content");
    if (alreadyProcessedPseudoElement && !fontFamily) {
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content !== "none" && content !== "") {
      var _content = styles2.getPropertyValue("content");
      var family = ~["Sharp"].indexOf(fontFamily[2]) ? FAMILY_SHARP : FAMILY_CLASSIC;
      var prefix = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[family][fontWeight];
      var _hexValueFromContent = hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
      var isV4 = fontFamily[0].startsWith("FontAwesome");
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;
      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);
        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      }
      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);
        if (alreadyProcessedPseudoElement) {
          node.removeChild(alreadyProcessedPseudoElement);
        }
        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
        findIcon(iconName, prefix).then(function(main) {
          var _abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
            icons: {
              main,
              mask: emptyCanonicalIcon()
            },
            prefix,
            iconName: iconIdentifier,
            extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement("svg");
          if (position === "::before") {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }
          element.outerHTML = _abstract.map(function(a5) {
            return toHtml(a5);
          }).join("\n");
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}
function replace2(node) {
  return Promise.all([replaceForPosition(node, "::before"), replaceForPosition(node, "::after")]);
}
function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function searchPseudoElements(root) {
  if (!IS_DOM) return;
  return new Promise(function(resolve, reject) {
    var operations = toArray(root.querySelectorAll("*")).filter(processable).map(replace2);
    var end3 = perf.begin("searchPseudoElements");
    disableObservation();
    Promise.all(operations).then(function() {
      end3();
      enableObservation();
      resolve();
    }).catch(function() {
      end3();
      enableObservation();
      reject();
    });
  });
}
var PseudoElements = {
  hooks: function hooks3() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides3(providers$$1) {
    providers$$1.pseudoElements2svg = function(params) {
      var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node;
      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};
var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout6() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks4() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks("mutationObserverCallbacks", {}));
      },
      noAuto: function noAuto3() {
        disconnect();
      },
      watch: function watch2(params) {
        var observeMutationsRoot = params.observeMutationsRoot;
        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks("mutationObserverCallbacks", {
            observeMutationsRoot
          }));
        }
      }
    };
  }
};
var parseTransformString = function parseTransformString2(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(" ").reduce(function(acc, n5) {
    var parts = n5.toLowerCase().split("-");
    var first = parts[0];
    var rest = parts.slice(1).join("-");
    if (first && rest === "h") {
      acc.flipX = true;
      return acc;
    }
    if (first && rest === "v") {
      acc.flipY = true;
      return acc;
    }
    rest = parseFloat(rest);
    if (isNaN(rest)) {
      return acc;
    }
    switch (first) {
      case "grow":
        acc.size = acc.size + rest;
        break;
      case "shrink":
        acc.size = acc.size - rest;
        break;
      case "left":
        acc.x = acc.x - rest;
        break;
      case "right":
        acc.x = acc.x + rest;
        break;
      case "up":
        acc.y = acc.y - rest;
        break;
      case "down":
        acc.y = acc.y + rest;
        break;
      case "rotate":
        acc.rotate = acc.rotate + rest;
        break;
    }
    return acc;
  }, transform);
};
var PowerTransforms = {
  mixout: function mixout7() {
    return {
      parse: {
        transform: function transform(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks5() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute("data-fa-transform");
        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }
        return accumulator;
      }
    };
  },
  provides: function provides4(providers2) {
    providers2.generateAbstractTransformGrouping = function(_ref2) {
      var main = _ref2.main, transform = _ref2.transform, containerWidth = _ref2.containerWidth, iconWidth = _ref2.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
      var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
      var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer,
        inner,
        path
      };
      return {
        tag: "g",
        attributes: _objectSpread2({}, operations.outer),
        children: [{
          tag: "g",
          attributes: _objectSpread2({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};
var ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(_abstract) {
  var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (_abstract.attributes && (_abstract.attributes.fill || force)) {
    _abstract.attributes.fill = "black";
  }
  return _abstract;
}
function deGroup(_abstract2) {
  if (_abstract2.tag === "g") {
    return _abstract2.children;
  } else {
    return [_abstract2];
  }
}
var Masks = {
  hooks: function hooks6() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute("data-fa-mask");
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(" ").map(function(i5) {
          return i5.trim();
        }));
        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }
        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute("data-fa-mask-id");
        return accumulator;
      }
    };
  },
  provides: function provides5(providers2) {
    providers2.generateAbstractMask = function(_ref2) {
      var children = _ref2.children, attributes = _ref2.attributes, main = _ref2.main, mask = _ref2.mask, explicitMaskId = _ref2.maskId, transform = _ref2.transform;
      var mainWidth = main.width, mainPath = main.icon;
      var maskWidth = mask.width, maskPath = mask.icon;
      var trans = transformForSvg({
        transform,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: "rect",
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          fill: "white"
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: "g",
        attributes: _objectSpread2({}, trans.inner),
        children: [fillBlack(_objectSpread2({
          tag: mainPath.tag,
          attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: "g",
        attributes: _objectSpread2({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: "mask",
        attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: "rect",
        attributes: _objectSpread2({
          fill: "currentColor",
          "clip-path": "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children,
        attributes
      };
    };
  }
};
var MissingIconIndicator = {
  provides: function provides6(providers2) {
    var reduceMotion = false;
    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    providers2.missingIconAbstract = function() {
      var gChildren = [];
      var FILL = {
        fill: "currentColor"
      };
      var ANIMATION_BASE = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      gChildren.push({
        tag: "path",
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
        attributeName: "opacity"
      });
      var dot = {
        tag: "circle",
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      if (!reduceMotion) {
        dot.children.push({
          tag: "animate",
          attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
            attributeName: "r",
            values: "28;14;28;28;14;28;"
          })
        }, {
          tag: "animate",
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: "1;0;1;1;0;1;"
          })
        });
      }
      gChildren.push(dot);
      gChildren.push({
        tag: "path",
        attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: reduceMotion ? [] : [{
          tag: "animate",
          attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      });
      if (!reduceMotion) {
        gChildren.push({
          tag: "path",
          attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
            opacity: "0",
            d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
          }),
          children: [{
            tag: "animate",
            attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
              values: "0;0;1;1;0;0;"
            })
          }]
        });
      }
      return {
        tag: "g",
        attributes: {
          "class": "missing"
        },
        children: gChildren
      };
    };
  }
};
var SvgSymbols = {
  hooks: function hooks7() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute("data-fa-symbol");
        var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
        accumulator["symbol"] = symbol;
        return accumulator;
      }
    };
  }
};
var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];
registerPlugins(plugins, {
  mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon2 = api.icon;
var layer = api.layer;
var text = api.text;
var counter = api.counter;

// ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var import_prop_types = __toESM(require_prop_types());
import React from "react";
function ownKeys2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread22(target) {
  for (var i5 = 1; i5 < arguments.length; i5++) {
    var source = null != arguments[i5] ? arguments[i5] : {};
    i5 % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
      _defineProperty2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof2(obj) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof2(obj);
}
function _defineProperty2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i5;
  for (i5 = 0; i5 < sourceKeys.length; i5++) {
    key = sourceKeys[i5];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i5;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i5 = 0; i5 < sourceSymbolKeys.length; i5++) {
      key = sourceSymbolKeys[i5];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toConsumableArray2(arr) {
  return _arrayWithoutHoles2(arr) || _iterableToArray2(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread2();
}
function _arrayWithoutHoles2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray2(arr);
}
function _iterableToArray2(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray2(o5, minLen) {
  if (!o5) return;
  if (typeof o5 === "string") return _arrayLikeToArray2(o5, minLen);
  var n5 = Object.prototype.toString.call(o5).slice(8, -1);
  if (n5 === "Object" && o5.constructor) n5 = o5.constructor.name;
  if (n5 === "Map" || n5 === "Set") return Array.from(o5);
  if (n5 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n5)) return _arrayLikeToArray2(o5, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i5 = 0, arr2 = new Array(len); i5 < len; i5++) arr2[i5] = arr[i5];
  return arr2;
}
function _nonIterableSpread2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function classList(props) {
  var _classes;
  var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip3 = props.flip, size3 = props.size, rotation = props.rotation, pull = props.pull;
  var classes = (_classes = {
    "fa-beat": beat,
    "fa-fade": fade,
    "fa-beat-fade": beatFade,
    "fa-bounce": bounce,
    "fa-shake": shake,
    "fa-flash": flash,
    "fa-spin": spin,
    "fa-spin-reverse": spinReverse,
    "fa-spin-pulse": spinPulse,
    "fa-pulse": pulse,
    "fa-fw": fixedWidth,
    "fa-inverse": inverse,
    "fa-border": border,
    "fa-li": listItem,
    "fa-flip": flip3 === true,
    "fa-flip-horizontal": flip3 === "horizontal" || flip3 === "both",
    "fa-flip-vertical": flip3 === "vertical" || flip3 === "both"
  }, _defineProperty2(_classes, "fa-".concat(size3), typeof size3 !== "undefined" && size3 !== null), _defineProperty2(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), _defineProperty2(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), _defineProperty2(_classes, "fa-swap-opacity", props.swapOpacity), _classes);
  return Object.keys(classes).map(function(key) {
    return classes[key] ? key : null;
  }).filter(function(key) {
    return key;
  });
}
function _isNumerical(obj) {
  obj = obj - 0;
  return obj === obj;
}
function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  }
  string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
    return chr ? chr.toUpperCase() : "";
  });
  return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var _excluded = ["style"];
function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}
function styleToObject(style) {
  return style.split(";").map(function(s5) {
    return s5.trim();
  }).filter(function(s5) {
    return s5;
  }).reduce(function(acc, pair) {
    var i5 = pair.indexOf(":");
    var prop = camelize(pair.slice(0, i5));
    var value = pair.slice(i5 + 1).trim();
    prop.startsWith("webkit") ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}
function convert(createElement10, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof element === "string") {
    return element;
  }
  var children = (element.children || []).map(function(child) {
    return convert(createElement10, child);
  });
  var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
    var val = element.attributes[key];
    switch (key) {
      case "class":
        acc.attrs["className"] = val;
        delete element.attributes["class"];
        break;
      case "style":
        acc.attrs["style"] = styleToObject(val);
        break;
      default:
        if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }
    }
    return acc;
  }, {
    attrs: {}
  });
  var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = _objectWithoutProperties(extraProps, _excluded);
  mixins.attrs["style"] = _objectSpread22(_objectSpread22({}, mixins.attrs["style"]), existingStyle);
  return createElement10.apply(void 0, [element.tag, _objectSpread22(_objectSpread22({}, mixins.attrs), remaining)].concat(_toConsumableArray2(children)));
}
var PRODUCTION2 = false;
try {
  PRODUCTION2 = false;
} catch (e3) {
}
function log() {
  if (!PRODUCTION2 && console && typeof console.error === "function") {
    var _console;
    (_console = console).error.apply(_console, arguments);
  }
}
function normalizeIconArgs(icon3) {
  if (icon3 && _typeof2(icon3) === "object" && icon3.prefix && icon3.iconName && icon3.icon) {
    return icon3;
  }
  if (parse$1.icon) {
    return parse$1.icon(icon3);
  }
  if (icon3 === null) {
    return null;
  }
  if (icon3 && _typeof2(icon3) === "object" && icon3.prefix && icon3.iconName) {
    return icon3;
  }
  if (Array.isArray(icon3) && icon3.length === 2) {
    return {
      prefix: icon3[0],
      iconName: icon3[1]
    };
  }
  if (typeof icon3 === "string") {
    return {
      prefix: "fas",
      iconName: icon3
    };
  }
}
function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty2({}, key, value) : {};
}
var FontAwesomeIcon = /* @__PURE__ */ React.forwardRef(function(props, ref) {
  var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey("classes", [].concat(_toConsumableArray2(classList(props)), _toConsumableArray2(className.split(" "))));
  var transform = objectWithKey("transform", typeof props.transform === "string" ? parse$1.transform(props.transform) : props.transform);
  var mask = objectWithKey("mask", normalizeIconArgs(maskArgs));
  var renderedIcon = icon2(iconLookup, _objectSpread22(_objectSpread22(_objectSpread22(_objectSpread22({}, classes), transform), mask), {}, {
    symbol,
    title,
    titleId,
    maskId
  }));
  if (!renderedIcon) {
    log("Could not find icon", iconLookup);
    return null;
  }
  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref
  };
  Object.keys(props).forEach(function(key) {
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
});
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: import_prop_types.default.bool,
  border: import_prop_types.default.bool,
  beatFade: import_prop_types.default.bool,
  bounce: import_prop_types.default.bool,
  className: import_prop_types.default.string,
  fade: import_prop_types.default.bool,
  flash: import_prop_types.default.bool,
  mask: import_prop_types.default.oneOfType([import_prop_types.default.object, import_prop_types.default.array, import_prop_types.default.string]),
  maskId: import_prop_types.default.string,
  fixedWidth: import_prop_types.default.bool,
  inverse: import_prop_types.default.bool,
  flip: import_prop_types.default.oneOf([true, false, "horizontal", "vertical", "both"]),
  icon: import_prop_types.default.oneOfType([import_prop_types.default.object, import_prop_types.default.array, import_prop_types.default.string]),
  listItem: import_prop_types.default.bool,
  pull: import_prop_types.default.oneOf(["right", "left"]),
  pulse: import_prop_types.default.bool,
  rotation: import_prop_types.default.oneOf([0, 90, 180, 270]),
  shake: import_prop_types.default.bool,
  size: import_prop_types.default.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: import_prop_types.default.bool,
  spinPulse: import_prop_types.default.bool,
  spinReverse: import_prop_types.default.bool,
  symbol: import_prop_types.default.oneOfType([import_prop_types.default.bool, import_prop_types.default.string]),
  title: import_prop_types.default.string,
  titleId: import_prop_types.default.string,
  transform: import_prop_types.default.oneOfType([import_prop_types.default.string, import_prop_types.default.object]),
  swapOpacity: import_prop_types.default.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: false,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  spinPulse: false,
  spinReverse: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React.createElement);

// src/components/Accordion/Accordion.tsx
var import_faCaretDown = __toESM(require_faCaretDown());

// ../../node_modules/clsx/dist/clsx.mjs
function r(e3) {
  var t3, f5, n5 = "";
  if ("string" == typeof e3 || "number" == typeof e3) n5 += e3;
  else if ("object" == typeof e3) if (Array.isArray(e3)) {
    var o5 = e3.length;
    for (t3 = 0; t3 < o5; t3++) e3[t3] && (f5 = r(e3[t3])) && (n5 && (n5 += " "), n5 += f5);
  } else for (f5 in e3) e3[f5] && (n5 && (n5 += " "), n5 += f5);
  return n5;
}
function clsx() {
  for (var e3, t3, f5 = 0, n5 = "", o5 = arguments.length; f5 < o5; f5++) (e3 = arguments[f5]) && (t3 = r(e3)) && (n5 && (n5 += " "), n5 += t3);
  return n5;
}

// src/lib/utils.ts
import { twMerge } from "tailwind-merge";
var PREFLIGHT_CLASS = "sb-preflight";
function cn(...inputs) {
  return twMerge(PREFLIGHT_CLASS, clsx(inputs));
}

// src/components/Accordion/Accordion.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Accordion = React2.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  $1bf158f521e1b1b4$export$be92b6f5f03c0fe9,
  {
    ref,
    className: cn(
      // Appearance
      "bg-neutral-0",
      className
    ),
    ...props
  }
));
Accordion.displayName = "Accordion";
var AccordionItem = React2.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  $1bf158f521e1b1b4$export$6d08773d2e66f8f2,
  {
    ref,
    className: cn(
      // Borders
      "border-b-neutral-2 border-b",
      className
    ),
    ...props
  }
));
AccordionItem.displayName = "AccordionItem";
var AccordionTrigger = React2.forwardRef(({ className, children, actions, ...props }, ref) => /* @__PURE__ */ jsxs(
  $1bf158f521e1b1b4$export$8b251419efc915eb,
  {
    className: cn(
      // Layout
      "flex"
    ),
    children: [
      /* @__PURE__ */ jsx(
        $1bf158f521e1b1b4$export$41fb9f06171c75f4,
        {
          ref,
          className: cn(
            // Layout
            "group flex flex-1 items-center justify-between",
            // Spacing
            "px-2 py-2 pr-1",
            // Typography
            "font-lato text-neutral-1 text-left text-sm font-bold",
            // Interactions
            "cursor-pointer transition-all",
            // Disabled state
            "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50",
            className
          ),
          ...props,
          children: /* @__PURE__ */ jsx("div", { className: "flex-1", children })
        }
      ),
      actions && /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            // Layout
            "flex items-center",
            // Spacing
            "gap-3"
          ),
          children: actions
        }
      ),
      /* @__PURE__ */ jsx(
        $1bf158f521e1b1b4$export$41fb9f06171c75f4,
        {
          ref,
          className: cn(
            // Layout
            "group",
            // Spacing
            "px-1 py-2",
            // Interactions
            "cursor-pointer",
            // Disabled state
            "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50"
          ),
          "aria-label": "Toggle accordion caret",
          children: /* @__PURE__ */ jsx(
            FontAwesomeIcon,
            {
              icon: import_faCaretDown.faCaretDown,
              className: cn(
                // Typography
                "text-neutral-4 text-sm",
                // Interactions
                "transition-transform duration-200",
                // Open state
                "group-data-[state=open]:rotate-[-180deg]"
              )
            }
          )
        }
      )
    ]
  }
));
AccordionTrigger.displayName = $1bf158f521e1b1b4$export$41fb9f06171c75f4.displayName;
var AccordionContent = React2.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsx(
  $1bf158f521e1b1b4$export$7c6e2c02157bb7d2,
  {
    ref,
    className: cn(
      // Layout
      "overflow-hidden",
      // Typography
      "text-neutral-1 text-sm",
      // Animations
      "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
      className
    ),
    ...props,
    children: /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          // Spacing
          "px-2 pb-4 pt-2",
          className
        ),
        children
      }
    )
  }
));
AccordionContent.displayName = $1bf158f521e1b1b4$export$7c6e2c02157bb7d2.displayName;

// src/components/Alert/Alert.tsx
import { cva } from "class-variance-authority";
import { jsx as jsx2 } from "react/jsx-runtime";
var alertVariants = cva(
  [
    // Layout
    "relative grid w-full items-start",
    "grid-cols-[0_1fr] has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr]",
    // Spacing
    "gap-y-2 has-[>svg]:gap-x-2 p-3",
    // Appearance
    "rounded-md border-1",
    // Typography
    "text-sm",
    // SVG styles (translate-y-1 only when title is present to align with text)
    "[&>svg]:size-4 [&>svg]:text-current has-[>*[data-slot=alert-title]]:[&>svg]:translate-y-1",
    // Button alignment
    "[&>button]:col-start-2 [&>button]:justify-self-end"
  ],
  {
    variants: {
      variant: {
        neutral: "bg-neutral-1 text-neutral-1 border-neutral-1 *:data-[slot=alert-description]:text-neutral-3",
        info: "bg-info-1 text-info-1 border-info-1",
        error: "bg-destructive-3 text-destructive-3 border-destructive-3",
        warning: "bg-alert-1 text-alert-2 border-alert-1"
      }
    },
    defaultVariants: {
      variant: "neutral"
    }
  }
);
function Alert({
  className,
  variant,
  ...props
}) {
  return /* @__PURE__ */ jsx2(
    "div",
    {
      "data-slot": "alert",
      role: "alert",
      className: cn(alertVariants({ variant }), className),
      ...props
    }
  );
}
function AlertTitle({ className, ...props }) {
  return /* @__PURE__ */ jsx2(
    "div",
    {
      "data-slot": "alert-title",
      className: cn(
        // Layout
        "col-start-2",
        // Sizing
        "min-h-4",
        // Typography
        "line-clamp-1 font-semibold",
        className
      ),
      ...props
    }
  );
}
function AlertDescription({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx2(
    "div",
    {
      "data-slot": "alert-description",
      className: cn(
        // Layout
        "col-start-2 grid justify-items-start gap-1",
        // Typography
        "text-xs",
        className
      ),
      ...props
    }
  );
}

// src/components/Button/Button.tsx
import * as React3 from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva as cva2 } from "class-variance-authority";

// src/shared/props.ts
var DEFAULT_COMPONENT_SIZE = "medium";

// src/components/Button/Button.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var buttonVariants = cva2(
  [
    // Layout
    "inline-flex items-center justify-center shrink-0",
    // Sizing
    "w-min",
    // Spacing
    "gap-2",
    // Appearance
    "rounded-md",
    // Typography
    "whitespace-nowrap font-lato text-xs font-semibold",
    // Interactions
    "cursor-pointer transition-all",
    // Focus state
    "outline-none ring-offset-transparent focus-visible:ring-2 focus-visible:ring-[var(--border-focus-ring)]",
    // Disabled state
    "disabled:cursor-not-allowed disabled:opacity-50",
    // SVG styles
    "[&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0"
  ],
  {
    variants: {
      variant: {
        neutral: "bg-neutral-1 text-neutral-1 border-1 border-neutral-1 hover:bg-neutral-2 hover:border-neutral-4 focus-visible:bg-neutral-2 focus-visible:border-neutral-4 data-[state=hover]:bg-neutral-2 data-[state=hover]:border-neutral-4 disabled:bg-neutral-0 disabled:border-neutral-4",
        primary: "bg-brand-1 text-highlight-2 hover:bg-brand-2 data-[state=hover]:bg-brand-2 disabled:bg-neutral-3",
        outline: "bg-transparent text-highlight-1 border-1 border-highlight-3 hover:bg-highlight-2 focus-visible:bg-highlight-2 data-[state=hover]:bg-highlight-2 disabled:border-neutral-3 disabled:text-neutral-4",
        ghost: "focus-visible:bg-highlight-3 hover:bg-highlight-3 text-neutral-1 data-[state=hover]:bg-highlight-3 disabled:bg-transparent disabled:text-neutral-4"
      },
      size: {
        small: "px-4 py-2 h-8 max-h-8 [&>svg]:!w-[14px] [&>svg]:!h-[14px] text-xs",
        medium: "px-4 py-3 h-10 max-h-10 [&>svg]:!w-[16px] [&>svg]:!h-[16px] text-sm",
        large: "px-6 py-3 h-12 max-h-12 [&>svg]:!w-[16px] [&>svg]:!h-[16px] text-sm"
      },
      modifier: {
        default: "",
        icon: "",
        destructive: ""
      },
      active: {
        true: "",
        false: ""
      },
      loading: {
        true: "opacity-85 pointer-events-none",
        false: ""
      },
      fullWidth: {
        true: "w-full",
        false: ""
      }
    },
    defaultVariants: {
      variant: "neutral",
      modifier: "default",
      size: DEFAULT_COMPONENT_SIZE,
      active: false,
      loading: false
    },
    compoundVariants: [
      {
        modifier: "icon",
        size: "small",
        class: "p-2"
      },
      {
        modifier: "icon",
        size: "medium",
        class: "p-3"
      },
      {
        modifier: "icon",
        size: "large",
        class: "px-4 py-3"
      },
      {
        variant: "ghost",
        class: "bg-transparent"
      },
      {
        variant: "ghost",
        active: true,
        class: "bg-highlight-4"
      },
      {
        variant: "ghost",
        modifier: "destructive",
        active: true,
        class: "bg-transparent"
      },
      {
        variant: "ghost",
        modifier: "destructive",
        class: "text-destructive-1 hover:bg-destructive-3 focus-visible:bg-destructive-3 data-[state=hover]:bg-destructive-3 disabled:bg-transparent disabled:text-neutral-4"
      },
      {
        variant: "neutral",
        active: true,
        class: "bg-neutral-1 border-neutral-4"
      },
      {
        variant: "primary",
        modifier: "destructive",
        class: "bg-destructive-1 hover:bg-destructive-2 focus-visible:bg-destructive-2 data-[state=hover]:bg-destructive-2 disabled:bg-neutral-3"
      },
      {
        variant: "outline",
        active: true,
        class: "bg-highlight-4"
      },
      {
        variant: "outline",
        modifier: "destructive",
        class: "border-destructive-1 hover:border-destructive-2 hover:bg-destructive-3 text-destructive-1 focus-visible:bg-destructive-3 focus-visible:border-destructive-2 data-[state=hover]:border-destructive-2 data-[state=hover]:bg-destructive-3 disabled:border-neutral-3 disabled:text-neutral-4"
      },
      {
        variant: "outline",
        modifier: "destructive",
        active: true,
        class: "bg-transparent"
      }
    ]
  }
);
var Button = React3.forwardRef(
  ({
    className,
    variant,
    size: size3 = DEFAULT_COMPONENT_SIZE,
    asChild = false,
    modifier,
    active,
    disabled: disabled2,
    loading,
    fullWidth,
    "data-state": dataState,
    ...props
  }, ref) => {
    const Comp = asChild ? Slot : "button";
    return /* @__PURE__ */ jsx3(
      Comp,
      {
        "data-slot": "button",
        "data-state": dataState,
        className: cn(
          buttonVariants({
            variant,
            size: size3,
            modifier,
            active,
            className,
            loading,
            fullWidth
          })
        ),
        disabled: disabled2,
        ref,
        ...props
      }
    );
  }
);
Button.displayName = "Button";

// src/components/ButtonGroup/ButtonGroup.tsx
import { Slot as Slot2 } from "@radix-ui/react-slot";
import { cva as cva4 } from "class-variance-authority";

// src/components/Separator/Separator.tsx
import * as React4 from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import { cva as cva3 } from "class-variance-authority";
import { jsx as jsx4 } from "react/jsx-runtime";
var separatorVariants = cva3(
  [
    // Appearance
    "shrink-0 bg-neutral-2"
  ],
  {
    variants: {
      orientation: {
        horizontal: "h-px w-full",
        vertical: "h-full w-px"
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
);
var Separator = React4.forwardRef(
  ({ className, orientation = "horizontal", decorative = true, ...props }, ref) => /* @__PURE__ */ jsx4(
    SeparatorPrimitive.Root,
    {
      ref,
      decorative,
      orientation,
      className: cn(separatorVariants({ orientation }), className),
      ...props
    }
  )
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

// src/components/ButtonGroup/ButtonGroup.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var buttonGroupVariants = cva4(
  [
    // Layout
    "flex w-fit items-stretch",
    // Focus management
    "[&>*]:focus-visible:z-10 [&>*]:focus-visible:relative",
    // Select trigger width handling
    "[&>[data-slot=select-trigger]:not([class*='w-'])]:w-fit",
    // Input flex
    "[&>input]:flex-1",
    // Select visibility handling
    "has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-md",
    // Nested button group gap
    "has-[>[data-slot=button-group]]:gap-2"
  ],
  {
    variants: {
      orientation: {
        horizontal: "[&>*:not(:first-child)]:rounded-l-none [&>*:not(:first-child)]:border-l-0 [&>*:not(:last-child)]:rounded-r-none",
        vertical: "flex-col [&>*:not(:first-child)]:rounded-t-none [&>*:not(:first-child)]:border-t-0 [&>*:not(:last-child)]:rounded-b-none"
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
);
function ButtonGroup({
  className,
  orientation = "horizontal",
  ...props
}) {
  return /* @__PURE__ */ jsx5(
    "div",
    {
      role: "group",
      "data-slot": "button-group",
      "data-orientation": orientation,
      className: cn(buttonGroupVariants({ orientation }), className),
      ...props
    }
  );
}
function ButtonGroupText({
  className,
  asChild = false,
  ...props
}) {
  const Comp = asChild ? Slot2 : "div";
  return /* @__PURE__ */ jsx5(
    Comp,
    {
      className: cn(
        // Layout
        "flex items-center gap-2",
        // Appearance
        "bg-neutral-1 border-1 border-neutral-2 rounded-md",
        // Spacing
        "px-4",
        // Typography
        "text-neutral-1 text-sm font-medium",
        // Shadow
        "shadow-xs",
        // SVG styles
        "[&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none",
        className
      ),
      ...props
    }
  );
}
function ButtonGroupSeparator({
  className,
  orientation = "vertical",
  ...props
}) {
  return /* @__PURE__ */ jsx5(
    Separator,
    {
      "data-slot": "button-group-separator",
      orientation,
      className: cn(
        // Appearance
        "bg-neutral-2",
        // Spacing
        "relative !m-0 self-stretch",
        // Orientation-based height
        "data-[orientation=vertical]:h-auto",
        className
      ),
      ...props
    }
  );
}

// src/components/ColorPicker/ColorPicker.tsx
import { useState as useState20, useEffect as useEffect20, forwardRef as forwardRef11 } from "react";

// node_modules/@radix-ui/react-portal/dist/index.mjs
import * as React7 from "react";
import ReactDOM2 from "react-dom";

// node_modules/@radix-ui/react-primitive/dist/index.mjs
import * as React5 from "react";
import * as ReactDOM from "react-dom";
import { createSlot } from "@radix-ui/react-slot";
import { jsx as jsx6 } from "react/jsx-runtime";
var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node) => {
  const Slot4 = createSlot(`Primitive.${node}`);
  const Node2 = React5.forwardRef((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? Slot4 : node;
    if (typeof window !== "undefined") {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ jsx6(Comp, { ...primitiveProps, ref: forwardedRef });
  });
  Node2.displayName = `Primitive.${node}`;
  return { ...primitive, [node]: Node2 };
}, {});

// node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
import * as React6 from "react";
var useLayoutEffect2 = globalThis?.document ? React6.useLayoutEffect : () => {
};

// node_modules/@radix-ui/react-portal/dist/index.mjs
import { jsx as jsx7 } from "react/jsx-runtime";
var PORTAL_NAME = "Portal";
var Portal = React7.forwardRef((props, forwardedRef) => {
  const { container: containerProp, ...portalProps } = props;
  const [mounted, setMounted] = React7.useState(false);
  useLayoutEffect2(() => setMounted(true), []);
  const container = containerProp || mounted && globalThis?.document?.body;
  return container ? ReactDOM2.createPortal(/* @__PURE__ */ jsx7(Primitive.div, { ...portalProps, ref: forwardedRef }), container) : null;
});
Portal.displayName = PORTAL_NAME;

// src/components/FloatingPanel/FloatingPanel.tsx
var import_faAngleRight = __toESM(require_faAngleRight());
var import_faAngleLeft = __toESM(require_faAngleLeft());
import React11, { useEffect as useEffect10, useState as useState9, useCallback as useCallback4 } from "react";
import { Presence } from "@radix-ui/react-presence";

// src/hooks/use-floating-window/use-floating-window.ts
import { useState as useState6, useEffect as useEffect6, useRef as useRef4 } from "react";

// ../../node_modules/@floating-ui/react/dist/floating-ui.react.esm.js
import * as React9 from "react";
import { useLayoutEffect as useLayoutEffect4, useEffect as useEffect5, useRef as useRef3 } from "react";

// ../../node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x5) {
    return Boolean(x5);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        try {
          var attr = node.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node) || 0) + 1;
          var markerValue = (markerCounter.get(node) || 0) + 1;
          counterMap.set(node, counterValue);
          markerCounter.set(node, markerValue);
          hiddenNodes.push(node);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node, true);
          }
          if (markerValue === 1) {
            node.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node.setAttribute(controlAttribute, "true");
          }
        } catch (e3) {
          console.error("aria-hidden: cannot operate on ", node, e3);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live], script")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};

// ../../node_modules/@floating-ui/react/dist/floating-ui.react.esm.js
import { createPortal, flushSync as flushSync3 } from "react-dom";

// ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var sides = ["top", "right", "bottom", "left"];
var alignments = ["start", "end"];
var placements = /* @__PURE__ */ sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = (v5) => ({
  x: v5,
  y: v5
});
var oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
var oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end3) {
  return max(start, min(value, end3));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
var yAxisSides = /* @__PURE__ */ new Set(["top", "bottom"]);
function getSideAxis(placement) {
  return yAxisSides.has(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
var lrPlacement = ["left", "right"];
var rlPlacement = ["right", "left"];
var tbPlacement = ["top", "bottom"];
var btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x5,
    y: y5,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y5,
    left: x5,
    right: x5 + width,
    bottom: y5 + height,
    x: x5,
    y: y5
  };
}

// ../../node_modules/@floating-ui/react/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref2, placement, rtl) {
  let {
    reference,
    floating
  } = _ref2;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
var computePosition = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x5,
    y: y5
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i5 = 0; i5 < validMiddleware.length; i5++) {
    const {
      name,
      fn
    } = validMiddleware[i5];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x: x5,
      y: y5,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x5 = nextX != null ? nextX : x5;
    y5 = nextY != null ? nextY : y5;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x5,
          y: y5
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i5 = -1;
    }
  }
  return {
    x: x5,
    y: y5,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x5,
    y: y5,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x5,
    y: y5,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter((placement) => getAlignment(placement) === alignment), ...allowedPlacements.filter((placement) => getAlignment(placement) !== alignment)] : allowedPlacements.filter((placement) => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter((placement) => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
var autoPlacement = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "autoPlacement",
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform: platform2,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== void 0 || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)));
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [], {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map((d6) => {
        const alignment2 = getAlignment(d6.placement);
        return [d6.placement, alignment2 && crossAxis ? (
          // Check along the mainAxis and main crossAxis side.
          d6.overflows.slice(0, 2).reduce((acc, v5) => acc + v5, 0)
        ) : (
          // Check only the mainAxis.
          d6.overflows[0]
        ), d6.overflows];
      }).sort((a5, b5) => a5[1] - b5[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d6) => d6[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        getAlignment(d6[0]) ? 2 : 3
      ).every((v5) => v5 <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};
var flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d6) => getSideAxis(d6.placement) === initialSideAxis ? d6.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d6) => d6.overflows[0] <= 0).sort((a5, b5) => a5.overflows[1] - b5.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d6) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d6.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d6) => [d6.placement, d6.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a5, b5) => a5[1] - b5[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
var originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
var offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x5,
        y: y5,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x5 + diffCoords.x,
        y: y5 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
var shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x: x5,
        y: y5,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref2) => {
            let {
              x: x6,
              y: y6
            } = _ref2;
            return {
              x: x6,
              y: y6
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x: x5,
        y: y5
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x5,
          y: limitedCoords.y - y5,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};

// ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref2;
  return (_ref2 = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref2.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
var invalidOverflowDisplayValues = /* @__PURE__ */ new Set(["inline", "contents"]);
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
var tableElements = /* @__PURE__ */ new Set(["table", "td", "th"]);
function isTableElement(element) {
  return tableElements.has(getNodeName(element));
}
var topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element) {
  return topLayerSelectors.some((selector) => {
    try {
      return element.matches(selector);
    } catch (_e) {
      return false;
    }
  });
}
var transformProperties = ["transform", "translate", "scale", "rotate", "perspective"];
var willChangeValues = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
var containValues = ["paint", "layout", "strict", "content"];
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css2 = isElement(elementOrCss) ? getComputedStyle2(elementOrCss) : elementOrCss;
  return transformProperties.some((value) => css2[value] ? css2[value] !== "none" : false) || (css2.containerType ? css2.containerType !== "normal" : false) || !webkit && (css2.backdropFilter ? css2.backdropFilter !== "none" : false) || !webkit && (css2.filter ? css2.filter !== "none" : false) || willChangeValues.some((value) => (css2.willChange || "").includes(value)) || containValues.some((value) => (css2.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
var lastTraversableNodeNames = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function isLastTraversableNode(node) {
  return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle2(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

// ../../node_modules/@floating-ui/react/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
  const css2 = getComputedStyle2(element);
  let width = parseFloat(css2.width) || 0;
  let height = parseFloat(css2.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x5 = ($ ? round(rect.width) : rect.width) / width;
  let y5 = ($ ? round(rect.height) : rect.height) / height;
  if (!x5 || !Number.isFinite(x5)) {
    x5 = 1;
  }
  if (!y5 || !Number.isFinite(y5)) {
    y5 = 1;
  }
  return {
    x: x5,
    y: y5
  };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x5 = (clientRect.left + visualOffsets.x) / scale.x;
  let y5 = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css2 = getComputedStyle2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css2.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css2.paddingTop)) * iframeScale.y;
      x5 *= iframeScale.x;
      y5 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x5 += left;
      y5 += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x5,
    y: y5
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x5 = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y5 = htmlRect.top + scroll.scrollTop;
  return {
    x: x5,
    y: y5
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref2) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref2;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x5 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y5 = -scroll.scrollTop;
  if (getComputedStyle2(body).direction === "rtl") {
    x5 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x5,
    y: y5
  };
}
var SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x5 = 0;
  let y5 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x5 = visualViewport.offsetLeft;
      y5 = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  if (windowScrollbarX <= 0) {
    const doc = html.ownerDocument;
    const body = doc.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x: x5,
    y: y5
  };
}
var absoluteOrFixed = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x5 = left * scale.x;
  const y5 = top * scale.y;
  return {
    width,
    height,
    x: x5,
    y: y5
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle2(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle2(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref2) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref2;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x5 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y5 = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x5,
    y: y5,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle2(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle2(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
var getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle2(element).direction === "rtl";
}
var platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a5, b5) {
  return a5.x === b5.x && a5.y === b5.y && a5.width === b5.width && a5.height === b5.height;
}
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref2) => {
      let [firstEntry] = _ref2;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var detectOverflow2 = detectOverflow;
var offset2 = offset;
var autoPlacement2 = autoPlacement;
var shift2 = shift;
var flip2 = flip;
var computePosition2 = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

// ../../node_modules/@floating-ui/react/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.esm.js
import * as React8 from "react";
import { useLayoutEffect as useLayoutEffect3, useEffect as useEffect3 } from "react";
import * as ReactDOM3 from "react-dom";
var index = typeof document !== "undefined" ? useLayoutEffect3 : useEffect3;
function deepEqual(a5, b5) {
  if (a5 === b5) {
    return true;
  }
  if (typeof a5 !== typeof b5) {
    return false;
  }
  if (typeof a5 === "function" && a5.toString() === b5.toString()) {
    return true;
  }
  let length, i5, keys;
  if (a5 && b5 && typeof a5 == "object") {
    if (Array.isArray(a5)) {
      length = a5.length;
      if (length != b5.length) return false;
      for (i5 = length; i5-- !== 0; ) {
        if (!deepEqual(a5[i5], b5[i5])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a5);
    length = keys.length;
    if (length !== Object.keys(b5).length) {
      return false;
    }
    for (i5 = length; i5-- !== 0; ) {
      if (!Object.prototype.hasOwnProperty.call(b5, keys[i5])) {
        return false;
      }
    }
    for (i5 = length; i5-- !== 0; ) {
      const key = keys[i5];
      if (key === "_owner" && a5.$$typeof) {
        continue;
      }
      if (!deepEqual(a5[key], b5[key])) {
        return false;
      }
    }
    return true;
  }
  return a5 !== a5 && b5 !== b5;
}
function useLatestRef(value) {
  const ref = React8.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    whileElementsMounted,
    open: open2
  } = options;
  const [data, setData] = React8.useState({
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React8.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const referenceRef = React8.useRef(null);
  const floatingRef = React8.useRef(null);
  const dataRef = React8.useRef(data);
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const [reference, _setReference] = React8.useState(null);
  const [floating, _setFloating] = React8.useState(null);
  const setReference = React8.useCallback((node) => {
    if (referenceRef.current !== node) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React8.useCallback((node) => {
    if (floatingRef.current !== node) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const update = React8.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config2 = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config2.platform = platformRef.current;
    }
    computePosition2(referenceRef.current, floatingRef.current, config2).then((data2) => {
      const fullData = {
        ...data2,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM3.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index(() => {
    if (open2 === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open2]);
  const isMountedRef = React8.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (reference && floating) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(reference, floating, update);
      } else {
        update();
      }
    }
  }, [reference, floating, update, whileElementsMountedRef]);
  const refs = React8.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React8.useMemo(() => ({
    reference,
    floating
  }), [reference, floating]);
  return React8.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    reference: setReference,
    floating: setFloating
  }), [data, update, refs, elements, setReference, setFloating]);
}

// ../../node_modules/@floating-ui/react/dist/floating-ui.react.esm.js
var index2 = typeof document !== "undefined" ? useLayoutEffect4 : useEffect5;
var useReactId = React9[/* @__PURE__ */ "useId".toString()];
function createPubSub() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null ? void 0 : _map$get.forEach((handler) => handler(data));
    },
    on(event, listener3) {
      map.set(event, [...map.get(event) || [], listener3]);
    },
    off(event, listener3) {
      map.set(event, (map.get(event) || []).filter((l5) => l5 !== listener3));
    }
  };
}
var FloatingTreeContext = /* @__PURE__ */ React9.createContext(null);
var useFloatingTree = () => React9.useContext(FloatingTreeContext);
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function getWindow2(value) {
  return getDocument(value).defaultView || window;
}
function isElement2(value) {
  return value ? value instanceof getWindow2(value).Element : false;
}
var useInsertionEffect = React9[/* @__PURE__ */ "useInsertionEffect".toString()];
var useSafeInsertionEffect = useInsertionEffect || ((fn) => fn());
function useEvent(callback) {
  const ref = React9.useRef(() => {
    if (true) {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React9.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}
function useFloating2(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open: open2 = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options;
  const position = useFloating(options);
  const tree = useFloatingTree();
  const domReferenceRef = React9.useRef(null);
  const dataRef = React9.useRef({});
  const events = React9.useState(() => createPubSub())[0];
  const [domReference, setDomReference] = React9.useState(null);
  const setPositionReference = React9.useCallback((node) => {
    const positionReference = isElement2(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = React9.useCallback((node) => {
    if (isElement2(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }
    if (isElement2(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement2(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React9.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React9.useMemo(() => ({
    ...position.elements,
    domReference
  }), [position.elements, domReference]);
  const onOpenChange = useEvent(unstable_onOpenChange);
  const context = React9.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    events,
    open: open2,
    onOpenChange
  }), [position, nodeId, events, open2, onOpenChange, refs, elements]);
  index2(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find((node2) => node2.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React9.useMemo(() => ({
    ...position,
    context,
    refs,
    reference: setReference,
    positionReference: setPositionReference
  }), [position, refs, context, setReference, setPositionReference]);
}

// src/hooks/use-floating-window/animation-throttle.ts
function animationThrottle(callback) {
  let token = null;
  let lastArgs = null;
  const invoke = () => {
    callback(...lastArgs ?? []);
    token = null;
  };
  const result = (...args) => {
    lastArgs = args;
    if (!token) {
      token = requestAnimationFrame(invoke);
    }
  };
  result.cancel = () => {
    if (token) {
      cancelAnimationFrame(token);
    }
  };
  return result;
}
var animation_throttle_default = animationThrottle;

// src/hooks/use-floating-window/use-floating-window.ts
var EVENT_NAME_DRAG_START = "floating-window-drag-start";
var EVENT_NAME_DRAG_END = "floating-window-drag-end";
function syncInitialPosition(pos = {}) {
  return {
    name: "syncInitialPosition",
    fn({ x: x5, y: y5, ...rest }) {
      return {
        x: pos?.x ?? x5,
        y: pos?.y ?? y5,
        ...rest
      };
    }
  };
}
function checkOverflowBoundary(boundary) {
  return {
    name: "checkOverflowBoundary",
    async fn(state) {
      const overflowOptions = boundary || document?.documentElement ? { boundary: boundary || document.documentElement } : {};
      const overflow = await detectOverflow2(state, overflowOptions);
      if (overflow.left > 0) {
        const boundaryLeft = boundary?.getBoundingClientRect().left ?? 0;
        return {
          ...state,
          x: boundaryLeft
        };
      }
      if (overflow.right > 0) {
        return {
          ...state,
          x: state.x - overflow.right
        };
      }
      return {};
    }
  };
}
var isOverlapping = (ref, floating) => {
  if (!ref || !floating) return false;
  const refElement = ref.getBoundingClientRect();
  const floatingElement = floating.getBoundingClientRect();
  return !(refElement.top > floatingElement.bottom || refElement.right < floatingElement.left || refElement.bottom < floatingElement.top || refElement.left > floatingElement.right);
};
var useFloatingWindow = ({
  initialPosition,
  offset: offset3 = 0,
  strategy = "absolute",
  parentEl,
  placement,
  disableAutoUpdate = false,
  disableOverlapCheck = false,
  disableOverflowBoundary = false
} = {}) => {
  const currentPosition = useRef4(initialPosition);
  const [pressed, setPressed] = useState6(false);
  const middleware = [offset2(offset3)];
  if (!disableOverflowBoundary) {
    middleware.push(checkOverflowBoundary(parentEl));
  }
  if (initialPosition) {
    middleware.push(syncInitialPosition(initialPosition));
  }
  if (placement) {
    middleware.push(
      autoPlacement2({
        ...placement,
        ...parentEl && { boundary: parentEl }
      })
    );
  } else {
    middleware.push(flip2(parentEl ? { boundary: parentEl } : {}));
  }
  if (parentEl || !disableOverflowBoundary) {
    middleware.push(shift2(parentEl ? { boundary: parentEl } : {}));
  }
  const floating = useFloating2({
    placement: "bottom",
    middleware,
    strategy,
    whileElementsMounted: disableAutoUpdate ? void 0 : autoUpdate
  });
  if (floating.x === null && floating.y === null) {
    floating.x = initialPosition?.x ?? 0;
    floating.y = initialPosition?.y ?? 0;
  }
  const handleMouseDown = () => {
    currentPosition.current = {
      x: floating.x ?? void 0,
      y: floating.y ?? void 0
    };
    setPressed(true);
  };
  const handleMouseUp = () => {
    const floatingElement = floating.refs.floating.current;
    const referenceElement = floating.refs.reference.current;
    if (!disableOverlapCheck && isOverlapping(referenceElement, floatingElement) && floatingElement) {
      floating.x = currentPosition.current?.x ?? 0;
      floating.y = currentPosition.current?.y ?? 0;
      floatingElement.style.top = `${floating.y}px`;
      floatingElement.style.left = `${floating.x}px`;
    }
    setPressed(false);
  };
  const getBoundedPositions = (container, event) => {
    const containerRect = container.getBoundingClientRect();
    const screenWidth = parentEl ? parentEl.clientWidth : window.innerWidth;
    const screenHeight = parentEl ? parentEl.clientHeight : window.innerHeight;
    const maxX = screenWidth - containerRect.width;
    const maxY = screenHeight - containerRect.height;
    return {
      x: Math.max(0, Math.min((floating.x ?? 0) + event.movementX, maxX)),
      y: Math.max(0, Math.min((floating.y ?? 0) + event.movementY, maxY))
    };
  };
  const handleMouseMove = animation_throttle_default((event) => {
    if (!floating.refs.floating.current) {
      return;
    }
    const container = floating.refs.floating.current;
    const pos = getBoundedPositions(container, event);
    floating.x = pos.x;
    floating.y = pos.y;
    container.style.top = `${floating.y}px`;
    container.style.left = `${floating.x}px`;
  });
  useEffect6(() => {
    if (!pressed) {
      return;
    }
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      handleMouseMove.cancel();
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [pressed]);
  useEffect6(() => {
    window.dispatchEvent(
      new CustomEvent(pressed ? EVENT_NAME_DRAG_START : EVENT_NAME_DRAG_END)
    );
  }, [pressed]);
  return {
    pressed,
    position: { x: floating.x, y: floating.y },
    positionReference: floating.refs.setPositionReference,
    containerRef: floating.refs.setFloating,
    containerElement: floating.refs.floating?.current ?? null,
    dragHandlers: {
      onMouseDown: handleMouseDown,
      onMouseUp: handleMouseUp
    },
    dragStyle: {
      userSelect: pressed ? "none" : "auto",
      cursor: "grab",
      ...pressed && { cursor: "grabbing" }
    },
    containerStyle: {
      position: floating.strategy,
      top: floating.y ?? 0,
      left: floating.x ?? 0,
      // when pressed this window should be on top of all other windows
      // can't use Number.MAX_SAFE_INTEGER as it breaks when using sonar select within
      // the floating window
      ...pressed && { zIndex: 30 }
    }
  };
};
var use_floating_window_default = useFloatingWindow;

// src/hooks/use-floating-window/use-floating-window-listener.ts
import { useState as useState7, useEffect as useEffect7 } from "react";
var useFloatingWindowListener = () => {
  const [isFloating, setIsFloating] = useState7(false);
  useEffect7(() => {
    const handleDragStart = () => setIsFloating(true);
    const handleDragEnd = () => setIsFloating(false);
    window.addEventListener("floating-window-drag-start", handleDragStart);
    window.addEventListener("floating-window-drag-end", handleDragEnd);
    return () => {
      window.removeEventListener("floating-window-drag-start", handleDragStart);
      window.removeEventListener("floating-window-drag-end", handleDragEnd);
    };
  }, []);
  return isFloating;
};

// src/hooks/use-click-outside.ts
import { useEffect as useEffect8 } from "react";
var useClickOutside = (refs, onClickOutside) => {
  useEffect8(() => {
    if (!refs || refs.length === 0) {
      return;
    }
    const validRefs = refs.filter((ref) => ref !== null);
    if (validRefs.length === 0) {
      return;
    }
    const handler = (event) => {
      const [target] = event.composedPath();
      const inside = validRefs.some((ref) => {
        if (!(target instanceof Node)) return false;
        return target === ref || ref.contains(target);
      });
      if (!inside) {
        onClickOutside?.(event);
      }
    };
    document.addEventListener("click", handler, true);
    return () => {
      document.removeEventListener("click", handler, true);
    };
  }, [refs, onClickOutside]);
};

// src/components/Icon/Icon.tsx
import { cva as cva5 } from "class-variance-authority";
import { jsx as jsx8 } from "react/jsx-runtime";
var COLOR_TOKEN_MAP = {
  "foreground-primary": "#1f2f4f",
  "foreground-error": "#dd2270",
  "foreground-warning": "#a66300",
  "foreground-disabled": "#8492ae",
  "foreground-success": "#108484",
  "color-neutral-700": "#425678",
  "color-neutral-0": "#ffffff",
  "background-button-destructive-default": "#dd2270"
};
var iconVariants = cva5("antialiased", {
  variants: {
    size: {
      "x-small": "text-xs",
      // ~12px
      small: "text-sm",
      // ~14px
      regular: "text-base",
      // ~16px
      large: "text-lg",
      // ~18px
      "x-large": "text-xl"
      // ~20px
    }
  },
  defaultVariants: {
    size: "regular"
  }
});
var Icon = ({
  className,
  colorToken,
  size: size3 = "regular",
  icon: icon3,
  style,
  ...props
}) => {
  if (!icon3) {
    return null;
  }
  const colorStyle = colorToken && COLOR_TOKEN_MAP[colorToken] ? { color: COLOR_TOKEN_MAP[colorToken], ...style } : style;
  return /* @__PURE__ */ jsx8(
    FontAwesomeIcon,
    {
      icon: icon3,
      className: cn(iconVariants({ size: size3 }), className),
      style: colorStyle,
      ...props
    }
  );
};
Icon.displayName = "Icon";

// src/components/FloatingPanel/DragHandlersContext.ts
import { createContext as createContext2 } from "react";
var DragHandlersContext = createContext2(null);

// src/components/FloatingPanel/Navigation.tsx
import * as React10 from "react";
import { jsx as jsx9 } from "react/jsx-runtime";
var NavigationContext = React10.createContext({
  toPage: () => null,
  goBack: () => null,
  getData: () => ({})
});
var useNavigation = () => {
  const navigationContext = React10.useContext(NavigationContext);
  return navigationContext;
};
var Navigation = ({ children, innerRef }) => {
  const [pageKey, setPageKey] = React10.useState(crypto.randomUUID());
  const [activePage, setActivePage] = React10.useState(0);
  const [previousPages, setPreviousPage] = React10.useState([]);
  const [activePageData, setPageData] = React10.useState({});
  const toPage = React10.useCallback(
    (index5, pageData) => {
      setActivePage(index5);
      setPageData(pageData ?? {});
      if (index5 === activePage) setPageKey(crypto.randomUUID());
    },
    [activePage]
  );
  const goBack = React10.useCallback(() => {
    const newHistory = previousPages.slice(0, -1);
    setPreviousPage(newHistory);
    toPage(newHistory.at(-1) ?? 0);
  }, [previousPages, toPage]);
  const getData = React10.useCallback(() => activePageData, [activePageData]);
  React10.useEffect(() => {
    if (activePage !== previousPages.at(-1)) {
      setPreviousPage([...previousPages, activePage]);
    }
  }, [activePage, previousPages]);
  const childrenArray = React10.useMemo(
    () => Array.isArray(children) ? children : [children],
    [children]
  );
  const value = React10.useMemo(() => {
    return {
      goBack,
      toPage,
      getData
    };
  }, [goBack, toPage, getData]);
  React10.useImperativeHandle(innerRef, () => value);
  return /* @__PURE__ */ jsx9(NavigationContext.Provider, { value, children: React10.cloneElement(childrenArray[activePage], {
    key: pageKey
  }) });
};

// src/components/FloatingPanel/FloatingPanel.tsx
import { Fragment as Fragment4, jsx as jsx10, jsxs as jsxs2 } from "react/jsx-runtime";
var mergeRefs = (refs) => {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
};
var panelSizeToWidth = {
  small: "w-[320px]",
  medium: "w-[376px]",
  large: "w-[460px]"
};
var BasePanel = React11.forwardRef(({ open: open2, size: size3, className, style, children, ...props }, ref) => {
  return /* @__PURE__ */ jsx10(
    "div",
    {
      ref,
      "data-state": open2 ? "open" : "closed",
      className: cn(
        // Layout
        "flex flex-col",
        // Sizing
        "min-w-80 h-fit max-h-[90vh] max-w-lg",
        // Appearance
        "bg-neutral-0 rounded-md shadow-md",
        // Borders
        "border-neutral-1 border",
        // Animations - Enter
        "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        // Animations - Exit
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        // Transitions
        "opacity-100 transition-opacity duration-200",
        panelSizeToWidth[size3],
        className
      ),
      style,
      ...props,
      children
    }
  );
});
var FloatingVariantPanel = React11.forwardRef(
  ({
    dragOptions,
    children,
    className = "",
    open: open2 = false,
    size: size3 = "medium",
    style: styleProps = {},
    targetZIndex = 0,
    onClickOutside,
    ...unhandledProps
  }, ref) => {
    const {
      dragHandlers,
      dragStyle,
      positionReference,
      containerRef,
      containerStyle,
      containerElement
    } = use_floating_window_default({
      ...dragOptions,
      parentEl: dragOptions?.getParentEl?.() || void 0
    });
    const contextValue = React11.useMemo(
      () => ({ dragHandlers, dragStyle }),
      [dragHandlers, dragStyle]
    );
    React11.useLayoutEffect(() => {
      if (dragOptions?.getPositionReferenceElement) {
        positionReference(dragOptions.getPositionReferenceElement());
      }
    }, [positionReference, dragOptions]);
    const style = {
      zIndex: targetZIndex + 1,
      ...containerStyle,
      ...styleProps
    };
    useClickOutside([containerElement], onClickOutside);
    return /* @__PURE__ */ jsx10(DragHandlersContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx10(Presence, { present: open2, children: /* @__PURE__ */ jsx10(
      BasePanel,
      {
        ref: mergeRefs([ref, containerRef]),
        style,
        className,
        open: open2,
        size: size3,
        ...unhandledProps,
        children
      }
    ) }) });
  }
);
function getCollapseButtonIcon(expanded, placement) {
  if (placement === "left") {
    return expanded ? import_faAngleLeft.faAngleLeft : import_faAngleRight.faAngleRight;
  }
  return expanded ? import_faAngleRight.faAngleRight : import_faAngleLeft.faAngleLeft;
}
var FixedVariantPanel = React11.forwardRef(
  ({
    children,
    className = "",
    collapsible = false,
    open: open2 = false,
    expanded: expandedProp = true,
    onExpandedChange,
    placement = { x: "left", y: "top" },
    position = { x: 0, y: 0 },
    size: size3 = "medium",
    style: styleProps = {},
    targetZIndex = 0,
    ...unhandledProps
  }, ref) => {
    const [expanded, setExpanded] = useState9(expandedProp);
    useEffect10(() => {
      setExpanded(expandedProp);
    }, [expandedProp, setExpanded]);
    const toggleExpanded = useCallback4(() => {
      setExpanded(!expanded);
      onExpandedChange?.(!expanded);
    }, [setExpanded, onExpandedChange, expanded]);
    const xPosition = typeof position.x === "string" ? position.x : `${position.x}px`;
    const yPosition = typeof position.y === "string" ? position.y : `${position.y}px`;
    const style = {
      zIndex: targetZIndex + 1,
      [placement.x]: xPosition,
      [placement.y]: yPosition,
      ...styleProps,
      ...expanded ? {} : { minWidth: "unset", width: 0, borderWidth: 0, [placement.x]: 0 }
    };
    return /* @__PURE__ */ jsx10(Presence, { present: open2, children: /* @__PURE__ */ jsx10(
      BasePanel,
      {
        ref,
        className: cn("absolute", className),
        style,
        open: open2,
        size: size3,
        ...unhandledProps,
        children: /* @__PURE__ */ jsxs2(Fragment4, { children: [
          collapsible ? /* @__PURE__ */ jsx10(
            Button,
            {
              "aria-label": expanded ? "Collapse" : "Expand",
              onClick: toggleExpanded,
              modifier: "icon",
              className: cn(
                "absolute",
                "bg-neutral-0",
                "w-[30px]",
                "top-[10px]",
                "p-[10px]",
                placement.x === "left" ? "rounded-l-none" : "rounded-r-none",
                placement.x === "left" ? "left-[100%]" : "right-[100%]"
              ),
              children: /* @__PURE__ */ jsx10(Icon, { icon: getCollapseButtonIcon(expanded, placement.x) })
            }
          ) : null,
          expanded ? children : null
        ] })
      }
    ) });
  }
);
var FloatingPanel = React11.forwardRef(
  ({ variant = "floating", children, ...props }, ref) => {
    return variant === "floating" ? /* @__PURE__ */ jsx10(FloatingVariantPanel, { ref, ...props, children }) : /* @__PURE__ */ jsx10(FixedVariantPanel, { ref, ...props, children });
  }
);
FloatingPanel.displayName = "FloatingPanel";
var FloatingPanelNavigation = Navigation;
var useFloatingPanelNavigation = useNavigation;

// src/components/FloatingPanel/FloatingPanelHeader.tsx
import * as React12 from "react";
var import_faXmarkLarge = __toESM(require_faXmarkLarge());
var import_faArrowLeft = __toESM(require_faArrowLeft());
import { jsx as jsx11, jsxs as jsxs3 } from "react/jsx-runtime";
var FloatingPanelHeader = ({
  title,
  onBack,
  onClose,
  actions
}) => {
  const dragContext = React12.useContext(DragHandlersContext);
  const dragProps = dragContext ? {
    ...dragContext.dragHandlers,
    style: dragContext.dragStyle
  } : {};
  return /* @__PURE__ */ jsxs3(
    "div",
    {
      className: cn(
        // Layout
        "flex items-center",
        // Spacing
        "gap-1 p-3",
        // Typography
        "font-lato text-neutral-1",
        // Conditional spacing
        {
          "p-1": onBack
        }
      ),
      ...dragProps,
      "aria-label": "Floating panel header",
      children: [
        onBack && /* @__PURE__ */ jsx11(
          Button,
          {
            onClick: onBack,
            "aria-label": "Go back",
            variant: "ghost",
            size: "small",
            modifier: "icon",
            children: /* @__PURE__ */ jsx11(FontAwesomeIcon, { icon: import_faArrowLeft.faArrowLeft })
          }
        ),
        /* @__PURE__ */ jsx11(
          "h2",
          {
            className: cn(
              // Layout
              "grow content-center overflow-hidden",
              // Typography
              "text-ellipsis whitespace-nowrap text-base font-semibold leading-normal"
            ),
            children: title
          }
        ),
        /* @__PURE__ */ jsxs3(
          "div",
          {
            className: cn(
              // Layout
              "flex content-center justify-end",
              // Interactions
              "cursor-default"
            ),
            children: [
              actions,
              onClose && /* @__PURE__ */ jsx11(
                Button,
                {
                  "aria-label": "Close",
                  onClick: onClose,
                  variant: "ghost",
                  modifier: "icon",
                  size: "small",
                  children: /* @__PURE__ */ jsx11(FontAwesomeIcon, { icon: import_faXmarkLarge.faXmarkLarge })
                }
              )
            ]
          }
        )
      ]
    }
  );
};

// src/components/FloatingPanel/FloatingPanelContent.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var FloatingPanelContent = ({ children }) => {
  return /* @__PURE__ */ jsx12("div", { className: "min-h-0 flex-1 overflow-y-auto overflow-x-clip px-3 pb-4 pt-2", children });
};

// src/components/ColorPicker/CustomColorPicker.tsx
import { Alpha, Hue, Saturation } from "react-color/lib/components/common";
import { CustomPicker as custom } from "react-color";

// src/components/ColorPicker/ColorSpaces/conversions.ts
import tinycolor from "tinycolor2";
var toRgb = (color) => tinycolor(color).toRgb();
var toHex2 = (colorRgb) => tinycolor(colorRgb).toHex();
var toHex8 = (colorRgb) => tinycolor(colorRgb).toHex8String();
var toHsl = (colorRgb) => tinycolor(colorRgb).toHsl();
var { round: round2 } = Math;
var roundAlpha = (a5 = 0) => round2(a5 * 100);
var hexToRgb = (hex, alpha) => ({
  ...tinycolor(`#${hex}`).toRgb(),
  a: alpha / 100
});

// src/components/ColorPicker/ColorSpaces/types.ts
var DEFAULT_SPACE = "HEX";

// src/components/ColorPicker/ColorSpaces/Selector.tsx
import { useState as useState19 } from "react";

// src/components/Select/Select.tsx
import * as React21 from "react";

// ../../node_modules/@radix-ui/react-select/dist/index.module.js
import { useState as $01b9c$useState, useRef as $01b9c$useRef, createElement as $01b9c$createElement, useCallback as $01b9c$useCallback, forwardRef as $01b9c$forwardRef, useEffect as $01b9c$useEffect, Fragment as $01b9c$Fragment, useMemo as $01b9c$useMemo } from "react";
import { createPortal as $01b9c$createPortal } from "react-dom";

// ../../node_modules/@radix-ui/number/dist/index.module.js
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, [min2, max2]) {
  return Math.min(max2, Math.max(min2, value));
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff103(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-collection/dist/index.module.js
import $6vYhU$react2 from "react";

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-context/dist/index.module.js
import { createContext as $3bkAK$createContext4, useMemo as $3bkAK$useMemo4, createElement as $3bkAK$createElement4, useContext as $3bkAK$useContext4 } from "react";
function $c512c27ab02ef895$export$50c7b4e9d9f19c14(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ $3bkAK$createContext4(defaultContext);
    const index5 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const value = $3bkAK$useMemo4(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ $3bkAK$createElement4(Context.Provider, {
        value
      }, children);
    }
    function useContext7(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const context = $3bkAK$useContext4(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext7
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ $3bkAK$createContext4(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo4(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes4(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes4(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return $3bkAK$useMemo4(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import { useCallback as $3vqmr$useCallback4 } from "react";
function $6ed0406888f73fc4$var$setRef4(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af4(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef4(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d054(...refs) {
  return $3vqmr$useCallback4($6ed0406888f73fc4$export$43e446d32b3d21af4(...refs), refs);
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-collection/dist/index.module.js
import { Slot as $6vYhU$Slot2 } from "@radix-ui/react-slot";
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb22(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c14(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  });
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = $6vYhU$react2.useRef(null);
    const itemMap = $6vYhU$react2.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ $6vYhU$react2.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  /* @__PURE__ */ Object.assign(CollectionProvider, {
    displayName: PROVIDER_NAME
  });
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */ $6vYhU$react2.forwardRef((props, forwardedRef) => {
    const { scope, children } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, context.collectionRef);
    return /* @__PURE__ */ $6vYhU$react2.createElement($6vYhU$Slot2, {
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionSlot, {
    displayName: COLLECTION_SLOT_NAME
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */ $6vYhU$react2.forwardRef((props, forwardedRef) => {
    const { scope, children, ...itemData } = props;
    const ref = $6vYhU$react2.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    $6vYhU$react2.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */ $6vYhU$react2.createElement($6vYhU$Slot2, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionItemSlot, {
    displayName: ITEM_SLOT_NAME
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = $6vYhU$react2.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a5, b5) => orderedNodes.indexOf(a5.ref.current) - orderedNodes.indexOf(b5.ref.current)
      );
      return orderedItems;
    }, [
      context.collectionRef,
      context.itemMap
    ]);
    return getItems;
  }
  return [
    {
      Provider: CollectionProvider,
      Slot: CollectionSlot,
      ItemSlot: CollectionItemSlot
    },
    useCollection,
    createCollectionScope
  ];
}

// ../../node_modules/@radix-ui/react-direction/dist/index.module.js
import { createContext as $7Gjcd$createContext, createElement as $7Gjcd$createElement, useContext as $7Gjcd$useContext } from "react";
var $f631663db3294ace$var$DirectionContext = /* @__PURE__ */ $7Gjcd$createContext(void 0);
function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
  const globalDir = $7Gjcd$useContext($f631663db3294ace$var$DirectionContext);
  return localDir || globalDir || "ltr";
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-dismissable-layer/dist/index.module.js
import { createContext as $kqwpH$createContext, forwardRef as $kqwpH$forwardRef, useContext as $kqwpH$useContext, useState as $kqwpH$useState, useEffect as $kqwpH$useEffect, createElement as $kqwpH$createElement, useRef as $kqwpH$useRef } from "react";

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef3, useEffect as $4q5Fq$useEffect3, createElement as $4q5Fq$createElement3 } from "react";
import { flushSync as $4q5Fq$flushSync3 } from "react-dom";
import { Slot as $4q5Fq$Slot3 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES3 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d0343 = $8927f6f2acc4f386$var$NODES3.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef3((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot3 : node;
    $4q5Fq$useEffect3(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement3(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});
function $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event) {
  if (target) $4q5Fq$flushSync3(
    () => target.dispatchEvent(event)
  );
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import { useRef as $lwiWj$useRef3, useEffect as $lwiWj$useEffect3, useMemo as $lwiWj$useMemo3 } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a3(callback) {
  const callbackRef = $lwiWj$useRef3(callback);
  $lwiWj$useEffect3(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo3(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-use-escape-keydown/dist/index.module.js
import { useEffect as $hPSQ5$useEffect } from "react";

// ../../node_modules/@radix-ui/react-use-escape-keydown/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import { useRef as $lwiWj$useRef4, useEffect as $lwiWj$useEffect4, useMemo as $lwiWj$useMemo4 } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a4(callback) {
  const callbackRef = $lwiWj$useRef4(callback);
  $lwiWj$useEffect4(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo4(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-use-escape-keydown/dist/index.module.js
function $addc16e1bbe58fd0$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const onEscapeKeyDown = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a4(onEscapeKeyDownProp);
  $hPSQ5$useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onEscapeKeyDown(event);
    };
    ownerDocument.addEventListener("keydown", handleKeyDown);
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown);
  }, [
    onEscapeKeyDown,
    ownerDocument
  ]);
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-dismissable-layer/dist/index.module.js
var $5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $5cb92bef7577960e$var$originalBodyPointerEvents;
var $5cb92bef7577960e$var$DismissableLayerContext = /* @__PURE__ */ $kqwpH$createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
var $5cb92bef7577960e$export$177fb62ff3ec1f22 = /* @__PURE__ */ $kqwpH$forwardRef((props, forwardedRef) => {
  var _node$ownerDocument;
  const { disableOutsidePointerEvents = false, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, onDismiss, ...layerProps } = props;
  const context = $kqwpH$useContext($5cb92bef7577960e$var$DismissableLayerContext);
  const [node1, setNode] = $kqwpH$useState(null);
  const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const [, force] = $kqwpH$useState({});
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(
    forwardedRef,
    (node) => setNode(node)
  );
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [
    ...context.layersWithOutsidePointerEventsDisabled
  ].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
  const index5 = node1 ? layers.indexOf(node1) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index5 >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside((event) => {
    const target = event.target;
    const isPointerDownOnBranch = [
      ...context.branches
    ].some(
      (branch) => branch.contains(target)
    );
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  const focusOutside = $5cb92bef7577960e$var$useFocusOutside((event) => {
    const target = event.target;
    const isFocusInBranch = [
      ...context.branches
    ].some(
      (branch) => branch.contains(target)
    );
    if (isFocusInBranch) return;
    onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  $addc16e1bbe58fd0$export$3a72a57244d6e765((event) => {
    const isHighestLayer = index5 === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  }, ownerDocument);
  $kqwpH$useEffect(() => {
    if (!node1) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        $5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
        ownerDocument.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node1);
    }
    context.layers.add(node1);
    $5cb92bef7577960e$var$dispatchUpdate();
    return () => {
      if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents;
    };
  }, [
    node1,
    ownerDocument,
    disableOutsidePointerEvents,
    context
  ]);
  $kqwpH$useEffect(() => {
    return () => {
      if (!node1) return;
      context.layers.delete(node1);
      context.layersWithOutsidePointerEventsDisabled.delete(node1);
      $5cb92bef7577960e$var$dispatchUpdate();
    };
  }, [
    node1,
    context
  ]);
  $kqwpH$useEffect(() => {
    const handleUpdate = () => force({});
    document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    return () => document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
  }, []);
  return /* @__PURE__ */ $kqwpH$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({}, layerProps, {
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
      ...props.style
    },
    onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff103(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff103(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff103(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  }));
});
function $5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a3(onPointerDownOutside);
  const isPointerInsideReactTreeRef = $kqwpH$useRef(false);
  const handleClickRef = $kqwpH$useRef(() => {
  });
  $kqwpH$useEffect(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
            discrete: true
          });
        };
        var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
        const eventDetail = {
          originalEvent: event
        };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, {
            once: true
          });
        } else handleAndDispatchPointerDownOutsideEvent2();
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [
    ownerDocument,
    handlePointerDownOutside
  ]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function $5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a3(onFocusOutside);
  const isFocusInsideReactTreeRef = $kqwpH$useRef(false);
  $kqwpH$useEffect(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = {
          originalEvent: event
        };
        $5cb92bef7577960e$var$handleAndDispatchCustomEvent($5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [
    ownerDocument,
    handleFocusOutside
  ]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function $5cb92bef7577960e$var$dispatchUpdate() {
  const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail
  });
  if (handler) target.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f(target, event);
  else target.dispatchEvent(event);
}

// ../../node_modules/@radix-ui/react-focus-guards/dist/index.module.js
import { useEffect as $1wErz$useEffect } from "react";
var $3db38b7d1fb3fe6a$var$count = 0;
function $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c() {
  $1wErz$useEffect(() => {
    var _edgeGuards$, _edgeGuards$2;
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $3db38b7d1fb3fe6a$var$createFocusGuard());
    document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $3db38b7d1fb3fe6a$var$createFocusGuard());
    $3db38b7d1fb3fe6a$var$count++;
    return () => {
      if ($3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (node) => node.remove()
      );
      $3db38b7d1fb3fe6a$var$count--;
    };
  }, []);
}
function $3db38b7d1fb3fe6a$var$createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
  return element;
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-focus-scope/dist/index.module.js
import { forwardRef as $45QHv$forwardRef, useState as $45QHv$useState, useRef as $45QHv$useRef, useEffect as $45QHv$useEffect, useCallback as $45QHv$useCallback, createElement as $45QHv$createElement } from "react";
var $d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $d3863c46a17e8a28$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
var $d3863c46a17e8a28$export$20e40289641fbbb6 = /* @__PURE__ */ $45QHv$forwardRef((props, forwardedRef) => {
  const { loop = false, trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
  const [container1, setContainer] = $45QHv$useState(null);
  const onMountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a3(onMountAutoFocusProp);
  const onUnmountAutoFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a3(onUnmountAutoFocusProp);
  const lastFocusedElementRef = $45QHv$useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(
    forwardedRef,
    (node) => setContainer(node)
  );
  const focusScope = $45QHv$useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  $45QHv$useEffect(() => {
    if (trapped) {
      let handleFocusIn2 = function(event) {
        if (focusScope.paused || !container1) return;
        const target = event.target;
        if (container1.contains(target)) lastFocusedElementRef.current = target;
        else $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
          select: true
        });
      }, handleFocusOut2 = function(event) {
        if (focusScope.paused || !container1) return;
        if (!container1.contains(event.relatedTarget)) $d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
          select: true
        });
      };
      var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2;
      document.addEventListener("focusin", handleFocusIn2);
      document.addEventListener("focusout", handleFocusOut2);
      return () => {
        document.removeEventListener("focusin", handleFocusIn2);
        document.removeEventListener("focusout", handleFocusOut2);
      };
    }
  }, [
    trapped,
    container1,
    focusScope.paused
  ]);
  $45QHv$useEffect(() => {
    if (container1) {
      $d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
        container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container1.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          $d3863c46a17e8a28$var$focusFirst($d3863c46a17e8a28$var$removeLinks($d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
            select: true
          });
          if (document.activeElement === previouslyFocusedElement) $d3863c46a17e8a28$var$focus(container1);
        }
      }
      return () => {
        container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $d3863c46a17e8a28$var$EVENT_OPTIONS);
          container1.addEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container1.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) $d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
            select: true
          });
          container1.removeEventListener($d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          $d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [
    container1,
    onMountAutoFocus,
    onUnmountAutoFocus,
    focusScope
  ]);
  const handleKeyDown = $45QHv$useCallback((event) => {
    if (!loop && !trapped) return;
    if (focusScope.paused) return;
    const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
    const focusedElement = document.activeElement;
    if (isTabKey && focusedElement) {
      const container = event.currentTarget;
      const [first, last] = $d3863c46a17e8a28$var$getTabbableEdges(container);
      const hasTabbableElementsInside = first && last;
      if (!hasTabbableElementsInside) {
        if (focusedElement === container) event.preventDefault();
      } else {
        if (!event.shiftKey && focusedElement === last) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(first, {
            select: true
          });
        } else if (event.shiftKey && focusedElement === first) {
          event.preventDefault();
          if (loop) $d3863c46a17e8a28$var$focus(last, {
            select: true
          });
        }
      }
    }
  }, [
    loop,
    trapped,
    focusScope.paused
  ]);
  return /* @__PURE__ */ $45QHv$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({
    tabIndex: -1
  }, scopeProps, {
    ref: composedRefs,
    onKeyDown: handleKeyDown
  }));
});
function $d3863c46a17e8a28$var$focusFirst(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    $d3863c46a17e8a28$var$focus(candidate, {
      select
    });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function $d3863c46a17e8a28$var$getTabbableEdges(container) {
  const candidates = $d3863c46a17e8a28$var$getTabbableCandidates(container);
  const first = $d3863c46a17e8a28$var$findVisible(candidates, container);
  const last = $d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
  return [
    first,
    last
  ];
}
function $d3863c46a17e8a28$var$getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function $d3863c46a17e8a28$var$findVisible(elements, container) {
  for (const element of elements) {
    if (!$d3863c46a17e8a28$var$isHidden(element, {
      upTo: container
    })) return element;
  }
}
function $d3863c46a17e8a28$var$isHidden(node, { upTo }) {
  if (getComputedStyle(node).visibility === "hidden") return true;
  while (node) {
    if (upTo !== void 0 && node === upTo) return false;
    if (getComputedStyle(node).display === "none") return true;
    node = node.parentElement;
  }
  return false;
}
function $d3863c46a17e8a28$var$isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function $d3863c46a17e8a28$var$focus(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({
      preventScroll: true
    });
    if (element !== previouslyFocusedElement && $d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
  }
}
var $d3863c46a17e8a28$var$focusScopesStack = $d3863c46a17e8a28$var$createFocusScopesStack();
function $d3863c46a17e8a28$var$createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _stack$;
      stack = $d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
      (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
    }
  };
}
function $d3863c46a17e8a28$var$arrayRemove(array, item) {
  const updatedArray = [
    ...array
  ];
  const index5 = updatedArray.indexOf(item);
  if (index5 !== -1) updatedArray.splice(index5, 1);
  return updatedArray;
}
function $d3863c46a17e8a28$var$removeLinks(items) {
  return items.filter(
    (item) => item.tagName !== "A"
  );
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-id/dist/index.module.js
import * as $2AODx$react3 from "react";

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js
import { useLayoutEffect as $dxlwH$useLayoutEffect3 } from "react";
var $9f79659886946c16$export$e5c5a5f917a5871c3 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? $dxlwH$useLayoutEffect3 : () => {
};

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-id/dist/index.module.js
var $1746a345f3d73bb7$var$useReactId3 = $2AODx$react3["useId".toString()] || (() => void 0);
var $1746a345f3d73bb7$var$count3 = 0;
function $1746a345f3d73bb7$export$f680877a34711e373(deterministicId) {
  const [id, setId] = $2AODx$react3.useState($1746a345f3d73bb7$var$useReactId3());
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    if (!deterministicId) setId(
      (reactId) => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count3++)
    );
  }, [
    deterministicId
  ]);
  return deterministicId || (id ? `radix-${id}` : "");
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-popper/dist/index.module.js
import { useState as $kY93V$useState, createElement as $kY93V$createElement, forwardRef as $kY93V$forwardRef, useRef as $kY93V$useRef, useEffect as $kY93V$useEffect, useLayoutEffect as $kY93V$useLayoutEffect } from "react";

// ../../node_modules/@radix-ui/react-select/node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function t(t3) {
  return t3.split("-")[0];
}
function e(t3) {
  return t3.split("-")[1];
}
function n(e3) {
  return ["top", "bottom"].includes(t(e3)) ? "x" : "y";
}
function r2(t3) {
  return "y" === t3 ? "height" : "width";
}
function i(i5, o5, a5) {
  let { reference: l5, floating: s5 } = i5;
  const c5 = l5.x + l5.width / 2 - s5.width / 2, f5 = l5.y + l5.height / 2 - s5.height / 2, u5 = n(o5), m5 = r2(u5), g5 = l5[m5] / 2 - s5[m5] / 2, d6 = "x" === u5;
  let p6;
  switch (t(o5)) {
    case "top":
      p6 = { x: c5, y: l5.y - s5.height };
      break;
    case "bottom":
      p6 = { x: c5, y: l5.y + l5.height };
      break;
    case "right":
      p6 = { x: l5.x + l5.width, y: f5 };
      break;
    case "left":
      p6 = { x: l5.x - s5.width, y: f5 };
      break;
    default:
      p6 = { x: l5.x, y: l5.y };
  }
  switch (e(o5)) {
    case "start":
      p6[u5] -= g5 * (a5 && d6 ? -1 : 1);
      break;
    case "end":
      p6[u5] += g5 * (a5 && d6 ? -1 : 1);
  }
  return p6;
}
var o = async (t3, e3, n5) => {
  const { placement: r6 = "bottom", strategy: o5 = "absolute", middleware: a5 = [], platform: l5 } = n5, s5 = await (null == l5.isRTL ? void 0 : l5.isRTL(e3));
  let c5 = await l5.getElementRects({ reference: t3, floating: e3, strategy: o5 }), { x: f5, y: u5 } = i(c5, r6, s5), m5 = r6, g5 = {}, d6 = 0;
  for (let n6 = 0; n6 < a5.length; n6++) {
    const { name: p6, fn: h5 } = a5[n6], { x: y5, y: x5, data: w6, reset: v5 } = await h5({ x: f5, y: u5, initialPlacement: r6, placement: m5, strategy: o5, middlewareData: g5, rects: c5, platform: l5, elements: { reference: t3, floating: e3 } });
    f5 = null != y5 ? y5 : f5, u5 = null != x5 ? x5 : u5, g5 = { ...g5, [p6]: { ...g5[p6], ...w6 } }, v5 && d6 <= 50 && (d6++, "object" == typeof v5 && (v5.placement && (m5 = v5.placement), v5.rects && (c5 = true === v5.rects ? await l5.getElementRects({ reference: t3, floating: e3, strategy: o5 }) : v5.rects), { x: f5, y: u5 } = i(c5, m5, s5)), n6 = -1);
  }
  return { x: f5, y: u5, placement: m5, strategy: o5, middlewareData: g5 };
};
function a(t3) {
  return "number" != typeof t3 ? (function(t4) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t4 };
  })(t3) : { top: t3, right: t3, bottom: t3, left: t3 };
}
function l(t3) {
  return { ...t3, top: t3.y, left: t3.x, right: t3.x + t3.width, bottom: t3.y + t3.height };
}
async function s(t3, e3) {
  var n5;
  void 0 === e3 && (e3 = {});
  const { x: r6, y: i5, platform: o5, rects: s5, elements: c5, strategy: f5 } = t3, { boundary: u5 = "clippingAncestors", rootBoundary: m5 = "viewport", elementContext: g5 = "floating", altBoundary: d6 = false, padding: p6 = 0 } = e3, h5 = a(p6), y5 = c5[d6 ? "floating" === g5 ? "reference" : "floating" : g5], x5 = l(await o5.getClippingRect({ element: null == (n5 = await (null == o5.isElement ? void 0 : o5.isElement(y5))) || n5 ? y5 : y5.contextElement || await (null == o5.getDocumentElement ? void 0 : o5.getDocumentElement(c5.floating)), boundary: u5, rootBoundary: m5, strategy: f5 })), w6 = l(o5.convertOffsetParentRelativeRectToViewportRelativeRect ? await o5.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: "floating" === g5 ? { ...s5.floating, x: r6, y: i5 } : s5.reference, offsetParent: await (null == o5.getOffsetParent ? void 0 : o5.getOffsetParent(c5.floating)), strategy: f5 }) : s5[g5]);
  return { top: x5.top - w6.top + h5.top, bottom: w6.bottom - x5.bottom + h5.bottom, left: x5.left - w6.left + h5.left, right: w6.right - x5.right + h5.right };
}
var c = Math.min;
var f = Math.max;
function u(t3, e3, n5) {
  return f(t3, c(e3, n5));
}
var m = (t3) => ({ name: "arrow", options: t3, async fn(i5) {
  const { element: o5, padding: l5 = 0 } = null != t3 ? t3 : {}, { x: s5, y: c5, placement: f5, rects: m5, platform: g5 } = i5;
  if (null == o5) return {};
  const d6 = a(l5), p6 = { x: s5, y: c5 }, h5 = n(f5), y5 = e(f5), x5 = r2(h5), w6 = await g5.getDimensions(o5), v5 = "y" === h5 ? "top" : "left", b5 = "y" === h5 ? "bottom" : "right", R5 = m5.reference[x5] + m5.reference[h5] - p6[h5] - m5.floating[x5], A3 = p6[h5] - m5.reference[h5], P3 = await (null == g5.getOffsetParent ? void 0 : g5.getOffsetParent(o5));
  let T5 = P3 ? "y" === h5 ? P3.clientHeight || 0 : P3.clientWidth || 0 : 0;
  0 === T5 && (T5 = m5.floating[x5]);
  const O3 = R5 / 2 - A3 / 2, D5 = d6[v5], L5 = T5 - w6[x5] - d6[b5], k3 = T5 / 2 - w6[x5] / 2 + O3, E5 = u(D5, k3, L5), C3 = ("start" === y5 ? d6[v5] : d6[b5]) > 0 && k3 !== E5 && m5.reference[x5] <= m5.floating[x5];
  return { [h5]: p6[h5] - (C3 ? k3 < D5 ? D5 - k3 : L5 - k3 : 0), data: { [h5]: E5, centerOffset: k3 - E5 } };
} });
var g = { left: "right", right: "left", bottom: "top", top: "bottom" };
function d2(t3) {
  return t3.replace(/left|right|bottom|top/g, ((t4) => g[t4]));
}
function p2(t3, i5, o5) {
  void 0 === o5 && (o5 = false);
  const a5 = e(t3), l5 = n(t3), s5 = r2(l5);
  let c5 = "x" === l5 ? a5 === (o5 ? "end" : "start") ? "right" : "left" : "start" === a5 ? "bottom" : "top";
  return i5.reference[s5] > i5.floating[s5] && (c5 = d2(c5)), { main: c5, cross: d2(c5) };
}
var h = { start: "end", end: "start" };
function y(t3) {
  return t3.replace(/start|end/g, ((t4) => h[t4]));
}
var x = ["top", "right", "bottom", "left"];
var w2 = x.reduce(((t3, e3) => t3.concat(e3, e3 + "-start", e3 + "-end")), []);
var b = function(e3) {
  return void 0 === e3 && (e3 = {}), { name: "flip", options: e3, async fn(n5) {
    var r6;
    const { placement: i5, middlewareData: o5, rects: a5, initialPlacement: l5, platform: c5, elements: f5 } = n5, { mainAxis: u5 = true, crossAxis: m5 = true, fallbackPlacements: g5, fallbackStrategy: h5 = "bestFit", flipAlignment: x5 = true, ...w6 } = e3, v5 = t(i5), b5 = g5 || (v5 === l5 || !x5 ? [d2(l5)] : (function(t3) {
      const e4 = d2(t3);
      return [y(t3), e4, y(e4)];
    })(l5)), R5 = [l5, ...b5], A3 = await s(n5, w6), P3 = [];
    let T5 = (null == (r6 = o5.flip) ? void 0 : r6.overflows) || [];
    if (u5 && P3.push(A3[v5]), m5) {
      const { main: t3, cross: e4 } = p2(i5, a5, await (null == c5.isRTL ? void 0 : c5.isRTL(f5.floating)));
      P3.push(A3[t3], A3[e4]);
    }
    if (T5 = [...T5, { placement: i5, overflows: P3 }], !P3.every(((t3) => t3 <= 0))) {
      var O3, D5;
      const t3 = (null != (O3 = null == (D5 = o5.flip) ? void 0 : D5.index) ? O3 : 0) + 1, e4 = R5[t3];
      if (e4) return { data: { index: t3, overflows: T5 }, reset: { placement: e4 } };
      let n6 = "bottom";
      switch (h5) {
        case "bestFit": {
          var L5;
          const t4 = null == (L5 = T5.map(((t5) => [t5, t5.overflows.filter(((t6) => t6 > 0)).reduce(((t6, e5) => t6 + e5), 0)])).sort(((t5, e5) => t5[1] - e5[1]))[0]) ? void 0 : L5[0].placement;
          t4 && (n6 = t4);
          break;
        }
        case "initialPlacement":
          n6 = l5;
      }
      if (i5 !== n6) return { reset: { placement: n6 } };
    }
    return {};
  } };
};
function R(t3, e3) {
  return { top: t3.top - e3.height, right: t3.right - e3.width, bottom: t3.bottom - e3.height, left: t3.left - e3.width };
}
function A(t3) {
  return x.some(((e3) => t3[e3] >= 0));
}
var P = function(t3) {
  let { strategy: e3 = "referenceHidden", ...n5 } = void 0 === t3 ? {} : t3;
  return { name: "hide", async fn(t4) {
    const { rects: r6 } = t4;
    switch (e3) {
      case "referenceHidden": {
        const e4 = R(await s(t4, { ...n5, elementContext: "reference" }), r6.reference);
        return { data: { referenceHiddenOffsets: e4, referenceHidden: A(e4) } };
      }
      case "escaped": {
        const e4 = R(await s(t4, { ...n5, altBoundary: true }), r6.floating);
        return { data: { escapedOffsets: e4, escaped: A(e4) } };
      }
      default:
        return {};
    }
  } };
};
var T = function(r6) {
  return void 0 === r6 && (r6 = 0), { name: "offset", options: r6, async fn(i5) {
    const { x: o5, y: a5 } = i5, l5 = await (async function(r7, i6) {
      const { placement: o6, platform: a6, elements: l6 } = r7, s5 = await (null == a6.isRTL ? void 0 : a6.isRTL(l6.floating)), c5 = t(o6), f5 = e(o6), u5 = "x" === n(o6), m5 = ["left", "top"].includes(c5) ? -1 : 1, g5 = s5 && u5 ? -1 : 1, d6 = "function" == typeof i6 ? i6(r7) : i6;
      let { mainAxis: p6, crossAxis: h5, alignmentAxis: y5 } = "number" == typeof d6 ? { mainAxis: d6, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...d6 };
      return f5 && "number" == typeof y5 && (h5 = "end" === f5 ? -1 * y5 : y5), u5 ? { x: h5 * g5, y: p6 * m5 } : { x: p6 * m5, y: h5 * g5 };
    })(i5, r6);
    return { x: o5 + l5.x, y: a5 + l5.y, data: l5 };
  } };
};
function O(t3) {
  return "x" === t3 ? "y" : "x";
}
var D = function(e3) {
  return void 0 === e3 && (e3 = {}), { name: "shift", options: e3, async fn(r6) {
    const { x: i5, y: o5, placement: a5 } = r6, { mainAxis: l5 = true, crossAxis: c5 = false, limiter: f5 = { fn: (t3) => {
      let { x: e4, y: n5 } = t3;
      return { x: e4, y: n5 };
    } }, ...m5 } = e3, g5 = { x: i5, y: o5 }, d6 = await s(r6, m5), p6 = n(t(a5)), h5 = O(p6);
    let y5 = g5[p6], x5 = g5[h5];
    if (l5) {
      const t3 = "y" === p6 ? "bottom" : "right";
      y5 = u(y5 + d6["y" === p6 ? "top" : "left"], y5, y5 - d6[t3]);
    }
    if (c5) {
      const t3 = "y" === h5 ? "bottom" : "right";
      x5 = u(x5 + d6["y" === h5 ? "top" : "left"], x5, x5 - d6[t3]);
    }
    const w6 = f5.fn({ ...r6, [p6]: y5, [h5]: x5 });
    return { ...w6, data: { x: w6.x - i5, y: w6.y - o5 } };
  } };
};
var L = function(e3) {
  return void 0 === e3 && (e3 = {}), { options: e3, fn(r6) {
    const { x: i5, y: o5, placement: a5, rects: l5, middlewareData: s5 } = r6, { offset: c5 = 0, mainAxis: f5 = true, crossAxis: u5 = true } = e3, m5 = { x: i5, y: o5 }, g5 = n(a5), d6 = O(g5);
    let p6 = m5[g5], h5 = m5[d6];
    const y5 = "function" == typeof c5 ? c5({ ...l5, placement: a5 }) : c5, x5 = "number" == typeof y5 ? { mainAxis: y5, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...y5 };
    if (f5) {
      const t3 = "y" === g5 ? "height" : "width", e4 = l5.reference[g5] - l5.floating[t3] + x5.mainAxis, n5 = l5.reference[g5] + l5.reference[t3] - x5.mainAxis;
      p6 < e4 ? p6 = e4 : p6 > n5 && (p6 = n5);
    }
    if (u5) {
      var w6, v5, b5, R5;
      const e4 = "y" === g5 ? "width" : "height", n5 = ["top", "left"].includes(t(a5)), r7 = l5.reference[d6] - l5.floating[e4] + (n5 && null != (w6 = null == (v5 = s5.offset) ? void 0 : v5[d6]) ? w6 : 0) + (n5 ? 0 : x5.crossAxis), i6 = l5.reference[d6] + l5.reference[e4] + (n5 ? 0 : null != (b5 = null == (R5 = s5.offset) ? void 0 : R5[d6]) ? b5 : 0) - (n5 ? x5.crossAxis : 0);
      h5 < r7 ? h5 = r7 : h5 > i6 && (h5 = i6);
    }
    return { [g5]: p6, [d6]: h5 };
  } };
};
var k = function(n5) {
  return void 0 === n5 && (n5 = {}), { name: "size", options: n5, async fn(r6) {
    const { placement: i5, rects: o5, platform: a5, elements: l5 } = r6, { apply: c5, ...u5 } = n5, m5 = await s(r6, u5), g5 = t(i5), d6 = e(i5);
    let p6, h5;
    "top" === g5 || "bottom" === g5 ? (p6 = g5, h5 = d6 === (await (null == a5.isRTL ? void 0 : a5.isRTL(l5.floating)) ? "start" : "end") ? "left" : "right") : (h5 = g5, p6 = "end" === d6 ? "top" : "bottom");
    const y5 = f(m5.left, 0), x5 = f(m5.right, 0), w6 = f(m5.top, 0), v5 = f(m5.bottom, 0), b5 = { availableHeight: o5.floating.height - (["left", "right"].includes(i5) ? 2 * (0 !== w6 || 0 !== v5 ? w6 + v5 : f(m5.top, m5.bottom)) : m5[p6]), availableWidth: o5.floating.width - (["top", "bottom"].includes(i5) ? 2 * (0 !== y5 || 0 !== x5 ? y5 + x5 : f(m5.left, m5.right)) : m5[h5]) }, R5 = await a5.getDimensions(l5.floating);
    null == c5 || c5({ ...r6, ...b5 });
    const A3 = await a5.getDimensions(l5.floating);
    return R5.width !== A3.width || R5.height !== A3.height ? { reset: { rects: true } } : {};
  } };
};

// ../../node_modules/@radix-ui/react-select/node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function n2(t3) {
  return t3 && t3.document && t3.location && t3.alert && t3.setInterval;
}
function o2(t3) {
  if (null == t3) return window;
  if (!n2(t3)) {
    const e3 = t3.ownerDocument;
    return e3 && e3.defaultView || window;
  }
  return t3;
}
function i2(t3) {
  return o2(t3).getComputedStyle(t3);
}
function r3(t3) {
  return n2(t3) ? "" : t3 ? (t3.nodeName || "").toLowerCase() : "";
}
function l2() {
  const t3 = navigator.userAgentData;
  return null != t3 && t3.brands ? t3.brands.map(((t4) => t4.brand + "/" + t4.version)).join(" ") : navigator.userAgent;
}
function c2(t3) {
  return t3 instanceof o2(t3).HTMLElement;
}
function f2(t3) {
  return t3 instanceof o2(t3).Element;
}
function s2(t3) {
  if ("undefined" == typeof ShadowRoot) return false;
  return t3 instanceof o2(t3).ShadowRoot || t3 instanceof ShadowRoot;
}
function u2(t3) {
  const { overflow: e3, overflowX: n5, overflowY: o5 } = i2(t3);
  return /auto|scroll|overlay|hidden/.test(e3 + o5 + n5);
}
function d3(t3) {
  return ["table", "td", "th"].includes(r3(t3));
}
function h2(t3) {
  const e3 = /firefox/i.test(l2()), n5 = i2(t3);
  return "none" !== n5.transform || "none" !== n5.perspective || "paint" === n5.contain || ["transform", "perspective"].includes(n5.willChange) || e3 && "filter" === n5.willChange || e3 && !!n5.filter && "none" !== n5.filter;
}
function a2() {
  return !/^((?!chrome|android).)*safari/i.test(l2());
}
var g2 = Math.min;
var p3 = Math.max;
var m2 = Math.round;
function w3(t3, e3, n5) {
  var i5, r6, l5, s5;
  void 0 === e3 && (e3 = false), void 0 === n5 && (n5 = false);
  const u5 = t3.getBoundingClientRect();
  let d6 = 1, h5 = 1;
  e3 && c2(t3) && (d6 = t3.offsetWidth > 0 && m2(u5.width) / t3.offsetWidth || 1, h5 = t3.offsetHeight > 0 && m2(u5.height) / t3.offsetHeight || 1);
  const g5 = f2(t3) ? o2(t3) : window, p6 = !a2() && n5, w6 = (u5.left + (p6 && null != (i5 = null == (r6 = g5.visualViewport) ? void 0 : r6.offsetLeft) ? i5 : 0)) / d6, v5 = (u5.top + (p6 && null != (l5 = null == (s5 = g5.visualViewport) ? void 0 : s5.offsetTop) ? l5 : 0)) / h5, y5 = u5.width / d6, x5 = u5.height / h5;
  return { width: y5, height: x5, top: v5, right: w6 + y5, bottom: v5 + x5, left: w6, x: w6, y: v5 };
}
function v2(t3) {
  return (e3 = t3, (e3 instanceof o2(e3).Node ? t3.ownerDocument : t3.document) || window.document).documentElement;
  var e3;
}
function y2(t3) {
  return f2(t3) ? { scrollLeft: t3.scrollLeft, scrollTop: t3.scrollTop } : { scrollLeft: t3.pageXOffset, scrollTop: t3.pageYOffset };
}
function x2(t3) {
  return w3(v2(t3)).left + y2(t3).scrollLeft;
}
function b2(t3, e3, n5) {
  const o5 = c2(e3), i5 = v2(e3), l5 = w3(t3, o5 && (function(t4) {
    const e4 = w3(t4);
    return m2(e4.width) !== t4.offsetWidth || m2(e4.height) !== t4.offsetHeight;
  })(e3), "fixed" === n5);
  let f5 = { scrollLeft: 0, scrollTop: 0 };
  const s5 = { x: 0, y: 0 };
  if (o5 || !o5 && "fixed" !== n5) if (("body" !== r3(e3) || u2(i5)) && (f5 = y2(e3)), c2(e3)) {
    const t4 = w3(e3, true);
    s5.x = t4.x + e3.clientLeft, s5.y = t4.y + e3.clientTop;
  } else i5 && (s5.x = x2(i5));
  return { x: l5.left + f5.scrollLeft - s5.x, y: l5.top + f5.scrollTop - s5.y, width: l5.width, height: l5.height };
}
function L2(t3) {
  return "html" === r3(t3) ? t3 : t3.assignedSlot || t3.parentNode || (s2(t3) ? t3.host : null) || v2(t3);
}
function R2(t3) {
  return c2(t3) && "fixed" !== getComputedStyle(t3).position ? t3.offsetParent : null;
}
function T2(t3) {
  const e3 = o2(t3);
  let n5 = R2(t3);
  for (; n5 && d3(n5) && "static" === getComputedStyle(n5).position; ) n5 = R2(n5);
  return n5 && ("html" === r3(n5) || "body" === r3(n5) && "static" === getComputedStyle(n5).position && !h2(n5)) ? e3 : n5 || (function(t4) {
    let e4 = L2(t4);
    for (s2(e4) && (e4 = e4.host); c2(e4) && !["html", "body"].includes(r3(e4)); ) {
      if (h2(e4)) return e4;
      e4 = e4.parentNode;
    }
    return null;
  })(t3) || e3;
}
function W(t3) {
  if (c2(t3)) return { width: t3.offsetWidth, height: t3.offsetHeight };
  const e3 = w3(t3);
  return { width: e3.width, height: e3.height };
}
function E2(t3) {
  const e3 = L2(t3);
  return ["html", "body", "#document"].includes(r3(e3)) ? t3.ownerDocument.body : c2(e3) && u2(e3) ? e3 : E2(e3);
}
function H(t3, e3) {
  var n5;
  void 0 === e3 && (e3 = []);
  const i5 = E2(t3), r6 = i5 === (null == (n5 = t3.ownerDocument) ? void 0 : n5.body), l5 = o2(i5), c5 = r6 ? [l5].concat(l5.visualViewport || [], u2(i5) ? i5 : []) : i5, f5 = e3.concat(c5);
  return r6 ? f5 : f5.concat(H(c5));
}
function C(e3, n5, r6) {
  return "viewport" === n5 ? l((function(t3, e4) {
    const n6 = o2(t3), i5 = v2(t3), r7 = n6.visualViewport;
    let l5 = i5.clientWidth, c5 = i5.clientHeight, f5 = 0, s5 = 0;
    if (r7) {
      l5 = r7.width, c5 = r7.height;
      const t4 = a2();
      (t4 || !t4 && "fixed" === e4) && (f5 = r7.offsetLeft, s5 = r7.offsetTop);
    }
    return { width: l5, height: c5, x: f5, y: s5 };
  })(e3, r6)) : f2(n5) ? (function(t3, e4) {
    const n6 = w3(t3, false, "fixed" === e4), o5 = n6.top + t3.clientTop, i5 = n6.left + t3.clientLeft;
    return { top: o5, left: i5, x: i5, y: o5, right: i5 + t3.clientWidth, bottom: o5 + t3.clientHeight, width: t3.clientWidth, height: t3.clientHeight };
  })(n5, r6) : l((function(t3) {
    var e4;
    const n6 = v2(t3), o5 = y2(t3), r7 = null == (e4 = t3.ownerDocument) ? void 0 : e4.body, l5 = p3(n6.scrollWidth, n6.clientWidth, r7 ? r7.scrollWidth : 0, r7 ? r7.clientWidth : 0), c5 = p3(n6.scrollHeight, n6.clientHeight, r7 ? r7.scrollHeight : 0, r7 ? r7.clientHeight : 0);
    let f5 = -o5.scrollLeft + x2(t3);
    const s5 = -o5.scrollTop;
    return "rtl" === i2(r7 || n6).direction && (f5 += p3(n6.clientWidth, r7 ? r7.clientWidth : 0) - l5), { width: l5, height: c5, x: f5, y: s5 };
  })(v2(e3)));
}
function S(t3) {
  const e3 = H(t3), n5 = ["absolute", "fixed"].includes(i2(t3).position) && c2(t3) ? T2(t3) : t3;
  return f2(n5) ? e3.filter(((t4) => f2(t4) && (function(t5, e4) {
    const n6 = null == e4.getRootNode ? void 0 : e4.getRootNode();
    if (t5.contains(e4)) return true;
    if (n6 && s2(n6)) {
      let n7 = e4;
      do {
        if (n7 && t5 === n7) return true;
        n7 = n7.parentNode || n7.host;
      } while (n7);
    }
    return false;
  })(t4, n5) && "body" !== r3(t4))) : [];
}
var D2 = { getClippingRect: function(t3) {
  let { element: e3, boundary: n5, rootBoundary: o5, strategy: i5 } = t3;
  const r6 = [..."clippingAncestors" === n5 ? S(e3) : [].concat(n5), o5], l5 = r6[0], c5 = r6.reduce(((t4, n6) => {
    const o6 = C(e3, n6, i5);
    return t4.top = p3(o6.top, t4.top), t4.right = g2(o6.right, t4.right), t4.bottom = g2(o6.bottom, t4.bottom), t4.left = p3(o6.left, t4.left), t4;
  }), C(e3, l5, i5));
  return { width: c5.right - c5.left, height: c5.bottom - c5.top, x: c5.left, y: c5.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t3) {
  let { rect: e3, offsetParent: n5, strategy: o5 } = t3;
  const i5 = c2(n5), l5 = v2(n5);
  if (n5 === l5) return e3;
  let f5 = { scrollLeft: 0, scrollTop: 0 };
  const s5 = { x: 0, y: 0 };
  if ((i5 || !i5 && "fixed" !== o5) && (("body" !== r3(n5) || u2(l5)) && (f5 = y2(n5)), c2(n5))) {
    const t4 = w3(n5, true);
    s5.x = t4.x + n5.clientLeft, s5.y = t4.y + n5.clientTop;
  }
  return { ...e3, x: e3.x - f5.scrollLeft + s5.x, y: e3.y - f5.scrollTop + s5.y };
}, isElement: f2, getDimensions: W, getOffsetParent: T2, getDocumentElement: v2, getElementRects: (t3) => {
  let { reference: e3, floating: n5, strategy: o5 } = t3;
  return { reference: b2(e3, T2(n5), o5), floating: { ...W(n5), x: 0, y: 0 } };
}, getClientRects: (t3) => Array.from(t3.getClientRects()), isRTL: (t3) => "rtl" === i2(t3).direction };
function N(t3, e3, n5, o5) {
  void 0 === o5 && (o5 = {});
  const { ancestorScroll: i5 = true, ancestorResize: r6 = true, elementResize: l5 = true, animationFrame: c5 = false } = o5, s5 = i5 && !c5, u5 = r6 && !c5, d6 = s5 || u5 ? [...f2(t3) ? H(t3) : [], ...H(e3)] : [];
  d6.forEach(((t4) => {
    s5 && t4.addEventListener("scroll", n5, { passive: true }), u5 && t4.addEventListener("resize", n5);
  }));
  let h5, a5 = null;
  if (l5) {
    let o6 = true;
    a5 = new ResizeObserver((() => {
      o6 || n5(), o6 = false;
    })), f2(t3) && !c5 && a5.observe(t3), a5.observe(e3);
  }
  let g5 = c5 ? w3(t3) : null;
  return c5 && (function e4() {
    const o6 = w3(t3);
    !g5 || o6.x === g5.x && o6.y === g5.y && o6.width === g5.width && o6.height === g5.height || n5();
    g5 = o6, h5 = requestAnimationFrame(e4);
  })(), n5(), () => {
    var t4;
    d6.forEach(((t5) => {
      s5 && t5.removeEventListener("scroll", n5), u5 && t5.removeEventListener("resize", n5);
    })), null == (t4 = a5) || t4.disconnect(), a5 = null, c5 && cancelAnimationFrame(h5);
  };
}
var z = (t3, n5, o5) => o(t3, n5, { platform: D2, ...o5 });

// ../../node_modules/@radix-ui/react-select/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.esm.js
import * as React13 from "react";
import { useLayoutEffect as useLayoutEffect5, useEffect as useEffect11 } from "react";
import * as ReactDOM4 from "react-dom";
var index3 = typeof document !== "undefined" ? useLayoutEffect5 : useEffect11;
function deepEqual2(a5, b5) {
  if (a5 === b5) {
    return true;
  }
  if (typeof a5 !== typeof b5) {
    return false;
  }
  if (typeof a5 === "function" && a5.toString() === b5.toString()) {
    return true;
  }
  let length, i5, keys;
  if (a5 && b5 && typeof a5 == "object") {
    if (Array.isArray(a5)) {
      length = a5.length;
      if (length != b5.length) return false;
      for (i5 = length; i5-- !== 0; ) {
        if (!deepEqual2(a5[i5], b5[i5])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a5);
    length = keys.length;
    if (length !== Object.keys(b5).length) {
      return false;
    }
    for (i5 = length; i5-- !== 0; ) {
      if (!Object.prototype.hasOwnProperty.call(b5, keys[i5])) {
        return false;
      }
    }
    for (i5 = length; i5-- !== 0; ) {
      const key = keys[i5];
      if (key === "_owner" && a5.$$typeof) {
        continue;
      }
      if (!deepEqual2(a5[key], b5[key])) {
        return false;
      }
    }
    return true;
  }
  return a5 !== a5 && b5 !== b5;
}
function useLatestRef2(value) {
  const ref = React13.useRef(value);
  index3(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating3(_temp) {
  let {
    middleware,
    placement = "bottom",
    strategy = "absolute",
    whileElementsMounted
  } = _temp === void 0 ? {} : _temp;
  const reference = React13.useRef(null);
  const floating = React13.useRef(null);
  const whileElementsMountedRef = useLatestRef2(whileElementsMounted);
  const cleanupRef = React13.useRef(null);
  const [data, setData] = React13.useState({
    // Setting these to `null` will allow the consumer to determine if
    // `computePosition()` has run yet
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {}
  });
  const [latestMiddleware, setLatestMiddleware] = React13.useState(middleware);
  if (!deepEqual2(latestMiddleware == null ? void 0 : latestMiddleware.map((_ref2) => {
    let {
      options
    } = _ref2;
    return options;
  }), middleware == null ? void 0 : middleware.map((_ref2) => {
    let {
      options
    } = _ref2;
    return options;
  }))) {
    setLatestMiddleware(middleware);
  }
  const update = React13.useCallback(() => {
    if (!reference.current || !floating.current) {
      return;
    }
    z(reference.current, floating.current, {
      middleware: latestMiddleware,
      placement,
      strategy
    }).then((data2) => {
      if (isMountedRef.current) {
        ReactDOM4.flushSync(() => {
          setData(data2);
        });
      }
    });
  }, [latestMiddleware, placement, strategy]);
  index3(() => {
    if (isMountedRef.current) {
      update();
    }
  }, [update]);
  const isMountedRef = React13.useRef(false);
  index3(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const runElementMountCallback = React13.useCallback(() => {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (reference.current && floating.current) {
      if (whileElementsMountedRef.current) {
        const cleanupFn = whileElementsMountedRef.current(reference.current, floating.current, update);
        cleanupRef.current = cleanupFn;
      } else {
        update();
      }
    }
  }, [update, whileElementsMountedRef]);
  const setReference = React13.useCallback((node) => {
    reference.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const setFloating = React13.useCallback((node) => {
    floating.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const refs = React13.useMemo(() => ({
    reference,
    floating
  }), []);
  return React13.useMemo(() => ({
    ...data,
    update,
    refs,
    reference: setReference,
    floating: setFloating
  }), [data, update, refs, setReference, setFloating]);
}
var arrow4 = (options) => {
  const {
    element,
    padding
  } = options;
  function isRef(value) {
    return Object.prototype.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(args) {
      if (isRef(element)) {
        if (element.current != null) {
          return m({
            element: element.current,
            padding
          }).fn(args);
        }
        return {};
      } else if (element) {
        return m({
          element,
          padding
        }).fn(args);
      }
      return {};
    }
  };
};

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-use-size/dist/index.module.js
import { useState as $9gyGR$useState } from "react";
function $db6c3485150b8e66$export$1ab7ae714698c4b8(element) {
  const [size3, setSize] = $9gyGR$useState(void 0);
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    if (element) {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) return;
        if (!entries.length) return;
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({
          width,
          height
        });
      });
      resizeObserver.observe(element, {
        box: "border-box"
      });
      return () => resizeObserver.unobserve(element);
    } else
      setSize(void 0);
  }, [
    element
  ]);
  return size3;
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-popper/dist/index.module.js
var $cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
var [$cf1ac5d9fe0e8206$var$createPopperContext, $cf1ac5d9fe0e8206$export$722aac194ae923] = $c512c27ab02ef895$export$50c7b4e9d9f19c14($cf1ac5d9fe0e8206$var$POPPER_NAME);
var [$cf1ac5d9fe0e8206$var$PopperProvider, $cf1ac5d9fe0e8206$var$usePopperContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$POPPER_NAME);
var $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9 = (props) => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = $kY93V$useState(null);
  return /* @__PURE__ */ $kY93V$createElement($cf1ac5d9fe0e8206$var$PopperProvider, {
    scope: __scopePopper,
    anchor,
    onAnchorChange: setAnchor
  }, children);
};
var $cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
var $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d = /* @__PURE__ */ $kY93V$forwardRef((props, forwardedRef) => {
  const { __scopePopper, virtualRef, ...anchorProps } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
  const ref = $kY93V$useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, ref);
  $kY93V$useEffect(() => {
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /* @__PURE__ */ $kY93V$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({}, anchorProps, {
    ref: composedRefs
  }));
});
var $cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
var [$cf1ac5d9fe0e8206$var$PopperContentProvider, $cf1ac5d9fe0e8206$var$useContentContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME);
var [$cf1ac5d9fe0e8206$var$PositionContextProvider, $cf1ac5d9fe0e8206$var$usePositionContext] = $cf1ac5d9fe0e8206$var$createPopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, {
  hasParent: false,
  positionUpdateFns: /* @__PURE__ */ new Set()
});
var $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc = /* @__PURE__ */ $kY93V$forwardRef((props, forwardedRef) => {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
  const { __scopePopper, side = "bottom", sideOffset = 0, align = "center", alignOffset = 0, arrowPadding = 0, collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky = "partial", hideWhenDetached = false, avoidCollisions = true, onPlaced, ...contentProps } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
  const [content, setContent] = $kY93V$useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(
    forwardedRef,
    (node) => setContent(node)
  );
  const [arrow6, setArrow] = $kY93V$useState(null);
  const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b8(arrow6);
  const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  const desiredPlacement = side + (align !== "center" ? "-" + align : "");
  const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...collisionPaddingProp
  };
  const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
    collisionBoundary
  ];
  const hasExplicitBoundaries = boundary.length > 0;
  const detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: hasExplicitBoundaries
  };
  const { reference, floating, strategy, x: x5, y: y5, placement, middlewareData, update } = useFloating3({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: desiredPlacement,
    whileElementsMounted: N,
    middleware: [
      $cf1ac5d9fe0e8206$var$anchorCssProperties(),
      T({
        mainAxis: sideOffset + arrowHeight,
        alignmentAxis: alignOffset
      }),
      avoidCollisions ? D({
        mainAxis: true,
        crossAxis: false,
        limiter: sticky === "partial" ? L() : void 0,
        ...detectOverflowOptions
      }) : void 0,
      arrow6 ? arrow4({
        element: arrow6,
        padding: arrowPadding
      }) : void 0,
      avoidCollisions ? b({
        ...detectOverflowOptions
      }) : void 0,
      k({
        ...detectOverflowOptions,
        apply: ({ elements, availableWidth: width, availableHeight: height }) => {
          elements.floating.style.setProperty("--radix-popper-available-width", `${width}px`);
          elements.floating.style.setProperty("--radix-popper-available-height", `${height}px`);
        }
      }),
      $cf1ac5d9fe0e8206$var$transformOrigin({
        arrowWidth,
        arrowHeight
      }),
      hideWhenDetached ? P({
        strategy: "referenceHidden"
      }) : void 0
    ].filter($cf1ac5d9fe0e8206$var$isDefined)
  });
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    reference(context.anchor);
  }, [
    reference,
    context.anchor
  ]);
  const isPlaced = x5 !== null && y5 !== null;
  const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
  const handlePlaced = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a3(onPlaced);
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    if (isPlaced) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
  }, [
    isPlaced,
    handlePlaced
  ]);
  const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
  const [contentZIndex, setContentZIndex] = $kY93V$useState();
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [
    content
  ]);
  const { hasParent, positionUpdateFns } = $cf1ac5d9fe0e8206$var$usePositionContext($cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
  const isRoot = !hasParent;
  $kY93V$useLayoutEffect(() => {
    if (!isRoot) {
      positionUpdateFns.add(update);
      return () => {
        positionUpdateFns.delete(update);
      };
    }
  }, [
    isRoot,
    positionUpdateFns,
    update
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach(
      (fn) => requestAnimationFrame(fn)
    );
  }, [
    isRoot,
    isPlaced,
    positionUpdateFns
  ]);
  const commonProps = {
    "data-side": placedSide,
    "data-align": placedAlign,
    ...contentProps,
    ref: composedRefs,
    style: {
      ...contentProps.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: !isPlaced ? "none" : void 0,
      // hide the content if using the hide middleware and should be hidden
      opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : void 0
    }
  };
  return /* @__PURE__ */ $kY93V$createElement("div", {
    ref: floating,
    "data-radix-popper-content-wrapper": "",
    style: {
      position: strategy,
      left: 0,
      top: 0,
      transform: isPlaced ? `translate3d(${Math.round(x5)}px, ${Math.round(y5)}px, 0)` : "translate3d(0, -200%, 0)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: contentZIndex,
      ["--radix-popper-transform-origin"]: [
        (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
        (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
      ].join(" ")
    },
    dir: props.dir
  }, /* @__PURE__ */ $kY93V$createElement($cf1ac5d9fe0e8206$var$PopperContentProvider, {
    scope: __scopePopper,
    placedSide,
    onArrowChange: setArrow,
    arrowX,
    arrowY,
    shouldHideArrow: cannotCenterArrow
  }, isRoot ? /* @__PURE__ */ $kY93V$createElement($cf1ac5d9fe0e8206$var$PositionContextProvider, {
    scope: __scopePopper,
    hasParent: true,
    positionUpdateFns
  }, /* @__PURE__ */ $kY93V$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, commonProps)) : /* @__PURE__ */ $kY93V$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, commonProps)));
});
function $cf1ac5d9fe0e8206$var$isDefined(value) {
  return value !== void 0;
}
function $cf1ac5d9fe0e8206$var$isNotNull(value) {
  return value !== null;
}
var $cf1ac5d9fe0e8206$var$anchorCssProperties = () => ({
  name: "anchorCssProperties",
  fn(data) {
    const { rects, elements } = data;
    const { width, height } = rects.reference;
    elements.floating.style.setProperty("--radix-popper-anchor-width", `${width}px`);
    elements.floating.style.setProperty("--radix-popper-anchor-height", `${height}px`);
    return {};
  }
});
var $cf1ac5d9fe0e8206$var$transformOrigin = (options) => ({
  name: "transformOrigin",
  options,
  fn(data) {
    var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const noArrowAlign = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[placedAlign];
    const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
    const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
    let x5 = "";
    let y5 = "";
    if (placedSide === "bottom") {
      x5 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y5 = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x5 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y5 = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x5 = `${-arrowHeight}px`;
      y5 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x5 = `${rects.floating.width + arrowHeight}px`;
      y5 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return {
      data: {
        x: x5,
        y: y5
      }
    };
  }
});
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [
    side,
    align
  ];
}
var $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf9;
var $cf1ac5d9fe0e8206$export$b688253958b8dfe7 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d;
var $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc;

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-portal/dist/index.module.js
import { forwardRef as $7SXl2$forwardRef, createElement as $7SXl2$createElement } from "react";
import $7SXl2$reactdom from "react-dom";
var $f1701beae083dbae$export$602eac185826482c = /* @__PURE__ */ $7SXl2$forwardRef((props, forwardedRef) => {
  var _globalThis$document;
  const { container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
  return container ? /* @__PURE__ */ $7SXl2$reactdom.createPortal(/* @__PURE__ */ $7SXl2$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({}, portalProps, {
    ref: forwardedRef
  })), container) : null;
});

// ../../node_modules/@radix-ui/react-select/dist/index.module.js
import { Slot as $01b9c$Slot } from "@radix-ui/react-slot";

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
import { useCallback as $bnPw9$useCallback3, useState as $bnPw9$useState3, useRef as $bnPw9$useRef3, useEffect as $bnPw9$useEffect3 } from "react";
function $71cd76cc60e0454e$export$6f32135080cb4c33({ prop, defaultProp, onChange: onChange2 = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState3({
    defaultProp,
    onChange: onChange2
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a3(onChange2);
  const setValue = $bnPw9$useCallback3((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState3({ defaultProp, onChange: onChange2 }) {
  const uncontrolledState = $bnPw9$useState3(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = $bnPw9$useRef3(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a3(onChange2);
  $bnPw9$useEffect3(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-use-previous/dist/index.module.js
import { useRef as $8LvvK$useRef, useMemo as $8LvvK$useMemo } from "react";
function $010c2913dbd2fe3d$export$5cae361ad82dce8b(value) {
  const ref = $8LvvK$useRef({
    value,
    previous: value
  });
  return $8LvvK$useMemo(() => {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [
    value
  ]);
}

// ../../node_modules/@radix-ui/react-select/node_modules/@radix-ui/react-visually-hidden/dist/index.module.js
import { forwardRef as $kVwnw$forwardRef, createElement as $kVwnw$createElement } from "react";
var $ea1ef594cf570d83$export$439d29a4e110a164 = /* @__PURE__ */ $kVwnw$forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ $kVwnw$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.span, _extends({}, props, {
    ref: forwardedRef,
    style: {
      // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...props.style
    }
  }));
});

// ../../node_modules/react-remove-scroll/node_modules/tslib/tslib.es6.mjs
var __assign = function() {
  __assign = Object.assign || function __assign3(t3) {
    for (var s5, i5 = 1, n5 = arguments.length; i5 < n5; i5++) {
      s5 = arguments[i5];
      for (var p6 in s5) if (Object.prototype.hasOwnProperty.call(s5, p6)) t3[p6] = s5[p6];
    }
    return t3;
  };
  return __assign.apply(this, arguments);
};
function __rest(s5, e3) {
  var t3 = {};
  for (var p6 in s5) if (Object.prototype.hasOwnProperty.call(s5, p6) && e3.indexOf(p6) < 0)
    t3[p6] = s5[p6];
  if (s5 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i5 = 0, p6 = Object.getOwnPropertySymbols(s5); i5 < p6.length; i5++) {
      if (e3.indexOf(p6[i5]) < 0 && Object.prototype.propertyIsEnumerable.call(s5, p6[i5]))
        t3[p6[i5]] = s5[p6[i5]];
    }
  return t3;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i5 = 0, l5 = from.length, ar; i5 < l5; i5++) {
    if (ar || !(i5 in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i5);
      ar[i5] = from[i5];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

// ../../node_modules/react-remove-scroll/dist/es2015/Combination.js
import * as React20 from "react";

// ../../node_modules/react-remove-scroll/dist/es2015/UI.js
import * as React16 from "react";

// ../../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";

// ../../node_modules/use-callback-ref/dist/es2015/assignRef.js
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}

// ../../node_modules/use-callback-ref/dist/es2015/useRef.js
import { useState as useState12 } from "react";
function useCallbackRef(initialValue, callback) {
  var ref = useState12(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}

// ../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
import * as React14 from "react";
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React14.useLayoutEffect : React14.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}

// ../../node_modules/use-sidecar/node_modules/tslib/tslib.es6.mjs
var __assign2 = function() {
  __assign2 = Object.assign || function __assign3(t3) {
    for (var s5, i5 = 1, n5 = arguments.length; i5 < n5; i5++) {
      s5 = arguments[i5];
      for (var p6 in s5) if (Object.prototype.hasOwnProperty.call(s5, p6)) t3[p6] = s5[p6];
    }
    return t3;
  };
  return __assign2.apply(this, arguments);
};
function __rest2(s5, e3) {
  var t3 = {};
  for (var p6 in s5) if (Object.prototype.hasOwnProperty.call(s5, p6) && e3.indexOf(p6) < 0)
    t3[p6] = s5[p6];
  if (s5 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i5 = 0, p6 = Object.getOwnPropertySymbols(s5); i5 < p6.length; i5++) {
      if (e3.indexOf(p6[i5]) < 0 && Object.prototype.propertyIsEnumerable.call(s5, p6[i5]))
        t3[p6[i5]] = s5[p6[i5]];
    }
  return t3;
}

// ../../node_modules/use-sidecar/dist/es2015/medium.js
function ItoI(a5) {
  return a5;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x5) {
          return x5 !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x5) {
          return cb(x5);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x5) {
          pendingQueue.push(x5);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign2({ async: true, ssr: false }, options);
  return medium;
}

// ../../node_modules/use-sidecar/dist/es2015/exports.js
import * as React15 from "react";
var SideCar = function(_a) {
  var sideCar = _a.sideCar, rest = __rest2(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React15.createElement(Target, __assign2({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar;
}

// ../../node_modules/react-remove-scroll/dist/es2015/medium.js
var effectCar = createSidecarMedium();

// ../../node_modules/react-remove-scroll/dist/es2015/UI.js
var nothing = function() {
  return;
};
var RemoveScroll = React16.forwardRef(function(props, parentRef) {
  var ref = React16.useRef(null);
  var _a = React16.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a[0], setCallbacks = _a[1];
  var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled2 = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React16.createElement(
    React16.Fragment,
    null,
    enabled2 && React16.createElement(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref }),
    forwardProps ? React16.cloneElement(React16.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef })) : React16.createElement(Container, __assign({}, containerProps, { className, ref: containerRef }), children)
  );
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};

// ../../node_modules/react-remove-scroll/dist/es2015/SideEffect.js
import * as React19 from "react";

// ../../node_modules/react-remove-scroll-bar/dist/es2015/component.js
import * as React18 from "react";

// ../../node_modules/react-style-singleton/dist/es2015/hook.js
import * as React17 from "react";

// ../../node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var getNonce = function() {
  if (currentNonce) {
    return currentNonce;
  }
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};

// ../../node_modules/react-style-singleton/dist/es2015/singleton.js
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css2) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css2;
  } else {
    tag.appendChild(document.createTextNode(css2));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter2 = 0;
  var stylesheet = null;
  return {
    add: function(style) {
      if (counter2 == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter2++;
    },
    remove: function() {
      counter2--;
      if (!counter2 && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};

// ../../node_modules/react-style-singleton/dist/es2015/hook.js
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles2, isDynamic) {
    React17.useEffect(function() {
      sheet.add(styles2);
      return function() {
        sheet.remove();
      };
    }, [styles2 && isDynamic]);
  };
};

// ../../node_modules/react-style-singleton/dist/es2015/component.js
var styleSingleton = function() {
  var useStyle = styleHookSingleton();
  var Sheet = function(_a) {
    var styles2 = _a.styles, dynamic = _a.dynamic;
    useStyle(styles2, dynamic);
    return null;
  };
  return Sheet;
};

// ../../node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse2 = function(x5) {
  return parseInt(x5 || "", 10) || 0;
};
var getOffset = function(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse2(left), parse2(top), parse2(right)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};

// ../../node_modules/react-remove-scroll-bar/dist/es2015/component.js
var Style = styleSingleton();
var lockAttribute = "data-scroll-locked";
var getStyles = function(_a, allowRelative, gapMode, important) {
  var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
    allowRelative && "position: relative ".concat(important, ";"),
    gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
  ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
  var counter2 = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(counter2) ? counter2 : 0;
};
var useLockAttribute = function() {
  React18.useEffect(function() {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function() {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function(_a) {
  var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
  useLockAttribute();
  var gap = React18.useMemo(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React18.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};

// ../../node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    options = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var options;
var nonPassive = passiveSupported ? { passive: false } : false;

// ../../node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function(node) {
  return node.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node, overflow) {
  var styles2 = window.getComputedStyle(node);
  return (
    // not-not-scrollable
    styles2[overflow] !== "hidden" && // contains scroll inside self
    !(styles2.overflowY === styles2.overflowX && !alwaysContainsScroll(node) && styles2[overflow] === "visible")
  );
};
var elementCouldBeVScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowY");
};
var elementCouldBeHScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowX");
};
var locationCouldBeScrolled = function(axis, node) {
  var current = node;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current), s5 = _a[1], d6 = _a[2];
      if (s5 > d6) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== document.body);
  return false;
};
var getVScrollVariables = function(_a) {
  var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a) {
  var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node) {
  return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
  return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    target = target.parentNode;
  } while (
    // portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target)
  );
  if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};

// ../../node_modules/react-remove-scroll/dist/es2015/SideEffect.js
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x5, y5) {
  return x5[0] === y5[0] && x5[1] === y5[1];
};
var generateStyle = function(id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React19.useRef([]);
  var touchStartRef = React19.useRef([0, 0]);
  var activeAxis = React19.useRef();
  var id = React19.useState(idCounter++)[0];
  var Style2 = React19.useState(function() {
    return styleSingleton();
  })[0];
  var lastProps = React19.useRef(props);
  React19.useEffect(function() {
    lastProps.current = props;
  }, [props]);
  React19.useEffect(function() {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React19.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React19.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e3) {
      return e3.name === event.type && e3.target === event.target && deltaCompare(e3.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React19.useCallback(function(name, delta, target, should) {
    var event = { name, delta, target, should };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e3) {
        return e3 !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React19.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React19.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React19.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React19.useEffect(function() {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar, inert = props.inert;
  return React19.createElement(
    React19.Fragment,
    null,
    inert ? React19.createElement(Style2, { styles: generateStyle(id) }) : null,
    removeScrollBar ? React19.createElement(RemoveScrollBar, { gapMode: "margin" }) : null
  );
}

// ../../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var sidecar_default = exportSidecar(effectCar, RemoveScrollSideCar);

// ../../node_modules/react-remove-scroll/dist/es2015/Combination.js
var ReactRemoveScroll = React20.forwardRef(function(props, ref) {
  return React20.createElement(RemoveScroll, __assign({}, props, { ref, sideCar: sidecar_default }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var Combination_default = ReactRemoveScroll;

// ../../node_modules/@radix-ui/react-select/dist/index.module.js
var $cc7e05a45900e73f$var$OPEN_KEYS = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
];
var $cc7e05a45900e73f$var$SELECTION_KEYS = [
  " ",
  "Enter"
];
var $cc7e05a45900e73f$var$SELECT_NAME = "Select";
var [$cc7e05a45900e73f$var$Collection, $cc7e05a45900e73f$var$useCollection, $cc7e05a45900e73f$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb22($cc7e05a45900e73f$var$SELECT_NAME);
var [$cc7e05a45900e73f$var$createSelectContext, $cc7e05a45900e73f$export$286727a75dc039bd] = $c512c27ab02ef895$export$50c7b4e9d9f19c14($cc7e05a45900e73f$var$SELECT_NAME, [
  $cc7e05a45900e73f$var$createCollectionScope,
  $cf1ac5d9fe0e8206$export$722aac194ae923
]);
var $cc7e05a45900e73f$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae923();
var [$cc7e05a45900e73f$var$SelectProvider, $cc7e05a45900e73f$var$useSelectContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$SELECT_NAME);
var [$cc7e05a45900e73f$var$SelectNativeOptionsProvider, $cc7e05a45900e73f$var$useSelectNativeOptionsContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$SELECT_NAME);
var $cc7e05a45900e73f$export$ef9b1a59e592288f = (props) => {
  const { __scopeSelect, children, open: openProp, defaultOpen, onOpenChange, value: valueProp, defaultValue, onValueChange, dir, name, autoComplete, disabled: disabled2, required } = props;
  const popperScope = $cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
  const [trigger, setTrigger] = $01b9c$useState(null);
  const [valueNode, setValueNode] = $01b9c$useState(null);
  const [valueNodeHasChildren, setValueNodeHasChildren] = $01b9c$useState(false);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [open2 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c33({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c33({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  const triggerPointerDownPosRef = $01b9c$useRef(null);
  const isFormControl = trigger ? Boolean(trigger.closest("form")) : true;
  const [nativeOptionsSet, setNativeOptionsSet] = $01b9c$useState(/* @__PURE__ */ new Set());
  const nativeSelectKey = Array.from(nativeOptionsSet).map(
    (option) => option.props.value
  ).join(";");
  return /* @__PURE__ */ $01b9c$createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe9, popperScope, /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectProvider, {
    required,
    scope: __scopeSelect,
    trigger,
    onTriggerChange: setTrigger,
    valueNode,
    onValueNodeChange: setValueNode,
    valueNodeHasChildren,
    onValueNodeHasChildrenChange: setValueNodeHasChildren,
    contentId: $1746a345f3d73bb7$export$f680877a34711e373(),
    value,
    onValueChange: setValue,
    open: open2,
    onOpenChange: setOpen,
    dir: direction,
    triggerPointerDownPosRef,
    disabled: disabled2
  }, /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$Collection.Provider, {
    scope: __scopeSelect
  }, /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectNativeOptionsProvider, {
    scope: props.__scopeSelect,
    onNativeOptionAdd: $01b9c$useCallback((option) => {
      setNativeOptionsSet(
        (prev) => new Set(prev).add(option)
      );
    }, []),
    onNativeOptionRemove: $01b9c$useCallback((option) => {
      setNativeOptionsSet((prev) => {
        const optionsSet = new Set(prev);
        optionsSet.delete(option);
        return optionsSet;
      });
    }, [])
  }, children)), isFormControl ? /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$BubbleSelect, {
    key: nativeSelectKey,
    "aria-hidden": true,
    required,
    tabIndex: -1,
    name,
    autoComplete,
    value,
    onChange: (event) => setValue(event.target.value),
    disabled: disabled2
  }, value === void 0 ? /* @__PURE__ */ $01b9c$createElement("option", {
    value: ""
  }) : null, Array.from(nativeOptionsSet)) : null));
};
var $cc7e05a45900e73f$var$TRIGGER_NAME = "SelectTrigger";
var $cc7e05a45900e73f$export$3ac1e88a1c0b9f1 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, disabled: disabled2 = false, ...triggerProps } = props;
  const popperScope = $cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$TRIGGER_NAME, __scopeSelect);
  const isDisabled = context.disabled || disabled2;
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, context.onTriggerChange);
  const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
  const [searchRef, handleTypeaheadSearch, resetTypeahead] = $cc7e05a45900e73f$var$useTypeaheadSearch((search) => {
    const enabledItems = getItems().filter(
      (item) => !item.disabled
    );
    const currentItem = enabledItems.find(
      (item) => item.value === context.value
    );
    const nextItem = $cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
    if (nextItem !== void 0) context.onValueChange(nextItem.value);
  });
  const handleOpen = () => {
    if (!isDisabled) {
      context.onOpenChange(true);
      resetTypeahead();
    }
  };
  return /* @__PURE__ */ $01b9c$createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe7, _extends({
    asChild: true
  }, popperScope), /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.button, _extends({
    type: "button",
    role: "combobox",
    "aria-controls": context.contentId,
    "aria-expanded": context.open,
    "aria-required": context.required,
    "aria-autocomplete": "none",
    dir: context.dir,
    "data-state": context.open ? "open" : "closed",
    disabled: isDisabled,
    "data-disabled": isDisabled ? "" : void 0,
    "data-placeholder": context.value === void 0 ? "" : void 0
  }, triggerProps, {
    ref: composedRefs,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff103(triggerProps.onClick, (event) => {
      event.currentTarget.focus();
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff103(triggerProps.onPointerDown, (event) => {
      const target = event.target;
      if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
      if (event.button === 0 && event.ctrlKey === false) {
        handleOpen();
        context.triggerPointerDownPosRef.current = {
          x: Math.round(event.pageX),
          y: Math.round(event.pageY)
        };
        event.preventDefault();
      }
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff103(triggerProps.onKeyDown, (event) => {
      const isTypingAhead = searchRef.current !== "";
      const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
      if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
      if (isTypingAhead && event.key === " ") return;
      if ($cc7e05a45900e73f$var$OPEN_KEYS.includes(event.key)) {
        handleOpen();
        event.preventDefault();
      }
    })
  })));
});
var $cc7e05a45900e73f$var$VALUE_NAME = "SelectValue";
var $cc7e05a45900e73f$export$e288731fd71264f0 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, className, style, children, placeholder, ...valueProps } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$VALUE_NAME, __scopeSelect);
  const { onValueNodeHasChildrenChange } = context;
  const hasChildren = children !== void 0;
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, context.onValueNodeChange);
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    onValueNodeHasChildrenChange(hasChildren);
  }, [
    onValueNodeHasChildrenChange,
    hasChildren
  ]);
  return /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.span, _extends({}, valueProps, {
    ref: composedRefs,
    style: {
      pointerEvents: "none"
    }
  }), context.value === void 0 && placeholder !== void 0 ? placeholder : children);
});
var $cc7e05a45900e73f$export$99b400cabb58c515 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, children, ...iconProps } = props;
  return /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.span, _extends({
    "aria-hidden": true
  }, iconProps, {
    ref: forwardedRef
  }), children || "\u25BC");
});
var $cc7e05a45900e73f$export$b2af6c9944296213 = (props) => {
  return /* @__PURE__ */ $01b9c$createElement($f1701beae083dbae$export$602eac185826482c, _extends({
    asChild: true
  }, props));
};
var $cc7e05a45900e73f$var$CONTENT_NAME = "SelectContent";
var $cc7e05a45900e73f$export$c973a4b3cb86a03d = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, props.__scopeSelect);
  const [fragment, setFragment] = $01b9c$useState();
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    setFragment(new DocumentFragment());
  }, []);
  if (!context.open) {
    const frag = fragment;
    return frag ? /* @__PURE__ */ $01b9c$createPortal(/* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectContentProvider, {
      scope: props.__scopeSelect
    }, /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$Collection.Slot, {
      scope: props.__scopeSelect
    }, /* @__PURE__ */ $01b9c$createElement("div", null, props.children))), frag) : null;
  }
  return /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectContentImpl, _extends({}, props, {
    ref: forwardedRef
  }));
});
var $cc7e05a45900e73f$var$CONTENT_MARGIN = 10;
var [$cc7e05a45900e73f$var$SelectContentProvider, $cc7e05a45900e73f$var$useSelectContentContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$CONTENT_NAME);
var $cc7e05a45900e73f$var$SelectContentImpl = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const {
    __scopeSelect,
    position = "item-aligned",
    onCloseAutoFocus,
    onEscapeKeyDown,
    onPointerDownOutside,
    side,
    sideOffset,
    align,
    alignOffset,
    arrowPadding,
    collisionBoundary,
    collisionPadding,
    sticky,
    hideWhenDetached,
    avoidCollisions,
    //
    ...contentProps
  } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
  const [content, setContent] = $01b9c$useState(null);
  const [viewport, setViewport] = $01b9c$useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(
    forwardedRef,
    (node) => setContent(node)
  );
  const [selectedItem, setSelectedItem] = $01b9c$useState(null);
  const [selectedItemText, setSelectedItemText] = $01b9c$useState(null);
  const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
  const [isPositioned, setIsPositioned] = $01b9c$useState(false);
  const firstValidItemFoundRef = $01b9c$useRef(false);
  $01b9c$useEffect(() => {
    if (content) return hideOthers(content);
  }, [
    content
  ]);
  $3db38b7d1fb3fe6a$export$b7ece24a22aeda8c();
  const focusFirst = $01b9c$useCallback((candidates) => {
    const [firstItem, ...restItems] = getItems().map(
      (item) => item.ref.current
    );
    const [lastItem] = restItems.slice(-1);
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates) {
      if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
      candidate === null || candidate === void 0 || candidate.scrollIntoView({
        block: "nearest"
      });
      if (candidate === firstItem && viewport) viewport.scrollTop = 0;
      if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
      candidate === null || candidate === void 0 || candidate.focus();
      if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
  }, [
    getItems,
    viewport
  ]);
  const focusSelectedItem = $01b9c$useCallback(
    () => focusFirst([
      selectedItem,
      content
    ]),
    [
      focusFirst,
      selectedItem,
      content
    ]
  );
  $01b9c$useEffect(() => {
    if (isPositioned) focusSelectedItem();
  }, [
    isPositioned,
    focusSelectedItem
  ]);
  const { onOpenChange, triggerPointerDownPosRef } = context;
  $01b9c$useEffect(() => {
    if (content) {
      let pointerMoveDelta = {
        x: 0,
        y: 0
      };
      const handlePointerMove = (event) => {
        var _triggerPointerDownPo, _triggerPointerDownPo2, _triggerPointerDownPo3, _triggerPointerDownPo4;
        pointerMoveDelta = {
          x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPo = (_triggerPointerDownPo2 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo2 === void 0 ? void 0 : _triggerPointerDownPo2.x) !== null && _triggerPointerDownPo !== void 0 ? _triggerPointerDownPo : 0)),
          y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPo3 = (_triggerPointerDownPo4 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPo4 === void 0 ? void 0 : _triggerPointerDownPo4.y) !== null && _triggerPointerDownPo3 !== void 0 ? _triggerPointerDownPo3 : 0))
        };
      };
      const handlePointerUp = (event) => {
        if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
        else if (!content.contains(event.target)) onOpenChange(false);
        document.removeEventListener("pointermove", handlePointerMove);
        triggerPointerDownPosRef.current = null;
      };
      if (triggerPointerDownPosRef.current !== null) {
        document.addEventListener("pointermove", handlePointerMove);
        document.addEventListener("pointerup", handlePointerUp, {
          capture: true,
          once: true
        });
      }
      return () => {
        document.removeEventListener("pointermove", handlePointerMove);
        document.removeEventListener("pointerup", handlePointerUp, {
          capture: true
        });
      };
    }
  }, [
    content,
    onOpenChange,
    triggerPointerDownPosRef
  ]);
  $01b9c$useEffect(() => {
    const close = () => onOpenChange(false);
    window.addEventListener("blur", close);
    window.addEventListener("resize", close);
    return () => {
      window.removeEventListener("blur", close);
      window.removeEventListener("resize", close);
    };
  }, [
    onOpenChange
  ]);
  const [searchRef, handleTypeaheadSearch] = $cc7e05a45900e73f$var$useTypeaheadSearch((search) => {
    const enabledItems = getItems().filter(
      (item) => !item.disabled
    );
    const currentItem = enabledItems.find(
      (item) => item.ref.current === document.activeElement
    );
    const nextItem = $cc7e05a45900e73f$var$findNextItem(enabledItems, search, currentItem);
    if (nextItem)
      setTimeout(
        () => nextItem.ref.current.focus()
      );
  });
  const itemRefCallback = $01b9c$useCallback((node, value, disabled2) => {
    const isFirstValidItem = !firstValidItemFoundRef.current && !disabled2;
    const isSelectedItem = context.value !== void 0 && context.value === value;
    if (isSelectedItem || isFirstValidItem) {
      setSelectedItem(node);
      if (isFirstValidItem) firstValidItemFoundRef.current = true;
    }
  }, [
    context.value
  ]);
  const handleItemLeave = $01b9c$useCallback(
    () => content === null || content === void 0 ? void 0 : content.focus(),
    [
      content
    ]
  );
  const itemTextRefCallback = $01b9c$useCallback((node, value, disabled2) => {
    const isFirstValidItem = !firstValidItemFoundRef.current && !disabled2;
    const isSelectedItem = context.value !== void 0 && context.value === value;
    if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
  }, [
    context.value
  ]);
  const SelectPosition = position === "popper" ? $cc7e05a45900e73f$var$SelectPopperPosition : $cc7e05a45900e73f$var$SelectItemAlignedPosition;
  const popperContentProps = SelectPosition === $cc7e05a45900e73f$var$SelectPopperPosition ? {
    side,
    sideOffset,
    align,
    alignOffset,
    arrowPadding,
    collisionBoundary,
    collisionPadding,
    sticky,
    hideWhenDetached,
    avoidCollisions
  } : {};
  return /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectContentProvider, {
    scope: __scopeSelect,
    content,
    viewport,
    onViewportChange: setViewport,
    itemRefCallback,
    selectedItem,
    onItemLeave: handleItemLeave,
    itemTextRefCallback,
    focusSelectedItem,
    selectedItemText,
    position,
    isPositioned,
    searchRef
  }, /* @__PURE__ */ $01b9c$createElement(Combination_default, {
    as: $01b9c$Slot,
    allowPinchZoom: true
  }, /* @__PURE__ */ $01b9c$createElement($d3863c46a17e8a28$export$20e40289641fbbb6, {
    asChild: true,
    trapped: context.open,
    onMountAutoFocus: (event) => {
      event.preventDefault();
    },
    onUnmountAutoFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff103(onCloseAutoFocus, (event) => {
      var _context$trigger;
      (_context$trigger = context.trigger) === null || _context$trigger === void 0 || _context$trigger.focus({
        preventScroll: true
      });
      event.preventDefault();
    })
  }, /* @__PURE__ */ $01b9c$createElement($5cb92bef7577960e$export$177fb62ff3ec1f22, {
    asChild: true,
    disableOutsidePointerEvents: true,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside: (event) => event.preventDefault(),
    onDismiss: () => context.onOpenChange(false)
  }, /* @__PURE__ */ $01b9c$createElement(SelectPosition, _extends({
    role: "listbox",
    id: context.contentId,
    "data-state": context.open ? "open" : "closed",
    dir: context.dir,
    onContextMenu: (event) => event.preventDefault()
  }, contentProps, popperContentProps, {
    onPlaced: () => setIsPositioned(true),
    ref: composedRefs,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ...contentProps.style
    },
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff103(contentProps.onKeyDown, (event) => {
      const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
      if (event.key === "Tab") event.preventDefault();
      if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
      if ([
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(event.key)) {
        const items = getItems().filter(
          (item) => !item.disabled
        );
        let candidateNodes = items.map(
          (item) => item.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
        if ([
          "ArrowUp",
          "ArrowDown"
        ].includes(event.key)) {
          const currentElement = event.target;
          const currentIndex = candidateNodes.indexOf(currentElement);
          candidateNodes = candidateNodes.slice(currentIndex + 1);
        }
        setTimeout(
          () => focusFirst(candidateNodes)
        );
        event.preventDefault();
      }
    })
  }))))));
});
var $cc7e05a45900e73f$var$SelectItemAlignedPosition = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, onPlaced, ...popperProps } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$CONTENT_NAME, __scopeSelect);
  const [contentWrapper, setContentWrapper] = $01b9c$useState(null);
  const [content, setContent] = $01b9c$useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(
    forwardedRef,
    (node) => setContent(node)
  );
  const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
  const shouldExpandOnScrollRef = $01b9c$useRef(false);
  const shouldRepositionRef = $01b9c$useRef(true);
  const { viewport, selectedItem, selectedItemText, focusSelectedItem } = contentContext;
  const position = $01b9c$useCallback(() => {
    if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
      const triggerRect = context.trigger.getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();
      const valueNodeRect = context.valueNode.getBoundingClientRect();
      const itemTextRect = selectedItemText.getBoundingClientRect();
      if (context.dir !== "rtl") {
        const itemTextOffset = itemTextRect.left - contentRect.left;
        const left = valueNodeRect.left - itemTextOffset;
        const leftDelta = triggerRect.left - left;
        const minContentWidth = triggerRect.width + leftDelta;
        const contentWidth = Math.max(minContentWidth, contentRect.width);
        const rightEdge = window.innerWidth - $cc7e05a45900e73f$var$CONTENT_MARGIN;
        const clampedLeft = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(left, [
          $cc7e05a45900e73f$var$CONTENT_MARGIN,
          rightEdge - contentWidth
        ]);
        contentWrapper.style.minWidth = minContentWidth + "px";
        contentWrapper.style.left = clampedLeft + "px";
      } else {
        const itemTextOffset = contentRect.right - itemTextRect.right;
        const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
        const rightDelta = window.innerWidth - triggerRect.right - right;
        const minContentWidth = triggerRect.width + rightDelta;
        const contentWidth = Math.max(minContentWidth, contentRect.width);
        const leftEdge = window.innerWidth - $cc7e05a45900e73f$var$CONTENT_MARGIN;
        const clampedRight = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(right, [
          $cc7e05a45900e73f$var$CONTENT_MARGIN,
          leftEdge - contentWidth
        ]);
        contentWrapper.style.minWidth = minContentWidth + "px";
        contentWrapper.style.right = clampedRight + "px";
      }
      const items = getItems();
      const availableHeight = window.innerHeight - $cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
      const itemsHeight = viewport.scrollHeight;
      const contentStyles = window.getComputedStyle(content);
      const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
      const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
      const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
      const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
      const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
      const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
      const viewportStyles = window.getComputedStyle(viewport);
      const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
      const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
      const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $cc7e05a45900e73f$var$CONTENT_MARGIN;
      const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
      const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
      const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
      const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
      const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
      const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
      if (willAlignWithoutTopOverflow) {
        const isLastItem = selectedItem === items[items.length - 1].ref.current;
        contentWrapper.style.bottom = "0px";
        const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
        const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
        const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
        contentWrapper.style.height = height + "px";
      } else {
        const isFirstItem = selectedItem === items[0].ref.current;
        contentWrapper.style.top = "0px";
        const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
        const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
        contentWrapper.style.height = height + "px";
        viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
      }
      contentWrapper.style.margin = `${$cc7e05a45900e73f$var$CONTENT_MARGIN}px 0`;
      contentWrapper.style.minHeight = minContentHeight + "px";
      contentWrapper.style.maxHeight = availableHeight + "px";
      onPlaced === null || onPlaced === void 0 || onPlaced();
      requestAnimationFrame(
        () => shouldExpandOnScrollRef.current = true
      );
    }
  }, [
    getItems,
    context.trigger,
    context.valueNode,
    contentWrapper,
    content,
    viewport,
    selectedItem,
    selectedItemText,
    context.dir,
    onPlaced
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c3(
    () => position(),
    [
      position
    ]
  );
  const [contentZIndex, setContentZIndex] = $01b9c$useState();
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [
    content
  ]);
  const handleScrollButtonChange = $01b9c$useCallback((node) => {
    if (node && shouldRepositionRef.current === true) {
      position();
      focusSelectedItem === null || focusSelectedItem === void 0 || focusSelectedItem();
      shouldRepositionRef.current = false;
    }
  }, [
    position,
    focusSelectedItem
  ]);
  return /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectViewportProvider, {
    scope: __scopeSelect,
    contentWrapper,
    shouldExpandOnScrollRef,
    onScrollButtonChange: handleScrollButtonChange
  }, /* @__PURE__ */ $01b9c$createElement("div", {
    ref: setContentWrapper,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: contentZIndex
    }
  }, /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({}, popperProps, {
    ref: composedRefs,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...popperProps.style
    }
  }))));
});
var $cc7e05a45900e73f$var$SelectPopperPosition = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, align = "start", collisionPadding = $cc7e05a45900e73f$var$CONTENT_MARGIN, ...popperProps } = props;
  const popperScope = $cc7e05a45900e73f$var$usePopperScope(__scopeSelect);
  return /* @__PURE__ */ $01b9c$createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d2, _extends({}, popperScope, popperProps, {
    ref: forwardedRef,
    align,
    collisionPadding,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...popperProps.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
});
var [$cc7e05a45900e73f$var$SelectViewportProvider, $cc7e05a45900e73f$var$useSelectViewportContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$CONTENT_NAME, {});
var $cc7e05a45900e73f$var$VIEWPORT_NAME = "SelectViewport";
var $cc7e05a45900e73f$export$9ed6e7b40248d36d = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, ...viewportProps } = props;
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
  const viewportContext = $cc7e05a45900e73f$var$useSelectViewportContext($cc7e05a45900e73f$var$VIEWPORT_NAME, __scopeSelect);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, contentContext.onViewportChange);
  const prevScrollTopRef = $01b9c$useRef(0);
  return /* @__PURE__ */ $01b9c$createElement($01b9c$Fragment, null, /* @__PURE__ */ $01b9c$createElement("style", {
    dangerouslySetInnerHTML: {
      __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
    }
  }), /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$Collection.Slot, {
    scope: __scopeSelect
  }, /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, viewportProps, {
    ref: composedRefs,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...viewportProps.style
    },
    onScroll: $e42e1063c40fb3ef$export$b9ecd428b558ff103(viewportProps.onScroll, (event) => {
      const viewport = event.currentTarget;
      const { contentWrapper, shouldExpandOnScrollRef } = viewportContext;
      if (shouldExpandOnScrollRef !== null && shouldExpandOnScrollRef !== void 0 && shouldExpandOnScrollRef.current && contentWrapper) {
        const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
        if (scrolledBy > 0) {
          const availableHeight = window.innerHeight - $cc7e05a45900e73f$var$CONTENT_MARGIN * 2;
          const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
          const cssHeight = parseFloat(contentWrapper.style.height);
          const prevHeight = Math.max(cssMinHeight, cssHeight);
          if (prevHeight < availableHeight) {
            const nextHeight = prevHeight + scrolledBy;
            const clampedNextHeight = Math.min(availableHeight, nextHeight);
            const heightDiff = nextHeight - clampedNextHeight;
            contentWrapper.style.height = clampedNextHeight + "px";
            if (contentWrapper.style.bottom === "0px") {
              viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
              contentWrapper.style.justifyContent = "flex-end";
            }
          }
        }
      }
      prevScrollTopRef.current = viewport.scrollTop;
    })
  }))));
});
var $cc7e05a45900e73f$var$GROUP_NAME = "SelectGroup";
var [$cc7e05a45900e73f$var$SelectGroupContextProvider, $cc7e05a45900e73f$var$useSelectGroupContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$GROUP_NAME);
var $cc7e05a45900e73f$export$ee25a334c55de1f4 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, ...groupProps } = props;
  const groupId = $1746a345f3d73bb7$export$f680877a34711e373();
  return /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectGroupContextProvider, {
    scope: __scopeSelect,
    id: groupId
  }, /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({
    role: "group",
    "aria-labelledby": groupId
  }, groupProps, {
    ref: forwardedRef
  })));
});
var $cc7e05a45900e73f$var$LABEL_NAME = "SelectLabel";
var $cc7e05a45900e73f$export$f67338d29bd972f8 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, ...labelProps } = props;
  const groupContext = $cc7e05a45900e73f$var$useSelectGroupContext($cc7e05a45900e73f$var$LABEL_NAME, __scopeSelect);
  return /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({
    id: groupContext.id
  }, labelProps, {
    ref: forwardedRef
  }));
});
var $cc7e05a45900e73f$var$ITEM_NAME = "SelectItem";
var [$cc7e05a45900e73f$var$SelectItemContextProvider, $cc7e05a45900e73f$var$useSelectItemContext] = $cc7e05a45900e73f$var$createSelectContext($cc7e05a45900e73f$var$ITEM_NAME);
var $cc7e05a45900e73f$export$13ef48a934230896 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, value, disabled: disabled2 = false, textValue: textValueProp, ...itemProps } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$ITEM_NAME, __scopeSelect);
  const isSelected = context.value === value;
  const [textValue, setTextValue] = $01b9c$useState(textValueProp !== null && textValueProp !== void 0 ? textValueProp : "");
  const [isFocused, setIsFocused] = $01b9c$useState(false);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, (node) => {
    var _contentContext$itemR;
    return (_contentContext$itemR = contentContext.itemRefCallback) === null || _contentContext$itemR === void 0 ? void 0 : _contentContext$itemR.call(contentContext, node, value, disabled2);
  });
  const textId = $1746a345f3d73bb7$export$f680877a34711e373();
  const handleSelect = () => {
    if (!disabled2) {
      context.onValueChange(value);
      context.onOpenChange(false);
    }
  };
  return /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectItemContextProvider, {
    scope: __scopeSelect,
    value,
    disabled: disabled2,
    textId,
    isSelected,
    onItemTextChange: $01b9c$useCallback((node) => {
      setTextValue((prevTextValue) => {
        var _node$textContent;
        return prevTextValue || ((_node$textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node$textContent !== void 0 ? _node$textContent : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$Collection.ItemSlot, {
    scope: __scopeSelect,
    value,
    disabled: disabled2,
    textValue
  }, /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({
    role: "option",
    "aria-labelledby": textId,
    "data-highlighted": isFocused ? "" : void 0,
    "aria-selected": isSelected && isFocused,
    "data-state": isSelected ? "checked" : "unchecked",
    "aria-disabled": disabled2 || void 0,
    "data-disabled": disabled2 ? "" : void 0,
    tabIndex: disabled2 ? void 0 : -1
  }, itemProps, {
    ref: composedRefs,
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff103(
      itemProps.onFocus,
      () => setIsFocused(true)
    ),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff103(
      itemProps.onBlur,
      () => setIsFocused(false)
    ),
    onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff103(itemProps.onPointerUp, handleSelect),
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff103(itemProps.onPointerMove, (event) => {
      if (disabled2) {
        var _contentContext$onIte;
        (_contentContext$onIte = contentContext.onItemLeave) === null || _contentContext$onIte === void 0 || _contentContext$onIte.call(contentContext);
      } else
        event.currentTarget.focus({
          preventScroll: true
        });
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff103(itemProps.onPointerLeave, (event) => {
      if (event.currentTarget === document.activeElement) {
        var _contentContext$onIte2;
        (_contentContext$onIte2 = contentContext.onItemLeave) === null || _contentContext$onIte2 === void 0 || _contentContext$onIte2.call(contentContext);
      }
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff103(itemProps.onKeyDown, (event) => {
      var _contentContext$searc;
      const isTypingAhead = ((_contentContext$searc = contentContext.searchRef) === null || _contentContext$searc === void 0 ? void 0 : _contentContext$searc.current) !== "";
      if (isTypingAhead && event.key === " ") return;
      if ($cc7e05a45900e73f$var$SELECTION_KEYS.includes(event.key)) handleSelect();
      if (event.key === " ") event.preventDefault();
    })
  }))));
});
var $cc7e05a45900e73f$var$ITEM_TEXT_NAME = "SelectItemText";
var $cc7e05a45900e73f$export$3572fb0fb821ff49 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, className, style, ...itemTextProps } = props;
  const context = $cc7e05a45900e73f$var$useSelectContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
  const itemContext = $cc7e05a45900e73f$var$useSelectItemContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
  const nativeOptionsContext = $cc7e05a45900e73f$var$useSelectNativeOptionsContext($cc7e05a45900e73f$var$ITEM_TEXT_NAME, __scopeSelect);
  const [itemTextNode, setItemTextNode] = $01b9c$useState(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(
    forwardedRef,
    (node) => setItemTextNode(node),
    itemContext.onItemTextChange,
    (node) => {
      var _contentContext$itemT;
      return (_contentContext$itemT = contentContext.itemTextRefCallback) === null || _contentContext$itemT === void 0 ? void 0 : _contentContext$itemT.call(contentContext, node, itemContext.value, itemContext.disabled);
    }
  );
  const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
  const nativeOption = $01b9c$useMemo(
    () => /* @__PURE__ */ $01b9c$createElement("option", {
      key: itemContext.value,
      value: itemContext.value,
      disabled: itemContext.disabled
    }, textContent),
    [
      itemContext.disabled,
      itemContext.value,
      textContent
    ]
  );
  const { onNativeOptionAdd, onNativeOptionRemove } = nativeOptionsContext;
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    onNativeOptionAdd(nativeOption);
    return () => onNativeOptionRemove(nativeOption);
  }, [
    onNativeOptionAdd,
    onNativeOptionRemove,
    nativeOption
  ]);
  return /* @__PURE__ */ $01b9c$createElement($01b9c$Fragment, null, /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.span, _extends({
    id: itemContext.textId
  }, itemTextProps, {
    ref: composedRefs
  })), itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? /* @__PURE__ */ $01b9c$createPortal(itemTextProps.children, context.valueNode) : null);
});
var $cc7e05a45900e73f$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
var $cc7e05a45900e73f$export$6b9198de19accfe6 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, ...itemIndicatorProps } = props;
  const itemContext = $cc7e05a45900e73f$var$useSelectItemContext($cc7e05a45900e73f$var$ITEM_INDICATOR_NAME, __scopeSelect);
  return itemContext.isSelected ? /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.span, _extends({
    "aria-hidden": true
  }, itemIndicatorProps, {
    ref: forwardedRef
  })) : null;
});
var $cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var $cc7e05a45900e73f$export$d8117927658af6d7 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
  const viewportContext = $cc7e05a45900e73f$var$useSelectViewportContext($cc7e05a45900e73f$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
  const [canScrollUp1, setCanScrollUp] = $01b9c$useState(false);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, viewportContext.onScrollButtonChange);
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    if (contentContext.viewport && contentContext.isPositioned) {
      let handleScroll3 = function() {
        const canScrollUp = viewport.scrollTop > 0;
        setCanScrollUp(canScrollUp);
      };
      var handleScroll2 = handleScroll3;
      const viewport = contentContext.viewport;
      handleScroll3();
      viewport.addEventListener("scroll", handleScroll3);
      return () => viewport.removeEventListener("scroll", handleScroll3);
    }
  }, [
    contentContext.viewport,
    contentContext.isPositioned
  ]);
  return canScrollUp1 ? /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectScrollButtonImpl, _extends({}, props, {
    ref: composedRefs,
    onAutoScroll: () => {
      const { viewport, selectedItem } = contentContext;
      if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
    }
  })) : null;
});
var $cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var $cc7e05a45900e73f$export$ff951e476c12189 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext($cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
  const viewportContext = $cc7e05a45900e73f$var$useSelectViewportContext($cc7e05a45900e73f$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
  const [canScrollDown1, setCanScrollDown] = $01b9c$useState(false);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, viewportContext.onScrollButtonChange);
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    if (contentContext.viewport && contentContext.isPositioned) {
      let handleScroll3 = function() {
        const maxScroll = viewport.scrollHeight - viewport.clientHeight;
        const canScrollDown = Math.ceil(viewport.scrollTop) < maxScroll;
        setCanScrollDown(canScrollDown);
      };
      var handleScroll2 = handleScroll3;
      const viewport = contentContext.viewport;
      handleScroll3();
      viewport.addEventListener("scroll", handleScroll3);
      return () => viewport.removeEventListener("scroll", handleScroll3);
    }
  }, [
    contentContext.viewport,
    contentContext.isPositioned
  ]);
  return canScrollDown1 ? /* @__PURE__ */ $01b9c$createElement($cc7e05a45900e73f$var$SelectScrollButtonImpl, _extends({}, props, {
    ref: composedRefs,
    onAutoScroll: () => {
      const { viewport, selectedItem } = contentContext;
      if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
    }
  })) : null;
});
var $cc7e05a45900e73f$var$SelectScrollButtonImpl = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, onAutoScroll, ...scrollIndicatorProps } = props;
  const contentContext = $cc7e05a45900e73f$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
  const autoScrollTimerRef = $01b9c$useRef(null);
  const getItems = $cc7e05a45900e73f$var$useCollection(__scopeSelect);
  const clearAutoScrollTimer = $01b9c$useCallback(() => {
    if (autoScrollTimerRef.current !== null) {
      window.clearInterval(autoScrollTimerRef.current);
      autoScrollTimerRef.current = null;
    }
  }, []);
  $01b9c$useEffect(() => {
    return () => clearAutoScrollTimer();
  }, [
    clearAutoScrollTimer
  ]);
  $9f79659886946c16$export$e5c5a5f917a5871c3(() => {
    var _activeItem$ref$curre;
    const activeItem = getItems().find(
      (item) => item.ref.current === document.activeElement
    );
    activeItem === null || activeItem === void 0 || (_activeItem$ref$curre = activeItem.ref.current) === null || _activeItem$ref$curre === void 0 || _activeItem$ref$curre.scrollIntoView({
      block: "nearest"
    });
  }, [
    getItems
  ]);
  return /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({
    "aria-hidden": true
  }, scrollIndicatorProps, {
    ref: forwardedRef,
    style: {
      flexShrink: 0,
      ...scrollIndicatorProps.style
    },
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff103(scrollIndicatorProps.onPointerMove, () => {
      var _contentContext$onIte3;
      (_contentContext$onIte3 = contentContext.onItemLeave) === null || _contentContext$onIte3 === void 0 || _contentContext$onIte3.call(contentContext);
      if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff103(scrollIndicatorProps.onPointerLeave, () => {
      clearAutoScrollTimer();
    })
  }));
});
var $cc7e05a45900e73f$export$eba4b1df07cb1d3 = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { __scopeSelect, ...separatorProps } = props;
  return /* @__PURE__ */ $01b9c$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0343.div, _extends({
    "aria-hidden": true
  }, separatorProps, {
    ref: forwardedRef
  }));
});
var $cc7e05a45900e73f$var$BubbleSelect = /* @__PURE__ */ $01b9c$forwardRef((props, forwardedRef) => {
  const { value, ...selectProps } = props;
  const ref = $01b9c$useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d054(forwardedRef, ref);
  const prevValue = $010c2913dbd2fe3d$export$5cae361ad82dce8b(value);
  $01b9c$useEffect(() => {
    const select = ref.current;
    const selectProto = window.HTMLSelectElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
    const setValue = descriptor.set;
    if (prevValue !== value && setValue) {
      const event = new Event("change", {
        bubbles: true
      });
      setValue.call(select, value);
      select.dispatchEvent(event);
    }
  }, [
    prevValue,
    value
  ]);
  return /* @__PURE__ */ $01b9c$createElement($ea1ef594cf570d83$export$439d29a4e110a164, {
    asChild: true
  }, /* @__PURE__ */ $01b9c$createElement("select", _extends({}, selectProps, {
    ref: composedRefs,
    defaultValue: value
  })));
});
$cc7e05a45900e73f$var$BubbleSelect.displayName = "BubbleSelect";
function $cc7e05a45900e73f$var$useTypeaheadSearch(onSearchChange) {
  const handleSearchChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a3(onSearchChange);
  const searchRef = $01b9c$useRef("");
  const timerRef = $01b9c$useRef(0);
  const handleTypeaheadSearch = $01b9c$useCallback((key) => {
    const search = searchRef.current + key;
    handleSearchChange(search);
    (function updateSearch(value) {
      searchRef.current = value;
      window.clearTimeout(timerRef.current);
      if (value !== "") timerRef.current = window.setTimeout(
        () => updateSearch(""),
        1e3
      );
    })(search);
  }, [
    handleSearchChange
  ]);
  const resetTypeahead = $01b9c$useCallback(() => {
    searchRef.current = "";
    window.clearTimeout(timerRef.current);
  }, []);
  $01b9c$useEffect(() => {
    return () => window.clearTimeout(timerRef.current);
  }, []);
  return [
    searchRef,
    handleTypeaheadSearch,
    resetTypeahead
  ];
}
function $cc7e05a45900e73f$var$findNextItem(items, search, currentItem) {
  const isRepeated = search.length > 1 && Array.from(search).every(
    (char) => char === search[0]
  );
  const normalizedSearch = isRepeated ? search[0] : search;
  const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
  let wrappedItems = $cc7e05a45900e73f$var$wrapArray(items, Math.max(currentItemIndex, 0));
  const excludeCurrentItem = normalizedSearch.length === 1;
  if (excludeCurrentItem) wrappedItems = wrappedItems.filter(
    (v5) => v5 !== currentItem
  );
  const nextItem = wrappedItems.find(
    (item) => item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase())
  );
  return nextItem !== currentItem ? nextItem : void 0;
}
function $cc7e05a45900e73f$var$wrapArray(array, startIndex) {
  return array.map(
    (_, index5) => array[(startIndex + index5) % array.length]
  );
}
var $cc7e05a45900e73f$export$be92b6f5f03c0fe9 = $cc7e05a45900e73f$export$ef9b1a59e592288f;
var $cc7e05a45900e73f$export$41fb9f06171c75f4 = $cc7e05a45900e73f$export$3ac1e88a1c0b9f1;
var $cc7e05a45900e73f$export$4c8d1a57a761ef94 = $cc7e05a45900e73f$export$e288731fd71264f0;
var $cc7e05a45900e73f$export$f04a61298a47a40f = $cc7e05a45900e73f$export$99b400cabb58c515;
var $cc7e05a45900e73f$export$602eac185826482c = $cc7e05a45900e73f$export$b2af6c9944296213;
var $cc7e05a45900e73f$export$7c6e2c02157bb7d2 = $cc7e05a45900e73f$export$c973a4b3cb86a03d;
var $cc7e05a45900e73f$export$d5c6c08dc2d3ca7 = $cc7e05a45900e73f$export$9ed6e7b40248d36d;
var $cc7e05a45900e73f$export$eb2fcfdbd7ba97d4 = $cc7e05a45900e73f$export$ee25a334c55de1f4;
var $cc7e05a45900e73f$export$b04be29aa201d4f5 = $cc7e05a45900e73f$export$f67338d29bd972f8;
var $cc7e05a45900e73f$export$6d08773d2e66f8f2 = $cc7e05a45900e73f$export$13ef48a934230896;
var $cc7e05a45900e73f$export$d6e5bf9c43ea9319 = $cc7e05a45900e73f$export$3572fb0fb821ff49;
var $cc7e05a45900e73f$export$c3468e2714d175fa = $cc7e05a45900e73f$export$6b9198de19accfe6;
var $cc7e05a45900e73f$export$2f60d3ec9ad468f2 = $cc7e05a45900e73f$export$d8117927658af6d7;
var $cc7e05a45900e73f$export$bf1aedc3039c8d63 = $cc7e05a45900e73f$export$ff951e476c12189;
var $cc7e05a45900e73f$export$1ff3c3f08ae963c0 = $cc7e05a45900e73f$export$eba4b1df07cb1d3;

// src/components/Select/Select.tsx
var import_faCheck = __toESM(require_faCheck());
var import_faCaretDown2 = __toESM(require_faCaretDown());
var import_faChevronUp = __toESM(require_faChevronUp());
var import_faChevronDown = __toESM(require_faChevronDown());
import { jsx as jsx13, jsxs as jsxs4 } from "react/jsx-runtime";
function Select({
  ...props
}) {
  return /* @__PURE__ */ jsx13($cc7e05a45900e73f$export$be92b6f5f03c0fe9, { "data-slot": "select", ...props });
}
function SelectGroup({
  ...props
}) {
  return /* @__PURE__ */ jsx13($cc7e05a45900e73f$export$eb2fcfdbd7ba97d4, { "data-slot": "select-group", ...props });
}
function SelectValue({
  ...props
}) {
  return /* @__PURE__ */ jsx13($cc7e05a45900e73f$export$4c8d1a57a761ef94, { "data-slot": "select-value", ...props });
}
function SelectTrigger({
  className,
  size: size3 = DEFAULT_COMPONENT_SIZE,
  children,
  ...props
}) {
  const sizeClasses = {
    small: "px-4 py-2 h-8 max-h-8",
    medium: "px-4 py-3 max-h-10"
  };
  return /* @__PURE__ */ jsxs4(
    $cc7e05a45900e73f$export$41fb9f06171c75f4,
    {
      "data-slot": "select-trigger",
      "data-size": size3,
      className: cn(
        // Layout
        "flex w-full items-center justify-between",
        // Spacing
        "gap-2",
        // Appearance
        "bg-neutral-1 rounded-md",
        // Borders
        "border-neutral-1 border",
        "data-[state=open]:border-highlight-2",
        // Typography
        "text-neutral-1 whitespace-nowrap text-sm",
        "[&>span]:inline [&>span]:text-ellipsis",
        // Interactions
        "cursor-pointer outline-none",
        "transition-[color,box-shadow]",
        "focus-within:ring-2 focus-within:ring-[var(--border-focus-ring)]",
        "disabled:cursor-not-allowed disabled:border-none disabled:opacity-50",
        // Icons
        '[&_svg:not([class*="size-"])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        // Select value styling
        "*:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2",
        // Size variants
        "data-[size=default]:h-10 data-[size=small]:h-8",
        sizeClasses[size3],
        className
      ),
      ...props,
      children: [
        children,
        /* @__PURE__ */ jsx13($cc7e05a45900e73f$export$f04a61298a47a40f, { asChild: true, children: /* @__PURE__ */ jsx13(FontAwesomeIcon, { icon: import_faCaretDown2.faCaretDown }) })
      ]
    }
  );
}
function SelectScrollUpButton({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx13(
    $cc7e05a45900e73f$export$2f60d3ec9ad468f2,
    {
      "data-slot": "select-scroll-up-button",
      className: cn(
        // Layout
        "flex items-center justify-center",
        // Spacing
        "py-1",
        // Interactions
        "cursor-default",
        // Icons
        "[&_svg]:size-3",
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsx13(FontAwesomeIcon, { icon: import_faChevronUp.faChevronUp })
    }
  );
}
function SelectScrollDownButton({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx13(
    $cc7e05a45900e73f$export$bf1aedc3039c8d63,
    {
      "data-slot": "select-scroll-down-button",
      className: cn(
        // Layout
        "flex items-center justify-center",
        // Spacing
        "py-1",
        // Interactions
        "cursor-default",
        // Icons
        "[&_svg]:size-3",
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsx13(FontAwesomeIcon, { icon: import_faChevronDown.faChevronDown })
    }
  );
}
function SelectPortal({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx13($cc7e05a45900e73f$export$602eac185826482c, { ...props, children });
}
var SelectContent = React21.forwardRef(({ className, children, position = "popper", ...props }, ref) => {
  return /* @__PURE__ */ jsxs4(
    $cc7e05a45900e73f$export$7c6e2c02157bb7d2,
    {
      ref,
      "data-slot": "select-content",
      className: cn(
        // Position
        "relative z-50",
        "origin-(--radix-select-content-transform-origin)",
        // Sizing
        "min-w-[8rem] max-w-md",
        "max-h-(--radix-select-content-available-height)",
        // Overflow
        "overflow-y-auto overflow-x-hidden",
        // Appearance
        "bg-neutral-1 rounded-md shadow-md",
        // Borders
        "border-neutral-1 border",
        // Typography
        "text-neutral-1",
        // Animations
        "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=top]:slide-in-from-bottom-2",
        // Position-specific translations
        position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        className
      ),
      position,
      ...props,
      children: [
        /* @__PURE__ */ jsx13(SelectScrollUpButton, {}),
        /* @__PURE__ */ jsx13(
          $cc7e05a45900e73f$export$d5c6c08dc2d3ca7,
          {
            className: cn(
              // Spacing
              "p-1",
              // Position-specific sizing
              position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children
          }
        ),
        /* @__PURE__ */ jsx13(SelectScrollDownButton, {})
      ]
    }
  );
});
SelectContent.displayName = "SelectContent";
function SelectLabel({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx13(
    $cc7e05a45900e73f$export$b04be29aa201d4f5,
    {
      "data-slot": "select-label",
      className: cn(
        // Spacing
        "px-2 py-1.5",
        // Typography
        "text-xs",
        className
      ),
      ...props
    }
  );
}
function SelectItem({
  className,
  children,
  title = typeof children === "string" ? children : void 0,
  hideIndicator = false,
  ...props
}) {
  return /* @__PURE__ */ jsxs4(
    $cc7e05a45900e73f$export$6d08773d2e66f8f2,
    {
      "data-slot": "select-item",
      className: cn(
        // Layout
        "relative flex h-8 w-full items-center",
        // Spacing
        "gap-2 py-1.5 pl-2 pr-8",
        // Appearance
        "rounded-sm",
        // Typography
        "text-sm",
        // Interactions
        "cursor-pointer select-none outline-none",
        "hover:bg-highlight-3",
        "focus:bg-highlight-3",
        // Checked state
        "data-[state=checked]:bg-highlight-1 data-[state=checked]:text-highlight-2",
        // Disabled state
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        // Span styling (for ItemText)
        "[&>span]:truncate [&>span]:first:inline [&>span]:first:w-fit",
        // Icons
        '[&_svg:not([class*="size-"])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        className
      ),
      title,
      ...props,
      children: [
        /* @__PURE__ */ jsx13($cc7e05a45900e73f$export$d6e5bf9c43ea9319, { children }),
        !hideIndicator && /* @__PURE__ */ jsx13($cc7e05a45900e73f$export$c3468e2714d175fa, { className: "size-3.5 absolute right-2 top-1/2 flex -translate-y-1/2 items-center justify-center", children: /* @__PURE__ */ jsx13(FontAwesomeIcon, { icon: import_faCheck.faCheck }) })
      ]
    }
  );
}
function SelectButton({
  children,
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx13(
    "button",
    {
      type: "button",
      "data-slot": "select-item",
      className: cn(
        "focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground outline-hidden [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2 hover:bg-highlight-3 data-[state=checked]:bg-highlight-1 data-[state=checked]:text-highlight-2 relative flex h-8 w-full cursor-pointer select-none items-center gap-2 rounded-sm py-1.5 pl-2 pr-8 text-sm data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>span]:truncate [&>span]:first:inline [&>span]:first:w-fit [&_svg]:pointer-events-none [&_svg]:shrink-0",
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsx13("span", { children })
    }
  );
}
function SelectSeparator({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx13(
    $cc7e05a45900e73f$export$1ff3c3f08ae963c0,
    {
      "data-slot": "select-separator",
      className: cn(
        // Sizing
        "w-45 h-px",
        // Spacing
        "mx-auto my-2",
        // Appearance
        "bg-neutral-2",
        // Interactions
        "pointer-events-none",
        className
      ),
      ...props
    }
  );
}

// src/components/ColorPicker/ColorSpaces/HEX.tsx
import { useState as useState16, useEffect as useEffect17 } from "react";

// src/components/Fieldset/Fieldset.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var Fieldset = ({
  children,
  className,
  showNumberControls = false
}) => /* @__PURE__ */ jsx14(
  "fieldset",
  {
    className: cn(
      // Container styles
      "flex rounded-md",
      "border-1 border-neutral-1 bg-neutral-1",
      // Input wrapper (div) styles
      "[&>div]:border-0 [&>div]:px-2 [&>div]:py-1",
      "[&>div]:rounded-l-none [&>div]:rounded-r-none",
      "[&>div:first-child]:rounded-l-md [&>div:last-child]:rounded-r-md",
      "[&>div:not(:last-child)]:border-r-1",
      // Button styles
      "[&>button]:rounded-l-none",
      "[&>button:first-child]:rounded-l-md [&>button:last-child]:rounded-r-md",
      // Hide number input controls by default
      !showNumberControls && "[&_.number-controls]:hidden",
      className
    ),
    children
  }
);

// src/components/Input/Input.tsx
import { useImperativeHandle as useImperativeHandle2, useRef as useRef9, forwardRef as forwardRef10 } from "react";

// src/components/Input/Icons.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var CustomChevronDown = () => {
  return /* @__PURE__ */ jsx15(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "6",
      viewBox: "0 0 8 6",
      fill: "none",
      "aria-hidden": true,
      children: /* @__PURE__ */ jsx15(
        "path",
        {
          d: "M7.78037 1.96282L4.59625 5.16949C4.41838 5.32732 4.21295 5.40498 4.00752 5.40498C3.80209 5.40498 3.59717 5.32669 3.44059 5.17011L0.256467 1.96344C0.00480378 1.73484 -0.0638491 1.38912 0.0602592 1.091C0.184367 0.792883 0.476926 0.594971 0.80085 0.594971L7.19165 0.594971C7.51582 0.594971 7.80843 0.789901 7.93269 1.08975C8.05695 1.3896 8.01085 1.73484 7.78037 1.96282Z",
          fill: "currentColor"
        }
      )
    }
  );
};
var CustomChevronUp = () => {
  return /* @__PURE__ */ jsx15(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "8",
      height: "6",
      viewBox: "0 0 8 6",
      fill: "none",
      "aria-hidden": true,
      children: /* @__PURE__ */ jsx15(
        "path",
        {
          d: "M0.235526 4.0379L3.42183 0.829035C3.60007 0.671098 3.80564 0.593384 4.01121 0.593384C4.21678 0.593384 4.42184 0.671725 4.57852 0.828408L7.76483 4.03727C7.99436 4.26681 8.06315 4.61161 7.93888 4.91169C7.81462 5.21177 7.54347 5.40668 7.19751 5.40668L0.802592 5.40668C0.478196 5.40668 0.185387 5.21162 0.0610436 4.91156C-0.0633 4.61151 0.00597392 4.26603 0.235526 4.0379Z",
          fill: "currentColor"
        }
      )
    }
  );
};

// src/components/Input/Custom/Color/Color.tsx
import { useState as useState15, useRef as useRef8, useEffect as useEffect16 } from "react";

// src/components/Input/Custom/Color/Swatch.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var backgroundColor = ({ r: r6, g: g5, b: b5, a: a5 = 1 }) => a5 < 1 ? `linear-gradient(to right, rgba(${r6}, ${g5}, ${b5}) 50%, rgba(${r6}, ${g5}, ${b5}, ${a5}) 50%)` : `rgba(${r6}, ${g5}, ${b5})`;
var Swatch = ({
  color,
  disabled: disabled2 = false
}) => /* @__PURE__ */ jsx16("span", { className: cn("block h-8 w-8 rounded-md px-1 py-1"), children: /* @__PURE__ */ jsx16(
  "span",
  {
    className: cn("block h-full w-full rounded-sm", disabled2 && "opacity-50"),
    style: { background: backgroundColor(color.rgb) }
  }
) });

// src/components/Input/Custom/Color/Color.tsx
import { jsx as jsx17, jsxs as jsxs5 } from "react/jsx-runtime";
var ColorInput = ({
  value = DEFAULT_COLOR,
  onChange: onChange2,
  display,
  alpha = false,
  className,
  container,
  disabled: disabled2 = false
}) => {
  const colorRgb = toRgb(value);
  const ref = useRef8(null);
  const [visible, setVisible] = useState15(false);
  const [currentColor, setCurrentColor] = useState15({
    rgb: colorRgb,
    hex: toHex2(colorRgb),
    hsl: toHsl(colorRgb)
  });
  useEffect16(() => {
    const newRgb = toRgb(value);
    setCurrentColor({
      rgb: newRgb,
      hex: toHex2(newRgb),
      hsl: toHsl(newRgb)
    });
  }, [value]);
  const open2 = () => {
    if (disabled2) return;
    setVisible(true);
  };
  const close = () => {
    if (disabled2) return;
    setVisible(false);
  };
  const handleChange = (newColor) => {
    if (disabled2) return;
    setCurrentColor(newColor);
    onChange2?.(newColor);
  };
  return /* @__PURE__ */ jsxs5("div", { className: cn(className), children: [
    /* @__PURE__ */ jsxs5(
      "button",
      {
        type: "button",
        className: cn(
          "font-lato text-neutral-1 border-1 border-neutral-1 bg-neutral-1 flex h-8 w-full cursor-pointer items-center justify-start rounded-md font-semibold",
          // Disabled state
          "disabled:text-neutral-4 disabled:*:pointer-events-none disabled:*:cursor-not-allowed disabled:cursor-not-allowed disabled:border-transparent"
        ),
        onClick: open2,
        "aria-label": "Color",
        ref,
        disabled: disabled2,
        children: [
          /* @__PURE__ */ jsx17(Swatch, { color: currentColor, disabled: disabled2 }),
          display && /* @__PURE__ */ jsxs5("span", { className: cn("flex h-full pr-1 text-xs/[30px]"), children: [
            display === "HEX" && /* @__PURE__ */ jsxs5("span", { className: "min-w-[58px]", children: [
              "#",
              currentColor.hex.replace("#", "").slice(0, 6)
            ] }),
            display === "HSL" && /* @__PURE__ */ jsxs5("div", { className: "flex flex-row gap-1", children: [
              /* @__PURE__ */ jsx17("span", { children: "H" }),
              currentColor.hsl.h.toFixed(0),
              /* @__PURE__ */ jsx17("span", { className: "border-neutral-1 border-l pl-1", children: "S" }),
              Math.round(currentColor.hsl.s * 100),
              "%",
              /* @__PURE__ */ jsx17("span", { className: "border-neutral-1 border-l pl-1", children: "L" }),
              Math.round(currentColor.hsl.l * 100),
              "%"
            ] }),
            display === "RGB" && /* @__PURE__ */ jsxs5("div", { className: "flex flex-row gap-1", children: [
              /* @__PURE__ */ jsx17("span", { children: "R" }),
              currentColor.rgb.r,
              /* @__PURE__ */ jsx17("span", { className: "border-neutral-1 border-l pl-1", children: "G" }),
              currentColor.rgb.g,
              /* @__PURE__ */ jsx17("span", { className: "border-neutral-1 border-l pl-1", children: "B" }),
              currentColor.rgb.b
            ] })
          ] }),
          display && alpha && /* @__PURE__ */ jsxs5(
            "span",
            {
              className: cn(
                "border-1 border-neutral-1 flex h-8 items-center justify-center rounded-r-md border-r-0 px-1 text-xs"
              ),
              children: [
                /* @__PURE__ */ jsx17("span", { children: Math.round((currentColor.rgb.a ?? 0) * 100) }),
                /* @__PURE__ */ jsx17("span", { className: cn("text-neutral-3 pl-1"), children: "%" })
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx17(
      ColorPicker,
      {
        color: currentColor.rgb,
        container,
        onClose: close,
        onChange: handleChange,
        ref,
        open: visible
      }
    )
  ] });
};

// src/components/Input/Custom/index.ts
var CUSTOM_TYPE_LIST = ["color"];
var CUSTOM_TYPE_MAP = {
  color: ColorInput
};
var isCustomType = (type) => CUSTOM_TYPE_LIST.includes(type);

// src/components/Input/Input.tsx
import { jsx as jsx18, jsxs as jsxs6 } from "react/jsx-runtime";
var isTextAffix = (affix) => {
  return typeof affix === "string";
};
var Input = forwardRef10(
  ({
    className,
    type = "",
    prefix,
    suffix,
    disabled: disabled2,
    size: size3 = DEFAULT_COMPONENT_SIZE,
    onChange: onChange2,
    ...props
  }, ref) => {
    const inputRef = useRef9(null);
    const hasPrefixOrSuffix = Boolean(prefix || suffix);
    useImperativeHandle2(ref, () => inputRef.current);
    const handleArrowClick = (direction) => {
      if (!inputRef.current || disabled2) return;
      inputRef.current.focus();
      const { step = 1, min: min2, max: max2 } = props;
      const currentValue = Number(inputRef.current.value) || 0;
      const stepValue = Number(step);
      const stepStr = stepValue.toString();
      const decimalPlaces = stepStr.includes(".") ? stepStr.split(".")[1].length : 0;
      let value = direction === "up" ? currentValue + stepValue : currentValue - stepValue;
      if (decimalPlaces > 0) {
        value = Number(value.toFixed(decimalPlaces));
      }
      if (min2 !== void 0) value = Math.max(value, Number(min2));
      if (max2 !== void 0) value = Math.min(value, Number(max2));
      inputRef.current.value = value.toString();
      if (onChange2) {
        const event = new Event("change", { bubbles: true });
        inputRef.current.dispatchEvent(event);
        onChange2({
          ...event,
          target: inputRef.current,
          currentTarget: inputRef.current
        });
      }
    };
    const sizeClasses = {
      small: "px-4 py-2 h-8 max-h-8",
      medium: "px-4 py-3 max-h-10"
    };
    const CustomInputType = CUSTOM_TYPE_MAP[type];
    return isCustomType(type) ? /* @__PURE__ */ jsx18(
      CustomInputType,
      {
        onChange: onChange2,
        ...props,
        disabled: disabled2
      }
    ) : /* @__PURE__ */ jsxs6(
      "div",
      {
        className: cn(
          // Layout
          "flex w-full items-center",
          // Appearance
          "bg-neutral-1 rounded-md",
          // Borders
          "border-1 border-neutral-1",
          // Typography
          "font-lato text-neutral-1 text-sm font-semibold leading-5",
          // Focus state
          "ring-offset-transparent focus-within:outline-none focus-within:ring-2 focus-within:ring-[var(--border-focus-ring)]",
          // Disabled state
          "[&:has(input:disabled)]:text-neutral-4 [&:has(input:disabled)]:cursor-not-allowed [&:has(input:disabled)]:border-transparent [&:has(input:disabled)_*]:pointer-events-none [&:has(input:disabled)_*]:cursor-not-allowed",
          // Read-only state
          "[&:has(input:read-only)]:text-neutral-3 [&:has(input:read-only)]:border-transparent",
          // Invalid state
          '[&:has(input[aria-invalid="true"])]:border-destructive-1',
          // Conditional spacing
          hasPrefixOrSuffix && "gap-2",
          sizeClasses[size3],
          className
        ),
        children: [
          prefix && /* @__PURE__ */ jsx18(
            "div",
            {
              className: cn(
                // Typography
                "text-neutral-1",
                // Text prefix style
                isTextAffix(prefix) && "text-neutral-3 font-medium leading-4"
              ),
              children: prefix
            }
          ),
          /* @__PURE__ */ jsx18(
            "input",
            {
              type,
              className: cn(
                // Sizing
                "w-full",
                // Appearance
                "bg-transparent",
                // Interactions
                "outline-none",
                // Placeholder
                "placeholder:text-neutral-3",
                // Hide number spinners
                type === "number" && "[&::-webkit-inner-spin-button]:hidden [&::-webkit-outer-spin-button]:hidden"
              ),
              ref: inputRef,
              disabled: disabled2,
              onChange: onChange2,
              ...props
            }
          ),
          suffix && /* @__PURE__ */ jsx18(
            "div",
            {
              className: cn(
                // Typography
                "text-neutral-1",
                // Text suffix style
                isTextAffix(suffix) && "text-neutral-3 font-medium leading-4"
              ),
              children: suffix
            }
          ),
          type === "number" && /* @__PURE__ */ jsxs6(
            "div",
            {
              className: cn(
                // Layout
                "number-controls flex w-3 flex-col",
                // Typography
                "text-neutral-3"
              ),
              children: [
                /* @__PURE__ */ jsx18(
                  "button",
                  {
                    type: "button",
                    tabIndex: -1,
                    "aria-label": "Increment",
                    onClick: () => handleArrowClick("up"),
                    className: cn(
                      // Spacing
                      "px-0.5 py-0.5",
                      // Typography
                      "text-xs"
                    ),
                    children: /* @__PURE__ */ jsx18(CustomChevronUp, {})
                  }
                ),
                /* @__PURE__ */ jsx18(
                  "button",
                  {
                    type: "button",
                    tabIndex: -1,
                    "aria-label": "Decrement",
                    onClick: () => handleArrowClick("down"),
                    className: cn(
                      // Spacing
                      "px-0.5 py-0.5",
                      // Typography
                      "text-xs"
                    ),
                    children: /* @__PURE__ */ jsx18(CustomChevronDown, {})
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
);
Input.displayName = "Input";

// src/components/ColorPicker/ColorSpaces/HEX.tsx
import { jsx as jsx19, jsxs as jsxs7 } from "react/jsx-runtime";
var SpaceHEX = ({ color, onChange: onChange2 }) => {
  const [hex, setHex] = useState16(toHex2(color));
  const [alpha, setAlpha] = useState16(roundAlpha(color.a));
  const onHexChange = ({
    target: { value }
  }) => setHex(value);
  const onChangeAlpha = ({
    target: { value }
  }) => setAlpha(Number(value));
  const updateColorPicker = () => onChange2(hexToRgb(hex, alpha));
  useEffect17(() => {
    setHex(toHex2(color));
    setAlpha(roundAlpha(color.a));
  }, [color]);
  return /* @__PURE__ */ jsxs7(Fieldset, { className: cn("w-full"), children: [
    /* @__PURE__ */ jsx19(
      Input,
      {
        type: "text",
        size: "small",
        value: hex,
        onChange: onHexChange,
        onBlur: updateColorPicker,
        prefix: "#",
        "aria-label": "HEX",
        className: "flex-3"
      }
    ),
    /* @__PURE__ */ jsx19(
      Input,
      {
        type: "number",
        size: "small",
        suffix: "%",
        value: alpha,
        onChange: onChangeAlpha,
        onBlur: updateColorPicker,
        "aria-label": "Alpha",
        min: 0,
        max: 100,
        className: "flex-1"
      }
    )
  ] });
};

// src/components/ColorPicker/ColorSpaces/RGB.tsx
import { useState as useState17, useEffect as useEffect18 } from "react";
import { jsx as jsx20, jsxs as jsxs8 } from "react/jsx-runtime";
var SpaceRGB = ({ onChange: onChange2, color }) => {
  const [rgba, setRgba] = useState17({
    r: round2(color.r),
    g: round2(color.g),
    b: round2(color.b),
    a: roundAlpha(color.a)
  });
  const onChangeColor = (key) => ({ target: { value } }) => setRgba({
    ...rgba,
    [key]: Number(value)
  });
  const updateColorPicker = () => onChange2({ ...rgba, a: rgba.a / 100 });
  useEffect18(() => {
    setRgba({
      r: round2(color.r),
      g: round2(color.g),
      b: round2(color.b),
      a: roundAlpha(color.a)
    });
  }, [color]);
  return /* @__PURE__ */ jsxs8(Fieldset, { className: cn("w-full"), children: [
    /* @__PURE__ */ jsx20(
      Input,
      {
        type: "number",
        size: "small",
        prefix: "R",
        onChange: onChangeColor("r"),
        onBlur: updateColorPicker,
        value: rgba.r,
        "aria-label": "Red",
        min: 0,
        max: 255
      }
    ),
    /* @__PURE__ */ jsx20(
      Input,
      {
        type: "number",
        size: "small",
        prefix: "G",
        onChange: onChangeColor("g"),
        onBlur: updateColorPicker,
        value: rgba.g,
        "aria-label": "Green",
        min: 0,
        max: 255
      }
    ),
    /* @__PURE__ */ jsx20(
      Input,
      {
        type: "number",
        size: "small",
        prefix: "B",
        onChange: onChangeColor("b"),
        onBlur: updateColorPicker,
        value: rgba.b,
        "aria-label": "Blue",
        min: 0,
        max: 255
      }
    ),
    /* @__PURE__ */ jsx20(
      Input,
      {
        type: "number",
        size: "small",
        suffix: "%",
        onChange: onChangeColor("a"),
        onBlur: updateColorPicker,
        value: rgba.a,
        "aria-label": "Alpha",
        min: 0,
        max: 100
      }
    )
  ] });
};

// src/components/ColorPicker/ColorSpaces/HSL.tsx
import { useState as useState18, useEffect as useEffect19 } from "react";
import { jsx as jsx21, jsxs as jsxs9 } from "react/jsx-runtime";
var SpaceHSL = ({ color, onChange: onChange2 }) => {
  const converted = toHsl(color);
  const [hsl, setHsl] = useState18({
    h: round2(converted.h),
    s: round2(converted.s * 100),
    l: round2(converted.l * 100),
    a: round2(converted.a * 100)
  });
  const onChangeColor = (key) => ({ target: { value } }) => setHsl({
    ...hsl,
    [key]: Number(value)
  });
  const updateColorPicker = () => {
    onChange2(
      toRgb({
        h: hsl.h,
        s: hsl.s / 100,
        l: hsl.l / 100,
        a: hsl.a / 100
      })
    );
  };
  useEffect19(() => {
    const newColor = toHsl(color);
    setHsl({
      h: round2(newColor.h),
      s: round2(newColor.s * 100),
      l: round2(newColor.l * 100),
      a: round2(newColor.a * 100)
    });
  }, [color]);
  return /* @__PURE__ */ jsxs9(Fieldset, { className: cn("w-full"), children: [
    /* @__PURE__ */ jsx21(
      Input,
      {
        type: "number",
        size: "small",
        prefix: "H",
        onChange: onChangeColor("h"),
        onBlur: updateColorPicker,
        value: hsl.h,
        "aria-label": "Hue",
        min: 0,
        max: 360
      }
    ),
    /* @__PURE__ */ jsx21(
      Input,
      {
        type: "number",
        size: "small",
        prefix: "S",
        onChange: onChangeColor("s"),
        onBlur: updateColorPicker,
        value: hsl.s,
        "aria-label": "Saturation",
        min: 0,
        max: 100
      }
    ),
    /* @__PURE__ */ jsx21(
      Input,
      {
        type: "number",
        size: "small",
        prefix: "L",
        onChange: onChangeColor("l"),
        onBlur: updateColorPicker,
        value: hsl.l,
        "aria-label": "Lightness",
        min: 0,
        max: 100
      }
    ),
    /* @__PURE__ */ jsx21(
      Input,
      {
        type: "number",
        size: "small",
        suffix: "%",
        onChange: onChangeColor("a"),
        onBlur: updateColorPicker,
        value: hsl.a,
        "aria-label": "Alpha",
        min: 0,
        max: 100
      }
    )
  ] });
};

// src/components/ColorPicker/ColorSpaces/Selector.tsx
import { Fragment as Fragment7, jsx as jsx22, jsxs as jsxs10 } from "react/jsx-runtime";
var ColorSpaces = {
  HEX: SpaceHEX,
  RGB: SpaceRGB,
  HSL: SpaceHSL
};
var ColorSpaceSelector = ({ color, onChange: onChange2 }) => {
  const [space, setSpace] = useState19(DEFAULT_SPACE);
  const ColorSpaceComponent = ColorSpaces[space];
  return /* @__PURE__ */ jsxs10(Fragment7, { children: [
    /* @__PURE__ */ jsx22("div", { className: cn("flex-1"), children: /* @__PURE__ */ jsxs10(
      Select,
      {
        onValueChange: (value) => setSpace(value),
        defaultValue: space,
        children: [
          /* @__PURE__ */ jsx22(SelectTrigger, { size: "small", children: /* @__PURE__ */ jsx22(SelectValue, { placeholder: "HEX" }) }),
          /* @__PURE__ */ jsxs10(SelectContent, { children: [
            /* @__PURE__ */ jsx22(SelectItem, { value: "HEX", children: "HEX" }),
            /* @__PURE__ */ jsx22(SelectItem, { value: "RGB", children: "RGB" }),
            /* @__PURE__ */ jsx22(SelectItem, { value: "HSL", children: "HSL" })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx22("div", { className: cn("flex w-full items-center gap-2"), children: /* @__PURE__ */ jsx22(ColorSpaceComponent, { onChange: onChange2, color }) })
  ] });
};

// src/components/ColorPicker/Fields/EyeDropper/EyeDropper.tsx
import { faEyeDropper as Icon2 } from "@fortawesome/pro-solid-svg-icons/faEyeDropper";

// src/components/ColorPicker/Fields/EyeDropper/window.ts
var enabled = () => !!window.EyeDropper;
var open = () => new window.EyeDropper().open();

// src/components/ColorPicker/Fields/EyeDropper/EyeDropper.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var EyeDropper = ({
  onChange: onChange2
}) => {
  const hasEyedropperCapabilities = enabled();
  const handleEyeDropperSelection = async () => {
    try {
      const result = await open();
      onChange2(result.sRGBHex);
    } catch {
    }
  };
  return hasEyedropperCapabilities ? /* @__PURE__ */ jsx23(Button, { modifier: "icon", onClick: handleEyeDropperSelection, size: "small", children: /* @__PURE__ */ jsx23(FontAwesomeIcon, { icon: Icon2 }) }) : null;
};

// src/components/ColorPicker/Fields/Fields.tsx
import { jsx as jsx24, jsxs as jsxs11 } from "react/jsx-runtime";
var Fields = ({ color, onChange: onChange2 }) => {
  return /* @__PURE__ */ jsxs11("div", { className: cn("flex flex-wrap items-center gap-2"), children: [
    /* @__PURE__ */ jsx24(EyeDropper, { onChange: onChange2 }),
    /* @__PURE__ */ jsx24(ColorSpaceSelector, { color, onChange: onChange2 })
  ] });
};

// src/components/ColorPicker/Pointer.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var Pointer = ({ shape }) => {
  const shapeClassName = shape === "circle" ? "rounded-full" : "";
  return /* @__PURE__ */ jsx25(
    "button",
    {
      type: "button",
      "aria-label": "pointer",
      className: cn(
        "border-neutral-1 block h-3 w-3 cursor-pointer border-2",
        shapeClassName
      )
    }
  );
};
var SquarePointer = () => /* @__PURE__ */ jsx25(Pointer, { shape: "square" });
var CircularPointer = () => /* @__PURE__ */ jsx25(Pointer, { shape: "circle" });

// src/components/ColorPicker/CustomColorPicker.tsx
import { Fragment as Fragment8, jsx as jsx26, jsxs as jsxs12 } from "react/jsx-runtime";
var CustomColorPickerComponent = ({
  color,
  onChange: onChange2,
  ...props
}) => {
  const handleColorChange = (newColor) => {
    const { source, hex, h: h5, s: s5, l: l5, a: a5 } = newColor;
    const { l: colorLightness } = toHsl(color);
    const lightness = colorLightness === 1 || colorLightness === 0 ? 0.5 : l5;
    let colorSource;
    switch (source) {
      case "hex":
        colorSource = hex;
        break;
      case "hsl":
        colorSource = { h: h5, s: s5 || 1, l: lightness, a: a5 };
        break;
      default:
        colorSource = newColor;
        break;
    }
    if (onChange2) {
      onChange2(toRgb(colorSource));
    }
  };
  return /* @__PURE__ */ jsxs12(Fragment8, { children: [
    /* @__PURE__ */ jsx26("div", { className: cn("h-42 relative my-2 overflow-hidden rounded-md"), children: /* @__PURE__ */ jsx26(
      Saturation,
      {
        ...props,
        color,
        onChange: handleColorChange,
        pointer: CircularPointer
      }
    ) }),
    /* @__PURE__ */ jsx26("div", { className: cn("relative my-2 h-3 overflow-hidden rounded-md"), children: /* @__PURE__ */ jsx26(
      Hue,
      {
        ...props,
        color,
        onChange: handleColorChange,
        pointer: SquarePointer
      }
    ) }),
    /* @__PURE__ */ jsx26("div", { className: cn("relative my-2 h-3 overflow-hidden rounded-md"), children: /* @__PURE__ */ jsx26(
      Alpha,
      {
        ...props,
        color,
        onChange: handleColorChange,
        pointer: SquarePointer
      }
    ) }),
    /* @__PURE__ */ jsx26(Fields, { ...props, onChange: handleColorChange, color })
  ] });
};
var CustomColorPicker = custom(CustomColorPickerComponent);

// src/components/ColorPicker/ColorPicker.tsx
import { jsx as jsx27, jsxs as jsxs13 } from "react/jsx-runtime";
var DEFAULT_COLOR = {
  r: 65,
  g: 127.5,
  b: 127.5,
  a: 0.5
};
var ColorPicker = forwardRef11(
  ({ color = DEFAULT_COLOR, container, onChange: onChange2, onClose, open: open2 }, ref) => {
    const [currentColor, setCurrentColor] = useState20(color);
    useEffect20(() => {
      setCurrentColor(color);
    }, [color]);
    const handleChange = (newColor) => {
      setCurrentColor(newColor.rgb);
      onChange2?.({
        ...newColor,
        hex: toHex8(newColor.rgb)
      });
    };
    return /* @__PURE__ */ jsx27(Portal, { container, children: /* @__PURE__ */ jsxs13(
      FloatingPanel,
      {
        open: open2,
        variant: "floating",
        dragOptions: {
          getPositionReferenceElement: () => ref?.current || null,
          offset: 8
        },
        targetZIndex: 20,
        children: [
          /* @__PURE__ */ jsx27(FloatingPanelHeader, { title: "Color", onClose }),
          /* @__PURE__ */ jsx27(FloatingPanelContent, { children: /* @__PURE__ */ jsx27(CustomColorPicker, { color: currentColor, onChange: handleChange }) })
        ]
      }
    ) });
  }
);

// src/components/ComboBox/ComboBox.tsx
import * as React29 from "react";
var import_faCheck2 = __toESM(require_faCheck());
var import_faCaretDown3 = __toESM(require_faCaretDown());

// src/components/Popover/Popover.tsx
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { jsx as jsx28 } from "react/jsx-runtime";
function Popover({
  ...props
}) {
  return /* @__PURE__ */ jsx28(PopoverPrimitive.Root, { "data-slot": "popover", ...props });
}
function PopoverTrigger({
  ...props
}) {
  return /* @__PURE__ */ jsx28(PopoverPrimitive.Trigger, { "data-slot": "popover-trigger", ...props });
}
function PopoverAnchor({
  ...props
}) {
  return /* @__PURE__ */ jsx28(PopoverPrimitive.Anchor, { "data-slot": "popover-anchor", ...props });
}
function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  container,
  ...props
}) {
  return /* @__PURE__ */ jsx28(PopoverPrimitive.Portal, { container, children: /* @__PURE__ */ jsx28(
    PopoverPrimitive.Content,
    {
      "data-slot": "popover-content",
      "data-ignore-click-outside": "true",
      align,
      sideOffset,
      className: cn(
        // Position
        "z-50",
        "origin-(--radix-popover-content-transform-origin)",
        // Sizing
        "w-72",
        // Spacing
        "p-4",
        // Appearance
        "bg-neutral-1 rounded-md shadow-md",
        // Borders
        "border-neutral-1 border",
        // Typography
        "text-neutral-1",
        // Overflow
        "outline-none",
        // Animations
        "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=top]:slide-in-from-bottom-2",
        className
      ),
      ...props
    }
  ) });
}

// src/components/Command/Command.tsx
import { Command as CommandPrimitive } from "cmdk";
var import_faSearch = __toESM(require_faSearch());
import { jsx as jsx29, jsxs as jsxs14 } from "react/jsx-runtime";
function Command({
  className,
  shouldFilter = true,
  ...props
}) {
  return /* @__PURE__ */ jsx29(
    CommandPrimitive,
    {
      "data-slot": "command",
      shouldFilter,
      className: cn(
        // Layout
        "flex flex-col",
        // Sizing
        "h-full w-full",
        // Overflow
        "overflow-hidden",
        // Appearance
        "bg-neutral-1 rounded-md",
        // Typography
        "text-neutral-1",
        className
      ),
      ...props
    }
  );
}
function CommandInput({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsxs14(
    "div",
    {
      className: cn(
        // Layout
        "flex items-center",
        // Sizing (matches Figma h-[32px] + wrapper py-[4px])
        "h-10",
        // Spacing (matches Figma px-[12px] py-[4px] gap-[8px])
        "gap-2 px-3 py-1",
        // Borders
        "border-neutral-2 border-b"
      ),
      "cmdk-input-wrapper": "",
      children: [
        /* @__PURE__ */ jsx29(
          FontAwesomeIcon,
          {
            icon: import_faSearch.faSearch,
            className: cn(
              // Sizing (matches Figma 12px)
              "size-3",
              // Appearance
              "text-neutral-4 shrink-0"
            )
          }
        ),
        /* @__PURE__ */ jsx29(
          CommandPrimitive.Input,
          {
            "data-slot": "command-input",
            className: cn(
              // Layout
              "flex",
              // Sizing (matches Figma h-[24px])
              "h-6 w-full",
              // Appearance
              "bg-transparent",
              // Typography (matches Figma 14px Medium)
              "text-sm font-medium",
              // Interactions
              "outline-none",
              // Placeholder
              "placeholder:text-neutral-4",
              // Disabled state
              "disabled:cursor-not-allowed disabled:opacity-50",
              className
            ),
            ...props
          }
        )
      ]
    }
  );
}
function CommandList({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx29(
    CommandPrimitive.List,
    {
      "data-slot": "command-list",
      className: cn(
        // Sizing
        "max-h-[300px]",
        // Overflow
        "overflow-y-auto overflow-x-hidden",
        // Scrollbar customization
        "[&::-webkit-scrollbar]:w-1.5",
        "[&::-webkit-scrollbar-thumb]:rounded-full",
        "[&::-webkit-scrollbar-thumb]:bg-neutral-3",
        className
      ),
      ...props
    }
  );
}
function CommandEmpty({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx29(
    CommandPrimitive.Empty,
    {
      "data-slot": "command-empty",
      className: cn(
        // Spacing
        "py-6",
        // Typography
        "text-neutral-4 text-center text-sm",
        className
      ),
      ...props
    }
  );
}
function CommandGroup({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx29(
    CommandPrimitive.Group,
    {
      "data-slot": "command-group",
      className: cn(
        // Overflow
        "overflow-hidden",
        // Spacing
        "px-1 py-0",
        // Typography
        "text-neutral-1",
        // Heading styling (matches Figma "DIVIDER TEXT" style)
        "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1",
        "[&_[cmdk-group-heading]]:text-neutral-4 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-bold [&_[cmdk-group-heading]]:uppercase",
        className
      ),
      ...props
    }
  );
}
function CommandSeparator({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx29(
    CommandPrimitive.Separator,
    {
      "data-slot": "command-separator",
      className: cn(
        // Sizing
        "-mx-1 h-px",
        // Appearance
        "bg-neutral-2",
        className
      ),
      ...props
    }
  );
}
function CommandItem({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx29(
    CommandPrimitive.Item,
    {
      "data-slot": "command-item",
      className: cn(
        // Layout
        "relative flex items-center",
        // Sizing (matches Figma 32px height)
        "h-8",
        // Spacing
        "gap-1 p-1",
        // Appearance
        "rounded-sm",
        // Typography
        "text-sm font-medium",
        // Interactions
        "cursor-pointer select-none outline-none",
        // Selected/Active state
        "data-[selected=true]:bg-highlight-3",
        // Disabled state
        "data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50",
        // Icons
        "[&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
        className
      ),
      ...props
    }
  );
}
function CommandShortcut({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx29(
    "span",
    {
      "data-slot": "command-shortcut",
      className: cn(
        // Layout
        "ml-auto",
        // Spacing
        "p-1",
        // Typography (matches Figma "CTRL + D" style)
        "text-neutral-3 text-[10px] font-semibold",
        className
      ),
      ...props
    }
  );
}
function CommandItemIcon({
  className,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx29(
    "div",
    {
      "data-slot": "command-item-icon",
      className: cn(
        // Layout
        "flex items-center justify-center",
        // Spacing
        "p-1",
        // Icons
        "[&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0",
        className
      ),
      ...props,
      children
    }
  );
}

// src/components/ComboBox/ComboBox.tsx
import { jsx as jsx30, jsxs as jsxs15 } from "react/jsx-runtime";
var ComboBoxContext = React29.createContext(null);
function useComboBoxContext() {
  const context = React29.useContext(ComboBoxContext);
  if (!context) {
    throw new Error("ComboBox components must be used within a ComboBox");
  }
  return context;
}
function ComboBox({
  children,
  value: controlledValue,
  defaultValue = "",
  onValueChange,
  open: controlledOpen,
  defaultOpen = false,
  onOpenChange,
  disabled: disabled2 = false
}) {
  const [uncontrolledOpen, setUncontrolledOpen] = React29.useState(defaultOpen);
  const [uncontrolledValue, setUncontrolledValue] = React29.useState(defaultValue);
  const isOpenControlled = controlledOpen !== void 0;
  const isValueControlled = controlledValue !== void 0;
  const open2 = isOpenControlled ? controlledOpen : uncontrolledOpen;
  const value = isValueControlled ? controlledValue : uncontrolledValue;
  const setOpen = React29.useCallback(
    (newOpen) => {
      if (!isOpenControlled) {
        setUncontrolledOpen(newOpen);
      }
      onOpenChange?.(newOpen);
    },
    [isOpenControlled, onOpenChange]
  );
  const handleValueChange = React29.useCallback(
    (newValue) => {
      if (!isValueControlled) {
        setUncontrolledValue(newValue);
      }
      onValueChange?.(newValue);
    },
    [isValueControlled, onValueChange]
  );
  const contextValue = React29.useMemo(
    () => ({
      open: open2,
      setOpen,
      value,
      onValueChange: handleValueChange,
      disabled: disabled2
    }),
    [open2, setOpen, value, handleValueChange, disabled2]
  );
  return /* @__PURE__ */ jsx30(ComboBoxContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx30(Popover, { open: open2, onOpenChange: setOpen, children }) });
}
function ComboBoxTrigger({
  children,
  placeholder = "Select option...",
  className,
  size: size3 = DEFAULT_COMPONENT_SIZE,
  "aria-label": ariaLabel
}) {
  const { open: open2, disabled: disabled2 } = useComboBoxContext();
  const sizeClasses = {
    small: "h-8 px-4 py-2 text-xs",
    medium: "h-10 px-4 py-3 text-sm"
  };
  return /* @__PURE__ */ jsx30(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs15(
    Button,
    {
      variant: "neutral",
      role: "combobox",
      "aria-expanded": open2,
      "aria-label": ariaLabel,
      disabled: disabled2,
      className: cn(
        // Layout
        "flex w-full items-center justify-between",
        // Typography
        "font-medium",
        // Size variants
        sizeClasses[size3],
        className
      ),
      children: [
        /* @__PURE__ */ jsx30("span", { className: "truncate", children: children || placeholder }),
        /* @__PURE__ */ jsx30(
          FontAwesomeIcon,
          {
            icon: import_faCaretDown3.faCaretDown,
            className: cn(
              // Sizing
              "size-4",
              // Appearance
              "shrink-0 opacity-50"
            )
          }
        )
      ]
    }
  ) });
}
function ComboBoxValue({
  placeholder = "Select option...",
  children
}) {
  const { value } = useComboBoxContext();
  if (!value) {
    return /* @__PURE__ */ jsx30("span", { children: placeholder });
  }
  if (children) {
    return /* @__PURE__ */ jsx30("span", { children: children(value) });
  }
  return /* @__PURE__ */ jsx30("span", { children: value });
}
function ComboBoxContent({
  children,
  className,
  container,
  filter
}) {
  return /* @__PURE__ */ jsx30(
    PopoverContent,
    {
      container,
      className: cn(
        // Sizing
        "w-[var(--radix-popover-trigger-width)]",
        // Spacing
        "p-0",
        className
      ),
      children: /* @__PURE__ */ jsx30(Command, { filter, children })
    }
  );
}
function ComboBoxInput({
  placeholder = "Search...",
  className
}) {
  return /* @__PURE__ */ jsx30(CommandInput, { placeholder, className });
}
function ComboBoxList({ children, className }) {
  return /* @__PURE__ */ jsx30(CommandList, { className, children });
}
function ComboBoxEmpty({
  children = "No results found.",
  className
}) {
  return /* @__PURE__ */ jsx30(CommandEmpty, { className, children });
}
function ComboBoxGroup({ children, heading, className }) {
  return /* @__PURE__ */ jsx30(CommandGroup, { heading, className, children });
}
function ComboBoxItem({
  children,
  value: itemValue,
  disabled: disabled2,
  className,
  icon: icon3,
  onSelect,
  keywords
}) {
  const { value, onValueChange, setOpen } = useComboBoxContext();
  const handleSelect = React29.useCallback(
    (currentValue) => {
      const newValue = currentValue === value ? "" : currentValue;
      onValueChange?.(newValue);
      onSelect?.(newValue);
      setOpen(false);
    },
    [value, onValueChange, onSelect, setOpen]
  );
  return /* @__PURE__ */ jsxs15(
    CommandItem,
    {
      value: itemValue,
      onSelect: handleSelect,
      disabled: disabled2,
      className,
      keywords,
      children: [
        icon3 && /* @__PURE__ */ jsx30(CommandItemIcon, { children: icon3 }),
        /* @__PURE__ */ jsx30("span", { className: "min-w-0 flex-1 truncate pl-1", children }),
        /* @__PURE__ */ jsx30(
          FontAwesomeIcon,
          {
            icon: import_faCheck2.faCheck,
            className: cn(
              // Layout
              "ml-auto",
              // Sizing
              "size-3",
              // Visibility
              value === itemValue ? "opacity-100" : "opacity-0"
            )
          }
        )
      ]
    }
  );
}
ComboBox.displayName = "ComboBox";
ComboBoxTrigger.displayName = "ComboBoxTrigger";
ComboBoxValue.displayName = "ComboBoxValue";
ComboBoxContent.displayName = "ComboBoxContent";
ComboBoxInput.displayName = "ComboBoxInput";
ComboBoxList.displayName = "ComboBoxList";
ComboBoxEmpty.displayName = "ComboBoxEmpty";
ComboBoxGroup.displayName = "ComboBoxGroup";
ComboBoxItem.displayName = "ComboBoxItem";

// src/components/Dropdown/Dropdown.tsx
var import_faCheck3 = __toESM(require_faCheck());
var import_faChevronRight = __toESM(require_faChevronRight());
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { faCircle } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { cva as cva6 } from "class-variance-authority";
import { jsx as jsx31, jsxs as jsxs16 } from "react/jsx-runtime";
var dropdownMenuContentVariants = cva6(
  [
    // Position
    "z-50",
    "origin-(--radix-dropdown-menu-content-transform-origin)",
    // Sizing
    "max-h-(--radix-dropdown-menu-content-available-height)",
    // Spacing
    "p-1",
    // Typography
    "text-neutral-1",
    // Appearance
    "bg-neutral-1 rounded-md shadow-md",
    // Borders
    "border-neutral-1 border",
    // Overflow
    "overflow-x-hidden overflow-y-auto",
    // Animations - Enter
    "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
    // Animations - Exit
    "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
    // Animations - Slide by side
    "data-[side=bottom]:slide-in-from-top-2",
    "data-[side=left]:slide-in-from-right-2",
    "data-[side=right]:slide-in-from-left-2",
    "data-[side=top]:slide-in-from-bottom-2"
  ],
  {
    variants: {
      size: {
        compact: "min-w-[8rem]",
        spacious: "min-w-[20rem]"
      }
    },
    defaultVariants: {
      size: "compact"
    }
  }
);
function DropdownMenu({
  ...props
}) {
  return /* @__PURE__ */ jsx31(DropdownMenuPrimitive.Root, { "data-slot": "dropdown-menu", ...props });
}
function DropdownMenuPortal({
  ...props
}) {
  return /* @__PURE__ */ jsx31(DropdownMenuPrimitive.Portal, { "data-slot": "dropdown-menu-portal", ...props });
}
function DropdownMenuTrigger({
  ...props
}) {
  return /* @__PURE__ */ jsx31(
    DropdownMenuPrimitive.Trigger,
    {
      "data-slot": "dropdown-menu-trigger",
      ...props
    }
  );
}
function DropdownMenuContent({
  className,
  sideOffset = 4,
  container,
  size: size3,
  ...props
}) {
  return /* @__PURE__ */ jsx31(DropdownMenuPrimitive.Portal, { container, children: /* @__PURE__ */ jsx31(
    DropdownMenuPrimitive.Content,
    {
      "data-slot": "dropdown-menu-content",
      sideOffset,
      className: cn(dropdownMenuContentVariants({ size: size3 }), className),
      ...props
    }
  ) });
}
function DropdownMenuGroup({
  ...props
}) {
  return /* @__PURE__ */ jsx31(DropdownMenuPrimitive.Group, { "data-slot": "dropdown-menu-group", ...props });
}
var dropdownMenuItemVariants = cva6(
  [
    // Layout - grid with optional icon column
    "relative grid items-center",
    "grid-cols-[0_1fr_auto] has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr_auto]",
    "has-[>svg]:gap-x-2",
    // Sizing
    "rounded-sm",
    // Spacing
    "px-2 py-1.5",
    // Typography
    "text-sm",
    // Appearance
    "cursor-default select-none outline-hidden",
    // States - Disabled
    "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
    // Inset
    "data-[inset=true]:pl-8",
    // Icons - align to first column, vertically center
    '[&>svg]:pointer-events-none [&>svg]:shrink-0 [&>svg:not([class*="size-"])]:size-4',
    "[&>svg]:col-start-1 [&>svg]:row-span-2"
  ],
  {
    variants: {
      variant: {
        default: ["focus:bg-highlight-3 focus:text-neutral-1"],
        destructive: ["text-destructive-1", "focus:bg-destructive-2/10"]
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function DropdownMenuItem({
  className,
  inset,
  variant,
  ...props
}) {
  return /* @__PURE__ */ jsx31(
    DropdownMenuPrimitive.Item,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": inset,
      className: cn(dropdownMenuItemVariants({ variant }), className),
      ...props
    }
  );
}
function DropdownMenuItemTitle({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx31(
    "span",
    {
      "data-slot": "dropdown-menu-item-title",
      className: cn("col-start-2", className),
      ...props
    }
  );
}
function DropdownMenuItemDescription({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx31(
    "span",
    {
      "data-slot": "dropdown-menu-item-description",
      className: cn(
        "text-neutral-3 col-start-2 py-1 text-xs font-normal",
        className
      ),
      ...props
    }
  );
}
function DropdownMenuCheckboxItem({
  className,
  children,
  checked,
  ...props
}) {
  return /* @__PURE__ */ jsxs16(
    DropdownMenuPrimitive.CheckboxItem,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      className: cn(
        // Layout
        "relative flex items-center gap-2",
        // Sizing
        "rounded-sm",
        // Spacing
        "py-1.5 pl-8 pr-2",
        // Typography
        "text-sm",
        // Appearance
        "outline-hidden cursor-default select-none",
        // States - Focus
        "focus:bg-highlight-3 focus:text-neutral-1",
        // States - Disabled
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        // Icons
        '[&_svg:not([class*="size-"])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        className
      ),
      checked,
      ...props,
      children: [
        /* @__PURE__ */ jsx31("span", { className: "size-3.5 pointer-events-none absolute left-2 flex items-center justify-center", children: /* @__PURE__ */ jsx31(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx31(Icon, { icon: import_faCheck3.faCheck, size: "small" }) }) }),
        children
      ]
    }
  );
}
function DropdownMenuRadioGroup({
  ...props
}) {
  return /* @__PURE__ */ jsx31(
    DropdownMenuPrimitive.RadioGroup,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...props
    }
  );
}
function DropdownMenuRadioItem({
  className,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs16(
    DropdownMenuPrimitive.RadioItem,
    {
      "data-slot": "dropdown-menu-radio-item",
      className: cn(
        // Layout
        "relative flex items-center gap-2",
        // Sizing
        "rounded-sm",
        // Spacing
        "py-1.5 pl-8 pr-2",
        // Typography
        "text-sm",
        // Appearance
        "outline-hidden cursor-default select-none",
        // States - Focus
        "focus:bg-highlight-3 focus:text-neutral-1",
        // States - Disabled
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        // Icons
        '[&_svg:not([class*="size-"])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        className
      ),
      ...props,
      children: [
        /* @__PURE__ */ jsx31("span", { className: "size-3.5 pointer-events-none absolute left-2 flex items-center justify-center", children: /* @__PURE__ */ jsx31(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx31(Icon, { icon: faCircle, size: "x-small" }) }) }),
        children
      ]
    }
  );
}
function DropdownMenuLabel({
  className,
  inset,
  ...props
}) {
  return /* @__PURE__ */ jsx31(
    DropdownMenuPrimitive.Label,
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": inset,
      className: cn(
        // Spacing
        "px-2 py-1.5",
        // Typography
        "text-neutral-3 text-xs font-semibold uppercase",
        // Inset
        "data-[inset]:pl-8",
        className
      ),
      ...props
    }
  );
}
function DropdownMenuSeparator({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx31(
    DropdownMenuPrimitive.Separator,
    {
      "data-slot": "dropdown-menu-separator",
      className: cn(
        // Spacing
        "mx-2 my-1",
        // Sizing
        "h-px",
        // Appearance
        "bg-neutral-2",
        className
      ),
      ...props
    }
  );
}
function DropdownMenuShortcut({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx31(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: cn(
        // Grid positioning
        "col-start-3 row-span-2 row-start-1",
        // Typography
        "text-neutral-4 text-xs tracking-widest",
        className
      ),
      ...props
    }
  );
}
function DropdownMenuSub({
  ...props
}) {
  return /* @__PURE__ */ jsx31(DropdownMenuPrimitive.Sub, { "data-slot": "dropdown-menu-sub", ...props });
}
function DropdownMenuSubTrigger({
  className,
  inset,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs16(
    DropdownMenuPrimitive.SubTrigger,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": inset,
      className: cn(
        // Layout
        "flex items-center gap-2",
        // Sizing
        "rounded-sm",
        // Spacing
        "px-2 py-1.5",
        // Typography
        "text-sm",
        // Appearance
        "outline-hidden cursor-default select-none",
        // States - Focus
        "focus:bg-highlight-3 focus:text-neutral-1",
        // States - Open
        "data-[state=open]:bg-highlight-3 data-[state=open]:text-neutral-1",
        // Inset
        "data-[inset]:pl-8",
        // Icons
        '[&_svg:not([class*="size-"])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        '[&_svg:not([class*="text-"])]:text-neutral-3',
        className
      ),
      ...props,
      children: [
        children,
        /* @__PURE__ */ jsx31(Icon, { icon: import_faChevronRight.faChevronRight, size: "small", className: "ml-auto" })
      ]
    }
  );
}
function DropdownMenuSubContent({
  className,
  container,
  ...props
}) {
  return /* @__PURE__ */ jsx31(DropdownMenuPrimitive.Portal, { container, children: /* @__PURE__ */ jsx31(
    DropdownMenuPrimitive.SubContent,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: cn(
        // Position
        "z-50",
        "origin-(--radix-dropdown-menu-content-transform-origin)",
        // Sizing
        "min-w-[8rem]",
        // Spacing
        "p-1",
        // Typography
        "text-neutral-1",
        // Appearance
        "bg-neutral-1 rounded-md shadow-lg",
        // Borders
        "border-neutral-1 border",
        // Overflow
        "overflow-hidden",
        // Animations - Enter
        "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        // Animations - Exit
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        // Animations - Slide by side
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=top]:slide-in-from-bottom-2",
        className
      ),
      ...props
    }
  ) });
}

// src/components/Form/FormItem.tsx
import {
  useMemo as useMemo7,
  createContext as createContext5,
  forwardRef as forwardRef12
} from "react";
import { jsx as jsx32 } from "react/jsx-runtime";
var FormItemContext = createContext5({
  id: "",
  error: false,
  disabled: false,
  readOnly: false,
  labelId: ""
});
var FormItem = forwardRef12(
  ({ className, error, disabled: disabled2, readOnly, ...props }, ref) => {
    const id = useMemo7(() => crypto.randomUUID(), []);
    const contextValue = useMemo7(
      () => ({ id, error, disabled: disabled2, readOnly, labelId: `${id}-label` }),
      [id, error, disabled2, readOnly]
    );
    return /* @__PURE__ */ jsx32(FormItemContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx32(
      "div",
      {
        ref,
        className: cn("flex flex-col gap-1 pb-3", className),
        ...props
      }
    ) });
  }
);
FormItem.displayName = "FormItem";

// src/components/Form/FormLabel.tsx
import React32 from "react";

// src/components/Label/Label.tsx
import * as React31 from "react";
import { cva as cva7 } from "class-variance-authority";
import { jsx as jsx33 } from "react/jsx-runtime";
var labelVariants = cva7(
  "font-lato text-sm font-semibold leading-4 pe-2 py-0.5 text-ellipsis overflow-hidden whitespace-nowrap",
  {
    variants: {
      state: {
        default: "text-neutral-1",
        error: "text-destructive-1"
      },
      row: {
        true: "pe-2 py-2.5",
        false: ""
      },
      disabled: {
        true: "text-neutral-3",
        false: ""
      },
      readOnly: {
        true: "text-neutral-3",
        false: ""
      }
    },
    defaultVariants: {
      state: "default",
      row: false,
      disabled: false,
      readOnly: false
    }
  }
);
var Label2 = React31.forwardRef(
  ({ className, state, row, disabled: disabled2, readOnly, ...props }, ref) => (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    /* @__PURE__ */ jsx33(
      "label",
      {
        ref,
        className: cn(
          labelVariants({ state, row, disabled: disabled2, readOnly }),
          className
        ),
        ...props
      }
    )
  )
);
Label2.displayName = "Label";

// src/components/Form/use-form-item.ts
import { useContext as useContext5 } from "react";
var useFormItem = () => {
  const itemContext = useContext5(FormItemContext);
  if (!itemContext) {
    throw new Error("useFormField should be used within <FormItem>");
  }
  const { id, error, disabled: disabled2, readOnly, labelId } = itemContext;
  return {
    id,
    formItemId: `${id}-form-item`,
    formMessageId: `${id}-form-item-message`,
    error,
    disabled: disabled2,
    readOnly,
    labelId
  };
};

// src/components/Form/FormLabel.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var FormLabel = React32.forwardRef(
  ({ className, ...props }, ref) => {
    const { formItemId, error, disabled: disabled2, readOnly, labelId } = useFormItem();
    return /* @__PURE__ */ jsx34(
      Label2,
      {
        id: labelId,
        ref,
        htmlFor: formItemId,
        state: error ? "error" : "default",
        className: cn("flex-1", className),
        disabled: disabled2,
        readOnly,
        ...props
      }
    );
  }
);
FormLabel.displayName = "FormLabel";

// src/components/Form/FormControl.tsx
import React33 from "react";
import { Slot as Slot3 } from "@radix-ui/react-slot";
import { jsx as jsx35 } from "react/jsx-runtime";
var FormControl = React33.forwardRef(({ className, ...props }, ref) => {
  const { error, formItemId, formMessageId, labelId, ...itemProps } = useFormItem();
  return /* @__PURE__ */ jsx35(
    Slot3,
    {
      ...itemProps,
      ...props,
      ref,
      id: formItemId,
      "aria-describedby": formMessageId,
      "aria-invalid": !!error,
      "aria-labelledby": labelId,
      className: cn("flex-1", className)
    }
  );
});
FormControl.displayName = "FormControl";

// src/components/Form/FormMessage.tsx
import React34 from "react";

// ../../node_modules/@fortawesome/pro-regular-svg-icons/index.mjs
var faCircleExclamation = {
  prefix: "far",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
};
var faExclamationCircle = faCircleExclamation;

// src/components/Form/FormMessage.tsx
import { jsx as jsx36, jsxs as jsxs17 } from "react/jsx-runtime";
var FormMessage = React34.forwardRef(({ className, state, children, ...props }, ref) => {
  const { formMessageId, disabled: disabled2, readOnly } = useFormItem();
  return /* @__PURE__ */ jsxs17(
    "p",
    {
      ref,
      id: formMessageId,
      className: cn(
        // Layout
        "flex flex-row items-center",
        // Spacing
        "gap-1",
        // Typography
        "font-lato text-neutral-3 text-xs font-normal leading-6",
        // Error state
        state === "error" && "text-destructive-1",
        // Disabled/ReadOnly state
        (disabled2 || readOnly) && "text-neutral-4",
        className
      ),
      ...props,
      children: [
        state === "error" && /* @__PURE__ */ jsx36(FontAwesomeIcon, { icon: faExclamationCircle }),
        children
      ]
    }
  );
});
FormMessage.displayName = "FormMessage";

// src/components/Form/FormRow.tsx
import { forwardRef as forwardRef14 } from "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var FormRow = forwardRef14(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx37(
      "div",
      {
        ref,
        className: cn("flex flex-row items-center gap-1", className),
        ...props
      }
    );
  }
);
FormRow.displayName = "FormRow";

// src/components/Modal/Modal.tsx
import * as React36 from "react";
import * as ModalPrimitive from "@radix-ui/react-dialog";
import { cva as cva8 } from "class-variance-authority";
import { faXmarkLarge as faXmarkLarge2 } from "@fortawesome/pro-solid-svg-icons/faXmarkLarge";
import { jsx as jsx38, jsxs as jsxs18 } from "react/jsx-runtime";
var modalContentVariants = cva8("grid w-full", {
  variants: {
    size: {
      small: "max-w-sm",
      regular: "max-w-lg",
      large: "max-w-4xl"
    }
  },
  defaultVariants: {
    size: "regular"
  }
});
var ModalClose = ModalPrimitive.Close;
var ModalTrigger = ModalPrimitive.Trigger;
var ModalPortal = ModalPrimitive.Portal;
var ModalOverlay = React36.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx38(
  ModalPrimitive.Overlay,
  {
    ref,
    className: cn(
      // Position
      "fixed inset-0 z-50",
      // Animations
      "data-[state=open]:animate-in data-[state=open]:fade-in-0",
      "data-[state=closed]:animate-out data-[state=closed]:fade-out-0",
      className
    ),
    ...props
  }
));
ModalOverlay.displayName = ModalPrimitive.Overlay.displayName;
var Modal = React36.forwardRef(({ children, container, trigger, ...props }, ref) => /* @__PURE__ */ jsxs18(ModalPrimitive.Root, { ...props, children: [
  trigger,
  /* @__PURE__ */ jsxs18(ModalPortal, { container, className: "relative z-30", children: [
    /* @__PURE__ */ jsx38(ModalOverlay, { ref }),
    children
  ] })
] }));
var ModalContent = React36.forwardRef(({ className, size: size3 = "regular", children, withoutFooter, ...props }, ref) => {
  return /* @__PURE__ */ jsxs18(
    ModalPrimitive.Content,
    {
      ref,
      className: cn(
        // Layout
        modalContentVariants({ size: size3 }),
        // Position
        "fixed left-[50%] top-[50%] z-50",
        "translate-x-[-50%] translate-y-[-50%]",
        // Appearance
        "bg-neutral-0 text-neutral-1 rounded-md shadow-2xl",
        // Typography
        "font-lato",
        // Animations
        "duration-200",
        "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        // Conditional padding
        { "pb-4": withoutFooter },
        className
      ),
      ...props,
      children: [
        children,
        /* @__PURE__ */ jsxs18(
          ModalPrimitive.Close,
          {
            className: cn(
              // Position
              "absolute right-6 top-5",
              // Appearance
              "text-neutral-1 rounded-sm opacity-70",
              // Interactions
              "transition-opacity",
              "hover:cursor-pointer hover:opacity-100",
              "focus:outline-none focus:ring-2 focus:ring-offset-2",
              "disabled:pointer-events-none"
            ),
            children: [
              /* @__PURE__ */ jsx38(FontAwesomeIcon, { icon: faXmarkLarge2 }),
              /* @__PURE__ */ jsx38("span", { className: "sr-only", children: "Close" })
            ]
          }
        )
      ]
    }
  );
});
ModalContent.displayName = ModalPrimitive.Content.displayName;
var ModalHeader = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx38(
  "div",
  {
    className: cn(
      // Layout
      "flex flex-col",
      // Spacing
      "space-y-1.5 px-6 py-5",
      // Typography
      "text-center sm:text-left",
      className
    ),
    ...props
  }
);
ModalHeader.displayName = "ModalHeader";
var ModalFooter = ({
  className,
  ...props
}) => /* @__PURE__ */ jsx38(
  "div",
  {
    className: cn(
      // Layout
      "flex items-center justify-end",
      // Spacing
      "gap-2 p-4",
      // Borders
      "border-neutral-1 border-t",
      className
    ),
    ...props
  }
);
ModalFooter.displayName = "ModalFooter";
var ModalTitle = React36.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx38(
  ModalPrimitive.Title,
  {
    ref,
    className: cn(
      // Layout
      "flex items-center",
      // Spacing
      "gap-2",
      // Typography
      "text-lg font-semibold",
      className
    ),
    ...props
  }
));
ModalTitle.displayName = ModalPrimitive.Title.displayName;
var ModalDescription = React36.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsx38(
  ModalPrimitive.Description,
  {
    ref,
    className: cn(
      // Spacing
      "px-6 pb-4 pt-2",
      className
    ),
    asChild: true,
    ...props,
    children: /* @__PURE__ */ jsx38("div", { children })
  }
));
ModalDescription.displayName = ModalPrimitive.Description.displayName;

// src/components/SegmentedControl/SegmentedControl.tsx
import * as React37 from "react";
import * as SegmentedControlGroupPrimitive from "@radix-ui/react-radio-group";
import { jsx as jsx39 } from "react/jsx-runtime";
var SegmentedControlSizeContext = React37.createContext(
  DEFAULT_COMPONENT_SIZE
);
var groupSizeClasses = {
  small: "h-8 max-h-8 gap-1 p-0.5",
  medium: "h-10 max-h-10 gap-2 p-0.5",
  large: "h-12 max-h-12 gap-2 p-0.5"
};
var itemSizeClasses = {
  small: "px-3 py-1.5 text-xs",
  medium: "px-4 py-2 text-sm",
  large: "px-4 py-2 text-sm"
};
var SegmentedControlGroup = React37.forwardRef(
  ({
    className,
    disabled: disabled2,
    readOnly,
    iconOnly,
    size: size3 = DEFAULT_COMPONENT_SIZE,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx39(SegmentedControlSizeContext.Provider, { value: size3, children: /* @__PURE__ */ jsx39(
      SegmentedControlGroupPrimitive.Root,
      {
        ref,
        className: cn(
          // Layout
          "flex",
          // Sizing
          "h-10 max-h-10",
          // Appearance
          "bg-neutral-1 rounded-md",
          // Borders
          "border-1 border-neutral-1",
          // Conditional spacing
          { "gap-1": iconOnly },
          // Size variants
          groupSizeClasses[size3],
          className
        ),
        ...props,
        disabled: disabled2 || readOnly
      }
    ) });
  }
);
SegmentedControlGroup.displayName = "SegmentedControlGroup";
var SegmentedControlGroupItem = React37.forwardRef(({ className, children, ...props }, ref) => {
  const size3 = React37.useContext(SegmentedControlSizeContext);
  return /* @__PURE__ */ jsx39(
    SegmentedControlGroupPrimitive.Item,
    {
      ref,
      className: cn(
        // Layout
        "inline-flex flex-1 items-center justify-center",
        // Spacing
        "gap-2 px-4 py-2",
        // Appearance
        "rounded-sm",
        // Typography
        "font-lato text-sm font-semibold",
        "text-neutral-3 whitespace-nowrap",
        // Transitions
        "transition-all",
        // Checked state
        "data-[state=checked]:bg-highlight-1 data-[state=checked]:text-highlight-2",
        // Disabled state
        "disabled:cursor-not-allowed",
        "data-[state=checked]:disabled:bg-highlight-2 data-[state=checked]:disabled:text-neutral-1",
        // Focus state
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--border-focus-ring)]",
        // Hover state
        "hover:cursor-pointer",
        // Size variants
        itemSizeClasses[size3],
        className
      ),
      ...props,
      children
    }
  );
});
SegmentedControlGroupItem.displayName = "SegmentedControlGroupItem";

// src/components/StepBar/StepBar.tsx
import React38, { useState as useState22, useMemo as useMemo8, useCallback as useCallback8, useEffect as useEffect21 } from "react";
import { faPlus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { Fragment as Fragment9, jsx as jsx40, jsxs as jsxs19 } from "react/jsx-runtime";
var StepBar = ({
  className,
  children,
  onAddStep,
  onDragEnd,
  ...props
}) => {
  const [items, setItems] = useState22([]);
  useEffect21(() => {
    const ids = React38.Children.toArray(children).map(
      (child) => child.props.id
    ) ?? [];
    setItems((prevItems) => {
      const filtered = prevItems.filter((id) => ids.includes(id));
      const appended = ids.filter((id) => !filtered.includes(id));
      if (filtered.length === prevItems.length && appended.length === 0) {
        return prevItems;
      }
      return [...filtered, ...appended];
    });
  }, [children]);
  const isDndEnabled = Boolean(onDragEnd);
  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: { distance: 6 }
  });
  const enabledSensors = useSensors(pointerSensor);
  const disabledSensors = useSensors();
  const sensors = isDndEnabled ? enabledSensors : disabledSensors;
  const handleDragEnd = useCallback8(
    (event) => {
      const { active, over } = event;
      if (!over || active.id === over.id) {
        return;
      }
      const oldIndex = items.indexOf(String(active.id));
      const newIndex = items.indexOf(String(over.id));
      if (oldIndex === -1 || newIndex === -1 || oldIndex === newIndex) {
        return;
      }
      const nextOrder = arrayMove(items, oldIndex, newIndex);
      setItems(nextOrder);
      const payload = {
        from: oldIndex,
        to: newIndex,
        targetStepId: String(over.id)
      };
      onDragEnd?.(String(active.id), payload);
    },
    [items, onDragEnd]
  );
  const childById = useMemo8(() => {
    const childrenArray = React38.Children.toArray(
      children
    );
    return new Map(childrenArray.map((child) => [child.props.id, child]));
  }, [children]);
  const orderedChildren = useMemo8(() => {
    return items.map((id, index5) => {
      const child = childById.get(id);
      return child ? React38.cloneElement(child, { index: index5 }) : null;
    }).filter(Boolean);
  }, [childById, items]);
  return /* @__PURE__ */ jsx40(
    DndContext,
    {
      sensors,
      collisionDetection: closestCenter,
      onDragEnd: handleDragEnd,
      children: /* @__PURE__ */ jsx40("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ jsxs19(
        "nav",
        {
          className: cn(
            // Layout
            "relative flex items-center justify-center",
            // Spacing
            "gap-1 p-1",
            // Appearance
            "bg-neutral-0 shadow-xs rounded-lg",
            // Borders
            "border-1 border-neutral-1",
            // Typography
            "font-lato",
            className
          ),
          ...props,
          children: [
            /* @__PURE__ */ jsx40(
              SortableContext,
              {
                items,
                strategy: horizontalListSortingStrategy,
                children: orderedChildren
              }
            ),
            onAddStep && /* @__PURE__ */ jsxs19(Fragment9, { children: [
              /* @__PURE__ */ jsx40("div", { className: "border-1 border-neutral-1 gap-1 self-stretch rounded-sm" }),
              /* @__PURE__ */ jsx40(
                Button,
                {
                  variant: "ghost",
                  modifier: "icon",
                  size: "large",
                  onClick: onAddStep,
                  children: /* @__PURE__ */ jsx40(FontAwesomeIcon, { icon: faPlus })
                }
              )
            ] })
          ]
        }
      ) })
    }
  );
};
StepBar.displayName = "StepBar";

// src/components/StepBar/icons.tsx
import { jsx as jsx41, jsxs as jsxs20 } from "react/jsx-runtime";
var ModalRightBottomIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2C1.89543 2 1 2.89543 1 4V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V4C23 2.89543 22.1046 2 21 2H3ZM2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4C4 4.55228 3.55228 5 3 5C2.44772 5 2 4.55228 2 4ZM6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3ZM9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3ZM2.5 6.8C2.5 6.35817 2.85817 6 3.3 6H20.7C21.1418 6 21.5 6.35817 21.5 6.8V13H13.6C13.2686 13 13 13.2686 13 13.6V18.4C13 18.7314 13.2686 19 13.6 19H21.5V19.7C21.5 20.1418 21.1418 20.5 20.7 20.5H3.3C2.85817 20.5 2.5 20.1418 2.5 19.7V6.8Z",
          fill: "currentColor"
        }
      )
    }
  );
};
var ModalLeftBottomIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2C1.89543 2 1 2.89543 1 4V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V4C23 2.89543 22.1046 2 21 2H3ZM2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4C4 4.55228 3.55228 5 3 5C2.44772 5 2 4.55228 2 4ZM6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3ZM9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3ZM2.5 6.8C2.5 6.35817 2.85817 6 3.3 6H20.7C21.1418 6 21.5 6.35817 21.5 6.8V19.7C21.5 20.1418 21.1418 20.5 20.7 20.5H3.3C2.85817 20.5 2.5 20.1418 2.5 19.7V19H10.4C10.7314 19 11 18.7314 11 18.4V13.6C11 13.2686 10.7314 13 10.4 13H2.5V6.8Z",
          fill: "currentColor"
        }
      )
    }
  );
};
var ModalRightTopIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2C1.89543 2 1 2.89543 1 4V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V4C23 2.89543 22.1046 2 21 2H3ZM2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4C4 4.55228 3.55228 5 3 5C2.44772 5 2 4.55228 2 4ZM6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3ZM9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3ZM2.5 6.8C2.5 6.35817 2.85817 6 3.3 6H20.7C21.1418 6 21.5 6.35817 21.5 6.8V7.40002H13.6C13.2686 7.40002 13 7.66865 13 8.00003V12.8C13 13.1314 13.2686 13.4 13.6 13.4H21.5V19.7C21.5 20.1418 21.1418 20.5 20.7 20.5H3.3C2.85817 20.5 2.5 20.1418 2.5 19.7V6.8Z",
          fill: "currentColor"
        }
      )
    }
  );
};
var ModalLeftTopIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2C1.89543 2 1 2.89543 1 4V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V4C23 2.89543 22.1046 2 21 2H3ZM2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4C4 4.55228 3.55228 5 3 5C2.44772 5 2 4.55228 2 4ZM6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3ZM9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3ZM2.5 6.8C2.5 6.35817 2.85817 6 3.3 6H20.7C21.1418 6 21.5 6.35817 21.5 6.8V19.7C21.5 20.1418 21.1418 20.5 20.7 20.5H3.3C2.85817 20.5 2.5 20.1418 2.5 19.7V13.4H10.4C10.7314 13.4 11 13.1314 11 12.8V8.00003C11 7.66865 10.7314 7.40002 10.4 7.40002H2.5V6.8Z",
          fill: "currentColor"
        }
      )
    }
  );
};
var ModalCenterTopIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2C1.89543 2 1 2.89543 1 4V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V4C23 2.89543 22.1046 2 21 2H3ZM2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4C4 4.55228 3.55228 5 3 5C2.44772 5 2 4.55228 2 4ZM6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3ZM9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3ZM7 6V12.4C7 12.7314 7.26863 13 7.6 13H16.4C16.7314 13 17 12.7314 17 12.4V6H20.7C21.1418 6 21.5 6.35817 21.5 6.8V19.7C21.5 20.1418 21.1418 20.5 20.7 20.5H3.3C2.85817 20.5 2.5 20.1418 2.5 19.7V6.8C2.5 6.35817 2.85817 6 3.3 6H7Z",
          fill: "currentColor"
        }
      )
    }
  );
};
var ModalCenterBottomIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2C1.89543 2 1 2.89543 1 4V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V4C23 2.89543 22.1046 2 21 2H3ZM2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4C4 4.55228 3.55228 5 3 5C2.44772 5 2 4.55228 2 4ZM6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3ZM9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3ZM2.5 6.8C2.5 6.35817 2.85817 6 3.3 6H20.7C21.1418 6 21.5 6.35817 21.5 6.8V19.7C21.5 20.1418 21.1418 20.5 20.7 20.5H16.9917C16.9972 20.4675 17 20.4341 17 20.4V13.6C17 13.2686 16.7314 13 16.4 13H7.6C7.26863 13 7 13.2686 7 13.6V20.4C7 20.4341 7.00284 20.4675 7.0083 20.5H3.3C2.85817 20.5 2.5 20.1418 2.5 19.7V6.8Z",
          fill: "currentColor"
        }
      )
    }
  );
};
var ModalCenterCenterIcon = () => {
  return /* @__PURE__ */ jsxs20(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx41(
          "path",
          {
            d: "M5.6 9C5.26863 9 5 9.26863 5 9.6V17.4C5 17.7314 5.26863 18 5.6 18H18.4C18.7314 18 19 17.7314 19 17.4V9.6C19 9.26862 18.7314 9 18.4 9H5.6Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx41(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 1.99999C1.89543 1.99999 1 2.89543 1 4V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V3.99999C23 2.89543 22.1046 1.99999 21 1.99999H3ZM2 3.99999C2 3.44771 2.44772 2.99999 3 2.99999C3.55228 2.99999 4 3.44771 4 3.99999C4 4.55228 3.55228 5 3 5C2.44772 5 2 4.55228 2 3.99999ZM6 2.99999C5.44772 2.99999 5 3.44771 5 3.99999C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 3.99999C7 3.44771 6.55228 2.99999 6 2.99999ZM9 2.99999C8.44772 2.99999 8 3.44771 8 3.99999C8 4.55228 8.44772 5 9 5C9.55228 5 10 4.55228 10 3.99999C10 3.44771 9.55228 2.99999 9 2.99999ZM2.5 6.8C2.5 6.35817 2.85817 6 3.3 6H20.7C21.1418 6 21.5 6.35817 21.5 6.8V19.7C21.5 20.1418 21.1418 20.5 20.7 20.5H3.3C2.85817 20.5 2.5 20.1418 2.5 19.7V6.8Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
};
var ModalRightCenterIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2C1.89543 2 1 2.89543 1 4V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V4C23 2.89543 22.1046 2 21 2H3ZM2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4C4 4.55228 3.55228 5 3 5C2.44772 5 2 4.55228 2 4ZM6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3ZM9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3ZM2.5 6.8C2.5 6.35817 2.85817 6 3.3 6H20.7C21.1418 6 21.5 6.35817 21.5 6.8V10.4H13.6C13.2686 10.4 13 10.6686 13 11V15.8C13 16.1314 13.2686 16.4 13.6 16.4H21.5V19.7C21.5 20.1418 21.1418 20.5 20.7 20.5H3.3C2.85817 20.5 2.5 20.1418 2.5 19.7V6.8Z",
          fill: "currentColor"
        }
      )
    }
  );
};
var ModalLeftCenterIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2C1.89543 2 1 2.89543 1 4V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V4C23 2.89543 22.1046 2 21 2H3ZM2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4C4 4.55228 3.55228 5 3 5C2.44772 5 2 4.55228 2 4ZM6 3C5.44772 3 5 3.44772 5 4C5 4.55228 5.44772 5 6 5C6.55228 5 7 4.55228 7 4C7 3.44772 6.55228 3 6 3ZM9 3C8.44772 3 8 3.44772 8 4C8 4.55228 8.44772 5 9 5C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3ZM2.5 6.8C2.5 6.35817 2.85817 6 3.3 6H20.7C21.1418 6 21.5 6.35817 21.5 6.8V19.7C21.5 20.1418 21.1418 20.5 20.7 20.5H3.3C2.85817 20.5 2.5 20.1418 2.5 19.7V16H10.4C10.7314 16 11 15.7314 11 15.4V10.6C11 10.2686 10.7314 10 10.4 10H2.5V6.8Z",
          fill: "currentColor"
        }
      )
    }
  );
};
var ModalPositionIcons = {
  "right-bottom": ModalRightBottomIcon,
  "right-center": ModalRightCenterIcon,
  "left-center": ModalLeftCenterIcon,
  "left-bottom": ModalLeftBottomIcon,
  "right-top": ModalRightTopIcon,
  "left-top": ModalLeftTopIcon,
  "center-top": ModalCenterTopIcon,
  "center-bottom": ModalCenterBottomIcon,
  "center-center": ModalCenterCenterIcon,
  default: ModalRightBottomIcon
};
var DelayIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41("g", { transform: "translate(2, 0)", children: /* @__PURE__ */ jsx41(
        "path",
        {
          d: "M10.875 15C10.875 15.6234 10.3734 16.125 9.75 16.125C9.12656 16.125 8.625 15.6234 8.625 15V10.125C8.625 9.50156 9.12656 9 9.75 9C10.3734 9 10.875 9.50156 10.875 10.125V15ZM6 1.125C6 0.503906 6.50156 0 7.125 0H12.375C12.9984 0 13.5 0.503906 13.5 1.125C13.5 1.74609 12.9984 2.25 12.375 2.25H10.875V4.56422C12.9094 4.8 14.7562 5.65781 16.2094 6.94687L17.5781 5.57812C18.0187 5.14219 18.7313 5.14219 19.1297 5.57812C19.6078 6.01875 19.6078 6.73125 19.1297 7.12969L17.7141 8.625C18.8391 10.2141 19.5 12.1547 19.5 14.25C19.5 19.6359 15.1359 24 9.75 24C4.36406 24 0 19.6359 0 14.25C0 9.24375 3.77016 5.12344 8.625 4.56422V2.25H7.125C6.50156 2.25 6 1.74609 6 1.125ZM9.75 21.75C13.8938 21.75 17.25 18.3937 17.25 14.25C17.25 10.1062 13.8938 6.75 9.75 6.75C5.60625 6.75 2.25 10.1062 2.25 14.25C2.25 18.3937 5.60625 21.75 9.75 21.75Z",
          fill: "currentColor"
        }
      ) })
    }
  );
};
var NavigateIcon = () => {
  return /* @__PURE__ */ jsx41(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 21",
      fill: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx41(
        "path",
        {
          d: "M23.6098 9.10223L15.3602 16.1847C14.6393 16.8081 13.4998 16.304 13.4998 15.3335V11.2537C6.2294 11.3568 3.09642 13.1614 5.22163 19.958C5.45745 20.7122 4.5462 21.2967 3.90638 20.8308C1.8557 19.3393 0 16.4894 0 13.6067C0 6.47267 5.9716 4.96336 13.4994 4.8743V1.12541C13.4994 0.156553 14.6374 -0.349204 15.3598 0.274204L23.6094 7.35669C24.1301 7.84604 24.1301 8.65225 23.6098 9.10223Z",
          fill: "currentColor"
        }
      )
    }
  );
};

// src/components/StepBar/StepBarItem.tsx
import { Fragment as Fragment10, jsx as jsx42, jsxs as jsxs21 } from "react/jsx-runtime";
var StepBarItem = ({
  id,
  index: index5,
  className,
  active,
  type = "modal",
  delay,
  modalPosition = "center-center",
  onClick,
  ...props
}) => {
  const stepIndex = (index5 ?? 0) + 1;
  const sortable = useSortable({ id });
  const { setNodeRef, transform, transition, isDragging } = sortable;
  const style = {
    transform: CSS2.Transform.toString(transform),
    transition
  };
  const onPointerDown = sortable.listeners?.onPointerDown;
  const handleClick = (e3) => {
    if (isDragging) {
      e3.preventDefault();
      e3.stopPropagation();
      return;
    }
    onClick?.(id);
  };
  const ModalIcon = ModalPositionIcons[modalPosition] || ModalPositionIcons.default;
  const renderContent = () => {
    switch (type) {
      case "delay":
        return /* @__PURE__ */ jsxs21(Fragment10, { children: [
          /* @__PURE__ */ jsx42(DelayIcon, {}),
          /* @__PURE__ */ jsx42(
            "span",
            {
              className: cn("text-neutral-3", active && "!text-over-theme"),
              "aria-hidden": "true",
              children: delay ?? 90
            }
          )
        ] });
      case "navigate":
        return /* @__PURE__ */ jsx42(NavigateIcon, {});
      case "modal":
      default:
        return /* @__PURE__ */ jsxs21(Fragment10, { children: [
          /* @__PURE__ */ jsx42("span", { className: "w-5", "aria-hidden": "true", children: stepIndex }),
          /* @__PURE__ */ jsx42(ModalIcon, {})
        ] });
    }
  };
  return /* @__PURE__ */ jsx42(
    "button",
    {
      type: "button",
      ref: setNodeRef,
      style,
      onPointerDown,
      className: cn(
        // Layout
        "flex items-center justify-center",
        // Sizing
        "w-18 h-12",
        // Spacing
        "gap-1",
        // Appearance
        "bg-neutral-0 rounded-sm",
        // Borders
        "border-1 border-neutral-1",
        // Typography
        "text-neutral-1 text-sm font-semibold leading-4",
        // Interactions
        "cursor-pointer",
        // Hover state
        "hover:bg-highlight-3 hover:border-highlight-3",
        // Focus state
        "focus-visible:bg-highlight-3 focus-visible:border-highlight-3",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--border-focus-ring)] focus-visible:ring-offset-2",
        // Active/Drag state
        "active:bg-highlight-2 active:border-highlight-3",
        // Selected state
        active && "!bg-level-inverse !border-level-inverse !text-over-theme",
        className
      ),
      "aria-label": `Click to select step ${type === "delay" ? `delay ${delay}s` : type === "navigate" ? "navigate" : stepIndex} ${active ? "- step active" : ""}`,
      ...props,
      onClick: handleClick,
      children: renderContent()
    }
  );
};
StepBarItem.displayName = "StepBarItem";

// src/components/Switch/Switch.tsx
import * as React39 from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { jsx as jsx43 } from "react/jsx-runtime";
var Switch = React39.forwardRef(({ className, "aria-label": ariaLabel = "Toggle switch", ...props }, ref) => /* @__PURE__ */ jsx43(
  SwitchPrimitives.Root,
  {
    className: cn(
      // Layout
      "peer inline-flex items-center",
      // Sizing
      "max-w-9 h-5 max-h-5 w-9 shrink-0",
      // Appearance
      "rounded-full shadow-sm",
      // Borders
      "border-2 border-transparent",
      // Checked state
      "data-[state=checked]:bg-highlight-1",
      "data-[state=unchecked]:bg-neutral-3",
      // Interactions
      "cursor-pointer transition-colors",
      // Focus state
      "ring-offset-transparent",
      "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[var(--border-focus-ring)] focus-visible:ring-offset-1",
      // Disabled state
      "disabled:cursor-not-allowed disabled:opacity-50",
      className
    ),
    "aria-label": ariaLabel,
    ...props,
    ref,
    children: /* @__PURE__ */ jsx43(
      SwitchPrimitives.Thumb,
      {
        className: cn(
          // Layout
          "block",
          // Sizing
          "h-4 w-4",
          // Appearance
          "rounded-full shadow-lg",
          "bg-[var(--fg-over-primary)]",
          // Ring
          "ring-0",
          // Interactions
          "pointer-events-none transition-transform",
          // State translations
          "data-[state=checked]:translate-x-4",
          "data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
Switch.displayName = SwitchPrimitives.Root.displayName;

// ../../node_modules/@radix-ui/react-tooltip/dist/index.module.js
import { useState as $8wepK$useState, useRef as $8wepK$useRef, useEffect as $8wepK$useEffect, createElement as $8wepK$createElement, useCallback as $8wepK$useCallback, useMemo as $8wepK$useMemo, forwardRef as $8wepK$forwardRef } from "react";

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff104(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import { useCallback as $3vqmr$useCallback5 } from "react";
function $6ed0406888f73fc4$var$setRef5(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af5(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef5(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d055(...refs) {
  return $3vqmr$useCallback5($6ed0406888f73fc4$export$43e446d32b3d21af5(...refs), refs);
}

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-context/dist/index.module.js
import { createContext as $3bkAK$createContext5, useMemo as $3bkAK$useMemo5, createElement as $3bkAK$createElement5, useContext as $3bkAK$useContext5 } from "react";
function $c512c27ab02ef895$export$50c7b4e9d9f19c15(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ $3bkAK$createContext5(defaultContext);
    const index5 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const value = $3bkAK$useMemo5(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ $3bkAK$createElement5(Context.Provider, {
        value
      }, children);
    }
    function useContext7(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const context = $3bkAK$useContext5(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext7
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ $3bkAK$createContext5(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo5(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes5(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes5(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return $3bkAK$useMemo5(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

// ../../node_modules/@radix-ui/react-dismissable-layer/dist/index.module.js
import { createContext as $kqwpH$createContext2, forwardRef as $kqwpH$forwardRef2, useContext as $kqwpH$useContext2, useState as $kqwpH$useState2, useEffect as $kqwpH$useEffect2, createElement as $kqwpH$createElement2, useRef as $kqwpH$useRef2 } from "react";

// ../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff105(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

// ../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef4, useEffect as $4q5Fq$useEffect4, createElement as $4q5Fq$createElement4 } from "react";
import { flushSync as $4q5Fq$flushSync4 } from "react-dom";
import { Slot as $4q5Fq$Slot4 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES4 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d0344 = $8927f6f2acc4f386$var$NODES4.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef4((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot4 : node;
    $4q5Fq$useEffect4(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement4(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});
function $8927f6f2acc4f386$export$6d1a0317bde7de7f2(target, event) {
  if (target) $4q5Fq$flushSync4(
    () => target.dispatchEvent(event)
  );
}

// ../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import { useCallback as $3vqmr$useCallback6 } from "react";
function $6ed0406888f73fc4$var$setRef6(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af6(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef6(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d056(...refs) {
  return $3vqmr$useCallback6($6ed0406888f73fc4$export$43e446d32b3d21af6(...refs), refs);
}

// ../../node_modules/@radix-ui/react-dismissable-layer/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import { useRef as $lwiWj$useRef5, useEffect as $lwiWj$useEffect5, useMemo as $lwiWj$useMemo5 } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a5(callback) {
  const callbackRef = $lwiWj$useRef5(callback);
  $lwiWj$useEffect5(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo5(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-dismissable-layer/dist/index.module.js
var $5cb92bef7577960e$var$CONTEXT_UPDATE2 = "dismissableLayer.update";
var $5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE2 = "dismissableLayer.pointerDownOutside";
var $5cb92bef7577960e$var$FOCUS_OUTSIDE2 = "dismissableLayer.focusOutside";
var $5cb92bef7577960e$var$originalBodyPointerEvents2;
var $5cb92bef7577960e$var$DismissableLayerContext2 = /* @__PURE__ */ $kqwpH$createContext2({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
var $5cb92bef7577960e$export$177fb62ff3ec1f222 = /* @__PURE__ */ $kqwpH$forwardRef2((props, forwardedRef) => {
  var _node$ownerDocument;
  const { disableOutsidePointerEvents = false, onEscapeKeyDown, onPointerDownOutside, onFocusOutside, onInteractOutside, onDismiss, ...layerProps } = props;
  const context = $kqwpH$useContext2($5cb92bef7577960e$var$DismissableLayerContext2);
  const [node1, setNode] = $kqwpH$useState2(null);
  const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
  const [, force] = $kqwpH$useState2({});
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d056(
    forwardedRef,
    (node) => setNode(node)
  );
  const layers = Array.from(context.layers);
  const [highestLayerWithOutsidePointerEventsDisabled] = [
    ...context.layersWithOutsidePointerEventsDisabled
  ].slice(-1);
  const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
  const index5 = node1 ? layers.indexOf(node1) : -1;
  const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
  const isPointerEventsEnabled = index5 >= highestLayerWithOutsidePointerEventsDisabledIndex;
  const pointerDownOutside = $5cb92bef7577960e$var$usePointerDownOutside2((event) => {
    const target = event.target;
    const isPointerDownOnBranch = [
      ...context.branches
    ].some(
      (branch) => branch.contains(target)
    );
    if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
    onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  const focusOutside = $5cb92bef7577960e$var$useFocusOutside2((event) => {
    const target = event.target;
    const isFocusInBranch = [
      ...context.branches
    ].some(
      (branch) => branch.contains(target)
    );
    if (isFocusInBranch) return;
    onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
    onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
    if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
  }, ownerDocument);
  $addc16e1bbe58fd0$export$3a72a57244d6e765((event) => {
    const isHighestLayer = index5 === context.layers.size - 1;
    if (!isHighestLayer) return;
    onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
    if (!event.defaultPrevented && onDismiss) {
      event.preventDefault();
      onDismiss();
    }
  }, ownerDocument);
  $kqwpH$useEffect2(() => {
    if (!node1) return;
    if (disableOutsidePointerEvents) {
      if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
        $5cb92bef7577960e$var$originalBodyPointerEvents2 = ownerDocument.body.style.pointerEvents;
        ownerDocument.body.style.pointerEvents = "none";
      }
      context.layersWithOutsidePointerEventsDisabled.add(node1);
    }
    context.layers.add(node1);
    $5cb92bef7577960e$var$dispatchUpdate2();
    return () => {
      if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $5cb92bef7577960e$var$originalBodyPointerEvents2;
    };
  }, [
    node1,
    ownerDocument,
    disableOutsidePointerEvents,
    context
  ]);
  $kqwpH$useEffect2(() => {
    return () => {
      if (!node1) return;
      context.layers.delete(node1);
      context.layersWithOutsidePointerEventsDisabled.delete(node1);
      $5cb92bef7577960e$var$dispatchUpdate2();
    };
  }, [
    node1,
    context
  ]);
  $kqwpH$useEffect2(() => {
    const handleUpdate = () => force({});
    document.addEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE2, handleUpdate);
    return () => document.removeEventListener($5cb92bef7577960e$var$CONTEXT_UPDATE2, handleUpdate);
  }, []);
  return /* @__PURE__ */ $kqwpH$createElement2($8927f6f2acc4f386$export$250ffa63cdc0d0344.div, _extends({}, layerProps, {
    ref: composedRefs,
    style: {
      pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
      ...props.style
    },
    onFocusCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff105(props.onFocusCapture, focusOutside.onFocusCapture),
    onBlurCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff105(props.onBlurCapture, focusOutside.onBlurCapture),
    onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff105(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
  }));
});
function $5cb92bef7577960e$var$usePointerDownOutside2(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const handlePointerDownOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a5(onPointerDownOutside);
  const isPointerInsideReactTreeRef = $kqwpH$useRef2(false);
  const handleClickRef = $kqwpH$useRef2(() => {
  });
  $kqwpH$useEffect2(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          $5cb92bef7577960e$var$handleAndDispatchCustomEvent2($5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE2, handlePointerDownOutside, eventDetail, {
            discrete: true
          });
        };
        var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
        const eventDetail = {
          originalEvent: event
        };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, {
            once: true
          });
        } else handleAndDispatchPointerDownOutsideEvent2();
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [
    ownerDocument,
    handlePointerDownOutside
  ]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function $5cb92bef7577960e$var$useFocusOutside2(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
  const handleFocusOutside = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a5(onFocusOutside);
  const isFocusInsideReactTreeRef = $kqwpH$useRef2(false);
  $kqwpH$useEffect2(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = {
          originalEvent: event
        };
        $5cb92bef7577960e$var$handleAndDispatchCustomEvent2($5cb92bef7577960e$var$FOCUS_OUTSIDE2, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [
    ownerDocument,
    handleFocusOutside
  ]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function $5cb92bef7577960e$var$dispatchUpdate2() {
  const event = new CustomEvent($5cb92bef7577960e$var$CONTEXT_UPDATE2);
  document.dispatchEvent(event);
}
function $5cb92bef7577960e$var$handleAndDispatchCustomEvent2(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, {
    bubbles: false,
    cancelable: true,
    detail
  });
  if (handler) target.addEventListener(name, handler, {
    once: true
  });
  if (discrete) $8927f6f2acc4f386$export$6d1a0317bde7de7f2(target, event);
  else target.dispatchEvent(event);
}

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-id/dist/index.module.js
import * as $2AODx$react4 from "react";

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js
import { useLayoutEffect as $dxlwH$useLayoutEffect4 } from "react";
var $9f79659886946c16$export$e5c5a5f917a5871c4 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? $dxlwH$useLayoutEffect4 : () => {
};

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-id/dist/index.module.js
var $1746a345f3d73bb7$var$useReactId4 = $2AODx$react4["useId".toString()] || (() => void 0);
var $1746a345f3d73bb7$var$count4 = 0;
function $1746a345f3d73bb7$export$f680877a34711e374(deterministicId) {
  const [id, setId] = $2AODx$react4.useState($1746a345f3d73bb7$var$useReactId4());
  $9f79659886946c16$export$e5c5a5f917a5871c4(() => {
    if (!deterministicId) setId(
      (reactId) => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count4++)
    );
  }, [
    deterministicId
  ]);
  return deterministicId || (id ? `radix-${id}` : "");
}

// ../../node_modules/@radix-ui/react-popper/dist/index.module.js
import { useState as $kY93V$useState2, createElement as $kY93V$createElement2, forwardRef as $kY93V$forwardRef2, useRef as $kY93V$useRef2, useEffect as $kY93V$useEffect2, useLayoutEffect as $kY93V$useLayoutEffect2 } from "react";

// ../../node_modules/@radix-ui/react-popper/node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function t2(t3) {
  return t3.split("-")[0];
}
function e2(t3) {
  return t3.split("-")[1];
}
function n3(e3) {
  return ["top", "bottom"].includes(t2(e3)) ? "x" : "y";
}
function r4(t3) {
  return "y" === t3 ? "height" : "width";
}
function i3(i5, o5, a5) {
  let { reference: l5, floating: s5 } = i5;
  const c5 = l5.x + l5.width / 2 - s5.width / 2, f5 = l5.y + l5.height / 2 - s5.height / 2, u5 = n3(o5), m5 = r4(u5), g5 = l5[m5] / 2 - s5[m5] / 2, d6 = "x" === u5;
  let p6;
  switch (t2(o5)) {
    case "top":
      p6 = { x: c5, y: l5.y - s5.height };
      break;
    case "bottom":
      p6 = { x: c5, y: l5.y + l5.height };
      break;
    case "right":
      p6 = { x: l5.x + l5.width, y: f5 };
      break;
    case "left":
      p6 = { x: l5.x - s5.width, y: f5 };
      break;
    default:
      p6 = { x: l5.x, y: l5.y };
  }
  switch (e2(o5)) {
    case "start":
      p6[u5] -= g5 * (a5 && d6 ? -1 : 1);
      break;
    case "end":
      p6[u5] += g5 * (a5 && d6 ? -1 : 1);
  }
  return p6;
}
var o3 = async (t3, e3, n5) => {
  const { placement: r6 = "bottom", strategy: o5 = "absolute", middleware: a5 = [], platform: l5 } = n5, s5 = await (null == l5.isRTL ? void 0 : l5.isRTL(e3));
  let c5 = await l5.getElementRects({ reference: t3, floating: e3, strategy: o5 }), { x: f5, y: u5 } = i3(c5, r6, s5), m5 = r6, g5 = {}, d6 = 0;
  for (let n6 = 0; n6 < a5.length; n6++) {
    const { name: p6, fn: h5 } = a5[n6], { x: y5, y: x5, data: w6, reset: v5 } = await h5({ x: f5, y: u5, initialPlacement: r6, placement: m5, strategy: o5, middlewareData: g5, rects: c5, platform: l5, elements: { reference: t3, floating: e3 } });
    f5 = null != y5 ? y5 : f5, u5 = null != x5 ? x5 : u5, g5 = { ...g5, [p6]: { ...g5[p6], ...w6 } }, v5 && d6 <= 50 && (d6++, "object" == typeof v5 && (v5.placement && (m5 = v5.placement), v5.rects && (c5 = true === v5.rects ? await l5.getElementRects({ reference: t3, floating: e3, strategy: o5 }) : v5.rects), { x: f5, y: u5 } = i3(c5, m5, s5)), n6 = -1);
  }
  return { x: f5, y: u5, placement: m5, strategy: o5, middlewareData: g5 };
};
function a3(t3) {
  return "number" != typeof t3 ? (function(t4) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t4 };
  })(t3) : { top: t3, right: t3, bottom: t3, left: t3 };
}
function l3(t3) {
  return { ...t3, top: t3.y, left: t3.x, right: t3.x + t3.width, bottom: t3.y + t3.height };
}
async function s3(t3, e3) {
  var n5;
  void 0 === e3 && (e3 = {});
  const { x: r6, y: i5, platform: o5, rects: s5, elements: c5, strategy: f5 } = t3, { boundary: u5 = "clippingAncestors", rootBoundary: m5 = "viewport", elementContext: g5 = "floating", altBoundary: d6 = false, padding: p6 = 0 } = e3, h5 = a3(p6), y5 = c5[d6 ? "floating" === g5 ? "reference" : "floating" : g5], x5 = l3(await o5.getClippingRect({ element: null == (n5 = await (null == o5.isElement ? void 0 : o5.isElement(y5))) || n5 ? y5 : y5.contextElement || await (null == o5.getDocumentElement ? void 0 : o5.getDocumentElement(c5.floating)), boundary: u5, rootBoundary: m5, strategy: f5 })), w6 = l3(o5.convertOffsetParentRelativeRectToViewportRelativeRect ? await o5.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: "floating" === g5 ? { ...s5.floating, x: r6, y: i5 } : s5.reference, offsetParent: await (null == o5.getOffsetParent ? void 0 : o5.getOffsetParent(c5.floating)), strategy: f5 }) : s5[g5]);
  return { top: x5.top - w6.top + h5.top, bottom: w6.bottom - x5.bottom + h5.bottom, left: x5.left - w6.left + h5.left, right: w6.right - x5.right + h5.right };
}
var c3 = Math.min;
var f3 = Math.max;
function u3(t3, e3, n5) {
  return f3(t3, c3(e3, n5));
}
var m3 = (t3) => ({ name: "arrow", options: t3, async fn(i5) {
  const { element: o5, padding: l5 = 0 } = null != t3 ? t3 : {}, { x: s5, y: c5, placement: f5, rects: m5, platform: g5 } = i5;
  if (null == o5) return {};
  const d6 = a3(l5), p6 = { x: s5, y: c5 }, h5 = n3(f5), y5 = e2(f5), x5 = r4(h5), w6 = await g5.getDimensions(o5), v5 = "y" === h5 ? "top" : "left", b5 = "y" === h5 ? "bottom" : "right", R5 = m5.reference[x5] + m5.reference[h5] - p6[h5] - m5.floating[x5], A3 = p6[h5] - m5.reference[h5], P3 = await (null == g5.getOffsetParent ? void 0 : g5.getOffsetParent(o5));
  let T5 = P3 ? "y" === h5 ? P3.clientHeight || 0 : P3.clientWidth || 0 : 0;
  0 === T5 && (T5 = m5.floating[x5]);
  const O3 = R5 / 2 - A3 / 2, D5 = d6[v5], L5 = T5 - w6[x5] - d6[b5], k3 = T5 / 2 - w6[x5] / 2 + O3, E5 = u3(D5, k3, L5), C3 = ("start" === y5 ? d6[v5] : d6[b5]) > 0 && k3 !== E5 && m5.reference[x5] <= m5.floating[x5];
  return { [h5]: p6[h5] - (C3 ? k3 < D5 ? D5 - k3 : L5 - k3 : 0), data: { [h5]: E5, centerOffset: k3 - E5 } };
} });
var g3 = { left: "right", right: "left", bottom: "top", top: "bottom" };
function d4(t3) {
  return t3.replace(/left|right|bottom|top/g, ((t4) => g3[t4]));
}
function p4(t3, i5, o5) {
  void 0 === o5 && (o5 = false);
  const a5 = e2(t3), l5 = n3(t3), s5 = r4(l5);
  let c5 = "x" === l5 ? a5 === (o5 ? "end" : "start") ? "right" : "left" : "start" === a5 ? "bottom" : "top";
  return i5.reference[s5] > i5.floating[s5] && (c5 = d4(c5)), { main: c5, cross: d4(c5) };
}
var h3 = { start: "end", end: "start" };
function y3(t3) {
  return t3.replace(/start|end/g, ((t4) => h3[t4]));
}
var x3 = ["top", "right", "bottom", "left"];
var w4 = x3.reduce(((t3, e3) => t3.concat(e3, e3 + "-start", e3 + "-end")), []);
var b3 = function(e3) {
  return void 0 === e3 && (e3 = {}), { name: "flip", options: e3, async fn(n5) {
    var r6;
    const { placement: i5, middlewareData: o5, rects: a5, initialPlacement: l5, platform: c5, elements: f5 } = n5, { mainAxis: u5 = true, crossAxis: m5 = true, fallbackPlacements: g5, fallbackStrategy: h5 = "bestFit", flipAlignment: x5 = true, ...w6 } = e3, v5 = t2(i5), b5 = g5 || (v5 === l5 || !x5 ? [d4(l5)] : (function(t3) {
      const e4 = d4(t3);
      return [y3(t3), e4, y3(e4)];
    })(l5)), R5 = [l5, ...b5], A3 = await s3(n5, w6), P3 = [];
    let T5 = (null == (r6 = o5.flip) ? void 0 : r6.overflows) || [];
    if (u5 && P3.push(A3[v5]), m5) {
      const { main: t3, cross: e4 } = p4(i5, a5, await (null == c5.isRTL ? void 0 : c5.isRTL(f5.floating)));
      P3.push(A3[t3], A3[e4]);
    }
    if (T5 = [...T5, { placement: i5, overflows: P3 }], !P3.every(((t3) => t3 <= 0))) {
      var O3, D5;
      const t3 = (null != (O3 = null == (D5 = o5.flip) ? void 0 : D5.index) ? O3 : 0) + 1, e4 = R5[t3];
      if (e4) return { data: { index: t3, overflows: T5 }, reset: { placement: e4 } };
      let n6 = "bottom";
      switch (h5) {
        case "bestFit": {
          var L5;
          const t4 = null == (L5 = T5.map(((t5) => [t5, t5.overflows.filter(((t6) => t6 > 0)).reduce(((t6, e5) => t6 + e5), 0)])).sort(((t5, e5) => t5[1] - e5[1]))[0]) ? void 0 : L5[0].placement;
          t4 && (n6 = t4);
          break;
        }
        case "initialPlacement":
          n6 = l5;
      }
      if (i5 !== n6) return { reset: { placement: n6 } };
    }
    return {};
  } };
};
function R3(t3, e3) {
  return { top: t3.top - e3.height, right: t3.right - e3.width, bottom: t3.bottom - e3.height, left: t3.left - e3.width };
}
function A2(t3) {
  return x3.some(((e3) => t3[e3] >= 0));
}
var P2 = function(t3) {
  let { strategy: e3 = "referenceHidden", ...n5 } = void 0 === t3 ? {} : t3;
  return { name: "hide", async fn(t4) {
    const { rects: r6 } = t4;
    switch (e3) {
      case "referenceHidden": {
        const e4 = R3(await s3(t4, { ...n5, elementContext: "reference" }), r6.reference);
        return { data: { referenceHiddenOffsets: e4, referenceHidden: A2(e4) } };
      }
      case "escaped": {
        const e4 = R3(await s3(t4, { ...n5, altBoundary: true }), r6.floating);
        return { data: { escapedOffsets: e4, escaped: A2(e4) } };
      }
      default:
        return {};
    }
  } };
};
var T3 = function(r6) {
  return void 0 === r6 && (r6 = 0), { name: "offset", options: r6, async fn(i5) {
    const { x: o5, y: a5 } = i5, l5 = await (async function(r7, i6) {
      const { placement: o6, platform: a6, elements: l6 } = r7, s5 = await (null == a6.isRTL ? void 0 : a6.isRTL(l6.floating)), c5 = t2(o6), f5 = e2(o6), u5 = "x" === n3(o6), m5 = ["left", "top"].includes(c5) ? -1 : 1, g5 = s5 && u5 ? -1 : 1, d6 = "function" == typeof i6 ? i6(r7) : i6;
      let { mainAxis: p6, crossAxis: h5, alignmentAxis: y5 } = "number" == typeof d6 ? { mainAxis: d6, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...d6 };
      return f5 && "number" == typeof y5 && (h5 = "end" === f5 ? -1 * y5 : y5), u5 ? { x: h5 * g5, y: p6 * m5 } : { x: p6 * m5, y: h5 * g5 };
    })(i5, r6);
    return { x: o5 + l5.x, y: a5 + l5.y, data: l5 };
  } };
};
function O2(t3) {
  return "x" === t3 ? "y" : "x";
}
var D3 = function(e3) {
  return void 0 === e3 && (e3 = {}), { name: "shift", options: e3, async fn(r6) {
    const { x: i5, y: o5, placement: a5 } = r6, { mainAxis: l5 = true, crossAxis: c5 = false, limiter: f5 = { fn: (t3) => {
      let { x: e4, y: n5 } = t3;
      return { x: e4, y: n5 };
    } }, ...m5 } = e3, g5 = { x: i5, y: o5 }, d6 = await s3(r6, m5), p6 = n3(t2(a5)), h5 = O2(p6);
    let y5 = g5[p6], x5 = g5[h5];
    if (l5) {
      const t3 = "y" === p6 ? "bottom" : "right";
      y5 = u3(y5 + d6["y" === p6 ? "top" : "left"], y5, y5 - d6[t3]);
    }
    if (c5) {
      const t3 = "y" === h5 ? "bottom" : "right";
      x5 = u3(x5 + d6["y" === h5 ? "top" : "left"], x5, x5 - d6[t3]);
    }
    const w6 = f5.fn({ ...r6, [p6]: y5, [h5]: x5 });
    return { ...w6, data: { x: w6.x - i5, y: w6.y - o5 } };
  } };
};
var L3 = function(e3) {
  return void 0 === e3 && (e3 = {}), { options: e3, fn(r6) {
    const { x: i5, y: o5, placement: a5, rects: l5, middlewareData: s5 } = r6, { offset: c5 = 0, mainAxis: f5 = true, crossAxis: u5 = true } = e3, m5 = { x: i5, y: o5 }, g5 = n3(a5), d6 = O2(g5);
    let p6 = m5[g5], h5 = m5[d6];
    const y5 = "function" == typeof c5 ? c5({ ...l5, placement: a5 }) : c5, x5 = "number" == typeof y5 ? { mainAxis: y5, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...y5 };
    if (f5) {
      const t3 = "y" === g5 ? "height" : "width", e4 = l5.reference[g5] - l5.floating[t3] + x5.mainAxis, n5 = l5.reference[g5] + l5.reference[t3] - x5.mainAxis;
      p6 < e4 ? p6 = e4 : p6 > n5 && (p6 = n5);
    }
    if (u5) {
      var w6, v5, b5, R5;
      const e4 = "y" === g5 ? "width" : "height", n5 = ["top", "left"].includes(t2(a5)), r7 = l5.reference[d6] - l5.floating[e4] + (n5 && null != (w6 = null == (v5 = s5.offset) ? void 0 : v5[d6]) ? w6 : 0) + (n5 ? 0 : x5.crossAxis), i6 = l5.reference[d6] + l5.reference[e4] + (n5 ? 0 : null != (b5 = null == (R5 = s5.offset) ? void 0 : R5[d6]) ? b5 : 0) - (n5 ? x5.crossAxis : 0);
      h5 < r7 ? h5 = r7 : h5 > i6 && (h5 = i6);
    }
    return { [g5]: p6, [d6]: h5 };
  } };
};

// ../../node_modules/@radix-ui/react-popper/node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function n4(t3) {
  return t3 && t3.document && t3.location && t3.alert && t3.setInterval;
}
function o4(t3) {
  if (null == t3) return window;
  if (!n4(t3)) {
    const e3 = t3.ownerDocument;
    return e3 && e3.defaultView || window;
  }
  return t3;
}
function i4(t3) {
  return o4(t3).getComputedStyle(t3);
}
function r5(t3) {
  return n4(t3) ? "" : t3 ? (t3.nodeName || "").toLowerCase() : "";
}
function l4() {
  const t3 = navigator.userAgentData;
  return null != t3 && t3.brands ? t3.brands.map(((t4) => t4.brand + "/" + t4.version)).join(" ") : navigator.userAgent;
}
function c4(t3) {
  return t3 instanceof o4(t3).HTMLElement;
}
function f4(t3) {
  return t3 instanceof o4(t3).Element;
}
function s4(t3) {
  if ("undefined" == typeof ShadowRoot) return false;
  return t3 instanceof o4(t3).ShadowRoot || t3 instanceof ShadowRoot;
}
function u4(t3) {
  const { overflow: e3, overflowX: n5, overflowY: o5 } = i4(t3);
  return /auto|scroll|overlay|hidden/.test(e3 + o5 + n5);
}
function d5(t3) {
  return ["table", "td", "th"].includes(r5(t3));
}
function h4(t3) {
  const e3 = /firefox/i.test(l4()), n5 = i4(t3);
  return "none" !== n5.transform || "none" !== n5.perspective || "paint" === n5.contain || ["transform", "perspective"].includes(n5.willChange) || e3 && "filter" === n5.willChange || e3 && !!n5.filter && "none" !== n5.filter;
}
function a4() {
  return !/^((?!chrome|android).)*safari/i.test(l4());
}
var g4 = Math.min;
var p5 = Math.max;
var m4 = Math.round;
function w5(t3, e3, n5) {
  var i5, r6, l5, s5;
  void 0 === e3 && (e3 = false), void 0 === n5 && (n5 = false);
  const u5 = t3.getBoundingClientRect();
  let d6 = 1, h5 = 1;
  e3 && c4(t3) && (d6 = t3.offsetWidth > 0 && m4(u5.width) / t3.offsetWidth || 1, h5 = t3.offsetHeight > 0 && m4(u5.height) / t3.offsetHeight || 1);
  const g5 = f4(t3) ? o4(t3) : window, p6 = !a4() && n5, w6 = (u5.left + (p6 && null != (i5 = null == (r6 = g5.visualViewport) ? void 0 : r6.offsetLeft) ? i5 : 0)) / d6, v5 = (u5.top + (p6 && null != (l5 = null == (s5 = g5.visualViewport) ? void 0 : s5.offsetTop) ? l5 : 0)) / h5, y5 = u5.width / d6, x5 = u5.height / h5;
  return { width: y5, height: x5, top: v5, right: w6 + y5, bottom: v5 + x5, left: w6, x: w6, y: v5 };
}
function v4(t3) {
  return (e3 = t3, (e3 instanceof o4(e3).Node ? t3.ownerDocument : t3.document) || window.document).documentElement;
  var e3;
}
function y4(t3) {
  return f4(t3) ? { scrollLeft: t3.scrollLeft, scrollTop: t3.scrollTop } : { scrollLeft: t3.pageXOffset, scrollTop: t3.pageYOffset };
}
function x4(t3) {
  return w5(v4(t3)).left + y4(t3).scrollLeft;
}
function b4(t3, e3, n5) {
  const o5 = c4(e3), i5 = v4(e3), l5 = w5(t3, o5 && (function(t4) {
    const e4 = w5(t4);
    return m4(e4.width) !== t4.offsetWidth || m4(e4.height) !== t4.offsetHeight;
  })(e3), "fixed" === n5);
  let f5 = { scrollLeft: 0, scrollTop: 0 };
  const s5 = { x: 0, y: 0 };
  if (o5 || !o5 && "fixed" !== n5) if (("body" !== r5(e3) || u4(i5)) && (f5 = y4(e3)), c4(e3)) {
    const t4 = w5(e3, true);
    s5.x = t4.x + e3.clientLeft, s5.y = t4.y + e3.clientTop;
  } else i5 && (s5.x = x4(i5));
  return { x: l5.left + f5.scrollLeft - s5.x, y: l5.top + f5.scrollTop - s5.y, width: l5.width, height: l5.height };
}
function L4(t3) {
  return "html" === r5(t3) ? t3 : t3.assignedSlot || t3.parentNode || (s4(t3) ? t3.host : null) || v4(t3);
}
function R4(t3) {
  return c4(t3) && "fixed" !== getComputedStyle(t3).position ? t3.offsetParent : null;
}
function T4(t3) {
  const e3 = o4(t3);
  let n5 = R4(t3);
  for (; n5 && d5(n5) && "static" === getComputedStyle(n5).position; ) n5 = R4(n5);
  return n5 && ("html" === r5(n5) || "body" === r5(n5) && "static" === getComputedStyle(n5).position && !h4(n5)) ? e3 : n5 || (function(t4) {
    let e4 = L4(t4);
    for (s4(e4) && (e4 = e4.host); c4(e4) && !["html", "body"].includes(r5(e4)); ) {
      if (h4(e4)) return e4;
      e4 = e4.parentNode;
    }
    return null;
  })(t3) || e3;
}
function W2(t3) {
  if (c4(t3)) return { width: t3.offsetWidth, height: t3.offsetHeight };
  const e3 = w5(t3);
  return { width: e3.width, height: e3.height };
}
function E4(t3) {
  const e3 = L4(t3);
  return ["html", "body", "#document"].includes(r5(e3)) ? t3.ownerDocument.body : c4(e3) && u4(e3) ? e3 : E4(e3);
}
function H2(t3, e3) {
  var n5;
  void 0 === e3 && (e3 = []);
  const i5 = E4(t3), r6 = i5 === (null == (n5 = t3.ownerDocument) ? void 0 : n5.body), l5 = o4(i5), c5 = r6 ? [l5].concat(l5.visualViewport || [], u4(i5) ? i5 : []) : i5, f5 = e3.concat(c5);
  return r6 ? f5 : f5.concat(H2(c5));
}
function C2(e3, n5, r6) {
  return "viewport" === n5 ? l3((function(t3, e4) {
    const n6 = o4(t3), i5 = v4(t3), r7 = n6.visualViewport;
    let l5 = i5.clientWidth, c5 = i5.clientHeight, f5 = 0, s5 = 0;
    if (r7) {
      l5 = r7.width, c5 = r7.height;
      const t4 = a4();
      (t4 || !t4 && "fixed" === e4) && (f5 = r7.offsetLeft, s5 = r7.offsetTop);
    }
    return { width: l5, height: c5, x: f5, y: s5 };
  })(e3, r6)) : f4(n5) ? (function(t3, e4) {
    const n6 = w5(t3, false, "fixed" === e4), o5 = n6.top + t3.clientTop, i5 = n6.left + t3.clientLeft;
    return { top: o5, left: i5, x: i5, y: o5, right: i5 + t3.clientWidth, bottom: o5 + t3.clientHeight, width: t3.clientWidth, height: t3.clientHeight };
  })(n5, r6) : l3((function(t3) {
    var e4;
    const n6 = v4(t3), o5 = y4(t3), r7 = null == (e4 = t3.ownerDocument) ? void 0 : e4.body, l5 = p5(n6.scrollWidth, n6.clientWidth, r7 ? r7.scrollWidth : 0, r7 ? r7.clientWidth : 0), c5 = p5(n6.scrollHeight, n6.clientHeight, r7 ? r7.scrollHeight : 0, r7 ? r7.clientHeight : 0);
    let f5 = -o5.scrollLeft + x4(t3);
    const s5 = -o5.scrollTop;
    return "rtl" === i4(r7 || n6).direction && (f5 += p5(n6.clientWidth, r7 ? r7.clientWidth : 0) - l5), { width: l5, height: c5, x: f5, y: s5 };
  })(v4(e3)));
}
function S2(t3) {
  const e3 = H2(t3), n5 = ["absolute", "fixed"].includes(i4(t3).position) && c4(t3) ? T4(t3) : t3;
  return f4(n5) ? e3.filter(((t4) => f4(t4) && (function(t5, e4) {
    const n6 = null == e4.getRootNode ? void 0 : e4.getRootNode();
    if (t5.contains(e4)) return true;
    if (n6 && s4(n6)) {
      let n7 = e4;
      do {
        if (n7 && t5 === n7) return true;
        n7 = n7.parentNode || n7.host;
      } while (n7);
    }
    return false;
  })(t4, n5) && "body" !== r5(t4))) : [];
}
var D4 = { getClippingRect: function(t3) {
  let { element: e3, boundary: n5, rootBoundary: o5, strategy: i5 } = t3;
  const r6 = [..."clippingAncestors" === n5 ? S2(e3) : [].concat(n5), o5], l5 = r6[0], c5 = r6.reduce(((t4, n6) => {
    const o6 = C2(e3, n6, i5);
    return t4.top = p5(o6.top, t4.top), t4.right = g4(o6.right, t4.right), t4.bottom = g4(o6.bottom, t4.bottom), t4.left = p5(o6.left, t4.left), t4;
  }), C2(e3, l5, i5));
  return { width: c5.right - c5.left, height: c5.bottom - c5.top, x: c5.left, y: c5.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t3) {
  let { rect: e3, offsetParent: n5, strategy: o5 } = t3;
  const i5 = c4(n5), l5 = v4(n5);
  if (n5 === l5) return e3;
  let f5 = { scrollLeft: 0, scrollTop: 0 };
  const s5 = { x: 0, y: 0 };
  if ((i5 || !i5 && "fixed" !== o5) && (("body" !== r5(n5) || u4(l5)) && (f5 = y4(n5)), c4(n5))) {
    const t4 = w5(n5, true);
    s5.x = t4.x + n5.clientLeft, s5.y = t4.y + n5.clientTop;
  }
  return { ...e3, x: e3.x - f5.scrollLeft + s5.x, y: e3.y - f5.scrollTop + s5.y };
}, isElement: f4, getDimensions: W2, getOffsetParent: T4, getDocumentElement: v4, getElementRects: (t3) => {
  let { reference: e3, floating: n5, strategy: o5 } = t3;
  return { reference: b4(e3, T4(n5), o5), floating: { ...W2(n5), x: 0, y: 0 } };
}, getClientRects: (t3) => Array.from(t3.getClientRects()), isRTL: (t3) => "rtl" === i4(t3).direction };
function N2(t3, e3, n5, o5) {
  void 0 === o5 && (o5 = {});
  const { ancestorScroll: i5 = true, ancestorResize: r6 = true, elementResize: l5 = true, animationFrame: c5 = false } = o5, s5 = i5 && !c5, u5 = r6 && !c5, d6 = s5 || u5 ? [...f4(t3) ? H2(t3) : [], ...H2(e3)] : [];
  d6.forEach(((t4) => {
    s5 && t4.addEventListener("scroll", n5, { passive: true }), u5 && t4.addEventListener("resize", n5);
  }));
  let h5, a5 = null;
  if (l5) {
    let o6 = true;
    a5 = new ResizeObserver((() => {
      o6 || n5(), o6 = false;
    })), f4(t3) && !c5 && a5.observe(t3), a5.observe(e3);
  }
  let g5 = c5 ? w5(t3) : null;
  return c5 && (function e4() {
    const o6 = w5(t3);
    !g5 || o6.x === g5.x && o6.y === g5.y && o6.width === g5.width && o6.height === g5.height || n5();
    g5 = o6, h5 = requestAnimationFrame(e4);
  })(), n5(), () => {
    var t4;
    d6.forEach(((t5) => {
      s5 && t5.removeEventListener("scroll", n5), u5 && t5.removeEventListener("resize", n5);
    })), null == (t4 = a5) || t4.disconnect(), a5 = null, c5 && cancelAnimationFrame(h5);
  };
}
var z2 = (t3, n5, o5) => o3(t3, n5, { platform: D4, ...o5 });

// ../../node_modules/@radix-ui/react-popper/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.esm.js
import * as React40 from "react";
import { useLayoutEffect as useLayoutEffect7, useEffect as useEffect22 } from "react";
import * as ReactDOM5 from "react-dom";
var index4 = typeof document !== "undefined" ? useLayoutEffect7 : useEffect22;
function deepEqual3(a5, b5) {
  if (a5 === b5) {
    return true;
  }
  if (typeof a5 !== typeof b5) {
    return false;
  }
  if (typeof a5 === "function" && a5.toString() === b5.toString()) {
    return true;
  }
  let length, i5, keys;
  if (a5 && b5 && typeof a5 == "object") {
    if (Array.isArray(a5)) {
      length = a5.length;
      if (length != b5.length) return false;
      for (i5 = length; i5-- !== 0; ) {
        if (!deepEqual3(a5[i5], b5[i5])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a5);
    length = keys.length;
    if (length !== Object.keys(b5).length) {
      return false;
    }
    for (i5 = length; i5-- !== 0; ) {
      if (!Object.prototype.hasOwnProperty.call(b5, keys[i5])) {
        return false;
      }
    }
    for (i5 = length; i5-- !== 0; ) {
      const key = keys[i5];
      if (key === "_owner" && a5.$$typeof) {
        continue;
      }
      if (!deepEqual3(a5[key], b5[key])) {
        return false;
      }
    }
    return true;
  }
  return a5 !== a5 && b5 !== b5;
}
function useLatestRef3(value) {
  const ref = React40.useRef(value);
  index4(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating4(_temp) {
  let {
    middleware,
    placement = "bottom",
    strategy = "absolute",
    whileElementsMounted
  } = _temp === void 0 ? {} : _temp;
  const reference = React40.useRef(null);
  const floating = React40.useRef(null);
  const whileElementsMountedRef = useLatestRef3(whileElementsMounted);
  const cleanupRef = React40.useRef(null);
  const [data, setData] = React40.useState({
    // Setting these to `null` will allow the consumer to determine if
    // `computePosition()` has run yet
    x: null,
    y: null,
    strategy,
    placement,
    middlewareData: {}
  });
  const [latestMiddleware, setLatestMiddleware] = React40.useState(middleware);
  if (!deepEqual3(latestMiddleware == null ? void 0 : latestMiddleware.map((_ref2) => {
    let {
      options
    } = _ref2;
    return options;
  }), middleware == null ? void 0 : middleware.map((_ref2) => {
    let {
      options
    } = _ref2;
    return options;
  }))) {
    setLatestMiddleware(middleware);
  }
  const update = React40.useCallback(() => {
    if (!reference.current || !floating.current) {
      return;
    }
    z2(reference.current, floating.current, {
      middleware: latestMiddleware,
      placement,
      strategy
    }).then((data2) => {
      if (isMountedRef.current) {
        ReactDOM5.flushSync(() => {
          setData(data2);
        });
      }
    });
  }, [latestMiddleware, placement, strategy]);
  index4(() => {
    if (isMountedRef.current) {
      update();
    }
  }, [update]);
  const isMountedRef = React40.useRef(false);
  index4(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const runElementMountCallback = React40.useCallback(() => {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (reference.current && floating.current) {
      if (whileElementsMountedRef.current) {
        const cleanupFn = whileElementsMountedRef.current(reference.current, floating.current, update);
        cleanupRef.current = cleanupFn;
      } else {
        update();
      }
    }
  }, [update, whileElementsMountedRef]);
  const setReference = React40.useCallback((node) => {
    reference.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const setFloating = React40.useCallback((node) => {
    floating.current = node;
    runElementMountCallback();
  }, [runElementMountCallback]);
  const refs = React40.useMemo(() => ({
    reference,
    floating
  }), []);
  return React40.useMemo(() => ({
    ...data,
    update,
    refs,
    reference: setReference,
    floating: setFloating
  }), [data, update, refs, setReference, setFloating]);
}
var arrow5 = (options) => {
  const {
    element,
    padding
  } = options;
  function isRef(value) {
    return Object.prototype.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(args) {
      if (isRef(element)) {
        if (element.current != null) {
          return m3({
            element: element.current,
            padding
          }).fn(args);
        }
        return {};
      } else if (element) {
        return m3({
          element,
          padding
        }).fn(args);
      }
      return {};
    }
  };
};

// ../../node_modules/@radix-ui/react-arrow/dist/index.module.js
import { forwardRef as $jbnEx$forwardRef, createElement as $jbnEx$createElement } from "react";

// ../../node_modules/@radix-ui/react-arrow/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef5, useEffect as $4q5Fq$useEffect5, createElement as $4q5Fq$createElement5 } from "react";
import { flushSync as $4q5Fq$flushSync5 } from "react-dom";
import { Slot as $4q5Fq$Slot5 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES5 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d0345 = $8927f6f2acc4f386$var$NODES5.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef5((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot5 : node;
    $4q5Fq$useEffect5(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement5(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-arrow/dist/index.module.js
var $7e8f5cd07187803e$export$21b07c8f274aebd5 = /* @__PURE__ */ $jbnEx$forwardRef((props, forwardedRef) => {
  const { children, width = 10, height = 5, ...arrowProps } = props;
  return /* @__PURE__ */ $jbnEx$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0345.svg, _extends({}, arrowProps, {
    ref: forwardedRef,
    width,
    height,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), props.asChild ? children : /* @__PURE__ */ $jbnEx$createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
});
var $7e8f5cd07187803e$export$be92b6f5f03c0fe9 = $7e8f5cd07187803e$export$21b07c8f274aebd5;

// ../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import { useCallback as $3vqmr$useCallback7 } from "react";
function $6ed0406888f73fc4$var$setRef7(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af7(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef7(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d057(...refs) {
  return $3vqmr$useCallback7($6ed0406888f73fc4$export$43e446d32b3d21af7(...refs), refs);
}

// ../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-context/dist/index.module.js
import { createContext as $3bkAK$createContext6, useMemo as $3bkAK$useMemo6, createElement as $3bkAK$createElement6, useContext as $3bkAK$useContext6 } from "react";
function $c512c27ab02ef895$export$50c7b4e9d9f19c16(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ $3bkAK$createContext6(defaultContext);
    const index5 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const value = $3bkAK$useMemo6(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ $3bkAK$createElement6(Context.Provider, {
        value
      }, children);
    }
    function useContext7(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const context = $3bkAK$useContext6(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext7
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ $3bkAK$createContext6(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo6(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes6(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes6(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return $3bkAK$useMemo6(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

// ../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef6, useEffect as $4q5Fq$useEffect6, createElement as $4q5Fq$createElement6 } from "react";
import { flushSync as $4q5Fq$flushSync6 } from "react-dom";
import { Slot as $4q5Fq$Slot6 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES6 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d0346 = $8927f6f2acc4f386$var$NODES6.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef6((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot6 : node;
    $4q5Fq$useEffect6(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement6(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js
import { useLayoutEffect as $dxlwH$useLayoutEffect5 } from "react";
var $9f79659886946c16$export$e5c5a5f917a5871c5 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? $dxlwH$useLayoutEffect5 : () => {
};

// ../../node_modules/@radix-ui/react-popper/node_modules/@radix-ui/react-use-size/dist/index.module.js
import { useState as $9gyGR$useState2 } from "react";
function $db6c3485150b8e66$export$1ab7ae714698c4b82(element) {
  const [size3, setSize] = $9gyGR$useState2(void 0);
  $9f79659886946c16$export$e5c5a5f917a5871c5(() => {
    if (element) {
      setSize({
        width: element.offsetWidth,
        height: element.offsetHeight
      });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) return;
        if (!entries.length) return;
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({
          width,
          height
        });
      });
      resizeObserver.observe(element, {
        box: "border-box"
      });
      return () => resizeObserver.unobserve(element);
    } else
      setSize(void 0);
  }, [
    element
  ]);
  return size3;
}

// ../../node_modules/@radix-ui/react-popper/dist/index.module.js
var $cf1ac5d9fe0e8206$var$POPPER_NAME2 = "Popper";
var [$cf1ac5d9fe0e8206$var$createPopperContext2, $cf1ac5d9fe0e8206$export$722aac194ae9232] = $c512c27ab02ef895$export$50c7b4e9d9f19c16($cf1ac5d9fe0e8206$var$POPPER_NAME2);
var [$cf1ac5d9fe0e8206$var$PopperProvider2, $cf1ac5d9fe0e8206$var$usePopperContext2] = $cf1ac5d9fe0e8206$var$createPopperContext2($cf1ac5d9fe0e8206$var$POPPER_NAME2);
var $cf1ac5d9fe0e8206$export$badac9ada3a0bdf92 = (props) => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = $kY93V$useState2(null);
  return /* @__PURE__ */ $kY93V$createElement2($cf1ac5d9fe0e8206$var$PopperProvider2, {
    scope: __scopePopper,
    anchor,
    onAnchorChange: setAnchor
  }, children);
};
var $cf1ac5d9fe0e8206$var$ANCHOR_NAME2 = "PopperAnchor";
var $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d2 = /* @__PURE__ */ $kY93V$forwardRef2((props, forwardedRef) => {
  const { __scopePopper, virtualRef, ...anchorProps } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext2($cf1ac5d9fe0e8206$var$ANCHOR_NAME2, __scopePopper);
  const ref = $kY93V$useRef2(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d057(forwardedRef, ref);
  $kY93V$useEffect2(() => {
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /* @__PURE__ */ $kY93V$createElement2($8927f6f2acc4f386$export$250ffa63cdc0d0346.div, _extends({}, anchorProps, {
    ref: composedRefs
  }));
});
var $cf1ac5d9fe0e8206$var$CONTENT_NAME2 = "PopperContent";
var [$cf1ac5d9fe0e8206$var$PopperContentProvider2, $cf1ac5d9fe0e8206$var$useContentContext2] = $cf1ac5d9fe0e8206$var$createPopperContext2($cf1ac5d9fe0e8206$var$CONTENT_NAME2);
var [$cf1ac5d9fe0e8206$var$PositionContextProvider2, $cf1ac5d9fe0e8206$var$usePositionContext2] = $cf1ac5d9fe0e8206$var$createPopperContext2($cf1ac5d9fe0e8206$var$CONTENT_NAME2, {
  hasParent: false,
  positionUpdateFns: /* @__PURE__ */ new Set()
});
var $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc2 = /* @__PURE__ */ $kY93V$forwardRef2((props, forwardedRef) => {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$hide, _middlewareData$trans, _middlewareData$trans2;
  const { __scopePopper, side = "bottom", sideOffset = 0, align = "center", alignOffset = 0, arrowPadding = 0, collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky = "partial", hideWhenDetached = false, avoidCollisions = true, ...contentProps } = props;
  const context = $cf1ac5d9fe0e8206$var$usePopperContext2($cf1ac5d9fe0e8206$var$CONTENT_NAME2, __scopePopper);
  const [content, setContent] = $kY93V$useState2(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d057(
    forwardedRef,
    (node) => setContent(node)
  );
  const [arrow6, setArrow] = $kY93V$useState2(null);
  const arrowSize = $db6c3485150b8e66$export$1ab7ae714698c4b82(arrow6);
  const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  const desiredPlacement = side + (align !== "center" ? "-" + align : "");
  const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...collisionPaddingProp
  };
  const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
    collisionBoundary
  ];
  const hasExplicitBoundaries = boundary.length > 0;
  const detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter($cf1ac5d9fe0e8206$var$isNotNull2),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: hasExplicitBoundaries
  };
  const { reference, floating, strategy, x: x5, y: y5, placement, middlewareData, update } = useFloating4({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: desiredPlacement,
    whileElementsMounted: N2,
    middleware: [
      T3({
        mainAxis: sideOffset + arrowHeight,
        alignmentAxis: alignOffset
      }),
      avoidCollisions ? D3({
        mainAxis: true,
        crossAxis: false,
        limiter: sticky === "partial" ? L3() : void 0,
        ...detectOverflowOptions
      }) : void 0,
      arrow6 ? arrow5({
        element: arrow6,
        padding: arrowPadding
      }) : void 0,
      avoidCollisions ? b3({
        ...detectOverflowOptions
      }) : void 0,
      $cf1ac5d9fe0e8206$var$transformOrigin2({
        arrowWidth,
        arrowHeight
      }),
      hideWhenDetached ? P2({
        strategy: "referenceHidden"
      }) : void 0
    ].filter($cf1ac5d9fe0e8206$var$isDefined2)
  });
  $9f79659886946c16$export$e5c5a5f917a5871c5(() => {
    reference(context.anchor);
  }, [
    reference,
    context.anchor
  ]);
  const isPlaced = x5 !== null && y5 !== null;
  const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement2(placement);
  const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
  const [contentZIndex, setContentZIndex] = $kY93V$useState2();
  $9f79659886946c16$export$e5c5a5f917a5871c5(() => {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [
    content
  ]);
  const { hasParent, positionUpdateFns } = $cf1ac5d9fe0e8206$var$usePositionContext2($cf1ac5d9fe0e8206$var$CONTENT_NAME2, __scopePopper);
  const isRoot = !hasParent;
  $kY93V$useLayoutEffect2(() => {
    if (!isRoot) {
      positionUpdateFns.add(update);
      return () => {
        positionUpdateFns.delete(update);
      };
    }
  }, [
    isRoot,
    positionUpdateFns,
    update
  ]);
  $kY93V$useLayoutEffect2(() => {
    if (isRoot && isPlaced) Array.from(positionUpdateFns).reverse().forEach(
      (fn) => requestAnimationFrame(fn)
    );
  }, [
    isRoot,
    isPlaced,
    positionUpdateFns
  ]);
  const commonProps = {
    "data-side": placedSide,
    "data-align": placedAlign,
    ...contentProps,
    ref: composedRefs,
    style: {
      ...contentProps.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: !isPlaced ? "none" : void 0,
      // hide the content if using the hide middleware and should be hidden
      opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : void 0
    }
  };
  return /* @__PURE__ */ $kY93V$createElement2("div", {
    ref: floating,
    "data-radix-popper-content-wrapper": "",
    style: {
      position: strategy,
      left: 0,
      top: 0,
      transform: isPlaced ? `translate3d(${Math.round(x5)}px, ${Math.round(y5)}px, 0)` : "translate3d(0, -200%, 0)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: contentZIndex,
      ["--radix-popper-transform-origin"]: [
        (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
        (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
      ].join(" ")
    }
  }, /* @__PURE__ */ $kY93V$createElement2($cf1ac5d9fe0e8206$var$PopperContentProvider2, {
    scope: __scopePopper,
    placedSide,
    onArrowChange: setArrow,
    arrowX,
    arrowY,
    shouldHideArrow: cannotCenterArrow
  }, isRoot ? /* @__PURE__ */ $kY93V$createElement2($cf1ac5d9fe0e8206$var$PositionContextProvider2, {
    scope: __scopePopper,
    hasParent: true,
    positionUpdateFns
  }, /* @__PURE__ */ $kY93V$createElement2($8927f6f2acc4f386$export$250ffa63cdc0d0346.div, commonProps)) : /* @__PURE__ */ $kY93V$createElement2($8927f6f2acc4f386$export$250ffa63cdc0d0346.div, commonProps)));
});
var $cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
var $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
var $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0 = /* @__PURE__ */ $kY93V$forwardRef2(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd02(props, forwardedRef) {
  const { __scopePopper, ...arrowProps } = props;
  const contentContext = $cf1ac5d9fe0e8206$var$useContentContext2($cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
  const baseSide = $cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ $kY93V$createElement2("span", {
      ref: contentContext.onArrowChange,
      style: {
        position: "absolute",
        left: contentContext.arrowX,
        top: contentContext.arrowY,
        [baseSide]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[contentContext.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: `rotate(180deg)`,
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[contentContext.placedSide],
        visibility: contentContext.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ $kY93V$createElement2($7e8f5cd07187803e$export$be92b6f5f03c0fe9, _extends({}, arrowProps, {
      ref: forwardedRef,
      style: {
        ...arrowProps.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function $cf1ac5d9fe0e8206$var$isDefined2(value) {
  return value !== void 0;
}
function $cf1ac5d9fe0e8206$var$isNotNull2(value) {
  return value !== null;
}
var $cf1ac5d9fe0e8206$var$transformOrigin2 = (options) => ({
  name: "transformOrigin",
  options,
  fn(data) {
    var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement2(placement);
    const noArrowAlign = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[placedAlign];
    const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
    const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
    let x5 = "";
    let y5 = "";
    if (placedSide === "bottom") {
      x5 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y5 = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x5 = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y5 = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x5 = `${-arrowHeight}px`;
      y5 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x5 = `${rects.floating.width + arrowHeight}px`;
      y5 = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return {
      data: {
        x: x5,
        y: y5
      }
    };
  }
});
function $cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement2(placement) {
  const [side, align = "center"] = placement.split("-");
  return [
    side,
    align
  ];
}
var $cf1ac5d9fe0e8206$export$be92b6f5f03c0fe92 = $cf1ac5d9fe0e8206$export$badac9ada3a0bdf92;
var $cf1ac5d9fe0e8206$export$b688253958b8dfe72 = $cf1ac5d9fe0e8206$export$ecd4e1ccab6ed6d2;
var $cf1ac5d9fe0e8206$export$7c6e2c02157bb7d22 = $cf1ac5d9fe0e8206$export$bc4ae5855d3c4fc2;
var $cf1ac5d9fe0e8206$export$21b07c8f274aebd52 = $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0;

// ../../node_modules/@radix-ui/react-portal/dist/index.module.js
import { forwardRef as $7SXl2$forwardRef2, createElement as $7SXl2$createElement2 } from "react";
import $7SXl2$reactdom2 from "react-dom";

// ../../node_modules/@radix-ui/react-portal/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef7, useEffect as $4q5Fq$useEffect7, createElement as $4q5Fq$createElement7 } from "react";
import { flushSync as $4q5Fq$flushSync7 } from "react-dom";
import { Slot as $4q5Fq$Slot7 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES7 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d0347 = $8927f6f2acc4f386$var$NODES7.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef7((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot7 : node;
    $4q5Fq$useEffect7(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement7(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-portal/dist/index.module.js
var $f1701beae083dbae$export$602eac185826482c2 = /* @__PURE__ */ $7SXl2$forwardRef2((props, forwardedRef) => {
  var _globalThis$document;
  const { container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
  return container ? /* @__PURE__ */ $7SXl2$reactdom2.createPortal(/* @__PURE__ */ $7SXl2$createElement2($8927f6f2acc4f386$export$250ffa63cdc0d0347.div, _extends({}, portalProps, {
    ref: forwardedRef
  })), container) : null;
});

// ../../node_modules/@radix-ui/react-tooltip/dist/index.module.js
import { Presence as $8wepK$Presence } from "@radix-ui/react-presence";

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef8, useEffect as $4q5Fq$useEffect8, createElement as $4q5Fq$createElement8 } from "react";
import { flushSync as $4q5Fq$flushSync8 } from "react-dom";
import { Slot as $4q5Fq$Slot8 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES8 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d0348 = $8927f6f2acc4f386$var$NODES8.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef8((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot8 : node;
    $4q5Fq$useEffect8(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement8(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-tooltip/dist/index.module.js
import { Slottable as $8wepK$Slottable } from "@radix-ui/react-slot";

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
import { useCallback as $bnPw9$useCallback4, useState as $bnPw9$useState4, useRef as $bnPw9$useRef4, useEffect as $bnPw9$useEffect4 } from "react";

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import { useRef as $lwiWj$useRef6, useEffect as $lwiWj$useEffect6, useMemo as $lwiWj$useMemo6 } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a6(callback) {
  const callbackRef = $lwiWj$useRef6(callback);
  $lwiWj$useEffect6(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo6(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
function $71cd76cc60e0454e$export$6f32135080cb4c34({ prop, defaultProp, onChange: onChange2 = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState4({
    defaultProp,
    onChange: onChange2
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a6(onChange2);
  const setValue = $bnPw9$useCallback4((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState4({ defaultProp, onChange: onChange2 }) {
  const uncontrolledState = $bnPw9$useState4(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = $bnPw9$useRef4(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a6(onChange2);
  $bnPw9$useEffect4(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}

// ../../node_modules/@radix-ui/react-visually-hidden/dist/index.module.js
import { forwardRef as $kVwnw$forwardRef2, createElement as $kVwnw$createElement2 } from "react";

// ../../node_modules/@radix-ui/react-visually-hidden/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef9, useEffect as $4q5Fq$useEffect9, createElement as $4q5Fq$createElement9 } from "react";
import { flushSync as $4q5Fq$flushSync9 } from "react-dom";
import { Slot as $4q5Fq$Slot9 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES9 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d0349 = $8927f6f2acc4f386$var$NODES9.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef9((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot9 : node;
    $4q5Fq$useEffect9(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement9(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-visually-hidden/dist/index.module.js
var $ea1ef594cf570d83$export$439d29a4e110a1642 = /* @__PURE__ */ $kVwnw$forwardRef2((props, forwardedRef) => {
  return /* @__PURE__ */ $kVwnw$createElement2($8927f6f2acc4f386$export$250ffa63cdc0d0349.span, _extends({}, props, {
    ref: forwardedRef,
    style: {
      // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal",
      ...props.style
    }
  }));
});
var $ea1ef594cf570d83$export$be92b6f5f03c0fe9 = $ea1ef594cf570d83$export$439d29a4e110a1642;

// ../../node_modules/@radix-ui/react-tooltip/dist/index.module.js
var [$a093c7e1ec25a057$var$createTooltipContext, $a093c7e1ec25a057$export$1c540a2224f0d865] = $c512c27ab02ef895$export$50c7b4e9d9f19c15("Tooltip", [
  $cf1ac5d9fe0e8206$export$722aac194ae9232
]);
var $a093c7e1ec25a057$var$usePopperScope = $cf1ac5d9fe0e8206$export$722aac194ae9232();
var $a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
var $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
var $a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
var [$a093c7e1ec25a057$var$TooltipProviderContextProvider, $a093c7e1ec25a057$var$useTooltipProviderContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PROVIDER_NAME);
var $a093c7e1ec25a057$export$f78649fb9ca566b8 = (props) => {
  const { __scopeTooltip, delayDuration = $a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION, skipDelayDuration = 300, disableHoverableContent = false, children } = props;
  const [isOpenDelayed, setIsOpenDelayed] = $8wepK$useState(true);
  const isPointerInTransitRef = $8wepK$useRef(false);
  const skipDelayTimerRef = $8wepK$useRef(0);
  $8wepK$useEffect(() => {
    const skipDelayTimer = skipDelayTimerRef.current;
    return () => window.clearTimeout(skipDelayTimer);
  }, []);
  return /* @__PURE__ */ $8wepK$createElement($a093c7e1ec25a057$var$TooltipProviderContextProvider, {
    scope: __scopeTooltip,
    isOpenDelayed,
    delayDuration,
    onOpen: $8wepK$useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      setIsOpenDelayed(false);
    }, []),
    onClose: $8wepK$useCallback(() => {
      window.clearTimeout(skipDelayTimerRef.current);
      skipDelayTimerRef.current = window.setTimeout(
        () => setIsOpenDelayed(true),
        skipDelayDuration
      );
    }, [
      skipDelayDuration
    ]),
    isPointerInTransitRef,
    onPointerInTransitChange: $8wepK$useCallback((inTransit) => {
      isPointerInTransitRef.current = inTransit;
    }, []),
    disableHoverableContent
  }, children);
};
var $a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
var [$a093c7e1ec25a057$var$TooltipContextProvider, $a093c7e1ec25a057$var$useTooltipContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME);
var $a093c7e1ec25a057$export$28c660c63b792dea = (props) => {
  const { __scopeTooltip, children, open: openProp, defaultOpen = false, onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const [trigger, setTrigger] = $8wepK$useState(null);
  const contentId = $1746a345f3d73bb7$export$f680877a34711e374();
  const openTimerRef = $8wepK$useRef(0);
  const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
  const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
  const wasOpenDelayedRef = $8wepK$useRef(false);
  const [open1 = false, setOpen] = $71cd76cc60e0454e$export$6f32135080cb4c34({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: (open2) => {
      if (open2) {
        providerContext.onOpen();
        document.dispatchEvent(new CustomEvent($a093c7e1ec25a057$var$TOOLTIP_OPEN));
      } else providerContext.onClose();
      onOpenChange === null || onOpenChange === void 0 || onOpenChange(open2);
    }
  });
  const stateAttribute = $8wepK$useMemo(() => {
    return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
  }, [
    open1
  ]);
  const handleOpen = $8wepK$useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    wasOpenDelayedRef.current = false;
    setOpen(true);
  }, [
    setOpen
  ]);
  const handleClose = $8wepK$useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    setOpen(false);
  }, [
    setOpen
  ]);
  const handleDelayedOpen = $8wepK$useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = window.setTimeout(() => {
      wasOpenDelayedRef.current = true;
      setOpen(true);
    }, delayDuration);
  }, [
    delayDuration,
    setOpen
  ]);
  $8wepK$useEffect(() => {
    return () => window.clearTimeout(openTimerRef.current);
  }, []);
  return /* @__PURE__ */ $8wepK$createElement($cf1ac5d9fe0e8206$export$be92b6f5f03c0fe92, popperScope, /* @__PURE__ */ $8wepK$createElement($a093c7e1ec25a057$var$TooltipContextProvider, {
    scope: __scopeTooltip,
    contentId,
    open: open1,
    stateAttribute,
    trigger,
    onTriggerChange: setTrigger,
    onTriggerEnter: $8wepK$useCallback(() => {
      if (providerContext.isOpenDelayed) handleDelayedOpen();
      else handleOpen();
    }, [
      providerContext.isOpenDelayed,
      handleDelayedOpen,
      handleOpen
    ]),
    onTriggerLeave: $8wepK$useCallback(() => {
      if (disableHoverableContent) handleClose();
      else
        window.clearTimeout(openTimerRef.current);
    }, [
      handleClose,
      disableHoverableContent
    ]),
    onOpen: handleOpen,
    onClose: handleClose,
    disableHoverableContent
  }, children));
};
var $a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
var $a093c7e1ec25a057$export$8c610744efcf8a1d = /* @__PURE__ */ $8wepK$forwardRef((props, forwardedRef) => {
  const { __scopeTooltip, ...triggerProps } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const ref = $8wepK$useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d055(forwardedRef, ref, context.onTriggerChange);
  const isPointerDownRef = $8wepK$useRef(false);
  const hasPointerMoveOpenedRef = $8wepK$useRef(false);
  const handlePointerUp = $8wepK$useCallback(
    () => isPointerDownRef.current = false,
    []
  );
  $8wepK$useEffect(() => {
    return () => document.removeEventListener("pointerup", handlePointerUp);
  }, [
    handlePointerUp
  ]);
  return /* @__PURE__ */ $8wepK$createElement($cf1ac5d9fe0e8206$export$b688253958b8dfe72, _extends({
    asChild: true
  }, popperScope), /* @__PURE__ */ $8wepK$createElement($8927f6f2acc4f386$export$250ffa63cdc0d0348.button, _extends({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": context.open ? context.contentId : void 0,
    "data-state": context.stateAttribute
  }, triggerProps, {
    ref: composedRefs,
    onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff104(props.onPointerMove, (event) => {
      if (event.pointerType === "touch") return;
      if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
        context.onTriggerEnter();
        hasPointerMoveOpenedRef.current = true;
      }
    }),
    onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff104(props.onPointerLeave, () => {
      context.onTriggerLeave();
      hasPointerMoveOpenedRef.current = false;
    }),
    onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff104(props.onPointerDown, () => {
      isPointerDownRef.current = true;
      document.addEventListener("pointerup", handlePointerUp, {
        once: true
      });
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff104(props.onFocus, () => {
      if (!isPointerDownRef.current) context.onOpen();
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff104(props.onBlur, context.onClose),
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff104(props.onClick, context.onClose)
  })));
});
var $a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
var [$a093c7e1ec25a057$var$PortalProvider, $a093c7e1ec25a057$var$usePortalContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, {
  forceMount: void 0
});
var $a093c7e1ec25a057$export$7b36b8f925ab7497 = (props) => {
  const { __scopeTooltip, forceMount, children, container } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
  return /* @__PURE__ */ $8wepK$createElement($a093c7e1ec25a057$var$PortalProvider, {
    scope: __scopeTooltip,
    forceMount
  }, /* @__PURE__ */ $8wepK$createElement($8wepK$Presence, {
    present: forceMount || context.open
  }, /* @__PURE__ */ $8wepK$createElement($f1701beae083dbae$export$602eac185826482c2, {
    asChild: true,
    container
  }, children)));
};
var $a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
var $a093c7e1ec25a057$export$e9003e2be37ec060 = /* @__PURE__ */ $8wepK$forwardRef((props, forwardedRef) => {
  const portalContext = $a093c7e1ec25a057$var$usePortalContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const { forceMount = portalContext.forceMount, side = "top", ...contentProps } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  return /* @__PURE__ */ $8wepK$createElement($8wepK$Presence, {
    present: forceMount || context.open
  }, context.disableHoverableContent ? /* @__PURE__ */ $8wepK$createElement($a093c7e1ec25a057$var$TooltipContentImpl, _extends({
    side
  }, contentProps, {
    ref: forwardedRef
  })) : /* @__PURE__ */ $8wepK$createElement($a093c7e1ec25a057$var$TooltipContentHoverable, _extends({
    side
  }, contentProps, {
    ref: forwardedRef
  })));
});
var $a093c7e1ec25a057$var$TooltipContentHoverable = /* @__PURE__ */ $8wepK$forwardRef((props, forwardedRef) => {
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const providerContext = $a093c7e1ec25a057$var$useTooltipProviderContext($a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
  const ref = $8wepK$useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d055(forwardedRef, ref);
  const [pointerGraceArea, setPointerGraceArea] = $8wepK$useState(null);
  const { trigger, onClose } = context;
  const content = ref.current;
  const { onPointerInTransitChange } = providerContext;
  const handleRemoveGraceArea = $8wepK$useCallback(() => {
    setPointerGraceArea(null);
    onPointerInTransitChange(false);
  }, [
    onPointerInTransitChange
  ]);
  const handleCreateGraceArea = $8wepK$useCallback((event, hoverTarget) => {
    const currentTarget = event.currentTarget;
    const exitPoint = {
      x: event.clientX,
      y: event.clientY
    };
    const exitSide = $a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
    const bleed = exitSide === "right" || exitSide === "bottom" ? -5 : 5;
    const isXAxis = exitSide === "right" || exitSide === "left";
    const startPoint = isXAxis ? {
      x: event.clientX + bleed,
      y: event.clientY
    } : {
      x: event.clientX,
      y: event.clientY + bleed
    };
    const hoverTargetPoints = $a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
    const graceArea = $a093c7e1ec25a057$var$getHull([
      startPoint,
      ...hoverTargetPoints
    ]);
    setPointerGraceArea(graceArea);
    onPointerInTransitChange(true);
  }, [
    onPointerInTransitChange
  ]);
  $8wepK$useEffect(() => {
    return () => handleRemoveGraceArea();
  }, [
    handleRemoveGraceArea
  ]);
  $8wepK$useEffect(() => {
    if (trigger && content) {
      const handleTriggerLeave = (event) => handleCreateGraceArea(event, content);
      const handleContentLeave = (event) => handleCreateGraceArea(event, trigger);
      trigger.addEventListener("pointerleave", handleTriggerLeave);
      content.addEventListener("pointerleave", handleContentLeave);
      return () => {
        trigger.removeEventListener("pointerleave", handleTriggerLeave);
        content.removeEventListener("pointerleave", handleContentLeave);
      };
    }
  }, [
    trigger,
    content,
    handleCreateGraceArea,
    handleRemoveGraceArea
  ]);
  $8wepK$useEffect(() => {
    if (pointerGraceArea) {
      const handleTrackPointerGrace = (event) => {
        const target = event.target;
        const pointerPosition = {
          x: event.clientX,
          y: event.clientY
        };
        const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
        const isPointerOutsideGraceArea = !$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
        if (hasEnteredTarget) handleRemoveGraceArea();
        else if (isPointerOutsideGraceArea) {
          handleRemoveGraceArea();
          onClose();
        }
      };
      document.addEventListener("pointermove", handleTrackPointerGrace);
      return () => document.removeEventListener("pointermove", handleTrackPointerGrace);
    }
  }, [
    trigger,
    content,
    pointerGraceArea,
    onClose,
    handleRemoveGraceArea
  ]);
  return /* @__PURE__ */ $8wepK$createElement($a093c7e1ec25a057$var$TooltipContentImpl, _extends({}, props, {
    ref: composedRefs
  }));
});
var [$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $a093c7e1ec25a057$var$createTooltipContext($a093c7e1ec25a057$var$TOOLTIP_NAME, {
  isInside: false
});
var $a093c7e1ec25a057$var$TooltipContentImpl = /* @__PURE__ */ $8wepK$forwardRef((props, forwardedRef) => {
  const { __scopeTooltip, children, "aria-label": ariaLabel, onEscapeKeyDown, onPointerDownOutside, ...contentProps } = props;
  const context = $a093c7e1ec25a057$var$useTooltipContext($a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const { onClose } = context;
  $8wepK$useEffect(() => {
    document.addEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    return () => document.removeEventListener($a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
  }, [
    onClose
  ]);
  $8wepK$useEffect(() => {
    if (context.trigger) {
      const handleScroll2 = (event) => {
        const target = event.target;
        if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
      };
      window.addEventListener("scroll", handleScroll2, {
        capture: true
      });
      return () => window.removeEventListener("scroll", handleScroll2, {
        capture: true
      });
    }
  }, [
    context.trigger,
    onClose
  ]);
  return /* @__PURE__ */ $8wepK$createElement($5cb92bef7577960e$export$177fb62ff3ec1f222, {
    asChild: true,
    disableOutsidePointerEvents: false,
    onEscapeKeyDown,
    onPointerDownOutside,
    onFocusOutside: (event) => event.preventDefault(),
    onDismiss: onClose
  }, /* @__PURE__ */ $8wepK$createElement($cf1ac5d9fe0e8206$export$7c6e2c02157bb7d22, _extends({
    "data-state": context.stateAttribute
  }, popperScope, contentProps, {
    ref: forwardedRef,
    style: {
      ...contentProps.style,
      // re-namespace exposed content custom property
      ["--radix-tooltip-content-transform-origin"]: "var(--radix-popper-transform-origin)"
    }
  }), /* @__PURE__ */ $8wepK$createElement($8wepK$Slottable, null, children), /* @__PURE__ */ $8wepK$createElement($a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
    scope: __scopeTooltip,
    isInside: true
  }, /* @__PURE__ */ $8wepK$createElement($ea1ef594cf570d83$export$be92b6f5f03c0fe9, {
    id: context.contentId,
    role: "tooltip"
  }, ariaLabel || children))));
});
var $a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
var $a093c7e1ec25a057$export$c27ee0ad710f7559 = /* @__PURE__ */ $8wepK$forwardRef((props, forwardedRef) => {
  const { __scopeTooltip, ...arrowProps } = props;
  const popperScope = $a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
  const visuallyHiddenContentContext = $a093c7e1ec25a057$var$useVisuallyHiddenContentContext($a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip);
  return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ $8wepK$createElement($cf1ac5d9fe0e8206$export$21b07c8f274aebd52, _extends({}, popperScope, arrowProps, {
    ref: forwardedRef
  }));
});
function $a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
  const top = Math.abs(rect.top - point.y);
  const bottom = Math.abs(rect.bottom - point.y);
  const right = Math.abs(rect.right - point.x);
  const left = Math.abs(rect.left - point.x);
  switch (Math.min(top, bottom, right, left)) {
    case left:
      return "left";
    case right:
      return "right";
    case top:
      return "top";
    case bottom:
      return "bottom";
    default:
      return null;
  }
}
function $a093c7e1ec25a057$var$getPointsFromRect(rect) {
  const { top, right, bottom, left } = rect;
  return [
    {
      x: left,
      y: top
    },
    {
      x: right,
      y: top
    },
    {
      x: right,
      y: bottom
    },
    {
      x: left,
      y: bottom
    }
  ];
}
function $a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
  const { x: x5, y: y5 } = point;
  let inside = false;
  for (let i5 = 0, j = polygon.length - 1; i5 < polygon.length; j = i5++) {
    const xi = polygon[i5].x;
    const yi = polygon[i5].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;
    const intersect = yi > y5 !== yj > y5 && x5 < (xj - xi) * (y5 - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function $a093c7e1ec25a057$var$getHull(points) {
  const newPoints = points.slice();
  newPoints.sort((a5, b5) => {
    if (a5.x < b5.x) return -1;
    else if (a5.x > b5.x) return 1;
    else if (a5.y < b5.y) return -1;
    else if (a5.y > b5.y) return 1;
    else return 0;
  });
  return $a093c7e1ec25a057$var$getHullPresorted(newPoints);
}
function $a093c7e1ec25a057$var$getHullPresorted(points) {
  if (points.length <= 1) return points.slice();
  const upperHull = [];
  for (let i5 = 0; i5 < points.length; i5++) {
    const p6 = points[i5];
    while (upperHull.length >= 2) {
      const q = upperHull[upperHull.length - 1];
      const r6 = upperHull[upperHull.length - 2];
      if ((q.x - r6.x) * (p6.y - r6.y) >= (q.y - r6.y) * (p6.x - r6.x)) upperHull.pop();
      else break;
    }
    upperHull.push(p6);
  }
  upperHull.pop();
  const lowerHull = [];
  for (let i1 = points.length - 1; i1 >= 0; i1--) {
    const p6 = points[i1];
    while (lowerHull.length >= 2) {
      const q = lowerHull[lowerHull.length - 1];
      const r6 = lowerHull[lowerHull.length - 2];
      if ((q.x - r6.x) * (p6.y - r6.y) >= (q.y - r6.y) * (p6.x - r6.x)) lowerHull.pop();
      else break;
    }
    lowerHull.push(p6);
  }
  lowerHull.pop();
  if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
  else return upperHull.concat(lowerHull);
}
var $a093c7e1ec25a057$export$2881499e37b75b9a = $a093c7e1ec25a057$export$f78649fb9ca566b8;
var $a093c7e1ec25a057$export$be92b6f5f03c0fe9 = $a093c7e1ec25a057$export$28c660c63b792dea;
var $a093c7e1ec25a057$export$41fb9f06171c75f4 = $a093c7e1ec25a057$export$8c610744efcf8a1d;
var $a093c7e1ec25a057$export$602eac185826482c = $a093c7e1ec25a057$export$7b36b8f925ab7497;
var $a093c7e1ec25a057$export$7c6e2c02157bb7d2 = $a093c7e1ec25a057$export$e9003e2be37ec060;
var $a093c7e1ec25a057$export$21b07c8f274aebd5 = $a093c7e1ec25a057$export$c27ee0ad710f7559;

// src/components/Tooltip/Tooltip.tsx
import { jsx as jsx44, jsxs as jsxs22 } from "react/jsx-runtime";
function TooltipProvider({
  delayDuration = 0,
  ...props
}) {
  return /* @__PURE__ */ jsx44(
    $a093c7e1ec25a057$export$2881499e37b75b9a,
    {
      "data-slot": "tooltip-provider",
      delayDuration,
      ...props
    }
  );
}
function Tooltip({
  ...props
}) {
  return /* @__PURE__ */ jsx44(TooltipProvider, { children: /* @__PURE__ */ jsx44($a093c7e1ec25a057$export$be92b6f5f03c0fe9, { "data-slot": "tooltip", ...props }) });
}
function TooltipTrigger({
  ...props
}) {
  return /* @__PURE__ */ jsx44($a093c7e1ec25a057$export$41fb9f06171c75f4, { asChild: true, "data-slot": "tooltip-trigger", ...props });
}
function TooltipContent({
  container,
  className,
  side = "top",
  sideOffset = 0,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx44($a093c7e1ec25a057$export$602eac185826482c, { container, children: /* @__PURE__ */ jsxs22(
    $a093c7e1ec25a057$export$7c6e2c02157bb7d2,
    {
      "data-slot": "tooltip-content",
      side,
      sideOffset,
      className: cn(
        // Sizing
        "max-w-xs",
        // Spacing
        "px-3 py-1.5",
        // Appearance
        "bg-level-inverse rounded-md shadow-md",
        // Position
        "z-50",
        // Typography
        "font-lato text-over-primary text-sm",
        // Animations - Enter
        "animate-in fade-in-0 zoom-in-95 origin-(--radix-tooltip-content-transform-origin)",
        // Animations - Exit
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        // Animations - Slide by side
        "data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      ),
      ...props,
      children: [
        children,
        /* @__PURE__ */ jsx44(
          $a093c7e1ec25a057$export$21b07c8f274aebd5,
          {
            className: cn(
              // Sizing
              "size-2.5",
              // Appearance
              "fill-none"
            )
          }
        )
      ]
    }
  ) });
}

// src/components/BlockTile/BlockTile.tsx
import { jsx as jsx45, jsxs as jsxs23 } from "react/jsx-runtime";
var BlockTile = ({
  id,
  icon: icon3,
  onClick,
  title,
  "data-state": dataState
}) => {
  return /* @__PURE__ */ jsxs23(
    "button",
    {
      id,
      type: "button",
      onClick,
      "data-state": dataState,
      className: cn(
        // Layout
        "flex items-center",
        // Sizing
        "w-[150px]",
        // Spacing
        "gap-2 p-3",
        // Appearance
        "bg-neutral-0 rounded-sm",
        // Borders
        "border-1 border-transparent",
        // Typography
        "text-neutral-1 font-semibold",
        // Interactions
        "cursor-pointer",
        // Hover state
        "hover:border-neutral-1 data-[state=hover]:border-neutral-1"
      ),
      children: [
        /* @__PURE__ */ jsx45(Icon, { size: "large", icon: icon3 }),
        /* @__PURE__ */ jsx45("span", { children: title })
      ]
    }
  );
};
var BlockTile_default = BlockTile;

// ../../node_modules/@radix-ui/react-tabs/dist/index.module.js
import { forwardRef as $1IHzk$forwardRef, createElement as $1IHzk$createElement, useRef as $1IHzk$useRef, useEffect as $1IHzk$useEffect } from "react";

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff106(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-context/dist/index.module.js
import { createContext as $3bkAK$createContext7, useMemo as $3bkAK$useMemo7, createElement as $3bkAK$createElement7, useContext as $3bkAK$useContext7 } from "react";
function $c512c27ab02ef895$export$50c7b4e9d9f19c17(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ $3bkAK$createContext7(defaultContext);
    const index5 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const value = $3bkAK$useMemo7(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ $3bkAK$createElement7(Context.Provider, {
        value
      }, children);
    }
    function useContext7(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const context = $3bkAK$useContext7(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext7
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ $3bkAK$createContext7(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo7(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes7(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes7(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return $3bkAK$useMemo7(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-roving-focus/dist/index.module.js
import { forwardRef as $98Iye$forwardRef, createElement as $98Iye$createElement, useRef as $98Iye$useRef, useState as $98Iye$useState, useEffect as $98Iye$useEffect, useCallback as $98Iye$useCallback } from "react";

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-collection/dist/index.module.js
import $6vYhU$react3 from "react";

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import { useCallback as $3vqmr$useCallback8 } from "react";
function $6ed0406888f73fc4$var$setRef8(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af8(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef8(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d058(...refs) {
  return $3vqmr$useCallback8($6ed0406888f73fc4$export$43e446d32b3d21af8(...refs), refs);
}

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-collection/dist/index.module.js
import { Slot as $6vYhU$Slot3 } from "@radix-ui/react-slot";
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb23(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c17(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  });
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = $6vYhU$react3.useRef(null);
    const itemMap = $6vYhU$react3.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ $6vYhU$react3.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  /* @__PURE__ */ Object.assign(CollectionProvider, {
    displayName: PROVIDER_NAME
  });
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */ $6vYhU$react3.forwardRef((props, forwardedRef) => {
    const { scope, children } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d058(forwardedRef, context.collectionRef);
    return /* @__PURE__ */ $6vYhU$react3.createElement($6vYhU$Slot3, {
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionSlot, {
    displayName: COLLECTION_SLOT_NAME
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */ $6vYhU$react3.forwardRef((props, forwardedRef) => {
    const { scope, children, ...itemData } = props;
    const ref = $6vYhU$react3.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d058(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    $6vYhU$react3.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */ $6vYhU$react3.createElement($6vYhU$Slot3, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionItemSlot, {
    displayName: ITEM_SLOT_NAME
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = $6vYhU$react3.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a5, b5) => orderedNodes.indexOf(a5.ref.current) - orderedNodes.indexOf(b5.ref.current)
      );
      return orderedItems;
    }, [
      context.collectionRef,
      context.itemMap
    ]);
    return getItems;
  }
  return [
    {
      Provider: CollectionProvider,
      Slot: CollectionSlot,
      ItemSlot: CollectionItemSlot
    },
    useCollection,
    createCollectionScope
  ];
}

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-id/dist/index.module.js
import * as $2AODx$react5 from "react";

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js
import { useLayoutEffect as $dxlwH$useLayoutEffect6 } from "react";
var $9f79659886946c16$export$e5c5a5f917a5871c6 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? $dxlwH$useLayoutEffect6 : () => {
};

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-id/dist/index.module.js
var $1746a345f3d73bb7$var$useReactId5 = $2AODx$react5["useId".toString()] || (() => void 0);
var $1746a345f3d73bb7$var$count5 = 0;
function $1746a345f3d73bb7$export$f680877a34711e375(deterministicId) {
  const [id, setId] = $2AODx$react5.useState($1746a345f3d73bb7$var$useReactId5());
  $9f79659886946c16$export$e5c5a5f917a5871c6(() => {
    if (!deterministicId) setId(
      (reactId) => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count5++)
    );
  }, [
    deterministicId
  ]);
  return deterministicId || (id ? `radix-${id}` : "");
}

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef10, useEffect as $4q5Fq$useEffect10, createElement as $4q5Fq$createElement10 } from "react";
import { flushSync as $4q5Fq$flushSync10 } from "react-dom";
import { Slot as $4q5Fq$Slot10 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES10 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d03410 = $8927f6f2acc4f386$var$NODES10.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef10((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot10 : node;
    $4q5Fq$useEffect10(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement10(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import { useRef as $lwiWj$useRef7, useEffect as $lwiWj$useEffect7, useMemo as $lwiWj$useMemo7 } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a7(callback) {
  const callbackRef = $lwiWj$useRef7(callback);
  $lwiWj$useEffect7(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo7(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
import { useCallback as $bnPw9$useCallback5, useState as $bnPw9$useState5, useRef as $bnPw9$useRef5, useEffect as $bnPw9$useEffect5 } from "react";
function $71cd76cc60e0454e$export$6f32135080cb4c35({ prop, defaultProp, onChange: onChange2 = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState5({
    defaultProp,
    onChange: onChange2
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a7(onChange2);
  const setValue = $bnPw9$useCallback5((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState5({ defaultProp, onChange: onChange2 }) {
  const uncontrolledState = $bnPw9$useState5(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = $bnPw9$useRef5(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a7(onChange2);
  $bnPw9$useEffect5(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}

// ../../node_modules/@radix-ui/react-tabs/node_modules/@radix-ui/react-roving-focus/dist/index.module.js
var $d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
  bubbles: false,
  cancelable: true
};
var $d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
var [$d7bdfb9eb0fdf311$var$Collection, $d7bdfb9eb0fdf311$var$useCollection, $d7bdfb9eb0fdf311$var$createCollectionScope] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb23($d7bdfb9eb0fdf311$var$GROUP_NAME);
var [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $d7bdfb9eb0fdf311$export$c7109489551a4f4] = $c512c27ab02ef895$export$50c7b4e9d9f19c17($d7bdfb9eb0fdf311$var$GROUP_NAME, [
  $d7bdfb9eb0fdf311$var$createCollectionScope
]);
var [$d7bdfb9eb0fdf311$var$RovingFocusProvider, $d7bdfb9eb0fdf311$var$useRovingFocusContext] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($d7bdfb9eb0fdf311$var$GROUP_NAME);
var $d7bdfb9eb0fdf311$export$8699f7c8af148338 = /* @__PURE__ */ $98Iye$forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ $98Iye$createElement($d7bdfb9eb0fdf311$var$Collection.Provider, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */ $98Iye$createElement($d7bdfb9eb0fdf311$var$Collection.Slot, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */ $98Iye$createElement($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, _extends({}, props, {
    ref: forwardedRef
  }))));
});
var $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /* @__PURE__ */ $98Iye$forwardRef((props, forwardedRef) => {
  const { __scopeRovingFocusGroup, orientation, loop = false, dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId, onCurrentTabStopIdChange, onEntryFocus, ...groupProps } = props;
  const ref = $98Iye$useRef(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d058(forwardedRef, ref);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [currentTabStopId = null, setCurrentTabStopId] = $71cd76cc60e0454e$export$6f32135080cb4c35({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId,
    onChange: onCurrentTabStopIdChange
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = $98Iye$useState(false);
  const handleEntryFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a7(onEntryFocus);
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  const isClickFocusRef = $98Iye$useRef(false);
  const [focusableItemsCount, setFocusableItemsCount] = $98Iye$useState(0);
  $98Iye$useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
      return () => node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
    }
  }, [
    handleEntryFocus
  ]);
  return /* @__PURE__ */ $98Iye$createElement($d7bdfb9eb0fdf311$var$RovingFocusProvider, {
    scope: __scopeRovingFocusGroup,
    orientation,
    dir: direction,
    loop,
    currentTabStopId,
    onItemFocus: $98Iye$useCallback(
      (tabStopId) => setCurrentTabStopId(tabStopId),
      [
        setCurrentTabStopId
      ]
    ),
    onItemShiftTab: $98Iye$useCallback(
      () => setIsTabbingBackOut(true),
      []
    ),
    onFocusableItemAdd: $98Iye$useCallback(
      () => setFocusableItemsCount(
        (prevCount) => prevCount + 1
      ),
      []
    ),
    onFocusableItemRemove: $98Iye$useCallback(
      () => setFocusableItemsCount(
        (prevCount) => prevCount - 1
      ),
      []
    )
  }, /* @__PURE__ */ $98Iye$createElement($8927f6f2acc4f386$export$250ffa63cdc0d03410.div, _extends({
    tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
    "data-orientation": orientation
  }, groupProps, {
    ref: composedRefs,
    style: {
      outline: "none",
      ...props.style
    },
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff106(props.onMouseDown, () => {
      isClickFocusRef.current = true;
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff106(props.onFocus, (event) => {
      const isKeyboardFocus = !isClickFocusRef.current;
      if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
        const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
        event.currentTarget.dispatchEvent(entryFocusEvent);
        if (!entryFocusEvent.defaultPrevented) {
          const items = getItems().filter(
            (item) => item.focusable
          );
          const activeItem = items.find(
            (item) => item.active
          );
          const currentItem = items.find(
            (item) => item.id === currentTabStopId
          );
          const candidateItems = [
            activeItem,
            currentItem,
            ...items
          ].filter(Boolean);
          const candidateNodes = candidateItems.map(
            (item) => item.ref.current
          );
          $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
        }
      }
      isClickFocusRef.current = false;
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff106(
      props.onBlur,
      () => setIsTabbingBackOut(false)
    )
  })));
});
var $d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
var $d7bdfb9eb0fdf311$export$ab9df7c53fe8454 = /* @__PURE__ */ $98Iye$forwardRef((props, forwardedRef) => {
  const { __scopeRovingFocusGroup, focusable = true, active = false, tabStopId, ...itemProps } = props;
  const autoId = $1746a345f3d73bb7$export$f680877a34711e375();
  const id = tabStopId || autoId;
  const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext($d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
  const isCurrentTabStop = context.currentTabStopId === id;
  const getItems = $d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
  const { onFocusableItemAdd, onFocusableItemRemove } = context;
  $98Iye$useEffect(() => {
    if (focusable) {
      onFocusableItemAdd();
      return () => onFocusableItemRemove();
    }
  }, [
    focusable,
    onFocusableItemAdd,
    onFocusableItemRemove
  ]);
  return /* @__PURE__ */ $98Iye$createElement($d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
    scope: __scopeRovingFocusGroup,
    id,
    focusable,
    active
  }, /* @__PURE__ */ $98Iye$createElement($8927f6f2acc4f386$export$250ffa63cdc0d03410.span, _extends({
    tabIndex: isCurrentTabStop ? 0 : -1,
    "data-orientation": context.orientation
  }, itemProps, {
    ref: forwardedRef,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff106(props.onMouseDown, (event) => {
      if (!focusable) event.preventDefault();
      else context.onItemFocus(id);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff106(
      props.onFocus,
      () => context.onItemFocus(id)
    ),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff106(props.onKeyDown, (event) => {
      if (event.key === "Tab" && event.shiftKey) {
        context.onItemShiftTab();
        return;
      }
      if (event.target !== event.currentTarget) return;
      const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
      if (focusIntent !== void 0) {
        event.preventDefault();
        const items = getItems().filter(
          (item) => item.focusable
        );
        let candidateNodes = items.map(
          (item) => item.ref.current
        );
        if (focusIntent === "last") candidateNodes.reverse();
        else if (focusIntent === "prev" || focusIntent === "next") {
          if (focusIntent === "prev") candidateNodes.reverse();
          const currentIndex = candidateNodes.indexOf(event.currentTarget);
          candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
        }
        setTimeout(
          () => $d7bdfb9eb0fdf311$var$focusFirst(candidateNodes)
        );
      }
    })
  })));
});
var $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
  const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(key)) return void 0;
  if (orientation === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(key)) return void 0;
  return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function $d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
  return array.map(
    (_, index5) => array[(startIndex + index5) % array.length]
  );
}
var $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9 = $d7bdfb9eb0fdf311$export$8699f7c8af148338;
var $d7bdfb9eb0fdf311$export$6d08773d2e66f8f2 = $d7bdfb9eb0fdf311$export$ab9df7c53fe8454;

// ../../node_modules/@radix-ui/react-tabs/dist/index.module.js
import { Presence as $1IHzk$Presence } from "@radix-ui/react-presence";
var $69cb30bb0017df05$var$TABS_NAME = "Tabs";
var [$69cb30bb0017df05$var$createTabsContext, $69cb30bb0017df05$export$355f5bd209d7b13a] = $c512c27ab02ef895$export$50c7b4e9d9f19c17($69cb30bb0017df05$var$TABS_NAME, [
  $d7bdfb9eb0fdf311$export$c7109489551a4f4
]);
var $69cb30bb0017df05$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f4();
var [$69cb30bb0017df05$var$TabsProvider, $69cb30bb0017df05$var$useTabsContext] = $69cb30bb0017df05$var$createTabsContext($69cb30bb0017df05$var$TABS_NAME);
var $69cb30bb0017df05$export$b2539bed5023c21c = /* @__PURE__ */ $1IHzk$forwardRef((props, forwardedRef) => {
  const { __scopeTabs, value: valueProp, onValueChange, defaultValue, orientation = "horizontal", dir, activationMode = "automatic", ...tabsProps } = props;
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c35({
    prop: valueProp,
    onChange: onValueChange,
    defaultProp: defaultValue
  });
  return /* @__PURE__ */ $1IHzk$createElement($69cb30bb0017df05$var$TabsProvider, {
    scope: __scopeTabs,
    baseId: $1746a345f3d73bb7$export$f680877a34711e375(),
    value,
    onValueChange: setValue,
    orientation,
    dir: direction,
    activationMode
  }, /* @__PURE__ */ $1IHzk$createElement($8927f6f2acc4f386$export$250ffa63cdc0d03410.div, _extends({
    dir: direction,
    "data-orientation": orientation
  }, tabsProps, {
    ref: forwardedRef
  })));
});
var $69cb30bb0017df05$var$TAB_LIST_NAME = "TabsList";
var $69cb30bb0017df05$export$9712d22edc0d78c1 = /* @__PURE__ */ $1IHzk$forwardRef((props, forwardedRef) => {
  const { __scopeTabs, loop = true, ...listProps } = props;
  const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TAB_LIST_NAME, __scopeTabs);
  const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
  return /* @__PURE__ */ $1IHzk$createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe9, _extends({
    asChild: true
  }, rovingFocusGroupScope, {
    orientation: context.orientation,
    dir: context.dir,
    loop
  }), /* @__PURE__ */ $1IHzk$createElement($8927f6f2acc4f386$export$250ffa63cdc0d03410.div, _extends({
    role: "tablist",
    "aria-orientation": context.orientation
  }, listProps, {
    ref: forwardedRef
  })));
});
var $69cb30bb0017df05$var$TRIGGER_NAME = "TabsTrigger";
var $69cb30bb0017df05$export$8114b9fdfdf9f3ba = /* @__PURE__ */ $1IHzk$forwardRef((props, forwardedRef) => {
  const { __scopeTabs, value, disabled: disabled2 = false, ...triggerProps } = props;
  const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$TRIGGER_NAME, __scopeTabs);
  const rovingFocusGroupScope = $69cb30bb0017df05$var$useRovingFocusGroupScope(__scopeTabs);
  const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
  const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
  const isSelected = value === context.value;
  return /* @__PURE__ */ $1IHzk$createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f2, _extends({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled2,
    active: isSelected
  }), /* @__PURE__ */ $1IHzk$createElement($8927f6f2acc4f386$export$250ffa63cdc0d03410.button, _extends({
    type: "button",
    role: "tab",
    "aria-selected": isSelected,
    "aria-controls": contentId,
    "data-state": isSelected ? "active" : "inactive",
    "data-disabled": disabled2 ? "" : void 0,
    disabled: disabled2,
    id: triggerId
  }, triggerProps, {
    ref: forwardedRef,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff106(props.onMouseDown, (event) => {
      if (!disabled2 && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
      else
        event.preventDefault();
    }),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff106(props.onKeyDown, (event) => {
      if ([
        " ",
        "Enter"
      ].includes(event.key)) context.onValueChange(value);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff106(props.onFocus, () => {
      const isAutomaticActivation = context.activationMode !== "manual";
      if (!isSelected && !disabled2 && isAutomaticActivation) context.onValueChange(value);
    })
  })));
});
var $69cb30bb0017df05$var$CONTENT_NAME = "TabsContent";
var $69cb30bb0017df05$export$bd905d70e8fd2ebb = /* @__PURE__ */ $1IHzk$forwardRef((props, forwardedRef) => {
  const { __scopeTabs, value, forceMount, children, ...contentProps } = props;
  const context = $69cb30bb0017df05$var$useTabsContext($69cb30bb0017df05$var$CONTENT_NAME, __scopeTabs);
  const triggerId = $69cb30bb0017df05$var$makeTriggerId(context.baseId, value);
  const contentId = $69cb30bb0017df05$var$makeContentId(context.baseId, value);
  const isSelected = value === context.value;
  const isMountAnimationPreventedRef = $1IHzk$useRef(isSelected);
  $1IHzk$useEffect(() => {
    const rAF = requestAnimationFrame(
      () => isMountAnimationPreventedRef.current = false
    );
    return () => cancelAnimationFrame(rAF);
  }, []);
  return /* @__PURE__ */ $1IHzk$createElement(
    $1IHzk$Presence,
    {
      present: forceMount || isSelected
    },
    ({ present }) => /* @__PURE__ */ $1IHzk$createElement($8927f6f2acc4f386$export$250ffa63cdc0d03410.div, _extends({
      "data-state": isSelected ? "active" : "inactive",
      "data-orientation": context.orientation,
      role: "tabpanel",
      "aria-labelledby": triggerId,
      hidden: !present,
      id: contentId,
      tabIndex: 0
    }, contentProps, {
      ref: forwardedRef,
      style: {
        ...props.style,
        animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
      }
    }), present && children)
  );
});
function $69cb30bb0017df05$var$makeTriggerId(baseId, value) {
  return `${baseId}-trigger-${value}`;
}
function $69cb30bb0017df05$var$makeContentId(baseId, value) {
  return `${baseId}-content-${value}`;
}
var $69cb30bb0017df05$export$be92b6f5f03c0fe9 = $69cb30bb0017df05$export$b2539bed5023c21c;
var $69cb30bb0017df05$export$54c2e3dc7acea9f5 = $69cb30bb0017df05$export$9712d22edc0d78c1;
var $69cb30bb0017df05$export$41fb9f06171c75f4 = $69cb30bb0017df05$export$8114b9fdfdf9f3ba;
var $69cb30bb0017df05$export$7c6e2c02157bb7d2 = $69cb30bb0017df05$export$bd905d70e8fd2ebb;

// src/components/Tabs/Tabs.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var TabsList = ({ children, ...props }) => /* @__PURE__ */ jsx46(
  $69cb30bb0017df05$export$54c2e3dc7acea9f5,
  {
    className: cn(
      // Layout
      "flex",
      // Spacing
      "gap-2 pb-2"
    ),
    ...props,
    children
  }
);
var TabsTrigger = ({ children, ...props }) => /* @__PURE__ */ jsx46(
  $69cb30bb0017df05$export$41fb9f06171c75f4,
  {
    className: cn(
      // Layout
      "flex items-center justify-center",
      // Spacing
      "gap-2 p-2",
      // Appearance
      "rounded-sm bg-transparent",
      // Typography
      "text-neutral-1 text-sm font-bold",
      // Interactions
      "cursor-pointer",
      // Active state
      "data-[state=active]:bg-highlight-3 data-[state=active]:text-highlight-1",
      // Disabled state
      "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50"
    ),
    ...props,
    children
  }
);
var TabsContent = ({ children, ...props }) => /* @__PURE__ */ jsx46($69cb30bb0017df05$export$7c6e2c02157bb7d2, { ...props, children });
var TabsRoot = ({ children, ...props }) => /* @__PURE__ */ jsx46(
  $69cb30bb0017df05$export$be92b6f5f03c0fe9,
  {
    className: cn(
      // Appearance
      "bg-highlight-0"
    ),
    ...props,
    children
  }
);

// ../../node_modules/@radix-ui/react-toggle/dist/index.module.js
import { forwardRef as $5AXX7$forwardRef, createElement as $5AXX7$createElement } from "react";

// ../../node_modules/@radix-ui/react-toggle/node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff107(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

// ../../node_modules/@radix-ui/react-toggle/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
import { useCallback as $bnPw9$useCallback6, useState as $bnPw9$useState6, useRef as $bnPw9$useRef6, useEffect as $bnPw9$useEffect6 } from "react";

// ../../node_modules/@radix-ui/react-toggle/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import { useRef as $lwiWj$useRef8, useEffect as $lwiWj$useEffect8, useMemo as $lwiWj$useMemo8 } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a8(callback) {
  const callbackRef = $lwiWj$useRef8(callback);
  $lwiWj$useEffect8(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo8(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-toggle/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
function $71cd76cc60e0454e$export$6f32135080cb4c36({ prop, defaultProp, onChange: onChange2 = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState6({
    defaultProp,
    onChange: onChange2
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a8(onChange2);
  const setValue = $bnPw9$useCallback6((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState6({ defaultProp, onChange: onChange2 }) {
  const uncontrolledState = $bnPw9$useState6(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = $bnPw9$useRef6(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a8(onChange2);
  $bnPw9$useEffect6(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}

// ../../node_modules/@radix-ui/react-toggle/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef11, useEffect as $4q5Fq$useEffect11, createElement as $4q5Fq$createElement11 } from "react";
import { flushSync as $4q5Fq$flushSync11 } from "react-dom";
import { Slot as $4q5Fq$Slot11 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES11 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d03411 = $8927f6f2acc4f386$var$NODES11.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef11((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot11 : node;
    $4q5Fq$useEffect11(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement11(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-toggle/dist/index.module.js
var $b3bbe2732c13b576$export$bea8ebba691c5813 = /* @__PURE__ */ $5AXX7$forwardRef((props, forwardedRef) => {
  const { pressed: pressedProp, defaultPressed = false, onPressedChange, ...buttonProps } = props;
  const [pressed = false, setPressed] = $71cd76cc60e0454e$export$6f32135080cb4c36({
    prop: pressedProp,
    onChange: onPressedChange,
    defaultProp: defaultPressed
  });
  return /* @__PURE__ */ $5AXX7$createElement($8927f6f2acc4f386$export$250ffa63cdc0d03411.button, _extends({
    type: "button",
    "aria-pressed": pressed,
    "data-state": pressed ? "on" : "off",
    "data-disabled": props.disabled ? "" : void 0
  }, buttonProps, {
    ref: forwardedRef,
    onClick: $e42e1063c40fb3ef$export$b9ecd428b558ff107(props.onClick, () => {
      if (!props.disabled) setPressed(!pressed);
    })
  }));
});

// ../../node_modules/@radix-ui/react-toggle-group/dist/index.module.js
import $jFibJ$react from "react";

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-context/dist/index.module.js
import { createContext as $3bkAK$createContext8, useMemo as $3bkAK$useMemo8, createElement as $3bkAK$createElement8, useContext as $3bkAK$useContext8 } from "react";
function $c512c27ab02ef895$export$50c7b4e9d9f19c18(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const BaseContext = /* @__PURE__ */ $3bkAK$createContext8(defaultContext);
    const index5 = defaultContexts.length;
    defaultContexts = [
      ...defaultContexts,
      defaultContext
    ];
    function Provider(props) {
      const { scope, children, ...context } = props;
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const value = $3bkAK$useMemo8(
        () => context,
        Object.values(context)
      );
      return /* @__PURE__ */ $3bkAK$createElement8(Context.Provider, {
        value
      }, children);
    }
    function useContext7(consumerName, scope) {
      const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index5]) || BaseContext;
      const context = $3bkAK$useContext8(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
      Provider,
      useContext7
    ];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return /* @__PURE__ */ $3bkAK$createContext8(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
      return $3bkAK$useMemo8(
        () => ({
          [`__scope${scopeName}`]: {
            ...scope,
            [scopeName]: contexts
          }
        }),
        [
          scope,
          contexts
        ]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [
    $c512c27ab02ef895$export$fd42f52fd3ae1109,
    $c512c27ab02ef895$var$composeContextScopes8(createScope, ...createContextScopeDeps)
  ];
}
function $c512c27ab02ef895$var$composeContextScopes8(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope1 = () => {
    const scopeHooks = scopes.map(
      (createScope) => ({
        useScope: createScope(),
        scopeName: createScope.scopeName
      })
    );
    return function useComposedScopes(overrideScopes) {
      const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return {
          ...nextScopes,
          ...currentScope
        };
      }, {});
      return $3bkAK$useMemo8(
        () => ({
          [`__scope${baseScope.scopeName}`]: nextScopes1
        }),
        [
          nextScopes1
        ]
      );
    };
  };
  createScope1.scopeName = baseScope.scopeName;
  return createScope1;
}

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-primitive/dist/index.module.js
import { forwardRef as $4q5Fq$forwardRef12, useEffect as $4q5Fq$useEffect12, createElement as $4q5Fq$createElement12 } from "react";
import { flushSync as $4q5Fq$flushSync12 } from "react-dom";
import { Slot as $4q5Fq$Slot12 } from "@radix-ui/react-slot";
var $8927f6f2acc4f386$var$NODES12 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var $8927f6f2acc4f386$export$250ffa63cdc0d03412 = $8927f6f2acc4f386$var$NODES12.reduce((primitive, node) => {
  const Node2 = /* @__PURE__ */ $4q5Fq$forwardRef12((props, forwardedRef) => {
    const { asChild, ...primitiveProps } = props;
    const Comp = asChild ? $4q5Fq$Slot12 : node;
    $4q5Fq$useEffect12(() => {
      window[/* @__PURE__ */ Symbol.for("radix-ui")] = true;
    }, []);
    return /* @__PURE__ */ $4q5Fq$createElement12(Comp, _extends({}, primitiveProps, {
      ref: forwardedRef
    }));
  });
  Node2.displayName = `Primitive.${node}`;
  return {
    ...primitive,
    [node]: Node2
  };
}, {});

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-roving-focus/dist/index.module.js
import { forwardRef as $98Iye$forwardRef2, createElement as $98Iye$createElement2, useRef as $98Iye$useRef2, useState as $98Iye$useState2, useEffect as $98Iye$useEffect2, useCallback as $98Iye$useCallback2 } from "react";

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/primitive/dist/index.module.js
function $e42e1063c40fb3ef$export$b9ecd428b558ff108(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
  };
}

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-collection/dist/index.module.js
import $6vYhU$react4 from "react";

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-compose-refs/dist/index.module.js
import { useCallback as $3vqmr$useCallback9 } from "react";
function $6ed0406888f73fc4$var$setRef9(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref !== null && ref !== void 0) ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af9(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef9(ref, node)
  );
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d059(...refs) {
  return $3vqmr$useCallback9($6ed0406888f73fc4$export$43e446d32b3d21af9(...refs), refs);
}

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-collection/dist/index.module.js
import { Slot as $6vYhU$Slot4 } from "@radix-ui/react-slot";
function $e02a7d9cb1dc128c$export$c74125a8e3af6bb24(name) {
  const PROVIDER_NAME = name + "CollectionProvider";
  const [createCollectionContext, createCollectionScope] = $c512c27ab02ef895$export$50c7b4e9d9f19c18(PROVIDER_NAME);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  });
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = $6vYhU$react4.useRef(null);
    const itemMap = $6vYhU$react4.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ $6vYhU$react4.createElement(CollectionProviderImpl, {
      scope,
      itemMap,
      collectionRef: ref
    }, children);
  };
  /* @__PURE__ */ Object.assign(CollectionProvider, {
    displayName: PROVIDER_NAME
  });
  const COLLECTION_SLOT_NAME = name + "CollectionSlot";
  const CollectionSlot = /* @__PURE__ */ $6vYhU$react4.forwardRef((props, forwardedRef) => {
    const { scope, children } = props;
    const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d059(forwardedRef, context.collectionRef);
    return /* @__PURE__ */ $6vYhU$react4.createElement($6vYhU$Slot4, {
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionSlot, {
    displayName: COLLECTION_SLOT_NAME
  });
  const ITEM_SLOT_NAME = name + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlot = /* @__PURE__ */ $6vYhU$react4.forwardRef((props, forwardedRef) => {
    const { scope, children, ...itemData } = props;
    const ref = $6vYhU$react4.useRef(null);
    const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d059(forwardedRef, ref);
    const context = useCollectionContext(ITEM_SLOT_NAME, scope);
    $6vYhU$react4.useEffect(() => {
      context.itemMap.set(ref, {
        ref,
        ...itemData
      });
      return () => void context.itemMap.delete(ref);
    });
    return /* @__PURE__ */ $6vYhU$react4.createElement($6vYhU$Slot4, {
      [ITEM_DATA_ATTR]: "",
      ref: composedRefs
    }, children);
  });
  /* @__PURE__ */ Object.assign(CollectionItemSlot, {
    displayName: ITEM_SLOT_NAME
  });
  function useCollection(scope) {
    const context = useCollectionContext(name + "CollectionConsumer", scope);
    const getItems = $6vYhU$react4.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a5, b5) => orderedNodes.indexOf(a5.ref.current) - orderedNodes.indexOf(b5.ref.current)
      );
      return orderedItems;
    }, [
      context.collectionRef,
      context.itemMap
    ]);
    return getItems;
  }
  return [
    {
      Provider: CollectionProvider,
      Slot: CollectionSlot,
      ItemSlot: CollectionItemSlot
    },
    useCollection,
    createCollectionScope
  ];
}

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-id/dist/index.module.js
import * as $2AODx$react6 from "react";

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js
import { useLayoutEffect as $dxlwH$useLayoutEffect7 } from "react";
var $9f79659886946c16$export$e5c5a5f917a5871c7 = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? $dxlwH$useLayoutEffect7 : () => {
};

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-id/dist/index.module.js
var $1746a345f3d73bb7$var$useReactId6 = $2AODx$react6["useId".toString()] || (() => void 0);
var $1746a345f3d73bb7$var$count6 = 0;
function $1746a345f3d73bb7$export$f680877a34711e376(deterministicId) {
  const [id, setId] = $2AODx$react6.useState($1746a345f3d73bb7$var$useReactId6());
  $9f79659886946c16$export$e5c5a5f917a5871c7(() => {
    if (!deterministicId) setId(
      (reactId) => reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count6++)
    );
  }, [
    deterministicId
  ]);
  return deterministicId || (id ? `radix-${id}` : "");
}

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
import { useRef as $lwiWj$useRef9, useEffect as $lwiWj$useEffect9, useMemo as $lwiWj$useMemo9 } from "react";
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a9(callback) {
  const callbackRef = $lwiWj$useRef9(callback);
  $lwiWj$useEffect9(() => {
    callbackRef.current = callback;
  });
  return $lwiWj$useMemo9(
    () => (...args) => {
      var _callbackRef$current;
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
    },
    []
  );
}

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
import { useCallback as $bnPw9$useCallback7, useState as $bnPw9$useState7, useRef as $bnPw9$useRef7, useEffect as $bnPw9$useEffect7 } from "react";
function $71cd76cc60e0454e$export$6f32135080cb4c37({ prop, defaultProp, onChange: onChange2 = () => {
} }) {
  const [uncontrolledProp, setUncontrolledProp] = $71cd76cc60e0454e$var$useUncontrolledState7({
    defaultProp,
    onChange: onChange2
  });
  const isControlled = prop !== void 0;
  const value1 = isControlled ? prop : uncontrolledProp;
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a9(onChange2);
  const setValue = $bnPw9$useCallback7((nextValue) => {
    if (isControlled) {
      const setter = nextValue;
      const value = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value !== prop) handleChange(value);
    } else setUncontrolledProp(nextValue);
  }, [
    isControlled,
    prop,
    setUncontrolledProp,
    handleChange
  ]);
  return [
    value1,
    setValue
  ];
}
function $71cd76cc60e0454e$var$useUncontrolledState7({ defaultProp, onChange: onChange2 }) {
  const uncontrolledState = $bnPw9$useState7(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = $bnPw9$useRef7(value);
  const handleChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a9(onChange2);
  $bnPw9$useEffect7(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [
    value,
    prevValueRef,
    handleChange
  ]);
  return uncontrolledState;
}

// ../../node_modules/@radix-ui/react-toggle-group/node_modules/@radix-ui/react-roving-focus/dist/index.module.js
var $d7bdfb9eb0fdf311$var$ENTRY_FOCUS2 = "rovingFocusGroup.onEntryFocus";
var $d7bdfb9eb0fdf311$var$EVENT_OPTIONS2 = {
  bubbles: false,
  cancelable: true
};
var $d7bdfb9eb0fdf311$var$GROUP_NAME2 = "RovingFocusGroup";
var [$d7bdfb9eb0fdf311$var$Collection2, $d7bdfb9eb0fdf311$var$useCollection2, $d7bdfb9eb0fdf311$var$createCollectionScope2] = $e02a7d9cb1dc128c$export$c74125a8e3af6bb24($d7bdfb9eb0fdf311$var$GROUP_NAME2);
var [$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext2, $d7bdfb9eb0fdf311$export$c7109489551a4f42] = $c512c27ab02ef895$export$50c7b4e9d9f19c18($d7bdfb9eb0fdf311$var$GROUP_NAME2, [
  $d7bdfb9eb0fdf311$var$createCollectionScope2
]);
var [$d7bdfb9eb0fdf311$var$RovingFocusProvider2, $d7bdfb9eb0fdf311$var$useRovingFocusContext2] = $d7bdfb9eb0fdf311$var$createRovingFocusGroupContext2($d7bdfb9eb0fdf311$var$GROUP_NAME2);
var $d7bdfb9eb0fdf311$export$8699f7c8af1483382 = /* @__PURE__ */ $98Iye$forwardRef2((props, forwardedRef) => {
  return /* @__PURE__ */ $98Iye$createElement2($d7bdfb9eb0fdf311$var$Collection2.Provider, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */ $98Iye$createElement2($d7bdfb9eb0fdf311$var$Collection2.Slot, {
    scope: props.__scopeRovingFocusGroup
  }, /* @__PURE__ */ $98Iye$createElement2($d7bdfb9eb0fdf311$var$RovingFocusGroupImpl2, _extends({}, props, {
    ref: forwardedRef
  }))));
});
var $d7bdfb9eb0fdf311$var$RovingFocusGroupImpl2 = /* @__PURE__ */ $98Iye$forwardRef2((props, forwardedRef) => {
  const { __scopeRovingFocusGroup, orientation, loop = false, dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId, onCurrentTabStopIdChange, onEntryFocus, ...groupProps } = props;
  const ref = $98Iye$useRef2(null);
  const composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d059(forwardedRef, ref);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const [currentTabStopId = null, setCurrentTabStopId] = $71cd76cc60e0454e$export$6f32135080cb4c37({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId,
    onChange: onCurrentTabStopIdChange
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = $98Iye$useState2(false);
  const handleEntryFocus = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a9(onEntryFocus);
  const getItems = $d7bdfb9eb0fdf311$var$useCollection2(__scopeRovingFocusGroup);
  const isClickFocusRef = $98Iye$useRef2(false);
  const [focusableItemsCount, setFocusableItemsCount] = $98Iye$useState2(0);
  $98Iye$useEffect2(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS2, handleEntryFocus);
      return () => node.removeEventListener($d7bdfb9eb0fdf311$var$ENTRY_FOCUS2, handleEntryFocus);
    }
  }, [
    handleEntryFocus
  ]);
  return /* @__PURE__ */ $98Iye$createElement2($d7bdfb9eb0fdf311$var$RovingFocusProvider2, {
    scope: __scopeRovingFocusGroup,
    orientation,
    dir: direction,
    loop,
    currentTabStopId,
    onItemFocus: $98Iye$useCallback2(
      (tabStopId) => setCurrentTabStopId(tabStopId),
      [
        setCurrentTabStopId
      ]
    ),
    onItemShiftTab: $98Iye$useCallback2(
      () => setIsTabbingBackOut(true),
      []
    ),
    onFocusableItemAdd: $98Iye$useCallback2(
      () => setFocusableItemsCount(
        (prevCount) => prevCount + 1
      ),
      []
    ),
    onFocusableItemRemove: $98Iye$useCallback2(
      () => setFocusableItemsCount(
        (prevCount) => prevCount - 1
      ),
      []
    )
  }, /* @__PURE__ */ $98Iye$createElement2($8927f6f2acc4f386$export$250ffa63cdc0d03412.div, _extends({
    tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
    "data-orientation": orientation
  }, groupProps, {
    ref: composedRefs,
    style: {
      outline: "none",
      ...props.style
    },
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff108(props.onMouseDown, () => {
      isClickFocusRef.current = true;
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff108(props.onFocus, (event) => {
      const isKeyboardFocus = !isClickFocusRef.current;
      if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
        const entryFocusEvent = new CustomEvent($d7bdfb9eb0fdf311$var$ENTRY_FOCUS2, $d7bdfb9eb0fdf311$var$EVENT_OPTIONS2);
        event.currentTarget.dispatchEvent(entryFocusEvent);
        if (!entryFocusEvent.defaultPrevented) {
          const items = getItems().filter(
            (item) => item.focusable
          );
          const activeItem = items.find(
            (item) => item.active
          );
          const currentItem = items.find(
            (item) => item.id === currentTabStopId
          );
          const candidateItems = [
            activeItem,
            currentItem,
            ...items
          ].filter(Boolean);
          const candidateNodes = candidateItems.map(
            (item) => item.ref.current
          );
          $d7bdfb9eb0fdf311$var$focusFirst2(candidateNodes);
        }
      }
      isClickFocusRef.current = false;
    }),
    onBlur: $e42e1063c40fb3ef$export$b9ecd428b558ff108(
      props.onBlur,
      () => setIsTabbingBackOut(false)
    )
  })));
});
var $d7bdfb9eb0fdf311$var$ITEM_NAME2 = "RovingFocusGroupItem";
var $d7bdfb9eb0fdf311$export$ab9df7c53fe84542 = /* @__PURE__ */ $98Iye$forwardRef2((props, forwardedRef) => {
  const { __scopeRovingFocusGroup, focusable = true, active = false, tabStopId, ...itemProps } = props;
  const autoId = $1746a345f3d73bb7$export$f680877a34711e376();
  const id = tabStopId || autoId;
  const context = $d7bdfb9eb0fdf311$var$useRovingFocusContext2($d7bdfb9eb0fdf311$var$ITEM_NAME2, __scopeRovingFocusGroup);
  const isCurrentTabStop = context.currentTabStopId === id;
  const getItems = $d7bdfb9eb0fdf311$var$useCollection2(__scopeRovingFocusGroup);
  const { onFocusableItemAdd, onFocusableItemRemove } = context;
  $98Iye$useEffect2(() => {
    if (focusable) {
      onFocusableItemAdd();
      return () => onFocusableItemRemove();
    }
  }, [
    focusable,
    onFocusableItemAdd,
    onFocusableItemRemove
  ]);
  return /* @__PURE__ */ $98Iye$createElement2($d7bdfb9eb0fdf311$var$Collection2.ItemSlot, {
    scope: __scopeRovingFocusGroup,
    id,
    focusable,
    active
  }, /* @__PURE__ */ $98Iye$createElement2($8927f6f2acc4f386$export$250ffa63cdc0d03412.span, _extends({
    tabIndex: isCurrentTabStop ? 0 : -1,
    "data-orientation": context.orientation
  }, itemProps, {
    ref: forwardedRef,
    onMouseDown: $e42e1063c40fb3ef$export$b9ecd428b558ff108(props.onMouseDown, (event) => {
      if (!focusable) event.preventDefault();
      else context.onItemFocus(id);
    }),
    onFocus: $e42e1063c40fb3ef$export$b9ecd428b558ff108(
      props.onFocus,
      () => context.onItemFocus(id)
    ),
    onKeyDown: $e42e1063c40fb3ef$export$b9ecd428b558ff108(props.onKeyDown, (event) => {
      if (event.key === "Tab" && event.shiftKey) {
        context.onItemShiftTab();
        return;
      }
      if (event.target !== event.currentTarget) return;
      const focusIntent = $d7bdfb9eb0fdf311$var$getFocusIntent2(event, context.orientation, context.dir);
      if (focusIntent !== void 0) {
        event.preventDefault();
        const items = getItems().filter(
          (item) => item.focusable
        );
        let candidateNodes = items.map(
          (item) => item.ref.current
        );
        if (focusIntent === "last") candidateNodes.reverse();
        else if (focusIntent === "prev" || focusIntent === "next") {
          if (focusIntent === "prev") candidateNodes.reverse();
          const currentIndex = candidateNodes.indexOf(event.currentTarget);
          candidateNodes = context.loop ? $d7bdfb9eb0fdf311$var$wrapArray2(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
        }
        setTimeout(
          () => $d7bdfb9eb0fdf311$var$focusFirst2(candidateNodes)
        );
      }
    })
  })));
});
var $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT2 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function $d7bdfb9eb0fdf311$var$getDirectionAwareKey2(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $d7bdfb9eb0fdf311$var$getFocusIntent2(event, orientation, dir) {
  const key = $d7bdfb9eb0fdf311$var$getDirectionAwareKey2(event.key, dir);
  if (orientation === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(key)) return void 0;
  if (orientation === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(key)) return void 0;
  return $d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT2[key];
}
function $d7bdfb9eb0fdf311$var$focusFirst2(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function $d7bdfb9eb0fdf311$var$wrapArray2(array, startIndex) {
  return array.map(
    (_, index5) => array[(startIndex + index5) % array.length]
  );
}
var $d7bdfb9eb0fdf311$export$be92b6f5f03c0fe92 = $d7bdfb9eb0fdf311$export$8699f7c8af1483382;
var $d7bdfb9eb0fdf311$export$6d08773d2e66f8f22 = $d7bdfb9eb0fdf311$export$ab9df7c53fe84542;

// ../../node_modules/@radix-ui/react-toggle-group/dist/index.module.js
var $6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME = "ToggleGroup";
var [$6c1fd9e6a8969628$var$createToggleGroupContext, $6c1fd9e6a8969628$export$d1c7c4bcd9f26dd4] = $c512c27ab02ef895$export$50c7b4e9d9f19c18($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME, [
  $d7bdfb9eb0fdf311$export$c7109489551a4f42
]);
var $6c1fd9e6a8969628$var$useRovingFocusGroupScope = $d7bdfb9eb0fdf311$export$c7109489551a4f42();
var $6c1fd9e6a8969628$export$af3ec21f6cfb5e30 = /* @__PURE__ */ $jFibJ$react.forwardRef((props, forwardedRef) => {
  const { type, ...toggleGroupProps } = props;
  if (type === "single") {
    const singleProps = toggleGroupProps;
    return /* @__PURE__ */ $jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupImplSingle, _extends({}, singleProps, {
      ref: forwardedRef
    }));
  }
  if (type === "multiple") {
    const multipleProps = toggleGroupProps;
    return /* @__PURE__ */ $jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupImplMultiple, _extends({}, multipleProps, {
      ref: forwardedRef
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${$6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME}\``);
});
var [$6c1fd9e6a8969628$var$ToggleGroupValueProvider, $6c1fd9e6a8969628$var$useToggleGroupValueContext] = $6c1fd9e6a8969628$var$createToggleGroupContext($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME);
var $6c1fd9e6a8969628$var$ToggleGroupImplSingle = /* @__PURE__ */ $jFibJ$react.forwardRef((props, forwardedRef) => {
  const { value: valueProp, defaultValue, onValueChange = () => {
  }, ...toggleGroupSingleProps } = props;
  const [value, setValue] = $71cd76cc60e0454e$export$6f32135080cb4c37({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  return /* @__PURE__ */ $jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupValueProvider, {
    scope: props.__scopeToggleGroup,
    type: "single",
    value: value ? [
      value
    ] : [],
    onItemActivate: setValue,
    onItemDeactivate: $jFibJ$react.useCallback(
      () => setValue(""),
      [
        setValue
      ]
    )
  }, /* @__PURE__ */ $jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupImpl, _extends({}, toggleGroupSingleProps, {
    ref: forwardedRef
  })));
});
var $6c1fd9e6a8969628$var$ToggleGroupImplMultiple = /* @__PURE__ */ $jFibJ$react.forwardRef((props, forwardedRef) => {
  const { value: valueProp, defaultValue, onValueChange = () => {
  }, ...toggleGroupMultipleProps } = props;
  const [value1 = [], setValue] = $71cd76cc60e0454e$export$6f32135080cb4c37({
    prop: valueProp,
    defaultProp: defaultValue,
    onChange: onValueChange
  });
  const handleButtonActivate = $jFibJ$react.useCallback(
    (itemValue) => setValue(
      (prevValue = []) => [
        ...prevValue,
        itemValue
      ]
    ),
    [
      setValue
    ]
  );
  const handleButtonDeactivate = $jFibJ$react.useCallback(
    (itemValue) => setValue(
      (prevValue = []) => prevValue.filter(
        (value) => value !== itemValue
      )
    ),
    [
      setValue
    ]
  );
  return /* @__PURE__ */ $jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupValueProvider, {
    scope: props.__scopeToggleGroup,
    type: "multiple",
    value: value1,
    onItemActivate: handleButtonActivate,
    onItemDeactivate: handleButtonDeactivate
  }, /* @__PURE__ */ $jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupImpl, _extends({}, toggleGroupMultipleProps, {
    ref: forwardedRef
  })));
});
var [$6c1fd9e6a8969628$var$ToggleGroupContext, $6c1fd9e6a8969628$var$useToggleGroupContext] = $6c1fd9e6a8969628$var$createToggleGroupContext($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME);
var $6c1fd9e6a8969628$var$ToggleGroupImpl = /* @__PURE__ */ $jFibJ$react.forwardRef((props, forwardedRef) => {
  const { __scopeToggleGroup, disabled: disabled2 = false, rovingFocus = true, orientation, dir, loop = true, ...toggleGroupProps } = props;
  const rovingFocusGroupScope = $6c1fd9e6a8969628$var$useRovingFocusGroupScope(__scopeToggleGroup);
  const direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
  const commonProps = {
    role: "group",
    dir: direction,
    ...toggleGroupProps
  };
  return /* @__PURE__ */ $jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupContext, {
    scope: __scopeToggleGroup,
    rovingFocus,
    disabled: disabled2
  }, rovingFocus ? /* @__PURE__ */ $jFibJ$react.createElement($d7bdfb9eb0fdf311$export$be92b6f5f03c0fe92, _extends({
    asChild: true
  }, rovingFocusGroupScope, {
    orientation,
    dir: direction,
    loop
  }), /* @__PURE__ */ $jFibJ$react.createElement($8927f6f2acc4f386$export$250ffa63cdc0d03412.div, _extends({}, commonProps, {
    ref: forwardedRef
  }))) : /* @__PURE__ */ $jFibJ$react.createElement($8927f6f2acc4f386$export$250ffa63cdc0d03412.div, _extends({}, commonProps, {
    ref: forwardedRef
  })));
});
var $6c1fd9e6a8969628$var$ITEM_NAME = "ToggleGroupItem";
var $6c1fd9e6a8969628$export$b453109e13abe10b = /* @__PURE__ */ $jFibJ$react.forwardRef((props, forwardedRef) => {
  const valueContext = $6c1fd9e6a8969628$var$useToggleGroupValueContext($6c1fd9e6a8969628$var$ITEM_NAME, props.__scopeToggleGroup);
  const context = $6c1fd9e6a8969628$var$useToggleGroupContext($6c1fd9e6a8969628$var$ITEM_NAME, props.__scopeToggleGroup);
  const rovingFocusGroupScope = $6c1fd9e6a8969628$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
  const pressed = valueContext.value.includes(props.value);
  const disabled2 = context.disabled || props.disabled;
  const commonProps = {
    ...props,
    pressed,
    disabled: disabled2
  };
  const ref = $jFibJ$react.useRef(null);
  return context.rovingFocus ? /* @__PURE__ */ $jFibJ$react.createElement($d7bdfb9eb0fdf311$export$6d08773d2e66f8f22, _extends({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled2,
    active: pressed,
    ref
  }), /* @__PURE__ */ $jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupItemImpl, _extends({}, commonProps, {
    ref: forwardedRef
  }))) : /* @__PURE__ */ $jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupItemImpl, _extends({}, commonProps, {
    ref: forwardedRef
  }));
});
var $6c1fd9e6a8969628$var$ToggleGroupItemImpl = /* @__PURE__ */ $jFibJ$react.forwardRef((props, forwardedRef) => {
  const { __scopeToggleGroup, value, ...itemProps } = props;
  const valueContext = $6c1fd9e6a8969628$var$useToggleGroupValueContext($6c1fd9e6a8969628$var$ITEM_NAME, __scopeToggleGroup);
  const singleProps = {
    role: "radio",
    "aria-checked": props.pressed,
    "aria-pressed": void 0
  };
  const typeProps = valueContext.type === "single" ? singleProps : void 0;
  return /* @__PURE__ */ $jFibJ$react.createElement($b3bbe2732c13b576$export$bea8ebba691c5813, _extends({}, typeProps, itemProps, {
    ref: forwardedRef,
    onPressedChange: (pressed) => {
      if (pressed) valueContext.onItemActivate(value);
      else valueContext.onItemDeactivate(value);
    }
  }));
});

// src/components/Toggle/Toggle.tsx
import { jsx as jsx47 } from "react/jsx-runtime";
var Toggle = ({ children, className, ...props }) => /* @__PURE__ */ jsx47(
  $b3bbe2732c13b576$export$bea8ebba691c5813,
  {
    className: cn(
      // Layout
      "flex flex-1 items-center justify-center",
      // Sizing
      "h-8",
      // Spacing
      "p-1",
      // Appearance
      "bg-neutral-1 rounded-md",
      // Borders
      "border-1 border-neutral-1",
      // Interactions
      "cursor-pointer",
      // On state
      "data-[state=on]:bg-highlight-1 data-[state=on]:text-highlight-2",
      // Disabled state
      "disabled:bg-neutral-0 disabled:text-neutral-4 disabled:cursor-not-allowed",
      className
    ),
    ...props,
    children
  }
);
var ToggleGroup = ({
  children,
  className,
  ...props
}) => /* @__PURE__ */ jsx47(
  $6c1fd9e6a8969628$export$af3ec21f6cfb5e30,
  {
    className: cn(
      // Layout
      "flex w-full items-center justify-between",
      // Spacing
      "gap-2 p-0.5",
      // Appearance
      "bg-neutral-1 rounded-md",
      // Borders
      "border-1 border-neutral-1",
      // Typography
      "font-lato text-neutral-3 text-sm font-bold",
      // Disabled state
      "disabled:bg-neutral-0 disabled:text-neutral-4 disabled:cursor-not-allowed",
      className
    ),
    ...props,
    children
  }
);
var ToggleGroupItem = ({
  children,
  className,
  ...props
}) => /* @__PURE__ */ jsx47(
  $6c1fd9e6a8969628$export$b453109e13abe10b,
  {
    className: cn(
      // Layout
      "flex flex-1 items-center justify-center",
      // Sizing
      "h-7",
      // Appearance
      "rounded-sm",
      // Interactions
      "cursor-pointer",
      // On state
      "data-[state=on]:bg-highlight-1 data-[state=on]:text-highlight-2",
      // Disabled state
      "data-[state=on]:disabled:bg-highlight-3 disabled:cursor-not-allowed",
      className
    ),
    ...props,
    children
  }
);

// src/components/GridSelector/GridSelector.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
var generateArrayOfIndexes = (amount) => Array.from({ length: amount }, (_, index5) => index5);
var GridSelector = ({
  amount,
  initialValue,
  onChange: onChange2
}) => {
  const selectors = generateArrayOfIndexes(amount);
  const onChangePosition = (positionIndex) => onChange2(positionIndex);
  return /* @__PURE__ */ jsx48(
    "form",
    {
      className: cn(
        "flex flex-row flex-wrap",
        "gap-2 p-2",
        "w-full",
        "border-neutral-2 rounded-md border",
        "bg-neutral"
      ),
      children: selectors.map((position) => /* @__PURE__ */ jsx48(
        "input",
        {
          className: cn(
            "block flex-1 basis-[calc(100%/3-8px)] self-stretch",
            "h-4 cursor-pointer appearance-none",
            "border-neutral-3 rounded-sm border",
            "bg-neutral-1",
            "transition-all duration-200 ease-in-out",
            position === initialValue && "border-highlight-2 bg-highlight-2"
          ),
          type: "radio",
          name: "position-selector",
          value: position,
          checked: position === initialValue,
          onChange: () => onChangePosition(position)
        },
        `position-selector-${position}`
      ))
    }
  );
};
export {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Alert,
  AlertDescription,
  AlertTitle,
  BlockTile_default as BlockTile,
  Button,
  ButtonGroup,
  ButtonGroupSeparator,
  ButtonGroupText,
  ColorPicker,
  ComboBox,
  ComboBoxContent,
  ComboBoxEmpty,
  ComboBoxGroup,
  ComboBoxInput,
  ComboBoxItem,
  ComboBoxList,
  ComboBoxTrigger,
  ComboBoxValue,
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandItemIcon,
  CommandList,
  CommandSeparator,
  CommandShortcut,
  DEFAULT_COLOR,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuItemDescription,
  DropdownMenuItemTitle,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
  Fieldset,
  FloatingPanel,
  FloatingPanelContent,
  FloatingPanelHeader,
  FloatingPanelNavigation,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
  FormRow,
  GridSelector,
  Icon,
  Input,
  Label2 as Label,
  Modal,
  ModalClose,
  ModalContent,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTrigger,
  Popover,
  PopoverAnchor,
  PopoverContent,
  PopoverTrigger,
  SegmentedControlGroup,
  SegmentedControlGroupItem,
  Select,
  SelectButton,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectPortal,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  Separator,
  StepBar,
  StepBarItem,
  Switch,
  TabsContent,
  TabsList,
  TabsRoot,
  TabsTrigger,
  Toggle,
  ToggleGroup,
  ToggleGroupItem,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  alertVariants,
  buttonGroupVariants,
  separatorVariants,
  useClickOutside,
  useFloatingPanelNavigation,
  use_floating_window_default as useFloatingWindow,
  useFloatingWindowListener
};
/*! Bundled license information:

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)
*/
//# sourceMappingURL=index.mjs.map